/*! For license information please see custom.min.js.LICENSE.txt */
(() => {
  var e = {
      827: () => {
        var e = document.querySelector(".newsletter__expand"),
          t = document.querySelector(".newsletter__collapse"),
          n = document.querySelector(".newsletter__remove"),
          r = document.querySelector(".newsletter"),
          i = document.querySelector(".newsletter__content"),
          a = (document.querySelector(".pdp"), document.querySelector(".newsletter__overlay"));
        n.addEventListener("click", function () {
          n.closest(".newsletter").remove(), a.classList.remove("newsletter__overlay--visible");
        }),
          e.addEventListener("click", function () {
            n.classList.add("nl-expanded"), e.classList.add("nl-expanded"), r.classList.add("nl-expanded"), i.classList.add("nl-expanded"), a.classList.add("newsletter__overlay--visible");
          }),
          t.addEventListener("click", function () {
            n.closest(".newsletter").remove(), a.classList.remove("newsletter__overlay--visible");
          }),
          r.addEventListener("click", function (e) {
            e.stopPropagation();
          }),
          a.addEventListener("click", function () {
            n.closest(".newsletter").remove(), a.classList.remove("newsletter__overlay--visible");
          });
      },
      812: (e, t, n) => {
        var r, i, a;
        (i = [n(755)]),
          void 0 ===
            (a =
              "function" ==
              typeof (r = function (e) {
                var t = /\+/g;
                function n(e) {
                  return a.raw ? e : encodeURIComponent(e);
                }
                function r(e) {
                  return n(a.json ? JSON.stringify(e) : String(e));
                }
                function i(n, r) {
                  var i = a.raw
                    ? n
                    : (function (e) {
                        0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
                        try {
                          return (e = decodeURIComponent(e.replace(t, " "))), a.json ? JSON.parse(e) : e;
                        } catch (e) {}
                      })(n);
                  return e.isFunction(r) ? r(i) : i;
                }
                var a = (e.cookie = function (t, o, s) {
                  if (void 0 !== o && !e.isFunction(o)) {
                    if ("number" == typeof (s = e.extend({}, a.defaults, s)).expires) {
                      var l = s.expires,
                        u = (s.expires = new Date());
                      u.setTime(+u + 864e5 * l);
                    }
                    return (document.cookie = [n(t), "=", r(o), s.expires ? "; expires=" + s.expires.toUTCString() : "", s.path ? "; path=" + s.path : "", s.domain ? "; domain=" + s.domain : "", s.secure ? "; secure" : ""].join(""));
                  }
                  for (var c = t ? void 0 : {}, d = document.cookie ? document.cookie.split("; ") : [], f = 0, p = d.length; f < p; f++) {
                    var h = d[f].split("="),
                      v = ((m = h.shift()), a.raw ? m : decodeURIComponent(m)),
                      g = h.join("=");
                    if (t && t === v) {
                      c = i(g, o);
                      break;
                    }
                    t || void 0 === (g = i(g)) || (c[v] = g);
                  }
                  var m;
                  return c;
                });
                (a.defaults = {}),
                  (e.removeCookie = function (t, n) {
                    return void 0 !== e.cookie(t) && (e.cookie(t, "", e.extend({}, n, { expires: -1 })), !e.cookie(t));
                  });
              })
                ? r.apply(t, i)
                : r) || (e.exports = a);
      },
      755: function (e, t) {
        var n;
        !(function (t, n) {
          "use strict";
          "object" == typeof e.exports
            ? (e.exports = t.document
                ? n(t, !0)
                : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return n(e);
                  })
            : n(t);
        })("undefined" != typeof window ? window : this, function (r, i) {
          "use strict";
          var a = [],
            o = Object.getPrototypeOf,
            s = a.slice,
            l = a.flat
              ? function (e) {
                  return a.flat.call(e);
                }
              : function (e) {
                  return a.concat.apply([], e);
                },
            u = a.push,
            c = a.indexOf,
            d = {},
            f = d.toString,
            p = d.hasOwnProperty,
            h = p.toString,
            v = h.call(Object),
            g = {},
            m = function (e) {
              return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
            },
            y = function (e) {
              return null != e && e === e.window;
            },
            b = r.document,
            w = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function _(e, t, n) {
            var r,
              i,
              a = (n = n || b).createElement("script");
            if (((a.text = e), t)) for (r in w) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && a.setAttribute(r, i);
            n.head.appendChild(a).parentNode.removeChild(a);
          }
          function x(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? d[f.call(e)] || "object" : typeof e;
          }
          var C = "3.6.0",
            T = function (e, t) {
              return new T.fn.init(e, t);
            };
          function k(e) {
            var t = !!e && "length" in e && e.length,
              n = x(e);
            return !m(e) && !y(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
          }
          (T.fn = T.prototype = {
            jquery: C,
            constructor: T,
            length: 0,
            toArray: function () {
              return s.call(this);
            },
            get: function (e) {
              return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function (e) {
              var t = T.merge(this.constructor(), e);
              return (t.prevObject = this), t;
            },
            each: function (e) {
              return T.each(this, e);
            },
            map: function (e) {
              return this.pushStack(
                T.map(this, function (t, n) {
                  return e.call(t, n, t);
                })
              );
            },
            slice: function () {
              return this.pushStack(s.apply(this, arguments));
            },
            first: function () {
              return this.eq(0);
            },
            last: function () {
              return this.eq(-1);
            },
            even: function () {
              return this.pushStack(
                T.grep(this, function (e, t) {
                  return (t + 1) % 2;
                })
              );
            },
            odd: function () {
              return this.pushStack(
                T.grep(this, function (e, t) {
                  return t % 2;
                })
              );
            },
            eq: function (e) {
              var t = this.length,
                n = +e + (e < 0 ? t : 0);
              return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
            },
            end: function () {
              return this.prevObject || this.constructor();
            },
            push: u,
            sort: a.sort,
            splice: a.splice,
          }),
            (T.extend = T.fn.extend = function () {
              var e,
                t,
                n,
                r,
                i,
                a,
                o = arguments[0] || {},
                s = 1,
                l = arguments.length,
                u = !1;
              for ("boolean" == typeof o && ((u = o), (o = arguments[s] || {}), s++), "object" == typeof o || m(o) || (o = {}), s === l && ((o = this), s--); s < l; s++)
                if (null != (e = arguments[s]))
                  for (t in e)
                    (r = e[t]),
                      "__proto__" !== t &&
                        o !== r &&
                        (u && r && (T.isPlainObject(r) || (i = Array.isArray(r))) ? ((n = o[t]), (a = i && !Array.isArray(n) ? [] : i || T.isPlainObject(n) ? n : {}), (i = !1), (o[t] = T.extend(u, a, r))) : void 0 !== r && (o[t] = r));
              return o;
            }),
            T.extend({
              expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
              isReady: !0,
              error: function (e) {
                throw new Error(e);
              },
              noop: function () {},
              isPlainObject: function (e) {
                var t, n;
                return !(!e || "[object Object]" !== f.call(e) || ((t = o(e)) && ("function" != typeof (n = p.call(t, "constructor") && t.constructor) || h.call(n) !== v)));
              },
              isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
              },
              globalEval: function (e, t, n) {
                _(e, { nonce: t && t.nonce }, n);
              },
              each: function (e, t) {
                var n,
                  r = 0;
                if (k(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
                else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
              },
              makeArray: function (e, t) {
                var n = t || [];
                return null != e && (k(Object(e)) ? T.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
              },
              inArray: function (e, t, n) {
                return null == t ? -1 : c.call(t, e, n);
              },
              merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
                return (e.length = i), e;
              },
              grep: function (e, t, n) {
                for (var r = [], i = 0, a = e.length, o = !n; i < a; i++) !t(e[i], i) !== o && r.push(e[i]);
                return r;
              },
              map: function (e, t, n) {
                var r,
                  i,
                  a = 0,
                  o = [];
                if (k(e)) for (r = e.length; a < r; a++) null != (i = t(e[a], a, n)) && o.push(i);
                else for (a in e) null != (i = t(e[a], a, n)) && o.push(i);
                return l(o);
              },
              guid: 1,
              support: g,
            }),
            "function" == typeof Symbol && (T.fn[Symbol.iterator] = a[Symbol.iterator]),
            T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
              d["[object " + t + "]"] = t.toLowerCase();
            });
          var E = (function (e) {
            var t,
              n,
              r,
              i,
              a,
              o,
              s,
              l,
              u,
              c,
              d,
              f,
              p,
              h,
              v,
              g,
              m,
              y,
              b,
              w = "sizzle" + 1 * new Date(),
              _ = e.document,
              x = 0,
              C = 0,
              T = le(),
              k = le(),
              E = le(),
              S = le(),
              O = function (e, t) {
                return e === t && (d = !0), 0;
              },
              M = {}.hasOwnProperty,
              P = [],
              A = P.pop,
              L = P.push,
              I = P.push,
              D = P.slice,
              z = function (e, t) {
                for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
                return -1;
              },
              j = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
              B = "[\\x20\\t\\r\\n\\f]",
              N = "(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
              R = "\\[[\\x20\\t\\r\\n\\f]*(" + N + ")(?:" + B + "*([*^$|!~]?=)" + B + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + N + "))|)" + B + "*\\]",
              q = ":(" + N + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
              F = new RegExp(B + "+", "g"),
              H = new RegExp("^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$", "g"),
              W = new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"),
              $ = new RegExp("^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"),
              V = new RegExp(B + "|>"),
              Y = new RegExp(q),
              G = new RegExp("^" + N + "$"),
              X = {
                ID: new RegExp("^#(" + N + ")"),
                CLASS: new RegExp("^\\.(" + N + ")"),
                TAG: new RegExp("^(" + N + "|[*])"),
                ATTR: new RegExp("^" + R),
                PSEUDO: new RegExp("^" + q),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)", "i"),
                bool: new RegExp("^(?:" + j + ")$", "i"),
                needsContext: new RegExp("^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)", "i"),
              },
              U = /HTML$/i,
              K = /^(?:input|select|textarea|button)$/i,
              Q = /^h\d$/i,
              Z = /^[^{]+\{\s*\[native \w/,
              J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              ee = /[+~]/,
              te = new RegExp("\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])", "g"),
              ne = function (e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
              },
              re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              ie = function (e, t) {
                return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
              },
              ae = function () {
                f();
              },
              oe = we(
                function (e) {
                  return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
              );
            try {
              I.apply((P = D.call(_.childNodes)), _.childNodes), P[_.childNodes.length].nodeType;
            } catch (e) {
              I = {
                apply: P.length
                  ? function (e, t) {
                      L.apply(e, D.call(t));
                    }
                  : function (e, t) {
                      for (var n = e.length, r = 0; (e[n++] = t[r++]); );
                      e.length = n - 1;
                    },
              };
            }
            function se(e, t, r, i) {
              var a,
                s,
                u,
                c,
                d,
                h,
                m,
                y = t && t.ownerDocument,
                _ = t ? t.nodeType : 9;
              if (((r = r || []), "string" != typeof e || !e || (1 !== _ && 9 !== _ && 11 !== _))) return r;
              if (!i && (f(t), (t = t || p), v)) {
                if (11 !== _ && (d = J.exec(e)))
                  if ((a = d[1])) {
                    if (9 === _) {
                      if (!(u = t.getElementById(a))) return r;
                      if (u.id === a) return r.push(u), r;
                    } else if (y && (u = y.getElementById(a)) && b(t, u) && u.id === a) return r.push(u), r;
                  } else {
                    if (d[2]) return I.apply(r, t.getElementsByTagName(e)), r;
                    if ((a = d[3]) && n.getElementsByClassName && t.getElementsByClassName) return I.apply(r, t.getElementsByClassName(a)), r;
                  }
                if (n.qsa && !S[e + " "] && (!g || !g.test(e)) && (1 !== _ || "object" !== t.nodeName.toLowerCase())) {
                  if (((m = e), (y = t), 1 === _ && (V.test(e) || $.test(e)))) {
                    for (((y = (ee.test(e) && me(t.parentNode)) || t) === t && n.scope) || ((c = t.getAttribute("id")) ? (c = c.replace(re, ie)) : t.setAttribute("id", (c = w))), s = (h = o(e)).length; s--; )
                      h[s] = (c ? "#" + c : ":scope") + " " + be(h[s]);
                    m = h.join(",");
                  }
                  try {
                    return I.apply(r, y.querySelectorAll(m)), r;
                  } catch (t) {
                    S(e, !0);
                  } finally {
                    c === w && t.removeAttribute("id");
                  }
                }
              }
              return l(e.replace(H, "$1"), t, r, i);
            }
            function le() {
              var e = [];
              return function t(n, i) {
                return e.push(n + " ") > r.cacheLength && delete t[e.shift()], (t[n + " "] = i);
              };
            }
            function ue(e) {
              return (e[w] = !0), e;
            }
            function ce(e) {
              var t = p.createElement("fieldset");
              try {
                return !!e(t);
              } catch (e) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
              }
            }
            function de(e, t) {
              for (var n = e.split("|"), i = n.length; i--; ) r.attrHandle[n[i]] = t;
            }
            function fe(e, t) {
              var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
              if (r) return r;
              if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
              return e ? 1 : -1;
            }
            function pe(e) {
              return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
              };
            }
            function he(e) {
              return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
              };
            }
            function ve(e) {
              return function (t) {
                return "form" in t
                  ? t.parentNode && !1 === t.disabled
                    ? "label" in t
                      ? "label" in t.parentNode
                        ? t.parentNode.disabled === e
                        : t.disabled === e
                      : t.isDisabled === e || (t.isDisabled !== !e && oe(t) === e)
                    : t.disabled === e
                  : "label" in t && t.disabled === e;
              };
            }
            function ge(e) {
              return ue(function (t) {
                return (
                  (t = +t),
                  ue(function (n, r) {
                    for (var i, a = e([], n.length, t), o = a.length; o--; ) n[(i = a[o])] && (n[i] = !(r[i] = n[i]));
                  })
                );
              });
            }
            function me(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            for (t in ((n = se.support = {}),
            (a = se.isXML = function (e) {
              var t = e && e.namespaceURI,
                n = e && (e.ownerDocument || e).documentElement;
              return !U.test(t || (n && n.nodeName) || "HTML");
            }),
            (f = se.setDocument = function (e) {
              var t,
                i,
                o = e ? e.ownerDocument || e : _;
              return o != p && 9 === o.nodeType && o.documentElement
                ? ((h = (p = o).documentElement),
                  (v = !a(p)),
                  _ != p && (i = p.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", ae, !1) : i.attachEvent && i.attachEvent("onunload", ae)),
                  (n.scope = ce(function (e) {
                    return h.appendChild(e).appendChild(p.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                  })),
                  (n.attributes = ce(function (e) {
                    return (e.className = "i"), !e.getAttribute("className");
                  })),
                  (n.getElementsByTagName = ce(function (e) {
                    return e.appendChild(p.createComment("")), !e.getElementsByTagName("*").length;
                  })),
                  (n.getElementsByClassName = Z.test(p.getElementsByClassName)),
                  (n.getById = ce(function (e) {
                    return (h.appendChild(e).id = w), !p.getElementsByName || !p.getElementsByName(w).length;
                  })),
                  n.getById
                    ? ((r.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          return e.getAttribute("id") === t;
                        };
                      }),
                      (r.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && v) {
                          var n = t.getElementById(e);
                          return n ? [n] : [];
                        }
                      }))
                    : ((r.filter.ID = function (e) {
                        var t = e.replace(te, ne);
                        return function (e) {
                          var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                          return n && n.value === t;
                        };
                      }),
                      (r.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && v) {
                          var n,
                            r,
                            i,
                            a = t.getElementById(e);
                          if (a) {
                            if ((n = a.getAttributeNode("id")) && n.value === e) return [a];
                            for (i = t.getElementsByName(e), r = 0; (a = i[r++]); ) if ((n = a.getAttributeNode("id")) && n.value === e) return [a];
                          }
                          return [];
                        }
                      })),
                  (r.find.TAG = n.getElementsByTagName
                    ? function (e, t) {
                        return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                      }
                    : function (e, t) {
                        var n,
                          r = [],
                          i = 0,
                          a = t.getElementsByTagName(e);
                        if ("*" === e) {
                          for (; (n = a[i++]); ) 1 === n.nodeType && r.push(n);
                          return r;
                        }
                        return a;
                      }),
                  (r.find.CLASS =
                    n.getElementsByClassName &&
                    function (e, t) {
                      if (void 0 !== t.getElementsByClassName && v) return t.getElementsByClassName(e);
                    }),
                  (m = []),
                  (g = []),
                  (n.qsa = Z.test(p.querySelectorAll)) &&
                    (ce(function (e) {
                      var t;
                      (h.appendChild(e).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                        e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),
                        e.querySelectorAll("[selected]").length || g.push("\\[[\\x20\\t\\r\\n\\f]*(?:value|" + j + ")"),
                        e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="),
                        (t = p.createElement("input")).setAttribute("name", ""),
                        e.appendChild(t),
                        e.querySelectorAll("[name='']").length || g.push("\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),
                        e.querySelectorAll(":checked").length || g.push(":checked"),
                        e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]"),
                        e.querySelectorAll("\\\f"),
                        g.push("[\\r\\n\\f]");
                    }),
                    ce(function (e) {
                      e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                      var t = p.createElement("input");
                      t.setAttribute("type", "hidden"),
                        e.appendChild(t).setAttribute("name", "D"),
                        e.querySelectorAll("[name=d]").length && g.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="),
                        2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"),
                        (h.appendChild(e).disabled = !0),
                        2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"),
                        e.querySelectorAll("*,:x"),
                        g.push(",.*:");
                    })),
                  (n.matchesSelector = Z.test((y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector))) &&
                    ce(function (e) {
                      (n.disconnectedMatch = y.call(e, "*")), y.call(e, "[s!='']:x"), m.push("!=", q);
                    }),
                  (g = g.length && new RegExp(g.join("|"))),
                  (m = m.length && new RegExp(m.join("|"))),
                  (t = Z.test(h.compareDocumentPosition)),
                  (b =
                    t || Z.test(h.contains)
                      ? function (e, t) {
                          var n = 9 === e.nodeType ? e.documentElement : e,
                            r = t && t.parentNode;
                          return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
                        }
                      : function (e, t) {
                          if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                          return !1;
                        }),
                  (O = t
                    ? function (e, t) {
                        if (e === t) return (d = !0), 0;
                        var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                        return (
                          r ||
                          (1 & (r = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === r)
                            ? e == p || (e.ownerDocument == _ && b(_, e))
                              ? -1
                              : t == p || (t.ownerDocument == _ && b(_, t))
                              ? 1
                              : c
                              ? z(c, e) - z(c, t)
                              : 0
                            : 4 & r
                            ? -1
                            : 1)
                        );
                      }
                    : function (e, t) {
                        if (e === t) return (d = !0), 0;
                        var n,
                          r = 0,
                          i = e.parentNode,
                          a = t.parentNode,
                          o = [e],
                          s = [t];
                        if (!i || !a) return e == p ? -1 : t == p ? 1 : i ? -1 : a ? 1 : c ? z(c, e) - z(c, t) : 0;
                        if (i === a) return fe(e, t);
                        for (n = e; (n = n.parentNode); ) o.unshift(n);
                        for (n = t; (n = n.parentNode); ) s.unshift(n);
                        for (; o[r] === s[r]; ) r++;
                        return r ? fe(o[r], s[r]) : o[r] == _ ? -1 : s[r] == _ ? 1 : 0;
                      }),
                  p)
                : p;
            }),
            (se.matches = function (e, t) {
              return se(e, null, null, t);
            }),
            (se.matchesSelector = function (e, t) {
              if ((f(e), n.matchesSelector && v && !S[t + " "] && (!m || !m.test(t)) && (!g || !g.test(t))))
                try {
                  var r = y.call(e, t);
                  if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
                } catch (e) {
                  S(t, !0);
                }
              return se(t, p, null, [e]).length > 0;
            }),
            (se.contains = function (e, t) {
              return (e.ownerDocument || e) != p && f(e), b(e, t);
            }),
            (se.attr = function (e, t) {
              (e.ownerDocument || e) != p && f(e);
              var i = r.attrHandle[t.toLowerCase()],
                a = i && M.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !v) : void 0;
              return void 0 !== a ? a : n.attributes || !v ? e.getAttribute(t) : (a = e.getAttributeNode(t)) && a.specified ? a.value : null;
            }),
            (se.escape = function (e) {
              return (e + "").replace(re, ie);
            }),
            (se.error = function (e) {
              throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (se.uniqueSort = function (e) {
              var t,
                r = [],
                i = 0,
                a = 0;
              if (((d = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(O), d)) {
                for (; (t = e[a++]); ) t === e[a] && (i = r.push(a));
                for (; i--; ) e.splice(r[i], 1);
              }
              return (c = null), e;
            }),
            (i = se.getText = function (e) {
              var t,
                n = "",
                r = 0,
                a = e.nodeType;
              if (a) {
                if (1 === a || 9 === a || 11 === a) {
                  if ("string" == typeof e.textContent) return e.textContent;
                  for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
                } else if (3 === a || 4 === a) return e.nodeValue;
              } else for (; (t = e[r++]); ) n += i(t);
              return n;
            }),
            (r = se.selectors = {
              cacheLength: 50,
              createPseudo: ue,
              match: X,
              attrHandle: {},
              find: {},
              relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
              preFilter: {
                ATTR: function (e) {
                  return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function (e) {
                  return (
                    (e[1] = e[1].toLowerCase()),
                    "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && se.error(e[0]),
                    e
                  );
                },
                PSEUDO: function (e) {
                  var t,
                    n = !e[6] && e[2];
                  return X.CHILD.test(e[0])
                    ? null
                    : (e[3] ? (e[2] = e[4] || e[5] || "") : n && Y.test(n) && (t = o(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                },
              },
              filter: {
                TAG: function (e) {
                  var t = e.replace(te, ne).toLowerCase();
                  return "*" === e
                    ? function () {
                        return !0;
                      }
                    : function (e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t;
                      };
                },
                CLASS: function (e) {
                  var t = T[e + " "];
                  return (
                    t ||
                    ((t = new RegExp("(^|[\\x20\\t\\r\\n\\f])" + e + "(" + B + "|$)")) &&
                      T(e, function (e) {
                        return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                      }))
                  );
                },
                ATTR: function (e, t, n) {
                  return function (r) {
                    var i = se.attr(r, e);
                    return null == i
                      ? "!=" === t
                      : !t ||
                          ((i += ""),
                          "=" === t
                            ? i === n
                            : "!=" === t
                            ? i !== n
                            : "^=" === t
                            ? n && 0 === i.indexOf(n)
                            : "*=" === t
                            ? n && i.indexOf(n) > -1
                            : "$=" === t
                            ? n && i.slice(-n.length) === n
                            : "~=" === t
                            ? (" " + i.replace(F, " ") + " ").indexOf(n) > -1
                            : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                  };
                },
                CHILD: function (e, t, n, r, i) {
                  var a = "nth" !== e.slice(0, 3),
                    o = "last" !== e.slice(-4),
                    s = "of-type" === t;
                  return 1 === r && 0 === i
                    ? function (e) {
                        return !!e.parentNode;
                      }
                    : function (t, n, l) {
                        var u,
                          c,
                          d,
                          f,
                          p,
                          h,
                          v = a !== o ? "nextSibling" : "previousSibling",
                          g = t.parentNode,
                          m = s && t.nodeName.toLowerCase(),
                          y = !l && !s,
                          b = !1;
                        if (g) {
                          if (a) {
                            for (; v; ) {
                              for (f = t; (f = f[v]); ) if (s ? f.nodeName.toLowerCase() === m : 1 === f.nodeType) return !1;
                              h = v = "only" === e && !h && "nextSibling";
                            }
                            return !0;
                          }
                          if (((h = [o ? g.firstChild : g.lastChild]), o && y)) {
                            for (b = (p = (u = (c = (d = (f = g)[w] || (f[w] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === x && u[1]) && u[2], f = p && g.childNodes[p]; (f = (++p && f && f[v]) || (b = p = 0) || h.pop()); )
                              if (1 === f.nodeType && ++b && f === t) {
                                c[e] = [x, p, b];
                                break;
                              }
                          } else if ((y && (b = p = (u = (c = (d = (f = t)[w] || (f[w] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === x && u[1]), !1 === b))
                            for (
                              ;
                              (f = (++p && f && f[v]) || (b = p = 0) || h.pop()) &&
                              ((s ? f.nodeName.toLowerCase() !== m : 1 !== f.nodeType) || !++b || (y && ((c = (d = f[w] || (f[w] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] = [x, b]), f !== t));

                            );
                          return (b -= i) === r || (b % r == 0 && b / r >= 0);
                        }
                      };
                },
                PSEUDO: function (e, t) {
                  var n,
                    i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                  return i[w]
                    ? i(t)
                    : i.length > 1
                    ? ((n = [e, e, "", t]),
                      r.setFilters.hasOwnProperty(e.toLowerCase())
                        ? ue(function (e, n) {
                            for (var r, a = i(e, t), o = a.length; o--; ) e[(r = z(e, a[o]))] = !(n[r] = a[o]);
                          })
                        : function (e) {
                            return i(e, 0, n);
                          })
                    : i;
                },
              },
              pseudos: {
                not: ue(function (e) {
                  var t = [],
                    n = [],
                    r = s(e.replace(H, "$1"));
                  return r[w]
                    ? ue(function (e, t, n, i) {
                        for (var a, o = r(e, null, i, []), s = e.length; s--; ) (a = o[s]) && (e[s] = !(t[s] = a));
                      })
                    : function (e, i, a) {
                        return (t[0] = e), r(t, null, a, n), (t[0] = null), !n.pop();
                      };
                }),
                has: ue(function (e) {
                  return function (t) {
                    return se(e, t).length > 0;
                  };
                }),
                contains: ue(function (e) {
                  return (
                    (e = e.replace(te, ne)),
                    function (t) {
                      return (t.textContent || i(t)).indexOf(e) > -1;
                    }
                  );
                }),
                lang: ue(function (e) {
                  return (
                    G.test(e || "") || se.error("unsupported lang: " + e),
                    (e = e.replace(te, ne).toLowerCase()),
                    function (t) {
                      var n;
                      do {
                        if ((n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                      } while ((t = t.parentNode) && 1 === t.nodeType);
                      return !1;
                    }
                  );
                }),
                target: function (t) {
                  var n = e.location && e.location.hash;
                  return n && n.slice(1) === t.id;
                },
                root: function (e) {
                  return e === h;
                },
                focus: function (e) {
                  return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: ve(!1),
                disabled: ve(!0),
                checked: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                  return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                  for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                  return !0;
                },
                parent: function (e) {
                  return !r.pseudos.empty(e);
                },
                header: function (e) {
                  return Q.test(e.nodeName);
                },
                input: function (e) {
                  return K.test(e.nodeName);
                },
                button: function (e) {
                  var t = e.nodeName.toLowerCase();
                  return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                  var t;
                  return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: ge(function () {
                  return [0];
                }),
                last: ge(function (e, t) {
                  return [t - 1];
                }),
                eq: ge(function (e, t, n) {
                  return [n < 0 ? n + t : n];
                }),
                even: ge(function (e, t) {
                  for (var n = 0; n < t; n += 2) e.push(n);
                  return e;
                }),
                odd: ge(function (e, t) {
                  for (var n = 1; n < t; n += 2) e.push(n);
                  return e;
                }),
                lt: ge(function (e, t, n) {
                  for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0; ) e.push(r);
                  return e;
                }),
                gt: ge(function (e, t, n) {
                  for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                  return e;
                }),
              },
            }),
            (r.pseudos.nth = r.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              r.pseudos[t] = pe(t);
            for (t in { submit: !0, reset: !0 }) r.pseudos[t] = he(t);
            function ye() {}
            function be(e) {
              for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
              return r;
            }
            function we(e, t, n) {
              var r = t.dir,
                i = t.next,
                a = i || r,
                o = n && "parentNode" === a,
                s = C++;
              return t.first
                ? function (t, n, i) {
                    for (; (t = t[r]); ) if (1 === t.nodeType || o) return e(t, n, i);
                    return !1;
                  }
                : function (t, n, l) {
                    var u,
                      c,
                      d,
                      f = [x, s];
                    if (l) {
                      for (; (t = t[r]); ) if ((1 === t.nodeType || o) && e(t, n, l)) return !0;
                    } else
                      for (; (t = t[r]); )
                        if (1 === t.nodeType || o)
                          if (((c = (d = t[w] || (t[w] = {}))[t.uniqueID] || (d[t.uniqueID] = {})), i && i === t.nodeName.toLowerCase())) t = t[r] || t;
                          else {
                            if ((u = c[a]) && u[0] === x && u[1] === s) return (f[2] = u[2]);
                            if (((c[a] = f), (f[2] = e(t, n, l)))) return !0;
                          }
                    return !1;
                  };
            }
            function _e(e) {
              return e.length > 1
                ? function (t, n, r) {
                    for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
                    return !0;
                  }
                : e[0];
            }
            function xe(e, t, n, r, i) {
              for (var a, o = [], s = 0, l = e.length, u = null != t; s < l; s++) (a = e[s]) && ((n && !n(a, r, i)) || (o.push(a), u && t.push(s)));
              return o;
            }
            function Ce(e, t, n, r, i, a) {
              return (
                r && !r[w] && (r = Ce(r)),
                i && !i[w] && (i = Ce(i, a)),
                ue(function (a, o, s, l) {
                  var u,
                    c,
                    d,
                    f = [],
                    p = [],
                    h = o.length,
                    v =
                      a ||
                      (function (e, t, n) {
                        for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                        return n;
                      })(t || "*", s.nodeType ? [s] : s, []),
                    g = !e || (!a && t) ? v : xe(v, f, e, s, l),
                    m = n ? (i || (a ? e : h || r) ? [] : o) : g;
                  if ((n && n(g, m, s, l), r)) for (u = xe(m, p), r(u, [], s, l), c = u.length; c--; ) (d = u[c]) && (m[p[c]] = !(g[p[c]] = d));
                  if (a) {
                    if (i || e) {
                      if (i) {
                        for (u = [], c = m.length; c--; ) (d = m[c]) && u.push((g[c] = d));
                        i(null, (m = []), u, l);
                      }
                      for (c = m.length; c--; ) (d = m[c]) && (u = i ? z(a, d) : f[c]) > -1 && (a[u] = !(o[u] = d));
                    }
                  } else (m = xe(m === o ? m.splice(h, m.length) : m)), i ? i(null, o, m, l) : I.apply(o, m);
                })
              );
            }
            function Te(e) {
              for (
                var t,
                  n,
                  i,
                  a = e.length,
                  o = r.relative[e[0].type],
                  s = o || r.relative[" "],
                  l = o ? 1 : 0,
                  c = we(
                    function (e) {
                      return e === t;
                    },
                    s,
                    !0
                  ),
                  d = we(
                    function (e) {
                      return z(t, e) > -1;
                    },
                    s,
                    !0
                  ),
                  f = [
                    function (e, n, r) {
                      var i = (!o && (r || n !== u)) || ((t = n).nodeType ? c(e, n, r) : d(e, n, r));
                      return (t = null), i;
                    },
                  ];
                l < a;
                l++
              )
                if ((n = r.relative[e[l].type])) f = [we(_e(f), n)];
                else {
                  if ((n = r.filter[e[l].type].apply(null, e[l].matches))[w]) {
                    for (i = ++l; i < a && !r.relative[e[i].type]; i++);
                    return Ce(l > 1 && _e(f), l > 1 && be(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(H, "$1"), n, l < i && Te(e.slice(l, i)), i < a && Te((e = e.slice(i))), i < a && be(e));
                  }
                  f.push(n);
                }
              return _e(f);
            }
            return (
              (ye.prototype = r.filters = r.pseudos),
              (r.setFilters = new ye()),
              (o = se.tokenize = function (e, t) {
                var n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  u,
                  c = k[e + " "];
                if (c) return t ? 0 : c.slice(0);
                for (s = e, l = [], u = r.preFilter; s; ) {
                  for (o in ((n && !(i = W.exec(s))) || (i && (s = s.slice(i[0].length) || s), l.push((a = []))),
                  (n = !1),
                  (i = $.exec(s)) && ((n = i.shift()), a.push({ value: n, type: i[0].replace(H, " ") }), (s = s.slice(n.length))),
                  r.filter))
                    !(i = X[o].exec(s)) || (u[o] && !(i = u[o](i))) || ((n = i.shift()), a.push({ value: n, type: o, matches: i }), (s = s.slice(n.length)));
                  if (!n) break;
                }
                return t ? s.length : s ? se.error(e) : k(e, l).slice(0);
              }),
              (s = se.compile = function (e, t) {
                var n,
                  i = [],
                  a = [],
                  s = E[e + " "];
                if (!s) {
                  for (t || (t = o(e)), n = t.length; n--; ) (s = Te(t[n]))[w] ? i.push(s) : a.push(s);
                  (s = E(
                    e,
                    (function (e, t) {
                      var n = t.length > 0,
                        i = e.length > 0,
                        a = function (a, o, s, l, c) {
                          var d,
                            h,
                            g,
                            m = 0,
                            y = "0",
                            b = a && [],
                            w = [],
                            _ = u,
                            C = a || (i && r.find.TAG("*", c)),
                            T = (x += null == _ ? 1 : Math.random() || 0.1),
                            k = C.length;
                          for (c && (u = o == p || o || c); y !== k && null != (d = C[y]); y++) {
                            if (i && d) {
                              for (h = 0, o || d.ownerDocument == p || (f(d), (s = !v)); (g = e[h++]); )
                                if (g(d, o || p, s)) {
                                  l.push(d);
                                  break;
                                }
                              c && (x = T);
                            }
                            n && ((d = !g && d) && m--, a && b.push(d));
                          }
                          if (((m += y), n && y !== m)) {
                            for (h = 0; (g = t[h++]); ) g(b, w, o, s);
                            if (a) {
                              if (m > 0) for (; y--; ) b[y] || w[y] || (w[y] = A.call(l));
                              w = xe(w);
                            }
                            I.apply(l, w), c && !a && w.length > 0 && m + t.length > 1 && se.uniqueSort(l);
                          }
                          return c && ((x = T), (u = _)), b;
                        };
                      return n ? ue(a) : a;
                    })(a, i)
                  )),
                    (s.selector = e);
                }
                return s;
              }),
              (l = se.select = function (e, t, n, i) {
                var a,
                  l,
                  u,
                  c,
                  d,
                  f = "function" == typeof e && e,
                  p = !i && o((e = f.selector || e));
                if (((n = n || []), 1 === p.length)) {
                  if ((l = p[0] = p[0].slice(0)).length > 2 && "ID" === (u = l[0]).type && 9 === t.nodeType && v && r.relative[l[1].type]) {
                    if (!(t = (r.find.ID(u.matches[0].replace(te, ne), t) || [])[0])) return n;
                    f && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                  }
                  for (a = X.needsContext.test(e) ? 0 : l.length; a-- && ((u = l[a]), !r.relative[(c = u.type)]); )
                    if ((d = r.find[c]) && (i = d(u.matches[0].replace(te, ne), (ee.test(l[0].type) && me(t.parentNode)) || t))) {
                      if ((l.splice(a, 1), !(e = i.length && be(l)))) return I.apply(n, i), n;
                      break;
                    }
                }
                return (f || s(e, p))(i, t, !v, n, !t || (ee.test(e) && me(t.parentNode)) || t), n;
              }),
              (n.sortStable = w.split("").sort(O).join("") === w),
              (n.detectDuplicates = !!d),
              f(),
              (n.sortDetached = ce(function (e) {
                return 1 & e.compareDocumentPosition(p.createElement("fieldset"));
              })),
              ce(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
              }) ||
                de("type|href|height|width", function (e, t, n) {
                  if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
              (n.attributes &&
                ce(function (e) {
                  return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                de("value", function (e, t, n) {
                  if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
              ce(function (e) {
                return null == e.getAttribute("disabled");
              }) ||
                de(j, function (e, t, n) {
                  var r;
                  if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                }),
              se
            );
          })(r);
          (T.find = E), (T.expr = E.selectors), (T.expr[":"] = T.expr.pseudos), (T.uniqueSort = T.unique = E.uniqueSort), (T.text = E.getText), (T.isXMLDoc = E.isXML), (T.contains = E.contains), (T.escapeSelector = E.escape);
          var S = function (e, t, n) {
              for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                  if (i && T(e).is(n)) break;
                  r.push(e);
                }
              return r;
            },
            O = function (e, t) {
              for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            M = T.expr.match.needsContext;
          function P(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function L(e, t, n) {
            return m(t)
              ? T.grep(e, function (e, r) {
                  return !!t.call(e, r, e) !== n;
                })
              : t.nodeType
              ? T.grep(e, function (e) {
                  return (e === t) !== n;
                })
              : "string" != typeof t
              ? T.grep(e, function (e) {
                  return c.call(t, e) > -1 !== n;
                })
              : T.filter(t, e, n);
          }
          (T.filter = function (e, t, n) {
            var r = t[0];
            return (
              n && (e = ":not(" + e + ")"),
              1 === t.length && 1 === r.nodeType
                ? T.find.matchesSelector(r, e)
                  ? [r]
                  : []
                : T.find.matches(
                    e,
                    T.grep(t, function (e) {
                      return 1 === e.nodeType;
                    })
                  )
            );
          }),
            T.fn.extend({
              find: function (e) {
                var t,
                  n,
                  r = this.length,
                  i = this;
                if ("string" != typeof e)
                  return this.pushStack(
                    T(e).filter(function () {
                      for (t = 0; t < r; t++) if (T.contains(i[t], this)) return !0;
                    })
                  );
                for (n = this.pushStack([]), t = 0; t < r; t++) T.find(e, i[t], n);
                return r > 1 ? T.uniqueSort(n) : n;
              },
              filter: function (e) {
                return this.pushStack(L(this, e || [], !1));
              },
              not: function (e) {
                return this.pushStack(L(this, e || [], !0));
              },
              is: function (e) {
                return !!L(this, "string" == typeof e && M.test(e) ? T(e) : e || [], !1).length;
              },
            });
          var I,
            D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((T.fn.init = function (e, t, n) {
            var r, i;
            if (!e) return this;
            if (((n = n || I), "string" == typeof e)) {
              if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : D.exec(e)) || (!r[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
              if (r[1]) {
                if (((t = t instanceof T ? t[0] : t), T.merge(this, T.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : b, !0)), A.test(r[1]) && T.isPlainObject(t))) for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
              }
              return (i = b.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
            }
            return e.nodeType ? ((this[0] = e), (this.length = 1), this) : m(e) ? (void 0 !== n.ready ? n.ready(e) : e(T)) : T.makeArray(e, this);
          }).prototype = T.fn),
            (I = T(b));
          var z = /^(?:parents|prev(?:Until|All))/,
            j = { children: !0, contents: !0, next: !0, prev: !0 };
          function B(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
          }
          T.fn.extend({
            has: function (e) {
              var t = T(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++) if (T.contains(this, t[e])) return !0;
              });
            },
            closest: function (e, t) {
              var n,
                r = 0,
                i = this.length,
                a = [],
                o = "string" != typeof e && T(e);
              if (!M.test(e))
                for (; r < i; r++)
                  for (n = this[r]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (o ? o.index(n) > -1 : 1 === n.nodeType && T.find.matchesSelector(n, e))) {
                      a.push(n);
                      break;
                    }
              return this.pushStack(a.length > 1 ? T.uniqueSort(a) : a);
            },
            index: function (e) {
              return e ? ("string" == typeof e ? c.call(T(e), this[0]) : c.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (e, t) {
              return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))));
            },
            addBack: function (e) {
              return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
          }),
            T.each(
              {
                parent: function (e) {
                  var t = e.parentNode;
                  return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                  return S(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                  return S(e, "parentNode", n);
                },
                next: function (e) {
                  return B(e, "nextSibling");
                },
                prev: function (e) {
                  return B(e, "previousSibling");
                },
                nextAll: function (e) {
                  return S(e, "nextSibling");
                },
                prevAll: function (e) {
                  return S(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                  return S(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                  return S(e, "previousSibling", n);
                },
                siblings: function (e) {
                  return O((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                  return O(e.firstChild);
                },
                contents: function (e) {
                  return null != e.contentDocument && o(e.contentDocument) ? e.contentDocument : (P(e, "template") && (e = e.content || e), T.merge([], e.childNodes));
                },
              },
              function (e, t) {
                T.fn[e] = function (n, r) {
                  var i = T.map(this, t, n);
                  return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = T.filter(r, i)), this.length > 1 && (j[e] || T.uniqueSort(i), z.test(e) && i.reverse()), this.pushStack(i);
                };
              }
            );
          var N = /[^\x20\t\r\n\f]+/g;
          function R(e) {
            return e;
          }
          function q(e) {
            throw e;
          }
          function F(e, t, n, r) {
            var i;
            try {
              e && m((i = e.promise)) ? i.call(e).done(t).fail(n) : e && m((i = e.then)) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          (T.Callbacks = function (e) {
            e =
              "string" == typeof e
                ? (function (e) {
                    var t = {};
                    return (
                      T.each(e.match(N) || [], function (e, n) {
                        t[n] = !0;
                      }),
                      t
                    );
                  })(e)
                : T.extend({}, e);
            var t,
              n,
              r,
              i,
              a = [],
              o = [],
              s = -1,
              l = function () {
                for (i = i || e.once, r = t = !0; o.length; s = -1) for (n = o.shift(); ++s < a.length; ) !1 === a[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = a.length), (n = !1));
                e.memory || (n = !1), (t = !1), i && (a = n ? [] : "");
              },
              u = {
                add: function () {
                  return (
                    a &&
                      (n && !t && ((s = a.length - 1), o.push(n)),
                      (function t(n) {
                        T.each(n, function (n, r) {
                          m(r) ? (e.unique && u.has(r)) || a.push(r) : r && r.length && "string" !== x(r) && t(r);
                        });
                      })(arguments),
                      n && !t && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    T.each(arguments, function (e, t) {
                      for (var n; (n = T.inArray(t, a, n)) > -1; ) a.splice(n, 1), n <= s && s--;
                    }),
                    this
                  );
                },
                has: function (e) {
                  return e ? T.inArray(e, a) > -1 : a.length > 0;
                },
                empty: function () {
                  return a && (a = []), this;
                },
                disable: function () {
                  return (i = o = []), (a = n = ""), this;
                },
                disabled: function () {
                  return !a;
                },
                lock: function () {
                  return (i = o = []), n || t || (a = n = ""), this;
                },
                locked: function () {
                  return !!i;
                },
                fireWith: function (e, n) {
                  return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), o.push(n), t || l()), this;
                },
                fire: function () {
                  return u.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!r;
                },
              };
            return u;
          }),
            T.extend({
              Deferred: function (e) {
                var t = [
                    ["notify", "progress", T.Callbacks("memory"), T.Callbacks("memory"), 2],
                    ["resolve", "done", T.Callbacks("once memory"), T.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", T.Callbacks("once memory"), T.Callbacks("once memory"), 1, "rejected"],
                  ],
                  n = "pending",
                  i = {
                    state: function () {
                      return n;
                    },
                    always: function () {
                      return a.done(arguments).fail(arguments), this;
                    },
                    catch: function (e) {
                      return i.then(null, e);
                    },
                    pipe: function () {
                      var e = arguments;
                      return T.Deferred(function (n) {
                        T.each(t, function (t, r) {
                          var i = m(e[r[4]]) && e[r[4]];
                          a[r[1]](function () {
                            var e = i && i.apply(this, arguments);
                            e && m(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this, i ? [e] : arguments);
                          });
                        }),
                          (e = null);
                      }).promise();
                    },
                    then: function (e, n, i) {
                      var a = 0;
                      function o(e, t, n, i) {
                        return function () {
                          var s = this,
                            l = arguments,
                            u = function () {
                              var r, u;
                              if (!(e < a)) {
                                if ((r = n.apply(s, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
                                (u = r && ("object" == typeof r || "function" == typeof r) && r.then),
                                  m(u) ? (i ? u.call(r, o(a, t, R, i), o(a, t, q, i)) : (a++, u.call(r, o(a, t, R, i), o(a, t, q, i), o(a, t, R, t.notifyWith)))) : (n !== R && ((s = void 0), (l = [r])), (i || t.resolveWith)(s, l));
                              }
                            },
                            c = i
                              ? u
                              : function () {
                                  try {
                                    u();
                                  } catch (r) {
                                    T.Deferred.exceptionHook && T.Deferred.exceptionHook(r, c.stackTrace), e + 1 >= a && (n !== q && ((s = void 0), (l = [r])), t.rejectWith(s, l));
                                  }
                                };
                          e ? c() : (T.Deferred.getStackHook && (c.stackTrace = T.Deferred.getStackHook()), r.setTimeout(c));
                        };
                      }
                      return T.Deferred(function (r) {
                        t[0][3].add(o(0, r, m(i) ? i : R, r.notifyWith)), t[1][3].add(o(0, r, m(e) ? e : R)), t[2][3].add(o(0, r, m(n) ? n : q));
                      }).promise();
                    },
                    promise: function (e) {
                      return null != e ? T.extend(e, i) : i;
                    },
                  },
                  a = {};
                return (
                  T.each(t, function (e, r) {
                    var o = r[2],
                      s = r[5];
                    (i[r[1]] = o.add),
                      s &&
                        o.add(
                          function () {
                            n = s;
                          },
                          t[3 - e][2].disable,
                          t[3 - e][3].disable,
                          t[0][2].lock,
                          t[0][3].lock
                        ),
                      o.add(r[3].fire),
                      (a[r[0]] = function () {
                        return a[r[0] + "With"](this === a ? void 0 : this, arguments), this;
                      }),
                      (a[r[0] + "With"] = o.fireWith);
                  }),
                  i.promise(a),
                  e && e.call(a, a),
                  a
                );
              },
              when: function (e) {
                var t = arguments.length,
                  n = t,
                  r = Array(n),
                  i = s.call(arguments),
                  a = T.Deferred(),
                  o = function (e) {
                    return function (n) {
                      (r[e] = this), (i[e] = arguments.length > 1 ? s.call(arguments) : n), --t || a.resolveWith(r, i);
                    };
                  };
                if (t <= 1 && (F(e, a.done(o(n)).resolve, a.reject, !t), "pending" === a.state() || m(i[n] && i[n].then))) return a.then();
                for (; n--; ) F(i[n], o(n), a.reject);
                return a.promise();
              },
            });
          var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (T.Deferred.exceptionHook = function (e, t) {
            r.console && r.console.warn && e && H.test(e.name) && r.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
          }),
            (T.readyException = function (e) {
              r.setTimeout(function () {
                throw e;
              });
            });
          var W = T.Deferred();
          function $() {
            b.removeEventListener("DOMContentLoaded", $), r.removeEventListener("load", $), T.ready();
          }
          (T.fn.ready = function (e) {
            return (
              W.then(e).catch(function (e) {
                T.readyException(e);
              }),
              this
            );
          }),
            T.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (e) {
                (!0 === e ? --T.readyWait : T.isReady) || ((T.isReady = !0), (!0 !== e && --T.readyWait > 0) || W.resolveWith(b, [T]));
              },
            }),
            (T.ready.then = W.then),
            "complete" === b.readyState || ("loading" !== b.readyState && !b.documentElement.doScroll) ? r.setTimeout(T.ready) : (b.addEventListener("DOMContentLoaded", $), r.addEventListener("load", $));
          var V = function (e, t, n, r, i, a, o) {
              var s = 0,
                l = e.length,
                u = null == n;
              if ("object" === x(n)) for (s in ((i = !0), n)) V(e, t, s, n[s], !0, a, o);
              else if (
                void 0 !== r &&
                ((i = !0),
                m(r) || (o = !0),
                u &&
                  (o
                    ? (t.call(e, r), (t = null))
                    : ((u = t),
                      (t = function (e, t, n) {
                        return u.call(T(e), n);
                      }))),
                t)
              )
                for (; s < l; s++) t(e[s], n, o ? r : r.call(e[s], s, t(e[s], n)));
              return i ? e : u ? t.call(e) : l ? t(e[0], n) : a;
            },
            Y = /^-ms-/,
            G = /-([a-z])/g;
          function X(e, t) {
            return t.toUpperCase();
          }
          function U(e) {
            return e.replace(Y, "ms-").replace(G, X);
          }
          var K = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function Q() {
            this.expando = T.expando + Q.uid++;
          }
          (Q.uid = 1),
            (Q.prototype = {
              cache: function (e) {
                var t = e[this.expando];
                return t || ((t = {}), K(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
              },
              set: function (e, t, n) {
                var r,
                  i = this.cache(e);
                if ("string" == typeof t) i[U(t)] = n;
                else for (r in t) i[U(r)] = t[r];
                return i;
              },
              get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)];
              },
              access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
              },
              remove: function (e, t) {
                var n,
                  r = e[this.expando];
                if (void 0 !== r) {
                  if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(U) : (t = U(t)) in r ? [t] : t.match(N) || []).length;
                    for (; n--; ) delete r[t[n]];
                  }
                  (void 0 === t || T.isEmptyObject(r)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
              },
              hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !T.isEmptyObject(t);
              },
            });
          var Z = new Q(),
            J = new Q(),
            ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            te = /[A-Z]/g;
          function ne(e, t, n) {
            var r;
            if (void 0 === n && 1 === e.nodeType)
              if (((r = "data-" + t.replace(te, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                try {
                  n = (function (e) {
                    return "true" === e || ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e));
                  })(n);
                } catch (e) {}
                J.set(e, t, n);
              } else n = void 0;
            return n;
          }
          T.extend({
            hasData: function (e) {
              return J.hasData(e) || Z.hasData(e);
            },
            data: function (e, t, n) {
              return J.access(e, t, n);
            },
            removeData: function (e, t) {
              J.remove(e, t);
            },
            _data: function (e, t, n) {
              return Z.access(e, t, n);
            },
            _removeData: function (e, t) {
              Z.remove(e, t);
            },
          }),
            T.fn.extend({
              data: function (e, t) {
                var n,
                  r,
                  i,
                  a = this[0],
                  o = a && a.attributes;
                if (void 0 === e) {
                  if (this.length && ((i = J.get(a)), 1 === a.nodeType && !Z.get(a, "hasDataAttrs"))) {
                    for (n = o.length; n--; ) o[n] && 0 === (r = o[n].name).indexOf("data-") && ((r = U(r.slice(5))), ne(a, r, i[r]));
                    Z.set(a, "hasDataAttrs", !0);
                  }
                  return i;
                }
                return "object" == typeof e
                  ? this.each(function () {
                      J.set(this, e);
                    })
                  : V(
                      this,
                      function (t) {
                        var n;
                        if (a && void 0 === t) return void 0 !== (n = J.get(a, e)) || void 0 !== (n = ne(a, e)) ? n : void 0;
                        this.each(function () {
                          J.set(this, e, t);
                        });
                      },
                      null,
                      t,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (e) {
                return this.each(function () {
                  J.remove(this, e);
                });
              },
            }),
            T.extend({
              queue: function (e, t, n) {
                var r;
                if (e) return (t = (t || "fx") + "queue"), (r = Z.get(e, t)), n && (!r || Array.isArray(n) ? (r = Z.access(e, t, T.makeArray(n))) : r.push(n)), r || [];
              },
              dequeue: function (e, t) {
                t = t || "fx";
                var n = T.queue(e, t),
                  r = n.length,
                  i = n.shift(),
                  a = T._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                  i &&
                    ("fx" === t && n.unshift("inprogress"),
                    delete a.stop,
                    i.call(
                      e,
                      function () {
                        T.dequeue(e, t);
                      },
                      a
                    )),
                  !r && a && a.empty.fire();
              },
              _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                  Z.get(e, n) ||
                  Z.access(e, n, {
                    empty: T.Callbacks("once memory").add(function () {
                      Z.remove(e, [t + "queue", n]);
                    }),
                  })
                );
              },
            }),
            T.fn.extend({
              queue: function (e, t) {
                var n = 2;
                return (
                  "string" != typeof e && ((t = e), (e = "fx"), n--),
                  arguments.length < n
                    ? T.queue(this[0], e)
                    : void 0 === t
                    ? this
                    : this.each(function () {
                        var n = T.queue(this, e, t);
                        T._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && T.dequeue(this, e);
                      })
                );
              },
              dequeue: function (e) {
                return this.each(function () {
                  T.dequeue(this, e);
                });
              },
              clearQueue: function (e) {
                return this.queue(e || "fx", []);
              },
              promise: function (e, t) {
                var n,
                  r = 1,
                  i = T.Deferred(),
                  a = this,
                  o = this.length,
                  s = function () {
                    --r || i.resolveWith(a, [a]);
                  };
                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; o--; ) (n = Z.get(a[o], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                return s(), i.promise(t);
              },
            });
          var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
            ae = ["Top", "Right", "Bottom", "Left"],
            oe = b.documentElement,
            se = function (e) {
              return T.contains(e.ownerDocument, e);
            },
            le = { composed: !0 };
          oe.getRootNode &&
            (se = function (e) {
              return T.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
            });
          var ue = function (e, t) {
            return "none" === (e = t || e).style.display || ("" === e.style.display && se(e) && "none" === T.css(e, "display"));
          };
          function ce(e, t, n, r) {
            var i,
              a,
              o = 20,
              s = r
                ? function () {
                    return r.cur();
                  }
                : function () {
                    return T.css(e, t, "");
                  },
              l = s(),
              u = (n && n[3]) || (T.cssNumber[t] ? "" : "px"),
              c = e.nodeType && (T.cssNumber[t] || ("px" !== u && +l)) && ie.exec(T.css(e, t));
            if (c && c[3] !== u) {
              for (l /= 2, u = u || c[3], c = +l || 1; o--; ) T.style(e, t, c + u), (1 - a) * (1 - (a = s() / l || 0.5)) <= 0 && (o = 0), (c /= a);
              (c *= 2), T.style(e, t, c + u), (n = n || []);
            }
            return n && ((c = +c || +l || 0), (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), r && ((r.unit = u), (r.start = c), (r.end = i))), i;
          }
          var de = {};
          function fe(e) {
            var t,
              n = e.ownerDocument,
              r = e.nodeName,
              i = de[r];
            return i || ((t = n.body.appendChild(n.createElement(r))), (i = T.css(t, "display")), t.parentNode.removeChild(t), "none" === i && (i = "block"), (de[r] = i), i);
          }
          function pe(e, t) {
            for (var n, r, i = [], a = 0, o = e.length; a < o; a++)
              (r = e[a]).style &&
                ((n = r.style.display),
                t ? ("none" === n && ((i[a] = Z.get(r, "display") || null), i[a] || (r.style.display = "")), "" === r.style.display && ue(r) && (i[a] = fe(r))) : "none" !== n && ((i[a] = "none"), Z.set(r, "display", n)));
            for (a = 0; a < o; a++) null != i[a] && (e[a].style.display = i[a]);
            return e;
          }
          T.fn.extend({
            show: function () {
              return pe(this, !0);
            },
            hide: function () {
              return pe(this);
            },
            toggle: function (e) {
              return "boolean" == typeof e
                ? e
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ue(this) ? T(this).show() : T(this).hide();
                  });
            },
          });
          var he,
            ve,
            ge = /^(?:checkbox|radio)$/i,
            me = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            ye = /^$|^module$|\/(?:java|ecma)script/i;
          (he = b.createDocumentFragment().appendChild(b.createElement("div"))),
            (ve = b.createElement("input")).setAttribute("type", "radio"),
            ve.setAttribute("checked", "checked"),
            ve.setAttribute("name", "t"),
            he.appendChild(ve),
            (g.checkClone = he.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (he.innerHTML = "<textarea>x</textarea>"),
            (g.noCloneChecked = !!he.cloneNode(!0).lastChild.defaultValue),
            (he.innerHTML = "<option></option>"),
            (g.option = !!he.lastChild);
          var be = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
          };
          function we(e, t) {
            var n;
            return (n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && P(e, t)) ? T.merge([e], n) : n;
          }
          function _e(e, t) {
            for (var n = 0, r = e.length; n < r; n++) Z.set(e[n], "globalEval", !t || Z.get(t[n], "globalEval"));
          }
          (be.tbody = be.tfoot = be.colgroup = be.caption = be.thead), (be.th = be.td), g.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);
          var xe = /<|&#?\w+;/;
          function Ce(e, t, n, r, i) {
            for (var a, o, s, l, u, c, d = t.createDocumentFragment(), f = [], p = 0, h = e.length; p < h; p++)
              if ((a = e[p]) || 0 === a)
                if ("object" === x(a)) T.merge(f, a.nodeType ? [a] : a);
                else if (xe.test(a)) {
                  for (o = o || d.appendChild(t.createElement("div")), s = (me.exec(a) || ["", ""])[1].toLowerCase(), l = be[s] || be._default, o.innerHTML = l[1] + T.htmlPrefilter(a) + l[2], c = l[0]; c--; ) o = o.lastChild;
                  T.merge(f, o.childNodes), ((o = d.firstChild).textContent = "");
                } else f.push(t.createTextNode(a));
            for (d.textContent = "", p = 0; (a = f[p++]); )
              if (r && T.inArray(a, r) > -1) i && i.push(a);
              else if (((u = se(a)), (o = we(d.appendChild(a), "script")), u && _e(o), n)) for (c = 0; (a = o[c++]); ) ye.test(a.type || "") && n.push(a);
            return d;
          }
          var Te = /^([^.]*)(?:\.(.+)|)/;
          function ke() {
            return !0;
          }
          function Ee() {
            return !1;
          }
          function Se(e, t) {
            return (
              (e ===
                (function () {
                  try {
                    return b.activeElement;
                  } catch (e) {}
                })()) ==
              ("focus" === t)
            );
          }
          function Oe(e, t, n, r, i, a) {
            var o, s;
            if ("object" == typeof t) {
              for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) Oe(e, s, n, r, t[s], a);
              return e;
            }
            if ((null == r && null == i ? ((i = n), (r = n = void 0)) : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))), !1 === i)) i = Ee;
            else if (!i) return e;
            return (
              1 === a &&
                ((o = i),
                (i = function (e) {
                  return T().off(e), o.apply(this, arguments);
                }),
                (i.guid = o.guid || (o.guid = T.guid++))),
              e.each(function () {
                T.event.add(this, t, i, r, n);
              })
            );
          }
          function Me(e, t, n) {
            n
              ? (Z.set(e, t, !1),
                T.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                    var r,
                      i,
                      a = Z.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                      if (a.length) (T.event.special[t] || {}).delegateType && e.stopPropagation();
                      else if (((a = s.call(arguments)), Z.set(this, t, a), (r = n(this, t)), this[t](), a !== (i = Z.get(this, t)) || r ? Z.set(this, t, !1) : (i = {}), a !== i))
                        return e.stopImmediatePropagation(), e.preventDefault(), i && i.value;
                    } else a.length && (Z.set(this, t, { value: T.event.trigger(T.extend(a[0], T.Event.prototype), a.slice(1), this) }), e.stopImmediatePropagation());
                  },
                }))
              : void 0 === Z.get(e, t) && T.event.add(e, t, ke);
          }
          (T.event = {
            global: {},
            add: function (e, t, n, r, i) {
              var a,
                o,
                s,
                l,
                u,
                c,
                d,
                f,
                p,
                h,
                v,
                g = Z.get(e);
              if (K(e))
                for (
                  n.handler && ((n = (a = n).handler), (i = a.selector)),
                    i && T.find.matchesSelector(oe, i),
                    n.guid || (n.guid = T.guid++),
                    (l = g.events) || (l = g.events = Object.create(null)),
                    (o = g.handle) ||
                      (o = g.handle = function (t) {
                        return void 0 !== T && T.event.triggered !== t.type ? T.event.dispatch.apply(e, arguments) : void 0;
                      }),
                    u = (t = (t || "").match(N) || [""]).length;
                  u--;

                )
                  (p = v = (s = Te.exec(t[u]) || [])[1]),
                    (h = (s[2] || "").split(".").sort()),
                    p &&
                      ((d = T.event.special[p] || {}),
                      (p = (i ? d.delegateType : d.bindType) || p),
                      (d = T.event.special[p] || {}),
                      (c = T.extend({ type: p, origType: v, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && T.expr.match.needsContext.test(i), namespace: h.join(".") }, a)),
                      (f = l[p]) || (((f = l[p] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(e, r, h, o)) || (e.addEventListener && e.addEventListener(p, o))),
                      d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                      i ? f.splice(f.delegateCount++, 0, c) : f.push(c),
                      (T.event.global[p] = !0));
            },
            remove: function (e, t, n, r, i) {
              var a,
                o,
                s,
                l,
                u,
                c,
                d,
                f,
                p,
                h,
                v,
                g = Z.hasData(e) && Z.get(e);
              if (g && (l = g.events)) {
                for (u = (t = (t || "").match(N) || [""]).length; u--; )
                  if (((p = v = (s = Te.exec(t[u]) || [])[1]), (h = (s[2] || "").split(".").sort()), p)) {
                    for (d = T.event.special[p] || {}, f = l[(p = (r ? d.delegateType : d.bindType) || p)] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), o = a = f.length; a--; )
                      (c = f[a]),
                        (!i && v !== c.origType) ||
                          (n && n.guid !== c.guid) ||
                          (s && !s.test(c.namespace)) ||
                          (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                          (f.splice(a, 1), c.selector && f.delegateCount--, d.remove && d.remove.call(e, c));
                    o && !f.length && ((d.teardown && !1 !== d.teardown.call(e, h, g.handle)) || T.removeEvent(e, p, g.handle), delete l[p]);
                  } else for (p in l) T.event.remove(e, p + t[u], n, r, !0);
                T.isEmptyObject(l) && Z.remove(e, "handle events");
              }
            },
            dispatch: function (e) {
              var t,
                n,
                r,
                i,
                a,
                o,
                s = new Array(arguments.length),
                l = T.event.fix(e),
                u = (Z.get(this, "events") || Object.create(null))[l.type] || [],
                c = T.event.special[l.type] || {};
              for (s[0] = l, t = 1; t < arguments.length; t++) s[t] = arguments[t];
              if (((l.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, l))) {
                for (o = T.event.handlers.call(this, l, u), t = 0; (i = o[t++]) && !l.isPropagationStopped(); )
                  for (l.currentTarget = i.elem, n = 0; (a = i.handlers[n++]) && !l.isImmediatePropagationStopped(); )
                    (l.rnamespace && !1 !== a.namespace && !l.rnamespace.test(a.namespace)) ||
                      ((l.handleObj = a), (l.data = a.data), void 0 !== (r = ((T.event.special[a.origType] || {}).handle || a.handler).apply(i.elem, s)) && !1 === (l.result = r) && (l.preventDefault(), l.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (e, t) {
              var n,
                r,
                i,
                a,
                o,
                s = [],
                l = t.delegateCount,
                u = e.target;
              if (l && u.nodeType && !("click" === e.type && e.button >= 1))
                for (; u !== this; u = u.parentNode || this)
                  if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                    for (a = [], o = {}, n = 0; n < l; n++) void 0 === o[(i = (r = t[n]).selector + " ")] && (o[i] = r.needsContext ? T(i, this).index(u) > -1 : T.find(i, this, null, [u]).length), o[i] && a.push(r);
                    a.length && s.push({ elem: u, handlers: a });
                  }
              return (u = this), l < t.length && s.push({ elem: u, handlers: t.slice(l) }), s;
            },
            addProp: function (e, t) {
              Object.defineProperty(T.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: m(t)
                  ? function () {
                      if (this.originalEvent) return t(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[e];
                    },
                set: function (t) {
                  Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                },
              });
            },
            fix: function (e) {
              return e[T.expando] ? e : new T.Event(e);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (e) {
                  var t = this || e;
                  return ge.test(t.type) && t.click && P(t, "input") && Me(t, "click", ke), !1;
                },
                trigger: function (e) {
                  var t = this || e;
                  return ge.test(t.type) && t.click && P(t, "input") && Me(t, "click"), !0;
                },
                _default: function (e) {
                  var t = e.target;
                  return (ge.test(t.type) && t.click && P(t, "input") && Z.get(t, "click")) || P(t, "a");
                },
              },
              beforeunload: {
                postDispatch: function (e) {
                  void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
              },
            },
          }),
            (T.removeEvent = function (e, t, n) {
              e.removeEventListener && e.removeEventListener(t, n);
            }),
            (T.Event = function (e, t) {
              if (!(this instanceof T.Event)) return new T.Event(e, t);
              e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? ke : Ee),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && T.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[T.expando] = !0);
            }),
            (T.Event.prototype = {
              constructor: T.Event,
              isDefaultPrevented: Ee,
              isPropagationStopped: Ee,
              isImmediatePropagationStopped: Ee,
              isSimulated: !1,
              preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = ke), e && !this.isSimulated && e.preventDefault();
              },
              stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = ke), e && !this.isSimulated && e.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = ke), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
              },
            }),
            T.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              T.event.addProp
            ),
            T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
              T.event.special[e] = {
                setup: function () {
                  return Me(this, e, Se), !1;
                },
                trigger: function () {
                  return Me(this, e), !0;
                },
                _default: function () {
                  return !0;
                },
                delegateType: t,
              };
            }),
            T.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
              T.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function (e) {
                  var n,
                    r = this,
                    i = e.relatedTarget,
                    a = e.handleObj;
                  return (i && (i === r || T.contains(r, i))) || ((e.type = a.origType), (n = a.handler.apply(this, arguments)), (e.type = t)), n;
                },
              };
            }),
            T.fn.extend({
              on: function (e, t, n, r) {
                return Oe(this, e, t, n, r);
              },
              one: function (e, t, n, r) {
                return Oe(this, e, t, n, r, 1);
              },
              off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj) return (r = e.handleObj), T(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                if ("object" == typeof e) {
                  for (i in e) this.off(i, t, e[i]);
                  return this;
                }
                return (
                  (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                  !1 === n && (n = Ee),
                  this.each(function () {
                    T.event.remove(this, e, n, t);
                  })
                );
              },
            });
          var Pe = /<script|<style|<link/i,
            Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Le = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function Ie(e, t) {
            return (P(e, "table") && P(11 !== t.nodeType ? t : t.firstChild, "tr") && T(e).children("tbody")[0]) || e;
          }
          function De(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
          }
          function ze(e) {
            return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
          }
          function je(e, t) {
            var n, r, i, a, o, s;
            if (1 === t.nodeType) {
              if (Z.hasData(e) && (s = Z.get(e).events)) for (i in (Z.remove(t, "handle events"), s)) for (n = 0, r = s[i].length; n < r; n++) T.event.add(t, i, s[i][n]);
              J.hasData(e) && ((a = J.access(e)), (o = T.extend({}, a)), J.set(t, o));
            }
          }
          function Be(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && ge.test(e.type) ? (t.checked = e.checked) : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
          }
          function Ne(e, t, n, r) {
            t = l(t);
            var i,
              a,
              o,
              s,
              u,
              c,
              d = 0,
              f = e.length,
              p = f - 1,
              h = t[0],
              v = m(h);
            if (v || (f > 1 && "string" == typeof h && !g.checkClone && Ae.test(h)))
              return e.each(function (i) {
                var a = e.eq(i);
                v && (t[0] = h.call(this, i, a.html())), Ne(a, t, n, r);
              });
            if (f && ((a = (i = Ce(t, e[0].ownerDocument, !1, e, r)).firstChild), 1 === i.childNodes.length && (i = a), a || r)) {
              for (s = (o = T.map(we(i, "script"), De)).length; d < f; d++) (u = i), d !== p && ((u = T.clone(u, !0, !0)), s && T.merge(o, we(u, "script"))), n.call(e[d], u, d);
              if (s)
                for (c = o[o.length - 1].ownerDocument, T.map(o, ze), d = 0; d < s; d++)
                  (u = o[d]),
                    ye.test(u.type || "") &&
                      !Z.access(u, "globalEval") &&
                      T.contains(c, u) &&
                      (u.src && "module" !== (u.type || "").toLowerCase() ? T._evalUrl && !u.noModule && T._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, c) : _(u.textContent.replace(Le, ""), u, c));
            }
            return e;
          }
          function Re(e, t, n) {
            for (var r, i = t ? T.filter(t, e) : e, a = 0; null != (r = i[a]); a++) n || 1 !== r.nodeType || T.cleanData(we(r)), r.parentNode && (n && se(r) && _e(we(r, "script")), r.parentNode.removeChild(r));
            return e;
          }
          T.extend({
            htmlPrefilter: function (e) {
              return e;
            },
            clone: function (e, t, n) {
              var r,
                i,
                a,
                o,
                s = e.cloneNode(!0),
                l = se(e);
              if (!(g.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || T.isXMLDoc(e))) for (o = we(s), r = 0, i = (a = we(e)).length; r < i; r++) Be(a[r], o[r]);
              if (t)
                if (n) for (a = a || we(e), o = o || we(s), r = 0, i = a.length; r < i; r++) je(a[r], o[r]);
                else je(e, s);
              return (o = we(s, "script")).length > 0 && _e(o, !l && we(e, "script")), s;
            },
            cleanData: function (e) {
              for (var t, n, r, i = T.event.special, a = 0; void 0 !== (n = e[a]); a++)
                if (K(n)) {
                  if ((t = n[Z.expando])) {
                    if (t.events) for (r in t.events) i[r] ? T.event.remove(n, r) : T.removeEvent(n, r, t.handle);
                    n[Z.expando] = void 0;
                  }
                  n[J.expando] && (n[J.expando] = void 0);
                }
            },
          }),
            T.fn.extend({
              detach: function (e) {
                return Re(this, e, !0);
              },
              remove: function (e) {
                return Re(this, e);
              },
              text: function (e) {
                return V(
                  this,
                  function (e) {
                    return void 0 === e
                      ? T.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                        });
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              append: function () {
                return Ne(this, arguments, function (e) {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Ie(this, e).appendChild(e);
                });
              },
              prepend: function () {
                return Ne(this, arguments, function (e) {
                  if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Ie(this, e);
                    t.insertBefore(e, t.firstChild);
                  }
                });
              },
              before: function () {
                return Ne(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this);
                });
              },
              after: function () {
                return Ne(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
              },
              empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (T.cleanData(we(e, !1)), (e.textContent = ""));
                return this;
              },
              clone: function (e, t) {
                return (
                  (e = null != e && e),
                  (t = null == t ? e : t),
                  this.map(function () {
                    return T.clone(this, e, t);
                  })
                );
              },
              html: function (e) {
                return V(
                  this,
                  function (e) {
                    var t = this[0] || {},
                      n = 0,
                      r = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if ("string" == typeof e && !Pe.test(e) && !be[(me.exec(e) || ["", ""])[1].toLowerCase()]) {
                      e = T.htmlPrefilter(e);
                      try {
                        for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (T.cleanData(we(t, !1)), (t.innerHTML = e));
                        t = 0;
                      } catch (e) {}
                    }
                    t && this.empty().append(e);
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              replaceWith: function () {
                var e = [];
                return Ne(
                  this,
                  arguments,
                  function (t) {
                    var n = this.parentNode;
                    T.inArray(this, e) < 0 && (T.cleanData(we(this)), n && n.replaceChild(t, this));
                  },
                  e
                );
              },
            }),
            T.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
              T.fn[e] = function (e) {
                for (var n, r = [], i = T(e), a = i.length - 1, o = 0; o <= a; o++) (n = o === a ? this : this.clone(!0)), T(i[o])[t](n), u.apply(r, n.get());
                return this.pushStack(r);
              };
            });
          var qe = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
            Fe = function (e) {
              var t = e.ownerDocument.defaultView;
              return (t && t.opener) || (t = r), t.getComputedStyle(e);
            },
            He = function (e, t, n) {
              var r,
                i,
                a = {};
              for (i in t) (a[i] = e.style[i]), (e.style[i] = t[i]);
              for (i in ((r = n.call(e)), t)) e.style[i] = a[i];
              return r;
            },
            We = new RegExp(ae.join("|"), "i");
          function $e(e, t, n) {
            var r,
              i,
              a,
              o,
              s = e.style;
            return (
              (n = n || Fe(e)) &&
                ("" !== (o = n.getPropertyValue(t) || n[t]) || se(e) || (o = T.style(e, t)),
                !g.pixelBoxStyles() && qe.test(o) && We.test(t) && ((r = s.width), (i = s.minWidth), (a = s.maxWidth), (s.minWidth = s.maxWidth = s.width = o), (o = n.width), (s.width = r), (s.minWidth = i), (s.maxWidth = a))),
              void 0 !== o ? o + "" : o
            );
          }
          function Ve(e, t) {
            return {
              get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function e() {
              if (c) {
                (u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                  (c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                  oe.appendChild(u).appendChild(c);
                var e = r.getComputedStyle(c);
                (n = "1%" !== e.top),
                  (l = 12 === t(e.marginLeft)),
                  (c.style.right = "60%"),
                  (o = 36 === t(e.right)),
                  (i = 36 === t(e.width)),
                  (c.style.position = "absolute"),
                  (a = 12 === t(c.offsetWidth / 3)),
                  oe.removeChild(u),
                  (c = null);
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              i,
              a,
              o,
              s,
              l,
              u = b.createElement("div"),
              c = b.createElement("div");
            c.style &&
              ((c.style.backgroundClip = "content-box"),
              (c.cloneNode(!0).style.backgroundClip = ""),
              (g.clearCloneStyle = "content-box" === c.style.backgroundClip),
              T.extend(g, {
                boxSizingReliable: function () {
                  return e(), i;
                },
                pixelBoxStyles: function () {
                  return e(), o;
                },
                pixelPosition: function () {
                  return e(), n;
                },
                reliableMarginLeft: function () {
                  return e(), l;
                },
                scrollboxSize: function () {
                  return e(), a;
                },
                reliableTrDimensions: function () {
                  var e, t, n, i;
                  return (
                    null == s &&
                      ((e = b.createElement("table")),
                      (t = b.createElement("tr")),
                      (n = b.createElement("div")),
                      (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                      (t.style.cssText = "border:1px solid"),
                      (t.style.height = "1px"),
                      (n.style.height = "9px"),
                      (n.style.display = "block"),
                      oe.appendChild(e).appendChild(t).appendChild(n),
                      (i = r.getComputedStyle(t)),
                      (s = parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) === t.offsetHeight),
                      oe.removeChild(e)),
                    s
                  );
                },
              }));
          })();
          var Ye = ["Webkit", "Moz", "ms"],
            Ge = b.createElement("div").style,
            Xe = {};
          function Ue(e) {
            return (
              T.cssProps[e] ||
              Xe[e] ||
              (e in Ge
                ? e
                : (Xe[e] =
                    (function (e) {
                      for (var t = e[0].toUpperCase() + e.slice(1), n = Ye.length; n--; ) if ((e = Ye[n] + t) in Ge) return e;
                    })(e) || e))
            );
          }
          var Ke = /^(none|table(?!-c[ea]).+)/,
            Qe = /^--/,
            Ze = { position: "absolute", visibility: "hidden", display: "block" },
            Je = { letterSpacing: "0", fontWeight: "400" };
          function et(e, t, n) {
            var r = ie.exec(t);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
          }
          function tt(e, t, n, r, i, a) {
            var o = "width" === t ? 1 : 0,
              s = 0,
              l = 0;
            if (n === (r ? "border" : "content")) return 0;
            for (; o < 4; o += 2)
              "margin" === n && (l += T.css(e, n + ae[o], !0, i)),
                r
                  ? ("content" === n && (l -= T.css(e, "padding" + ae[o], !0, i)), "margin" !== n && (l -= T.css(e, "border" + ae[o] + "Width", !0, i)))
                  : ((l += T.css(e, "padding" + ae[o], !0, i)), "padding" !== n ? (l += T.css(e, "border" + ae[o] + "Width", !0, i)) : (s += T.css(e, "border" + ae[o] + "Width", !0, i)));
            return !r && a >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - a - l - s - 0.5)) || 0), l;
          }
          function nt(e, t, n) {
            var r = Fe(e),
              i = (!g.boxSizingReliable() || n) && "border-box" === T.css(e, "boxSizing", !1, r),
              a = i,
              o = $e(e, t, r),
              s = "offset" + t[0].toUpperCase() + t.slice(1);
            if (qe.test(o)) {
              if (!n) return o;
              o = "auto";
            }
            return (
              ((!g.boxSizingReliable() && i) || (!g.reliableTrDimensions() && P(e, "tr")) || "auto" === o || (!parseFloat(o) && "inline" === T.css(e, "display", !1, r))) &&
                e.getClientRects().length &&
                ((i = "border-box" === T.css(e, "boxSizing", !1, r)), (a = s in e) && (o = e[s])),
              (o = parseFloat(o) || 0) + tt(e, t, n || (i ? "border" : "content"), a, r, o) + "px"
            );
          }
          function rt(e, t, n, r, i) {
            return new rt.prototype.init(e, t, n, r, i);
          }
          T.extend({
            cssHooks: {
              opacity: {
                get: function (e, t) {
                  if (t) {
                    var n = $e(e, "opacity");
                    return "" === n ? "1" : n;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (e, t, n, r) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                  a,
                  o,
                  s = U(t),
                  l = Qe.test(t),
                  u = e.style;
                if ((l || (t = Ue(s)), (o = T.cssHooks[t] || T.cssHooks[s]), void 0 === n)) return o && "get" in o && void 0 !== (i = o.get(e, !1, r)) ? i : u[t];
                "string" == (a = typeof n) && (i = ie.exec(n)) && i[1] && ((n = ce(e, t, i)), (a = "number")),
                  null != n &&
                    n == n &&
                    ("number" !== a || l || (n += (i && i[3]) || (T.cssNumber[s] ? "" : "px")),
                    g.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"),
                    (o && "set" in o && void 0 === (n = o.set(e, n, r))) || (l ? u.setProperty(t, n) : (u[t] = n)));
              }
            },
            css: function (e, t, n, r) {
              var i,
                a,
                o,
                s = U(t);
              return (
                Qe.test(t) || (t = Ue(s)),
                (o = T.cssHooks[t] || T.cssHooks[s]) && "get" in o && (i = o.get(e, !0, n)),
                void 0 === i && (i = $e(e, t, r)),
                "normal" === i && t in Je && (i = Je[t]),
                "" === n || n ? ((a = parseFloat(i)), !0 === n || isFinite(a) ? a || 0 : i) : i
              );
            },
          }),
            T.each(["height", "width"], function (e, t) {
              T.cssHooks[t] = {
                get: function (e, n, r) {
                  if (n)
                    return !Ke.test(T.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                      ? nt(e, t, r)
                      : He(e, Ze, function () {
                          return nt(e, t, r);
                        });
                },
                set: function (e, n, r) {
                  var i,
                    a = Fe(e),
                    o = !g.scrollboxSize() && "absolute" === a.position,
                    s = (o || r) && "border-box" === T.css(e, "boxSizing", !1, a),
                    l = r ? tt(e, t, r, s, a) : 0;
                  return (
                    s && o && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(a[t]) - tt(e, t, "border", !1, a) - 0.5)),
                    l && (i = ie.exec(n)) && "px" !== (i[3] || "px") && ((e.style[t] = n), (n = T.css(e, t))),
                    et(0, n, l)
                  );
                },
              };
            }),
            (T.cssHooks.marginLeft = Ve(g.reliableMarginLeft, function (e, t) {
              if (t)
                return (
                  (parseFloat($e(e, "marginLeft")) ||
                    e.getBoundingClientRect().left -
                      He(e, { marginLeft: 0 }, function () {
                        return e.getBoundingClientRect().left;
                      })) + "px"
                );
            })),
            T.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
              (T.cssHooks[e + t] = {
                expand: function (n) {
                  for (var r = 0, i = {}, a = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) i[e + ae[r] + t] = a[r] || a[r - 2] || a[0];
                  return i;
                },
              }),
                "margin" !== e && (T.cssHooks[e + t].set = et);
            }),
            T.fn.extend({
              css: function (e, t) {
                return V(
                  this,
                  function (e, t, n) {
                    var r,
                      i,
                      a = {},
                      o = 0;
                    if (Array.isArray(t)) {
                      for (r = Fe(e), i = t.length; o < i; o++) a[t[o]] = T.css(e, t[o], !1, r);
                      return a;
                    }
                    return void 0 !== n ? T.style(e, t, n) : T.css(e, t);
                  },
                  e,
                  t,
                  arguments.length > 1
                );
              },
            }),
            (T.Tween = rt),
            (rt.prototype = {
              constructor: rt,
              init: function (e, t, n, r, i, a) {
                (this.elem = e), (this.prop = n), (this.easing = i || T.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = r), (this.unit = a || (T.cssNumber[n] ? "" : "px"));
              },
              cur: function () {
                var e = rt.propHooks[this.prop];
                return e && e.get ? e.get(this) : rt.propHooks._default.get(this);
              },
              run: function (e) {
                var t,
                  n = rt.propHooks[this.prop];
                return (
                  this.options.duration ? (this.pos = t = T.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                  (this.now = (this.end - this.start) * t + this.start),
                  this.options.step && this.options.step.call(this.elem, this.now, this),
                  n && n.set ? n.set(this) : rt.propHooks._default.set(this),
                  this
                );
              },
            }),
            (rt.prototype.init.prototype = rt.prototype),
            (rt.propHooks = {
              _default: {
                get: function (e) {
                  var t;
                  return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = T.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                },
                set: function (e) {
                  T.fx.step[e.prop] ? T.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!T.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)]) ? (e.elem[e.prop] = e.now) : T.style(e.elem, e.prop, e.now + e.unit);
                },
              },
            }),
            (rt.propHooks.scrollTop = rt.propHooks.scrollLeft = {
              set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
              },
            }),
            (T.easing = {
              linear: function (e) {
                return e;
              },
              swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
              },
              _default: "swing",
            }),
            (T.fx = rt.prototype.init),
            (T.fx.step = {});
          var it,
            at,
            ot = /^(?:toggle|show|hide)$/,
            st = /queueHooks$/;
          function lt() {
            at && (!1 === b.hidden && r.requestAnimationFrame ? r.requestAnimationFrame(lt) : r.setTimeout(lt, T.fx.interval), T.fx.tick());
          }
          function ut() {
            return (
              r.setTimeout(function () {
                it = void 0;
              }),
              (it = Date.now())
            );
          }
          function ct(e, t) {
            var n,
              r = 0,
              i = { height: e };
            for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = ae[r])] = i["padding" + n] = e;
            return t && (i.opacity = i.width = e), i;
          }
          function dt(e, t, n) {
            for (var r, i = (ft.tweeners[t] || []).concat(ft.tweeners["*"]), a = 0, o = i.length; a < o; a++) if ((r = i[a].call(n, t, e))) return r;
          }
          function ft(e, t, n) {
            var r,
              i,
              a = 0,
              o = ft.prefilters.length,
              s = T.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (i) return !1;
                for (var t = it || ut(), n = Math.max(0, u.startTime + u.duration - t), r = 1 - (n / u.duration || 0), a = 0, o = u.tweens.length; a < o; a++) u.tweens[a].run(r);
                return s.notifyWith(e, [u, r, n]), r < 1 && o ? n : (o || s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u]), !1);
              },
              u = s.promise({
                elem: e,
                props: T.extend({}, t),
                opts: T.extend(!0, { specialEasing: {}, easing: T.easing._default }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: it || ut(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                  var r = T.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                  return u.tweens.push(r), r;
                },
                stop: function (t) {
                  var n = 0,
                    r = t ? u.tweens.length : 0;
                  if (i) return this;
                  for (i = !0; n < r; n++) u.tweens[n].run(1);
                  return t ? (s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u, t])) : s.rejectWith(e, [u, t]), this;
                },
              }),
              c = u.props;
            for (
              (function (e, t) {
                var n, r, i, a, o;
                for (n in e)
                  if (((i = t[(r = U(n))]), (a = e[n]), Array.isArray(a) && ((i = a[1]), (a = e[n] = a[0])), n !== r && ((e[r] = a), delete e[n]), (o = T.cssHooks[r]) && ("expand" in o)))
                    for (n in ((a = o.expand(a)), delete e[r], a)) (n in e) || ((e[n] = a[n]), (t[n] = i));
                  else t[r] = i;
              })(c, u.opts.specialEasing);
              a < o;
              a++
            )
              if ((r = ft.prefilters[a].call(u, e, c, u.opts))) return m(r.stop) && (T._queueHooks(u.elem, u.opts.queue).stop = r.stop.bind(r)), r;
            return (
              T.map(c, dt, u),
              m(u.opts.start) && u.opts.start.call(e, u),
              u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
              T.fx.timer(T.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
              u
            );
          }
          (T.Animation = T.extend(ft, {
            tweeners: {
              "*": [
                function (e, t) {
                  var n = this.createTween(e, t);
                  return ce(n.elem, e, ie.exec(t), n), n;
                },
              ],
            },
            tweener: function (e, t) {
              m(e) ? ((t = e), (e = ["*"])) : (e = e.match(N));
              for (var n, r = 0, i = e.length; r < i; r++) (n = e[r]), (ft.tweeners[n] = ft.tweeners[n] || []), ft.tweeners[n].unshift(t);
            },
            prefilters: [
              function (e, t, n) {
                var r,
                  i,
                  a,
                  o,
                  s,
                  l,
                  u,
                  c,
                  d = "width" in t || "height" in t,
                  f = this,
                  p = {},
                  h = e.style,
                  v = e.nodeType && ue(e),
                  g = Z.get(e, "fxshow");
                for (r in (n.queue ||
                  (null == (o = T._queueHooks(e, "fx")).unqueued &&
                    ((o.unqueued = 0),
                    (s = o.empty.fire),
                    (o.empty.fire = function () {
                      o.unqueued || s();
                    })),
                  o.unqueued++,
                  f.always(function () {
                    f.always(function () {
                      o.unqueued--, T.queue(e, "fx").length || o.empty.fire();
                    });
                  })),
                t))
                  if (((i = t[r]), ot.test(i))) {
                    if ((delete t[r], (a = a || "toggle" === i), i === (v ? "hide" : "show"))) {
                      if ("show" !== i || !g || void 0 === g[r]) continue;
                      v = !0;
                    }
                    p[r] = (g && g[r]) || T.style(e, r);
                  }
                if ((l = !T.isEmptyObject(t)) || !T.isEmptyObject(p))
                  for (r in (d &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (u = g && g.display) && (u = Z.get(e, "display")),
                    "none" === (c = T.css(e, "display")) && (u ? (c = u) : (pe([e], !0), (u = e.style.display || u), (c = T.css(e, "display")), pe([e]))),
                    ("inline" === c || ("inline-block" === c && null != u)) &&
                      "none" === T.css(e, "float") &&
                      (l ||
                        (f.done(function () {
                          h.display = u;
                        }),
                        null == u && ((c = h.display), (u = "none" === c ? "" : c))),
                      (h.display = "inline-block"))),
                  n.overflow &&
                    ((h.overflow = "hidden"),
                    f.always(function () {
                      (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                    })),
                  (l = !1),
                  p))
                    l ||
                      (g ? "hidden" in g && (v = g.hidden) : (g = Z.access(e, "fxshow", { display: u })),
                      a && (g.hidden = !v),
                      v && pe([e], !0),
                      f.done(function () {
                        for (r in (v || pe([e]), Z.remove(e, "fxshow"), p)) T.style(e, r, p[r]);
                      })),
                      (l = dt(v ? g[r] : 0, r, f)),
                      r in g || ((g[r] = l.start), v && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (e, t) {
              t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
            },
          })),
            (T.speed = function (e, t, n) {
              var r = e && "object" == typeof e ? T.extend({}, e) : { complete: n || (!n && t) || (m(e) && e), duration: e, easing: (n && t) || (t && !m(t) && t) };
              return (
                T.fx.off ? (r.duration = 0) : "number" != typeof r.duration && (r.duration in T.fx.speeds ? (r.duration = T.fx.speeds[r.duration]) : (r.duration = T.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                  m(r.old) && r.old.call(this), r.queue && T.dequeue(this, r.queue);
                }),
                r
              );
            }),
            T.fn.extend({
              fadeTo: function (e, t, n, r) {
                return this.filter(ue).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
              },
              animate: function (e, t, n, r) {
                var i = T.isEmptyObject(e),
                  a = T.speed(t, n, r),
                  o = function () {
                    var t = ft(this, T.extend({}, e), a);
                    (i || Z.get(this, "finish")) && t.stop(!0);
                  };
                return (o.finish = o), i || !1 === a.queue ? this.each(o) : this.queue(a.queue, o);
              },
              stop: function (e, t, n) {
                var r = function (e) {
                  var t = e.stop;
                  delete e.stop, t(n);
                };
                return (
                  "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                  t && this.queue(e || "fx", []),
                  this.each(function () {
                    var t = !0,
                      i = null != e && e + "queueHooks",
                      a = T.timers,
                      o = Z.get(this);
                    if (i) o[i] && o[i].stop && r(o[i]);
                    else for (i in o) o[i] && o[i].stop && st.test(i) && r(o[i]);
                    for (i = a.length; i--; ) a[i].elem !== this || (null != e && a[i].queue !== e) || (a[i].anim.stop(n), (t = !1), a.splice(i, 1));
                    (!t && n) || T.dequeue(this, e);
                  })
                );
              },
              finish: function (e) {
                return (
                  !1 !== e && (e = e || "fx"),
                  this.each(function () {
                    var t,
                      n = Z.get(this),
                      r = n[e + "queue"],
                      i = n[e + "queueHooks"],
                      a = T.timers,
                      o = r ? r.length : 0;
                    for (n.finish = !0, T.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = a.length; t--; ) a[t].elem === this && a[t].queue === e && (a[t].anim.stop(!0), a.splice(t, 1));
                    for (t = 0; t < o; t++) r[t] && r[t].finish && r[t].finish.call(this);
                    delete n.finish;
                  })
                );
              },
            }),
            T.each(["toggle", "show", "hide"], function (e, t) {
              var n = T.fn[t];
              T.fn[t] = function (e, r, i) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ct(t, !0), e, r, i);
              };
            }),
            T.each({ slideDown: ct("show"), slideUp: ct("hide"), slideToggle: ct("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
              T.fn[e] = function (e, n, r) {
                return this.animate(t, e, n, r);
              };
            }),
            (T.timers = []),
            (T.fx.tick = function () {
              var e,
                t = 0,
                n = T.timers;
              for (it = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
              n.length || T.fx.stop(), (it = void 0);
            }),
            (T.fx.timer = function (e) {
              T.timers.push(e), T.fx.start();
            }),
            (T.fx.interval = 13),
            (T.fx.start = function () {
              at || ((at = !0), lt());
            }),
            (T.fx.stop = function () {
              at = null;
            }),
            (T.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (T.fn.delay = function (e, t) {
              return (
                (e = (T.fx && T.fx.speeds[e]) || e),
                (t = t || "fx"),
                this.queue(t, function (t, n) {
                  var i = r.setTimeout(t, e);
                  n.stop = function () {
                    r.clearTimeout(i);
                  };
                })
              );
            }),
            (function () {
              var e = b.createElement("input"),
                t = b.createElement("select").appendChild(b.createElement("option"));
              (e.type = "checkbox"), (g.checkOn = "" !== e.value), (g.optSelected = t.selected), ((e = b.createElement("input")).value = "t"), (e.type = "radio"), (g.radioValue = "t" === e.value);
            })();
          var pt,
            ht = T.expr.attrHandle;
          T.fn.extend({
            attr: function (e, t) {
              return V(this, T.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
              return this.each(function () {
                T.removeAttr(this, e);
              });
            },
          }),
            T.extend({
              attr: function (e, t, n) {
                var r,
                  i,
                  a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a)
                  return void 0 === e.getAttribute
                    ? T.prop(e, t, n)
                    : ((1 === a && T.isXMLDoc(e)) || (i = T.attrHooks[t.toLowerCase()] || (T.expr.match.bool.test(t) ? pt : void 0)),
                      void 0 !== n
                        ? null === n
                          ? void T.removeAttr(e, t)
                          : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                          ? r
                          : (e.setAttribute(t, n + ""), n)
                        : i && "get" in i && null !== (r = i.get(e, t))
                        ? r
                        : null == (r = T.find.attr(e, t))
                        ? void 0
                        : r);
              },
              attrHooks: {
                type: {
                  set: function (e, t) {
                    if (!g.radioValue && "radio" === t && P(e, "input")) {
                      var n = e.value;
                      return e.setAttribute("type", t), n && (e.value = n), t;
                    }
                  },
                },
              },
              removeAttr: function (e, t) {
                var n,
                  r = 0,
                  i = t && t.match(N);
                if (i && 1 === e.nodeType) for (; (n = i[r++]); ) e.removeAttribute(n);
              },
            }),
            (pt = {
              set: function (e, t, n) {
                return !1 === t ? T.removeAttr(e, n) : e.setAttribute(n, n), n;
              },
            }),
            T.each(T.expr.match.bool.source.match(/\w+/g), function (e, t) {
              var n = ht[t] || T.find.attr;
              ht[t] = function (e, t, r) {
                var i,
                  a,
                  o = t.toLowerCase();
                return r || ((a = ht[o]), (ht[o] = i), (i = null != n(e, t, r) ? o : null), (ht[o] = a)), i;
              };
            });
          var vt = /^(?:input|select|textarea|button)$/i,
            gt = /^(?:a|area)$/i;
          function mt(e) {
            return (e.match(N) || []).join(" ");
          }
          function yt(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
          }
          function bt(e) {
            return Array.isArray(e) ? e : ("string" == typeof e && e.match(N)) || [];
          }
          T.fn.extend({
            prop: function (e, t) {
              return V(this, T.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
              return this.each(function () {
                delete this[T.propFix[e] || e];
              });
            },
          }),
            T.extend({
              prop: function (e, t, n) {
                var r,
                  i,
                  a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a)
                  return (
                    (1 === a && T.isXMLDoc(e)) || ((t = T.propFix[t] || t), (i = T.propHooks[t])),
                    void 0 !== n ? (i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e[t] = n)) : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (e) {
                    var t = T.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : vt.test(e.nodeName) || (gt.test(e.nodeName) && e.href) ? 0 : -1;
                  },
                },
              },
              propFix: { for: "htmlFor", class: "className" },
            }),
            g.optSelected ||
              (T.propHooks.selected = {
                get: function (e) {
                  var t = e.parentNode;
                  return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                  var t = e.parentNode;
                  t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
              }),
            T.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
              T.propFix[this.toLowerCase()] = this;
            }),
            T.fn.extend({
              addClass: function (e) {
                var t,
                  n,
                  r,
                  i,
                  a,
                  o,
                  s,
                  l = 0;
                if (m(e))
                  return this.each(function (t) {
                    T(this).addClass(e.call(this, t, yt(this)));
                  });
                if ((t = bt(e)).length)
                  for (; (n = this[l++]); )
                    if (((i = yt(n)), (r = 1 === n.nodeType && " " + mt(i) + " "))) {
                      for (o = 0; (a = t[o++]); ) r.indexOf(" " + a + " ") < 0 && (r += a + " ");
                      i !== (s = mt(r)) && n.setAttribute("class", s);
                    }
                return this;
              },
              removeClass: function (e) {
                var t,
                  n,
                  r,
                  i,
                  a,
                  o,
                  s,
                  l = 0;
                if (m(e))
                  return this.each(function (t) {
                    T(this).removeClass(e.call(this, t, yt(this)));
                  });
                if (!arguments.length) return this.attr("class", "");
                if ((t = bt(e)).length)
                  for (; (n = this[l++]); )
                    if (((i = yt(n)), (r = 1 === n.nodeType && " " + mt(i) + " "))) {
                      for (o = 0; (a = t[o++]); ) for (; r.indexOf(" " + a + " ") > -1; ) r = r.replace(" " + a + " ", " ");
                      i !== (s = mt(r)) && n.setAttribute("class", s);
                    }
                return this;
              },
              toggleClass: function (e, t) {
                var n = typeof e,
                  r = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && r
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : m(e)
                  ? this.each(function (n) {
                      T(this).toggleClass(e.call(this, n, yt(this), t), t);
                    })
                  : this.each(function () {
                      var t, i, a, o;
                      if (r) for (i = 0, a = T(this), o = bt(e); (t = o[i++]); ) a.hasClass(t) ? a.removeClass(t) : a.addClass(t);
                      else (void 0 !== e && "boolean" !== n) || ((t = yt(this)) && Z.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Z.get(this, "__className__") || ""));
                    });
              },
              hasClass: function (e) {
                var t,
                  n,
                  r = 0;
                for (t = " " + e + " "; (n = this[r++]); ) if (1 === n.nodeType && (" " + mt(yt(n)) + " ").indexOf(t) > -1) return !0;
                return !1;
              },
            });
          var wt = /\r/g;
          T.fn.extend({
            val: function (e) {
              var t,
                n,
                r,
                i = this[0];
              return arguments.length
                ? ((r = m(e)),
                  this.each(function (n) {
                    var i;
                    1 === this.nodeType &&
                      (null == (i = r ? e.call(this, n, T(this).val()) : e)
                        ? (i = "")
                        : "number" == typeof i
                        ? (i += "")
                        : Array.isArray(i) &&
                          (i = T.map(i, function (e) {
                            return null == e ? "" : e + "";
                          })),
                      ((t = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value")) || (this.value = i));
                  }))
                : i
                ? (t = T.valHooks[i.type] || T.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value"))
                  ? n
                  : "string" == typeof (n = i.value)
                  ? n.replace(wt, "")
                  : null == n
                  ? ""
                  : n
                : void 0;
            },
          }),
            T.extend({
              valHooks: {
                option: {
                  get: function (e) {
                    var t = T.find.attr(e, "value");
                    return null != t ? t : mt(T.text(e));
                  },
                },
                select: {
                  get: function (e) {
                    var t,
                      n,
                      r,
                      i = e.options,
                      a = e.selectedIndex,
                      o = "select-one" === e.type,
                      s = o ? null : [],
                      l = o ? a + 1 : i.length;
                    for (r = a < 0 ? l : o ? a : 0; r < l; r++)
                      if (((n = i[r]).selected || r === a) && !n.disabled && (!n.parentNode.disabled || !P(n.parentNode, "optgroup"))) {
                        if (((t = T(n).val()), o)) return t;
                        s.push(t);
                      }
                    return s;
                  },
                  set: function (e, t) {
                    for (var n, r, i = e.options, a = T.makeArray(t), o = i.length; o--; ) ((r = i[o]).selected = T.inArray(T.valHooks.option.get(r), a) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1), a;
                  },
                },
              },
            }),
            T.each(["radio", "checkbox"], function () {
              (T.valHooks[this] = {
                set: function (e, t) {
                  if (Array.isArray(t)) return (e.checked = T.inArray(T(e).val(), t) > -1);
                },
              }),
                g.checkOn ||
                  (T.valHooks[this].get = function (e) {
                    return null === e.getAttribute("value") ? "on" : e.value;
                  });
            }),
            (g.focusin = "onfocusin" in r);
          var _t = /^(?:focusinfocus|focusoutblur)$/,
            xt = function (e) {
              e.stopPropagation();
            };
          T.extend(T.event, {
            trigger: function (e, t, n, i) {
              var a,
                o,
                s,
                l,
                u,
                c,
                d,
                f,
                h = [n || b],
                v = p.call(e, "type") ? e.type : e,
                g = p.call(e, "namespace") ? e.namespace.split(".") : [];
              if (
                ((o = f = s = n = n || b),
                3 !== n.nodeType &&
                  8 !== n.nodeType &&
                  !_t.test(v + T.event.triggered) &&
                  (v.indexOf(".") > -1 && ((g = v.split(".")), (v = g.shift()), g.sort()),
                  (u = v.indexOf(":") < 0 && "on" + v),
                  ((e = e[T.expando] ? e : new T.Event(v, "object" == typeof e && e)).isTrigger = i ? 2 : 3),
                  (e.namespace = g.join(".")),
                  (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                  (e.result = void 0),
                  e.target || (e.target = n),
                  (t = null == t ? [e] : T.makeArray(t, [e])),
                  (d = T.event.special[v] || {}),
                  i || !d.trigger || !1 !== d.trigger.apply(n, t)))
              ) {
                if (!i && !d.noBubble && !y(n)) {
                  for (l = d.delegateType || v, _t.test(l + v) || (o = o.parentNode); o; o = o.parentNode) h.push(o), (s = o);
                  s === (n.ownerDocument || b) && h.push(s.defaultView || s.parentWindow || r);
                }
                for (a = 0; (o = h[a++]) && !e.isPropagationStopped(); )
                  (f = o),
                    (e.type = a > 1 ? l : d.bindType || v),
                    (c = (Z.get(o, "events") || Object.create(null))[e.type] && Z.get(o, "handle")) && c.apply(o, t),
                    (c = u && o[u]) && c.apply && K(o) && ((e.result = c.apply(o, t)), !1 === e.result && e.preventDefault());
                return (
                  (e.type = v),
                  i ||
                    e.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(h.pop(), t)) ||
                    !K(n) ||
                    (u &&
                      m(n[v]) &&
                      !y(n) &&
                      ((s = n[u]) && (n[u] = null),
                      (T.event.triggered = v),
                      e.isPropagationStopped() && f.addEventListener(v, xt),
                      n[v](),
                      e.isPropagationStopped() && f.removeEventListener(v, xt),
                      (T.event.triggered = void 0),
                      s && (n[u] = s))),
                  e.result
                );
              }
            },
            simulate: function (e, t, n) {
              var r = T.extend(new T.Event(), n, { type: e, isSimulated: !0 });
              T.event.trigger(r, null, t);
            },
          }),
            T.fn.extend({
              trigger: function (e, t) {
                return this.each(function () {
                  T.event.trigger(e, t, this);
                });
              },
              triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return T.event.trigger(e, t, n, !0);
              },
            }),
            g.focusin ||
              T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                  T.event.simulate(t, e.target, T.event.fix(e));
                };
                T.event.special[t] = {
                  setup: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = Z.access(r, t);
                    i || r.addEventListener(e, n, !0), Z.access(r, t, (i || 0) + 1);
                  },
                  teardown: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = Z.access(r, t) - 1;
                    i ? Z.access(r, t, i) : (r.removeEventListener(e, n, !0), Z.remove(r, t));
                  },
                };
              });
          var Ct = r.location,
            Tt = { guid: Date.now() },
            kt = /\?/;
          T.parseXML = function (e) {
            var t, n;
            if (!e || "string" != typeof e) return null;
            try {
              t = new r.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {}
            return (
              (n = t && t.getElementsByTagName("parsererror")[0]),
              (t && !n) ||
                T.error(
                  "Invalid XML: " +
                    (n
                      ? T.map(n.childNodes, function (e) {
                          return e.textContent;
                        }).join("\n")
                      : e)
                ),
              t
            );
          };
          var Et = /\[\]$/,
            St = /\r?\n/g,
            Ot = /^(?:submit|button|image|reset|file)$/i,
            Mt = /^(?:input|select|textarea|keygen)/i;
          function Pt(e, t, n, r) {
            var i;
            if (Array.isArray(t))
              T.each(t, function (t, i) {
                n || Et.test(e) ? r(e, i) : Pt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
              });
            else if (n || "object" !== x(t)) r(e, t);
            else for (i in t) Pt(e + "[" + i + "]", t[i], n, r);
          }
          (T.param = function (e, t) {
            var n,
              r = [],
              i = function (e, t) {
                var n = m(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
              };
            if (null == e) return "";
            if (Array.isArray(e) || (e.jquery && !T.isPlainObject(e)))
              T.each(e, function () {
                i(this.name, this.value);
              });
            else for (n in e) Pt(n, e[n], t, i);
            return r.join("&");
          }),
            T.fn.extend({
              serialize: function () {
                return T.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var e = T.prop(this, "elements");
                  return e ? T.makeArray(e) : this;
                })
                  .filter(function () {
                    var e = this.type;
                    return this.name && !T(this).is(":disabled") && Mt.test(this.nodeName) && !Ot.test(e) && (this.checked || !ge.test(e));
                  })
                  .map(function (e, t) {
                    var n = T(this).val();
                    return null == n
                      ? null
                      : Array.isArray(n)
                      ? T.map(n, function (e) {
                          return { name: t.name, value: e.replace(St, "\r\n") };
                        })
                      : { name: t.name, value: n.replace(St, "\r\n") };
                  })
                  .get();
              },
            });
          var At = /%20/g,
            Lt = /#.*$/,
            It = /([?&])_=[^&]*/,
            Dt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            zt = /^(?:GET|HEAD)$/,
            jt = /^\/\//,
            Bt = {},
            Nt = {},
            Rt = "*/".concat("*"),
            qt = b.createElement("a");
          function Ft(e) {
            return function (t, n) {
              "string" != typeof t && ((n = t), (t = "*"));
              var r,
                i = 0,
                a = t.toLowerCase().match(N) || [];
              if (m(n)) for (; (r = a[i++]); ) "+" === r[0] ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
            };
          }
          function Ht(e, t, n, r) {
            var i = {},
              a = e === Nt;
            function o(s) {
              var l;
              return (
                (i[s] = !0),
                T.each(e[s] || [], function (e, s) {
                  var u = s(t, n, r);
                  return "string" != typeof u || a || i[u] ? (a ? !(l = u) : void 0) : (t.dataTypes.unshift(u), o(u), !1);
                }),
                l
              );
            }
            return o(t.dataTypes[0]) || (!i["*"] && o("*"));
          }
          function Wt(e, t) {
            var n,
              r,
              i = T.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
            return r && T.extend(!0, e, r), e;
          }
          (qt.href = Ct.href),
            T.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: Ct.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ct.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": Rt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": T.parseXML },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (e, t) {
                return t ? Wt(Wt(e, T.ajaxSettings), t) : Wt(T.ajaxSettings, e);
              },
              ajaxPrefilter: Ft(Bt),
              ajaxTransport: Ft(Nt),
              ajax: function (e, t) {
                "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                var n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  u,
                  c,
                  d,
                  f,
                  p = T.ajaxSetup({}, t),
                  h = p.context || p,
                  v = p.context && (h.nodeType || h.jquery) ? T(h) : T.event,
                  g = T.Deferred(),
                  m = T.Callbacks("once memory"),
                  y = p.statusCode || {},
                  w = {},
                  _ = {},
                  x = "canceled",
                  C = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                      var t;
                      if (u) {
                        if (!o) for (o = {}; (t = Dt.exec(a)); ) o[t[1].toLowerCase() + " "] = (o[t[1].toLowerCase() + " "] || []).concat(t[2]);
                        t = o[e.toLowerCase() + " "];
                      }
                      return null == t ? null : t.join(", ");
                    },
                    getAllResponseHeaders: function () {
                      return u ? a : null;
                    },
                    setRequestHeader: function (e, t) {
                      return null == u && ((e = _[e.toLowerCase()] = _[e.toLowerCase()] || e), (w[e] = t)), this;
                    },
                    overrideMimeType: function (e) {
                      return null == u && (p.mimeType = e), this;
                    },
                    statusCode: function (e) {
                      var t;
                      if (e)
                        if (u) C.always(e[C.status]);
                        else for (t in e) y[t] = [y[t], e[t]];
                      return this;
                    },
                    abort: function (e) {
                      var t = e || x;
                      return n && n.abort(t), k(0, t), this;
                    },
                  };
                if (
                  (g.promise(C),
                  (p.url = ((e || p.url || Ct.href) + "").replace(jt, Ct.protocol + "//")),
                  (p.type = t.method || t.type || p.method || p.type),
                  (p.dataTypes = (p.dataType || "*").toLowerCase().match(N) || [""]),
                  null == p.crossDomain)
                ) {
                  l = b.createElement("a");
                  try {
                    (l.href = p.url), (l.href = l.href), (p.crossDomain = qt.protocol + "//" + qt.host != l.protocol + "//" + l.host);
                  } catch (e) {
                    p.crossDomain = !0;
                  }
                }
                if ((p.data && p.processData && "string" != typeof p.data && (p.data = T.param(p.data, p.traditional)), Ht(Bt, p, t, C), u)) return C;
                for (d in ((c = T.event && p.global) && 0 == T.active++ && T.event.trigger("ajaxStart"),
                (p.type = p.type.toUpperCase()),
                (p.hasContent = !zt.test(p.type)),
                (i = p.url.replace(Lt, "")),
                p.hasContent
                  ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(At, "+"))
                  : ((f = p.url.slice(i.length)),
                    p.data && (p.processData || "string" == typeof p.data) && ((i += (kt.test(i) ? "&" : "?") + p.data), delete p.data),
                    !1 === p.cache && ((i = i.replace(It, "$1")), (f = (kt.test(i) ? "&" : "?") + "_=" + Tt.guid++ + f)),
                    (p.url = i + f)),
                p.ifModified && (T.lastModified[i] && C.setRequestHeader("If-Modified-Since", T.lastModified[i]), T.etag[i] && C.setRequestHeader("If-None-Match", T.etag[i])),
                ((p.data && p.hasContent && !1 !== p.contentType) || t.contentType) && C.setRequestHeader("Content-Type", p.contentType),
                C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Rt + "; q=0.01" : "") : p.accepts["*"]),
                p.headers))
                  C.setRequestHeader(d, p.headers[d]);
                if (p.beforeSend && (!1 === p.beforeSend.call(h, C, p) || u)) return C.abort();
                if (((x = "abort"), m.add(p.complete), C.done(p.success), C.fail(p.error), (n = Ht(Nt, p, t, C)))) {
                  if (((C.readyState = 1), c && v.trigger("ajaxSend", [C, p]), u)) return C;
                  p.async &&
                    p.timeout > 0 &&
                    (s = r.setTimeout(function () {
                      C.abort("timeout");
                    }, p.timeout));
                  try {
                    (u = !1), n.send(w, k);
                  } catch (e) {
                    if (u) throw e;
                    k(-1, e);
                  }
                } else k(-1, "No Transport");
                function k(e, t, o, l) {
                  var d,
                    f,
                    b,
                    w,
                    _,
                    x = t;
                  u ||
                    ((u = !0),
                    s && r.clearTimeout(s),
                    (n = void 0),
                    (a = l || ""),
                    (C.readyState = e > 0 ? 4 : 0),
                    (d = (e >= 200 && e < 300) || 304 === e),
                    o &&
                      (w = (function (e, t, n) {
                        for (var r, i, a, o, s = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                        if (r)
                          for (i in s)
                            if (s[i] && s[i].test(r)) {
                              l.unshift(i);
                              break;
                            }
                        if (l[0] in n) a = l[0];
                        else {
                          for (i in n) {
                            if (!l[0] || e.converters[i + " " + l[0]]) {
                              a = i;
                              break;
                            }
                            o || (o = i);
                          }
                          a = a || o;
                        }
                        if (a) return a !== l[0] && l.unshift(a), n[a];
                      })(p, C, o)),
                    !d && T.inArray("script", p.dataTypes) > -1 && T.inArray("json", p.dataTypes) < 0 && (p.converters["text script"] = function () {}),
                    (w = (function (e, t, n, r) {
                      var i,
                        a,
                        o,
                        s,
                        l,
                        u = {},
                        c = e.dataTypes.slice();
                      if (c[1]) for (o in e.converters) u[o.toLowerCase()] = e.converters[o];
                      for (a = c.shift(); a; )
                        if ((e.responseFields[a] && (n[e.responseFields[a]] = t), !l && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = a), (a = c.shift())))
                          if ("*" === a) a = l;
                          else if ("*" !== l && l !== a) {
                            if (!(o = u[l + " " + a] || u["* " + a]))
                              for (i in u)
                                if ((s = i.split(" "))[1] === a && (o = u[l + " " + s[0]] || u["* " + s[0]])) {
                                  !0 === o ? (o = u[i]) : !0 !== u[i] && ((a = s[0]), c.unshift(s[1]));
                                  break;
                                }
                            if (!0 !== o)
                              if (o && e.throws) t = o(t);
                              else
                                try {
                                  t = o(t);
                                } catch (e) {
                                  return { state: "parsererror", error: o ? e : "No conversion from " + l + " to " + a };
                                }
                          }
                      return { state: "success", data: t };
                    })(p, w, C, d)),
                    d
                      ? (p.ifModified && ((_ = C.getResponseHeader("Last-Modified")) && (T.lastModified[i] = _), (_ = C.getResponseHeader("etag")) && (T.etag[i] = _)),
                        204 === e || "HEAD" === p.type ? (x = "nocontent") : 304 === e ? (x = "notmodified") : ((x = w.state), (f = w.data), (d = !(b = w.error))))
                      : ((b = x), (!e && x) || ((x = "error"), e < 0 && (e = 0))),
                    (C.status = e),
                    (C.statusText = (t || x) + ""),
                    d ? g.resolveWith(h, [f, x, C]) : g.rejectWith(h, [C, x, b]),
                    C.statusCode(y),
                    (y = void 0),
                    c && v.trigger(d ? "ajaxSuccess" : "ajaxError", [C, p, d ? f : b]),
                    m.fireWith(h, [C, x]),
                    c && (v.trigger("ajaxComplete", [C, p]), --T.active || T.event.trigger("ajaxStop")));
                }
                return C;
              },
              getJSON: function (e, t, n) {
                return T.get(e, t, n, "json");
              },
              getScript: function (e, t) {
                return T.get(e, void 0, t, "script");
              },
            }),
            T.each(["get", "post"], function (e, t) {
              T[t] = function (e, n, r, i) {
                return m(n) && ((i = i || r), (r = n), (n = void 0)), T.ajax(T.extend({ url: e, type: t, dataType: i, data: n, success: r }, T.isPlainObject(e) && e));
              };
            }),
            T.ajaxPrefilter(function (e) {
              var t;
              for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
            }),
            (T._evalUrl = function (e, t, n) {
              return T.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                  T.globalEval(e, t, n);
                },
              });
            }),
            T.fn.extend({
              wrapAll: function (e) {
                var t;
                return (
                  this[0] &&
                    (m(e) && (e = e.call(this[0])),
                    (t = T(e, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && t.insertBefore(this[0]),
                    t
                      .map(function () {
                        for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                        return e;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (e) {
                return m(e)
                  ? this.each(function (t) {
                      T(this).wrapInner(e.call(this, t));
                    })
                  : this.each(function () {
                      var t = T(this),
                        n = t.contents();
                      n.length ? n.wrapAll(e) : t.append(e);
                    });
              },
              wrap: function (e) {
                var t = m(e);
                return this.each(function (n) {
                  T(this).wrapAll(t ? e.call(this, n) : e);
                });
              },
              unwrap: function (e) {
                return (
                  this.parent(e)
                    .not("body")
                    .each(function () {
                      T(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (T.expr.pseudos.hidden = function (e) {
              return !T.expr.pseudos.visible(e);
            }),
            (T.expr.pseudos.visible = function (e) {
              return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            }),
            (T.ajaxSettings.xhr = function () {
              try {
                return new r.XMLHttpRequest();
              } catch (e) {}
            });
          var $t = { 0: 200, 1223: 204 },
            Vt = T.ajaxSettings.xhr();
          (g.cors = !!Vt && "withCredentials" in Vt),
            (g.ajax = Vt = !!Vt),
            T.ajaxTransport(function (e) {
              var t, n;
              if (g.cors || (Vt && !e.crossDomain))
                return {
                  send: function (i, a) {
                    var o,
                      s = e.xhr();
                    if ((s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (o in e.xhrFields) s[o] = e.xhrFields[o];
                    for (o in (e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i)) s.setRequestHeader(o, i[o]);
                    (t = function (e) {
                      return function () {
                        t &&
                          ((t = n = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null),
                          "abort" === e
                            ? s.abort()
                            : "error" === e
                            ? "number" != typeof s.status
                              ? a(0, "error")
                              : a(s.status, s.statusText)
                            : a($t[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? { binary: s.response } : { text: s.responseText }, s.getAllResponseHeaders()));
                      };
                    }),
                      (s.onload = t()),
                      (n = s.onerror = s.ontimeout = t("error")),
                      void 0 !== s.onabort
                        ? (s.onabort = n)
                        : (s.onreadystatechange = function () {
                            4 === s.readyState &&
                              r.setTimeout(function () {
                                t && n();
                              });
                          }),
                      (t = t("abort"));
                    try {
                      s.send((e.hasContent && e.data) || null);
                    } catch (e) {
                      if (t) throw e;
                    }
                  },
                  abort: function () {
                    t && t();
                  },
                };
            }),
            T.ajaxPrefilter(function (e) {
              e.crossDomain && (e.contents.script = !1);
            }),
            T.ajaxSetup({
              accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                "text script": function (e) {
                  return T.globalEval(e), e;
                },
              },
            }),
            T.ajaxPrefilter("script", function (e) {
              void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            T.ajaxTransport("script", function (e) {
              var t, n;
              if (e.crossDomain || e.scriptAttrs)
                return {
                  send: function (r, i) {
                    (t = T("<script>")
                      .attr(e.scriptAttrs || {})
                      .prop({ charset: e.scriptCharset, src: e.url })
                      .on(
                        "load error",
                        (n = function (e) {
                          t.remove(), (n = null), e && i("error" === e.type ? 404 : 200, e.type);
                        })
                      )),
                      b.head.appendChild(t[0]);
                  },
                  abort: function () {
                    n && n();
                  },
                };
            });
          var Yt,
            Gt = [],
            Xt = /(=)\?(?=&|$)|\?\?/;
          T.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var e = Gt.pop() || T.expando + "_" + Tt.guid++;
              return (this[e] = !0), e;
            },
          }),
            T.ajaxPrefilter("json jsonp", function (e, t, n) {
              var i,
                a,
                o,
                s = !1 !== e.jsonp && (Xt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Xt.test(e.data) && "data");
              if (s || "jsonp" === e.dataTypes[0])
                return (
                  (i = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                  s ? (e[s] = e[s].replace(Xt, "$1" + i)) : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                  (e.converters["script json"] = function () {
                    return o || T.error(i + " was not called"), o[0];
                  }),
                  (e.dataTypes[0] = "json"),
                  (a = r[i]),
                  (r[i] = function () {
                    o = arguments;
                  }),
                  n.always(function () {
                    void 0 === a ? T(r).removeProp(i) : (r[i] = a), e[i] && ((e.jsonpCallback = t.jsonpCallback), Gt.push(i)), o && m(a) && a(o[0]), (o = a = void 0);
                  }),
                  "script"
                );
            }),
            (g.createHTMLDocument = (((Yt = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Yt.childNodes.length)),
            (T.parseHTML = function (e, t, n) {
              return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t || (g.createHTMLDocument ? (((r = (t = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href), t.head.appendChild(r)) : (t = b)),
                  (a = !n && []),
                  (i = A.exec(e)) ? [t.createElement(i[1])] : ((i = Ce([e], t, a)), a && a.length && T(a).remove(), T.merge([], i.childNodes)));
              var r, i, a;
            }),
            (T.fn.load = function (e, t, n) {
              var r,
                i,
                a,
                o = this,
                s = e.indexOf(" ");
              return (
                s > -1 && ((r = mt(e.slice(s))), (e = e.slice(0, s))),
                m(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
                o.length > 0 &&
                  T.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                    .done(function (e) {
                      (a = arguments), o.html(r ? T("<div>").append(T.parseHTML(e)).find(r) : e);
                    })
                    .always(
                      n &&
                        function (e, t) {
                          o.each(function () {
                            n.apply(this, a || [e.responseText, t, e]);
                          });
                        }
                    ),
                this
              );
            }),
            (T.expr.pseudos.animated = function (e) {
              return T.grep(T.timers, function (t) {
                return e === t.elem;
              }).length;
            }),
            (T.offset = {
              setOffset: function (e, t, n) {
                var r,
                  i,
                  a,
                  o,
                  s,
                  l,
                  u = T.css(e, "position"),
                  c = T(e),
                  d = {};
                "static" === u && (e.style.position = "relative"),
                  (s = c.offset()),
                  (a = T.css(e, "top")),
                  (l = T.css(e, "left")),
                  ("absolute" === u || "fixed" === u) && (a + l).indexOf("auto") > -1 ? ((o = (r = c.position()).top), (i = r.left)) : ((o = parseFloat(a) || 0), (i = parseFloat(l) || 0)),
                  m(t) && (t = t.call(e, n, T.extend({}, s))),
                  null != t.top && (d.top = t.top - s.top + o),
                  null != t.left && (d.left = t.left - s.left + i),
                  "using" in t ? t.using.call(e, d) : c.css(d);
              },
            }),
            T.fn.extend({
              offset: function (e) {
                if (arguments.length)
                  return void 0 === e
                    ? this
                    : this.each(function (t) {
                        T.offset.setOffset(this, e, t);
                      });
                var t,
                  n,
                  r = this[0];
                return r ? (r.getClientRects().length ? ((t = r.getBoundingClientRect()), (n = r.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
              },
              position: function () {
                if (this[0]) {
                  var e,
                    t,
                    n,
                    r = this[0],
                    i = { top: 0, left: 0 };
                  if ("fixed" === T.css(r, "position")) t = r.getBoundingClientRect();
                  else {
                    for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === T.css(e, "position"); ) e = e.parentNode;
                    e && e !== r && 1 === e.nodeType && (((i = T(e).offset()).top += T.css(e, "borderTopWidth", !0)), (i.left += T.css(e, "borderLeftWidth", !0)));
                  }
                  return { top: t.top - i.top - T.css(r, "marginTop", !0), left: t.left - i.left - T.css(r, "marginLeft", !0) };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (var e = this.offsetParent; e && "static" === T.css(e, "position"); ) e = e.offsetParent;
                  return e || oe;
                });
              },
            }),
            T.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
              var n = "pageYOffset" === t;
              T.fn[e] = function (r) {
                return V(
                  this,
                  function (e, r, i) {
                    var a;
                    if ((y(e) ? (a = e) : 9 === e.nodeType && (a = e.defaultView), void 0 === i)) return a ? a[t] : e[r];
                    a ? a.scrollTo(n ? a.pageXOffset : i, n ? i : a.pageYOffset) : (e[r] = i);
                  },
                  e,
                  r,
                  arguments.length
                );
              };
            }),
            T.each(["top", "left"], function (e, t) {
              T.cssHooks[t] = Ve(g.pixelPosition, function (e, n) {
                if (n) return (n = $e(e, t)), qe.test(n) ? T(e).position()[t] + "px" : n;
              });
            }),
            T.each({ Height: "height", Width: "width" }, function (e, t) {
              T.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
                T.fn[r] = function (i, a) {
                  var o = arguments.length && (n || "boolean" != typeof i),
                    s = n || (!0 === i || !0 === a ? "margin" : "border");
                  return V(
                    this,
                    function (t, n, i) {
                      var a;
                      return y(t)
                        ? 0 === r.indexOf("outer")
                          ? t["inner" + e]
                          : t.document.documentElement["client" + e]
                        : 9 === t.nodeType
                        ? ((a = t.documentElement), Math.max(t.body["scroll" + e], a["scroll" + e], t.body["offset" + e], a["offset" + e], a["client" + e]))
                        : void 0 === i
                        ? T.css(t, n, s)
                        : T.style(t, n, i, s);
                    },
                    t,
                    o ? i : void 0,
                    o
                  );
                };
              });
            }),
            T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
              T.fn[t] = function (e) {
                return this.on(t, e);
              };
            }),
            T.fn.extend({
              bind: function (e, t, n) {
                return this.on(e, null, t, n);
              },
              unbind: function (e, t) {
                return this.off(e, null, t);
              },
              delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
              },
              undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
              },
              hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
              },
            }),
            T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
              T.fn[t] = function (e, n) {
                return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
              };
            });
          var Ut = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (T.proxy = function (e, t) {
            var n, r, i;
            if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
              return (
                (r = s.call(arguments, 2)),
                (i = function () {
                  return e.apply(t || this, r.concat(s.call(arguments)));
                }),
                (i.guid = e.guid = e.guid || T.guid++),
                i
              );
          }),
            (T.holdReady = function (e) {
              e ? T.readyWait++ : T.ready(!0);
            }),
            (T.isArray = Array.isArray),
            (T.parseJSON = JSON.parse),
            (T.nodeName = P),
            (T.isFunction = m),
            (T.isWindow = y),
            (T.camelCase = U),
            (T.type = x),
            (T.now = Date.now),
            (T.isNumeric = function (e) {
              var t = T.type(e);
              return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
            }),
            (T.trim = function (e) {
              return null == e ? "" : (e + "").replace(Ut, "");
            }),
            void 0 ===
              (n = function () {
                return T;
              }.apply(t, [])) || (e.exports = n);
          var Kt = r.jQuery,
            Qt = r.$;
          return (
            (T.noConflict = function (e) {
              return r.$ === T && (r.$ = Qt), e && r.jQuery === T && (r.jQuery = Kt), T;
            }),
            void 0 === i && (r.jQuery = r.$ = T),
            T
          );
        });
      },
      486: function (e, t, n) {
        var r;
        (e = n.nmd(e)),
          function () {
            var i,
              a = "Expected a function",
              o = "__lodash_hash_undefined__",
              s = "__lodash_placeholder__",
              l = 32,
              u = 128,
              c = 1 / 0,
              d = 9007199254740991,
              f = NaN,
              p = 4294967295,
              h = [
                ["ary", u],
                ["bind", 1],
                ["bindKey", 2],
                ["curry", 8],
                ["curryRight", 16],
                ["flip", 512],
                ["partial", l],
                ["partialRight", 64],
                ["rearg", 256],
              ],
              v = "[object Arguments]",
              g = "[object Array]",
              m = "[object Boolean]",
              y = "[object Date]",
              b = "[object Error]",
              w = "[object Function]",
              _ = "[object GeneratorFunction]",
              x = "[object Map]",
              C = "[object Number]",
              T = "[object Object]",
              k = "[object Promise]",
              E = "[object RegExp]",
              S = "[object Set]",
              O = "[object String]",
              M = "[object Symbol]",
              P = "[object WeakMap]",
              A = "[object ArrayBuffer]",
              L = "[object DataView]",
              I = "[object Float32Array]",
              D = "[object Float64Array]",
              z = "[object Int8Array]",
              j = "[object Int16Array]",
              B = "[object Int32Array]",
              N = "[object Uint8Array]",
              R = "[object Uint8ClampedArray]",
              q = "[object Uint16Array]",
              F = "[object Uint32Array]",
              H = /\b__p \+= '';/g,
              W = /\b(__p \+=) '' \+/g,
              $ = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
              V = /&(?:amp|lt|gt|quot|#39);/g,
              Y = /[&<>"']/g,
              G = RegExp(V.source),
              X = RegExp(Y.source),
              U = /<%-([\s\S]+?)%>/g,
              K = /<%([\s\S]+?)%>/g,
              Q = /<%=([\s\S]+?)%>/g,
              Z = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
              J = /^\w*$/,
              ee = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
              te = /[\\^$.*+?()[\]{}|]/g,
              ne = RegExp(te.source),
              re = /^\s+/,
              ie = /\s/,
              ae = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
              oe = /\{\n\/\* \[wrapped with (.+)\] \*/,
              se = /,? & /,
              le = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
              ue = /[()=,{}\[\]\/\s]/,
              ce = /\\(\\)?/g,
              de = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
              fe = /\w*$/,
              pe = /^[-+]0x[0-9a-f]+$/i,
              he = /^0b[01]+$/i,
              ve = /^\[object .+?Constructor\]$/,
              ge = /^0o[0-7]+$/i,
              me = /^(?:0|[1-9]\d*)$/,
              ye = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
              be = /($^)/,
              we = /['\n\r\u2028\u2029\\]/g,
              _e = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
              xe = "a-z\\xdf-\\xf6\\xf8-\\xff",
              Ce = "A-Z\\xc0-\\xd6\\xd8-\\xde",
              Te =
                "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
              ke = "[" + Te + "]",
              Ee = "[" + _e + "]",
              Se = "\\d+",
              Oe = "[" + xe + "]",
              Me = "[^\\ud800-\\udfff" + Te + Se + "\\u2700-\\u27bf" + xe + Ce + "]",
              Pe = "\\ud83c[\\udffb-\\udfff]",
              Ae = "[^\\ud800-\\udfff]",
              Le = "(?:\\ud83c[\\udde6-\\uddff]){2}",
              Ie = "[\\ud800-\\udbff][\\udc00-\\udfff]",
              De = "[" + Ce + "]",
              ze = "(?:" + Oe + "|" + Me + ")",
              je = "(?:" + De + "|" + Me + ")",
              Be = "(?:['’](?:d|ll|m|re|s|t|ve))?",
              Ne = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
              Re = "(?:" + Ee + "|" + Pe + ")?",
              qe = "[\\ufe0e\\ufe0f]?",
              Fe = qe + Re + "(?:\\u200d(?:" + [Ae, Le, Ie].join("|") + ")" + qe + Re + ")*",
              He = "(?:" + ["[\\u2700-\\u27bf]", Le, Ie].join("|") + ")" + Fe,
              We = "(?:" + [Ae + Ee + "?", Ee, Le, Ie, "[\\ud800-\\udfff]"].join("|") + ")",
              $e = RegExp("['’]", "g"),
              Ve = RegExp(Ee, "g"),
              Ye = RegExp(Pe + "(?=" + Pe + ")|" + We + Fe, "g"),
              Ge = RegExp(
                [
                  De + "?" + Oe + "+" + Be + "(?=" + [ke, De, "$"].join("|") + ")",
                  je + "+" + Ne + "(?=" + [ke, De + ze, "$"].join("|") + ")",
                  De + "?" + ze + "+" + Be,
                  De + "+" + Ne,
                  "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
                  "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
                  Se,
                  He,
                ].join("|"),
                "g"
              ),
              Xe = RegExp("[\\u200d\\ud800-\\udfff" + _e + "\\ufe0e\\ufe0f]"),
              Ue = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
              Ke = [
                "Array",
                "Buffer",
                "DataView",
                "Date",
                "Error",
                "Float32Array",
                "Float64Array",
                "Function",
                "Int8Array",
                "Int16Array",
                "Int32Array",
                "Map",
                "Math",
                "Object",
                "Promise",
                "RegExp",
                "Set",
                "String",
                "Symbol",
                "TypeError",
                "Uint8Array",
                "Uint8ClampedArray",
                "Uint16Array",
                "Uint32Array",
                "WeakMap",
                "_",
                "clearTimeout",
                "isFinite",
                "parseInt",
                "setTimeout",
              ],
              Qe = -1,
              Ze = {};
            (Ze[I] = Ze[D] = Ze[z] = Ze[j] = Ze[B] = Ze[N] = Ze[R] = Ze[q] = Ze[F] = !0), (Ze[v] = Ze[g] = Ze[A] = Ze[m] = Ze[L] = Ze[y] = Ze[b] = Ze[w] = Ze[x] = Ze[C] = Ze[T] = Ze[E] = Ze[S] = Ze[O] = Ze[P] = !1);
            var Je = {};
            (Je[v] = Je[g] = Je[A] = Je[L] = Je[m] = Je[y] = Je[I] = Je[D] = Je[z] = Je[j] = Je[B] = Je[x] = Je[C] = Je[T] = Je[E] = Je[S] = Je[O] = Je[M] = Je[N] = Je[R] = Je[q] = Je[F] = !0), (Je[b] = Je[w] = Je[P] = !1);
            var et = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" },
              tt = parseFloat,
              nt = parseInt,
              rt = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
              it = "object" == typeof self && self && self.Object === Object && self,
              at = rt || it || Function("return this")(),
              ot = t && !t.nodeType && t,
              st = ot && e && !e.nodeType && e,
              lt = st && st.exports === ot,
              ut = lt && rt.process,
              ct = (function () {
                try {
                  return (st && st.require && st.require("util").types) || (ut && ut.binding && ut.binding("util"));
                } catch (e) {}
              })(),
              dt = ct && ct.isArrayBuffer,
              ft = ct && ct.isDate,
              pt = ct && ct.isMap,
              ht = ct && ct.isRegExp,
              vt = ct && ct.isSet,
              gt = ct && ct.isTypedArray;
            function mt(e, t, n) {
              switch (n.length) {
                case 0:
                  return e.call(t);
                case 1:
                  return e.call(t, n[0]);
                case 2:
                  return e.call(t, n[0], n[1]);
                case 3:
                  return e.call(t, n[0], n[1], n[2]);
              }
              return e.apply(t, n);
            }
            function yt(e, t, n, r) {
              for (var i = -1, a = null == e ? 0 : e.length; ++i < a; ) {
                var o = e[i];
                t(r, o, n(o), e);
              }
              return r;
            }
            function bt(e, t) {
              for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e); );
              return e;
            }
            function wt(e, t) {
              for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e); );
              return e;
            }
            function _t(e, t) {
              for (var n = -1, r = null == e ? 0 : e.length; ++n < r; ) if (!t(e[n], n, e)) return !1;
              return !0;
            }
            function xt(e, t) {
              for (var n = -1, r = null == e ? 0 : e.length, i = 0, a = []; ++n < r; ) {
                var o = e[n];
                t(o, n, e) && (a[i++] = o);
              }
              return a;
            }
            function Ct(e, t) {
              return !(null == e || !e.length) && It(e, t, 0) > -1;
            }
            function Tt(e, t, n) {
              for (var r = -1, i = null == e ? 0 : e.length; ++r < i; ) if (n(t, e[r])) return !0;
              return !1;
            }
            function kt(e, t) {
              for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r; ) i[n] = t(e[n], n, e);
              return i;
            }
            function Et(e, t) {
              for (var n = -1, r = t.length, i = e.length; ++n < r; ) e[i + n] = t[n];
              return e;
            }
            function St(e, t, n, r) {
              var i = -1,
                a = null == e ? 0 : e.length;
              for (r && a && (n = e[++i]); ++i < a; ) n = t(n, e[i], i, e);
              return n;
            }
            function Ot(e, t, n, r) {
              var i = null == e ? 0 : e.length;
              for (r && i && (n = e[--i]); i--; ) n = t(n, e[i], i, e);
              return n;
            }
            function Mt(e, t) {
              for (var n = -1, r = null == e ? 0 : e.length; ++n < r; ) if (t(e[n], n, e)) return !0;
              return !1;
            }
            var Pt = Bt("length");
            function At(e, t, n) {
              var r;
              return (
                n(e, function (e, n, i) {
                  if (t(e, n, i)) return (r = n), !1;
                }),
                r
              );
            }
            function Lt(e, t, n, r) {
              for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i; ) if (t(e[a], a, e)) return a;
              return -1;
            }
            function It(e, t, n) {
              return t == t
                ? (function (e, t, n) {
                    for (var r = n - 1, i = e.length; ++r < i; ) if (e[r] === t) return r;
                    return -1;
                  })(e, t, n)
                : Lt(e, zt, n);
            }
            function Dt(e, t, n, r) {
              for (var i = n - 1, a = e.length; ++i < a; ) if (r(e[i], t)) return i;
              return -1;
            }
            function zt(e) {
              return e != e;
            }
            function jt(e, t) {
              var n = null == e ? 0 : e.length;
              return n ? qt(e, t) / n : f;
            }
            function Bt(e) {
              return function (t) {
                return null == t ? i : t[e];
              };
            }
            function Nt(e) {
              return function (t) {
                return null == e ? i : e[t];
              };
            }
            function Rt(e, t, n, r, i) {
              return (
                i(e, function (e, i, a) {
                  n = r ? ((r = !1), e) : t(n, e, i, a);
                }),
                n
              );
            }
            function qt(e, t) {
              for (var n, r = -1, a = e.length; ++r < a; ) {
                var o = t(e[r]);
                o !== i && (n = n === i ? o : n + o);
              }
              return n;
            }
            function Ft(e, t) {
              for (var n = -1, r = Array(e); ++n < e; ) r[n] = t(n);
              return r;
            }
            function Ht(e) {
              return e ? e.slice(0, sn(e) + 1).replace(re, "") : e;
            }
            function Wt(e) {
              return function (t) {
                return e(t);
              };
            }
            function $t(e, t) {
              return kt(t, function (t) {
                return e[t];
              });
            }
            function Vt(e, t) {
              return e.has(t);
            }
            function Yt(e, t) {
              for (var n = -1, r = e.length; ++n < r && It(t, e[n], 0) > -1; );
              return n;
            }
            function Gt(e, t) {
              for (var n = e.length; n-- && It(t, e[n], 0) > -1; );
              return n;
            }
            function Xt(e, t) {
              for (var n = e.length, r = 0; n--; ) e[n] === t && ++r;
              return r;
            }
            var Ut = Nt({
                À: "A",
                Á: "A",
                Â: "A",
                Ã: "A",
                Ä: "A",
                Å: "A",
                à: "a",
                á: "a",
                â: "a",
                ã: "a",
                ä: "a",
                å: "a",
                Ç: "C",
                ç: "c",
                Ð: "D",
                ð: "d",
                È: "E",
                É: "E",
                Ê: "E",
                Ë: "E",
                è: "e",
                é: "e",
                ê: "e",
                ë: "e",
                Ì: "I",
                Í: "I",
                Î: "I",
                Ï: "I",
                ì: "i",
                í: "i",
                î: "i",
                ï: "i",
                Ñ: "N",
                ñ: "n",
                Ò: "O",
                Ó: "O",
                Ô: "O",
                Õ: "O",
                Ö: "O",
                Ø: "O",
                ò: "o",
                ó: "o",
                ô: "o",
                õ: "o",
                ö: "o",
                ø: "o",
                Ù: "U",
                Ú: "U",
                Û: "U",
                Ü: "U",
                ù: "u",
                ú: "u",
                û: "u",
                ü: "u",
                Ý: "Y",
                ý: "y",
                ÿ: "y",
                Æ: "Ae",
                æ: "ae",
                Þ: "Th",
                þ: "th",
                ß: "ss",
                Ā: "A",
                Ă: "A",
                Ą: "A",
                ā: "a",
                ă: "a",
                ą: "a",
                Ć: "C",
                Ĉ: "C",
                Ċ: "C",
                Č: "C",
                ć: "c",
                ĉ: "c",
                ċ: "c",
                č: "c",
                Ď: "D",
                Đ: "D",
                ď: "d",
                đ: "d",
                Ē: "E",
                Ĕ: "E",
                Ė: "E",
                Ę: "E",
                Ě: "E",
                ē: "e",
                ĕ: "e",
                ė: "e",
                ę: "e",
                ě: "e",
                Ĝ: "G",
                Ğ: "G",
                Ġ: "G",
                Ģ: "G",
                ĝ: "g",
                ğ: "g",
                ġ: "g",
                ģ: "g",
                Ĥ: "H",
                Ħ: "H",
                ĥ: "h",
                ħ: "h",
                Ĩ: "I",
                Ī: "I",
                Ĭ: "I",
                Į: "I",
                İ: "I",
                ĩ: "i",
                ī: "i",
                ĭ: "i",
                į: "i",
                ı: "i",
                Ĵ: "J",
                ĵ: "j",
                Ķ: "K",
                ķ: "k",
                ĸ: "k",
                Ĺ: "L",
                Ļ: "L",
                Ľ: "L",
                Ŀ: "L",
                Ł: "L",
                ĺ: "l",
                ļ: "l",
                ľ: "l",
                ŀ: "l",
                ł: "l",
                Ń: "N",
                Ņ: "N",
                Ň: "N",
                Ŋ: "N",
                ń: "n",
                ņ: "n",
                ň: "n",
                ŋ: "n",
                Ō: "O",
                Ŏ: "O",
                Ő: "O",
                ō: "o",
                ŏ: "o",
                ő: "o",
                Ŕ: "R",
                Ŗ: "R",
                Ř: "R",
                ŕ: "r",
                ŗ: "r",
                ř: "r",
                Ś: "S",
                Ŝ: "S",
                Ş: "S",
                Š: "S",
                ś: "s",
                ŝ: "s",
                ş: "s",
                š: "s",
                Ţ: "T",
                Ť: "T",
                Ŧ: "T",
                ţ: "t",
                ť: "t",
                ŧ: "t",
                Ũ: "U",
                Ū: "U",
                Ŭ: "U",
                Ů: "U",
                Ű: "U",
                Ų: "U",
                ũ: "u",
                ū: "u",
                ŭ: "u",
                ů: "u",
                ű: "u",
                ų: "u",
                Ŵ: "W",
                ŵ: "w",
                Ŷ: "Y",
                ŷ: "y",
                Ÿ: "Y",
                Ź: "Z",
                Ż: "Z",
                Ž: "Z",
                ź: "z",
                ż: "z",
                ž: "z",
                Ĳ: "IJ",
                ĳ: "ij",
                Œ: "Oe",
                œ: "oe",
                ŉ: "'n",
                ſ: "s",
              }),
              Kt = Nt({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" });
            function Qt(e) {
              return "\\" + et[e];
            }
            function Zt(e) {
              return Xe.test(e);
            }
            function Jt(e) {
              var t = -1,
                n = Array(e.size);
              return (
                e.forEach(function (e, r) {
                  n[++t] = [r, e];
                }),
                n
              );
            }
            function en(e, t) {
              return function (n) {
                return e(t(n));
              };
            }
            function tn(e, t) {
              for (var n = -1, r = e.length, i = 0, a = []; ++n < r; ) {
                var o = e[n];
                (o !== t && o !== s) || ((e[n] = s), (a[i++] = n));
              }
              return a;
            }
            function nn(e) {
              var t = -1,
                n = Array(e.size);
              return (
                e.forEach(function (e) {
                  n[++t] = e;
                }),
                n
              );
            }
            function rn(e) {
              var t = -1,
                n = Array(e.size);
              return (
                e.forEach(function (e) {
                  n[++t] = [e, e];
                }),
                n
              );
            }
            function an(e) {
              return Zt(e)
                ? (function (e) {
                    for (var t = (Ye.lastIndex = 0); Ye.test(e); ) ++t;
                    return t;
                  })(e)
                : Pt(e);
            }
            function on(e) {
              return Zt(e)
                ? (function (e) {
                    return e.match(Ye) || [];
                  })(e)
                : (function (e) {
                    return e.split("");
                  })(e);
            }
            function sn(e) {
              for (var t = e.length; t-- && ie.test(e.charAt(t)); );
              return t;
            }
            var ln = Nt({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }),
              un = (function e(t) {
                var n,
                  r = (t = null == t ? at : un.defaults(at.Object(), t, un.pick(at, Ke))).Array,
                  ie = t.Date,
                  _e = t.Error,
                  xe = t.Function,
                  Ce = t.Math,
                  Te = t.Object,
                  ke = t.RegExp,
                  Ee = t.String,
                  Se = t.TypeError,
                  Oe = r.prototype,
                  Me = xe.prototype,
                  Pe = Te.prototype,
                  Ae = t["__core-js_shared__"],
                  Le = Me.toString,
                  Ie = Pe.hasOwnProperty,
                  De = 0,
                  ze = (n = /[^.]+$/.exec((Ae && Ae.keys && Ae.keys.IE_PROTO) || "")) ? "Symbol(src)_1." + n : "",
                  je = Pe.toString,
                  Be = Le.call(Te),
                  Ne = at._,
                  Re = ke(
                    "^" +
                      Le.call(Ie)
                        .replace(te, "\\$&")
                        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") +
                      "$"
                  ),
                  qe = lt ? t.Buffer : i,
                  Fe = t.Symbol,
                  He = t.Uint8Array,
                  We = qe ? qe.allocUnsafe : i,
                  Ye = en(Te.getPrototypeOf, Te),
                  Xe = Te.create,
                  et = Pe.propertyIsEnumerable,
                  rt = Oe.splice,
                  it = Fe ? Fe.isConcatSpreadable : i,
                  ot = Fe ? Fe.iterator : i,
                  st = Fe ? Fe.toStringTag : i,
                  ut = (function () {
                    try {
                      var e = ua(Te, "defineProperty");
                      return e({}, "", {}), e;
                    } catch (e) {}
                  })(),
                  ct = t.clearTimeout !== at.clearTimeout && t.clearTimeout,
                  Pt = ie && ie.now !== at.Date.now && ie.now,
                  Nt = t.setTimeout !== at.setTimeout && t.setTimeout,
                  cn = Ce.ceil,
                  dn = Ce.floor,
                  fn = Te.getOwnPropertySymbols,
                  pn = qe ? qe.isBuffer : i,
                  hn = t.isFinite,
                  vn = Oe.join,
                  gn = en(Te.keys, Te),
                  mn = Ce.max,
                  yn = Ce.min,
                  bn = ie.now,
                  wn = t.parseInt,
                  _n = Ce.random,
                  xn = Oe.reverse,
                  Cn = ua(t, "DataView"),
                  Tn = ua(t, "Map"),
                  kn = ua(t, "Promise"),
                  En = ua(t, "Set"),
                  Sn = ua(t, "WeakMap"),
                  On = ua(Te, "create"),
                  Mn = Sn && new Sn(),
                  Pn = {},
                  An = Na(Cn),
                  Ln = Na(Tn),
                  In = Na(kn),
                  Dn = Na(En),
                  zn = Na(Sn),
                  jn = Fe ? Fe.prototype : i,
                  Bn = jn ? jn.valueOf : i,
                  Nn = jn ? jn.toString : i;
                function Rn(e) {
                  if (ns(e) && !Vo(e) && !(e instanceof Wn)) {
                    if (e instanceof Hn) return e;
                    if (Ie.call(e, "__wrapped__")) return Ra(e);
                  }
                  return new Hn(e);
                }
                var qn = (function () {
                  function e() {}
                  return function (t) {
                    if (!ts(t)) return {};
                    if (Xe) return Xe(t);
                    e.prototype = t;
                    var n = new e();
                    return (e.prototype = i), n;
                  };
                })();
                function Fn() {}
                function Hn(e, t) {
                  (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t), (this.__index__ = 0), (this.__values__ = i);
                }
                function Wn(e) {
                  (this.__wrapped__ = e), (this.__actions__ = []), (this.__dir__ = 1), (this.__filtered__ = !1), (this.__iteratees__ = []), (this.__takeCount__ = p), (this.__views__ = []);
                }
                function $n(e) {
                  var t = -1,
                    n = null == e ? 0 : e.length;
                  for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }
                function Vn(e) {
                  var t = -1,
                    n = null == e ? 0 : e.length;
                  for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }
                function Yn(e) {
                  var t = -1,
                    n = null == e ? 0 : e.length;
                  for (this.clear(); ++t < n; ) {
                    var r = e[t];
                    this.set(r[0], r[1]);
                  }
                }
                function Gn(e) {
                  var t = -1,
                    n = null == e ? 0 : e.length;
                  for (this.__data__ = new Yn(); ++t < n; ) this.add(e[t]);
                }
                function Xn(e) {
                  var t = (this.__data__ = new Vn(e));
                  this.size = t.size;
                }
                function Un(e, t) {
                  var n = Vo(e),
                    r = !n && $o(e),
                    i = !n && !r && Uo(e),
                    a = !n && !r && !i && cs(e),
                    o = n || r || i || a,
                    s = o ? Ft(e.length, Ee) : [],
                    l = s.length;
                  for (var u in e) (!t && !Ie.call(e, u)) || (o && ("length" == u || (i && ("offset" == u || "parent" == u)) || (a && ("buffer" == u || "byteLength" == u || "byteOffset" == u)) || ga(u, l))) || s.push(u);
                  return s;
                }
                function Kn(e) {
                  var t = e.length;
                  return t ? e[Yr(0, t - 1)] : i;
                }
                function Qn(e, t) {
                  return Ia(Si(e), or(t, 0, e.length));
                }
                function Zn(e) {
                  return Ia(Si(e));
                }
                function Jn(e, t, n) {
                  ((n !== i && !Fo(e[t], n)) || (n === i && !(t in e))) && ir(e, t, n);
                }
                function er(e, t, n) {
                  var r = e[t];
                  (Ie.call(e, t) && Fo(r, n) && (n !== i || t in e)) || ir(e, t, n);
                }
                function tr(e, t) {
                  for (var n = e.length; n--; ) if (Fo(e[n][0], t)) return n;
                  return -1;
                }
                function nr(e, t, n, r) {
                  return (
                    dr(e, function (e, i, a) {
                      t(r, e, n(e), a);
                    }),
                    r
                  );
                }
                function rr(e, t) {
                  return e && Oi(t, Ls(t), e);
                }
                function ir(e, t, n) {
                  "__proto__" == t && ut ? ut(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 }) : (e[t] = n);
                }
                function ar(e, t) {
                  for (var n = -1, a = t.length, o = r(a), s = null == e; ++n < a; ) o[n] = s ? i : Ss(e, t[n]);
                  return o;
                }
                function or(e, t, n) {
                  return e == e && (n !== i && (e = e <= n ? e : n), t !== i && (e = e >= t ? e : t)), e;
                }
                function sr(e, t, n, r, a, o) {
                  var s,
                    l = 1 & t,
                    u = 2 & t,
                    c = 4 & t;
                  if ((n && (s = a ? n(e, r, a, o) : n(e)), s !== i)) return s;
                  if (!ts(e)) return e;
                  var d = Vo(e);
                  if (d) {
                    if (
                      ((s = (function (e) {
                        var t = e.length,
                          n = new e.constructor(t);
                        return t && "string" == typeof e[0] && Ie.call(e, "index") && ((n.index = e.index), (n.input = e.input)), n;
                      })(e)),
                      !l)
                    )
                      return Si(e, s);
                  } else {
                    var f = fa(e),
                      p = f == w || f == _;
                    if (Uo(e)) return _i(e, l);
                    if (f == T || f == v || (p && !a)) {
                      if (((s = u || p ? {} : ha(e)), !l))
                        return u
                          ? (function (e, t) {
                              return Oi(e, da(e), t);
                            })(
                              e,
                              (function (e, t) {
                                return e && Oi(t, Is(t), e);
                              })(s, e)
                            )
                          : (function (e, t) {
                              return Oi(e, ca(e), t);
                            })(e, rr(s, e));
                    } else {
                      if (!Je[f]) return a ? e : {};
                      s = (function (e, t, n) {
                        var r,
                          i = e.constructor;
                        switch (t) {
                          case A:
                            return xi(e);
                          case m:
                          case y:
                            return new i(+e);
                          case L:
                            return (function (e, t) {
                              var n = t ? xi(e.buffer) : e.buffer;
                              return new e.constructor(n, e.byteOffset, e.byteLength);
                            })(e, n);
                          case I:
                          case D:
                          case z:
                          case j:
                          case B:
                          case N:
                          case R:
                          case q:
                          case F:
                            return Ci(e, n);
                          case x:
                            return new i();
                          case C:
                          case O:
                            return new i(e);
                          case E:
                            return (function (e) {
                              var t = new e.constructor(e.source, fe.exec(e));
                              return (t.lastIndex = e.lastIndex), t;
                            })(e);
                          case S:
                            return new i();
                          case M:
                            return (r = e), Bn ? Te(Bn.call(r)) : {};
                        }
                      })(e, f, l);
                    }
                  }
                  o || (o = new Xn());
                  var h = o.get(e);
                  if (h) return h;
                  o.set(e, s),
                    ss(e)
                      ? e.forEach(function (r) {
                          s.add(sr(r, t, n, r, e, o));
                        })
                      : rs(e) &&
                        e.forEach(function (r, i) {
                          s.set(i, sr(r, t, n, i, e, o));
                        });
                  var g = d ? i : (c ? (u ? na : ta) : u ? Is : Ls)(e);
                  return (
                    bt(g || e, function (r, i) {
                      g && (r = e[(i = r)]), er(s, i, sr(r, t, n, i, e, o));
                    }),
                    s
                  );
                }
                function lr(e, t, n) {
                  var r = n.length;
                  if (null == e) return !r;
                  for (e = Te(e); r--; ) {
                    var a = n[r],
                      o = t[a],
                      s = e[a];
                    if ((s === i && !(a in e)) || !o(s)) return !1;
                  }
                  return !0;
                }
                function ur(e, t, n) {
                  if ("function" != typeof e) throw new Se(a);
                  return Ma(function () {
                    e.apply(i, n);
                  }, t);
                }
                function cr(e, t, n, r) {
                  var i = -1,
                    a = Ct,
                    o = !0,
                    s = e.length,
                    l = [],
                    u = t.length;
                  if (!s) return l;
                  n && (t = kt(t, Wt(n))), r ? ((a = Tt), (o = !1)) : t.length >= 200 && ((a = Vt), (o = !1), (t = new Gn(t)));
                  e: for (; ++i < s; ) {
                    var c = e[i],
                      d = null == n ? c : n(c);
                    if (((c = r || 0 !== c ? c : 0), o && d == d)) {
                      for (var f = u; f--; ) if (t[f] === d) continue e;
                      l.push(c);
                    } else a(t, d, r) || l.push(c);
                  }
                  return l;
                }
                (Rn.templateSettings = { escape: U, evaluate: K, interpolate: Q, variable: "", imports: { _: Rn } }),
                  (Rn.prototype = Fn.prototype),
                  (Rn.prototype.constructor = Rn),
                  (Hn.prototype = qn(Fn.prototype)),
                  (Hn.prototype.constructor = Hn),
                  (Wn.prototype = qn(Fn.prototype)),
                  (Wn.prototype.constructor = Wn),
                  ($n.prototype.clear = function () {
                    (this.__data__ = On ? On(null) : {}), (this.size = 0);
                  }),
                  ($n.prototype.delete = function (e) {
                    var t = this.has(e) && delete this.__data__[e];
                    return (this.size -= t ? 1 : 0), t;
                  }),
                  ($n.prototype.get = function (e) {
                    var t = this.__data__;
                    if (On) {
                      var n = t[e];
                      return n === o ? i : n;
                    }
                    return Ie.call(t, e) ? t[e] : i;
                  }),
                  ($n.prototype.has = function (e) {
                    var t = this.__data__;
                    return On ? t[e] !== i : Ie.call(t, e);
                  }),
                  ($n.prototype.set = function (e, t) {
                    var n = this.__data__;
                    return (this.size += this.has(e) ? 0 : 1), (n[e] = On && t === i ? o : t), this;
                  }),
                  (Vn.prototype.clear = function () {
                    (this.__data__ = []), (this.size = 0);
                  }),
                  (Vn.prototype.delete = function (e) {
                    var t = this.__data__,
                      n = tr(t, e);
                    return !(n < 0 || (n == t.length - 1 ? t.pop() : rt.call(t, n, 1), --this.size, 0));
                  }),
                  (Vn.prototype.get = function (e) {
                    var t = this.__data__,
                      n = tr(t, e);
                    return n < 0 ? i : t[n][1];
                  }),
                  (Vn.prototype.has = function (e) {
                    return tr(this.__data__, e) > -1;
                  }),
                  (Vn.prototype.set = function (e, t) {
                    var n = this.__data__,
                      r = tr(n, e);
                    return r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this;
                  }),
                  (Yn.prototype.clear = function () {
                    (this.size = 0), (this.__data__ = { hash: new $n(), map: new (Tn || Vn)(), string: new $n() });
                  }),
                  (Yn.prototype.delete = function (e) {
                    var t = sa(this, e).delete(e);
                    return (this.size -= t ? 1 : 0), t;
                  }),
                  (Yn.prototype.get = function (e) {
                    return sa(this, e).get(e);
                  }),
                  (Yn.prototype.has = function (e) {
                    return sa(this, e).has(e);
                  }),
                  (Yn.prototype.set = function (e, t) {
                    var n = sa(this, e),
                      r = n.size;
                    return n.set(e, t), (this.size += n.size == r ? 0 : 1), this;
                  }),
                  (Gn.prototype.add = Gn.prototype.push = function (e) {
                    return this.__data__.set(e, o), this;
                  }),
                  (Gn.prototype.has = function (e) {
                    return this.__data__.has(e);
                  }),
                  (Xn.prototype.clear = function () {
                    (this.__data__ = new Vn()), (this.size = 0);
                  }),
                  (Xn.prototype.delete = function (e) {
                    var t = this.__data__,
                      n = t.delete(e);
                    return (this.size = t.size), n;
                  }),
                  (Xn.prototype.get = function (e) {
                    return this.__data__.get(e);
                  }),
                  (Xn.prototype.has = function (e) {
                    return this.__data__.has(e);
                  }),
                  (Xn.prototype.set = function (e, t) {
                    var n = this.__data__;
                    if (n instanceof Vn) {
                      var r = n.__data__;
                      if (!Tn || r.length < 199) return r.push([e, t]), (this.size = ++n.size), this;
                      n = this.__data__ = new Yn(r);
                    }
                    return n.set(e, t), (this.size = n.size), this;
                  });
                var dr = Ai(br),
                  fr = Ai(wr, !0);
                function pr(e, t) {
                  var n = !0;
                  return (
                    dr(e, function (e, r, i) {
                      return (n = !!t(e, r, i));
                    }),
                    n
                  );
                }
                function hr(e, t, n) {
                  for (var r = -1, a = e.length; ++r < a; ) {
                    var o = e[r],
                      s = t(o);
                    if (null != s && (l === i ? s == s && !us(s) : n(s, l)))
                      var l = s,
                        u = o;
                  }
                  return u;
                }
                function vr(e, t) {
                  var n = [];
                  return (
                    dr(e, function (e, r, i) {
                      t(e, r, i) && n.push(e);
                    }),
                    n
                  );
                }
                function gr(e, t, n, r, i) {
                  var a = -1,
                    o = e.length;
                  for (n || (n = va), i || (i = []); ++a < o; ) {
                    var s = e[a];
                    t > 0 && n(s) ? (t > 1 ? gr(s, t - 1, n, r, i) : Et(i, s)) : r || (i[i.length] = s);
                  }
                  return i;
                }
                var mr = Li(),
                  yr = Li(!0);
                function br(e, t) {
                  return e && mr(e, t, Ls);
                }
                function wr(e, t) {
                  return e && yr(e, t, Ls);
                }
                function _r(e, t) {
                  return xt(t, function (t) {
                    return Zo(e[t]);
                  });
                }
                function xr(e, t) {
                  for (var n = 0, r = (t = mi(t, e)).length; null != e && n < r; ) e = e[Ba(t[n++])];
                  return n && n == r ? e : i;
                }
                function Cr(e, t, n) {
                  var r = t(e);
                  return Vo(e) ? r : Et(r, n(e));
                }
                function Tr(e) {
                  return null == e
                    ? e === i
                      ? "[object Undefined]"
                      : "[object Null]"
                    : st && st in Te(e)
                    ? (function (e) {
                        var t = Ie.call(e, st),
                          n = e[st];
                        try {
                          e[st] = i;
                          var r = !0;
                        } catch (e) {}
                        var a = je.call(e);
                        return r && (t ? (e[st] = n) : delete e[st]), a;
                      })(e)
                    : (function (e) {
                        return je.call(e);
                      })(e);
                }
                function kr(e, t) {
                  return e > t;
                }
                function Er(e, t) {
                  return null != e && Ie.call(e, t);
                }
                function Sr(e, t) {
                  return null != e && t in Te(e);
                }
                function Or(e, t, n) {
                  for (var a = n ? Tt : Ct, o = e[0].length, s = e.length, l = s, u = r(s), c = 1 / 0, d = []; l--; ) {
                    var f = e[l];
                    l && t && (f = kt(f, Wt(t))), (c = yn(f.length, c)), (u[l] = !n && (t || (o >= 120 && f.length >= 120)) ? new Gn(l && f) : i);
                  }
                  f = e[0];
                  var p = -1,
                    h = u[0];
                  e: for (; ++p < o && d.length < c; ) {
                    var v = f[p],
                      g = t ? t(v) : v;
                    if (((v = n || 0 !== v ? v : 0), !(h ? Vt(h, g) : a(d, g, n)))) {
                      for (l = s; --l; ) {
                        var m = u[l];
                        if (!(m ? Vt(m, g) : a(e[l], g, n))) continue e;
                      }
                      h && h.push(g), d.push(v);
                    }
                  }
                  return d;
                }
                function Mr(e, t, n) {
                  var r = null == (e = ka(e, (t = mi(t, e)))) ? e : e[Ba(Ka(t))];
                  return null == r ? i : mt(r, e, n);
                }
                function Pr(e) {
                  return ns(e) && Tr(e) == v;
                }
                function Ar(e, t, n, r, a) {
                  return (
                    e === t ||
                    (null == e || null == t || (!ns(e) && !ns(t))
                      ? e != e && t != t
                      : (function (e, t, n, r, a, o) {
                          var s = Vo(e),
                            l = Vo(t),
                            u = s ? g : fa(e),
                            c = l ? g : fa(t),
                            d = (u = u == v ? T : u) == T,
                            f = (c = c == v ? T : c) == T,
                            p = u == c;
                          if (p && Uo(e)) {
                            if (!Uo(t)) return !1;
                            (s = !0), (d = !1);
                          }
                          if (p && !d)
                            return (
                              o || (o = new Xn()),
                              s || cs(e)
                                ? Ji(e, t, n, r, a, o)
                                : (function (e, t, n, r, i, a, o) {
                                    switch (n) {
                                      case L:
                                        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                        (e = e.buffer), (t = t.buffer);
                                      case A:
                                        return !(e.byteLength != t.byteLength || !a(new He(e), new He(t)));
                                      case m:
                                      case y:
                                      case C:
                                        return Fo(+e, +t);
                                      case b:
                                        return e.name == t.name && e.message == t.message;
                                      case E:
                                      case O:
                                        return e == t + "";
                                      case x:
                                        var s = Jt;
                                      case S:
                                        var l = 1 & r;
                                        if ((s || (s = nn), e.size != t.size && !l)) return !1;
                                        var u = o.get(e);
                                        if (u) return u == t;
                                        (r |= 2), o.set(e, t);
                                        var c = Ji(s(e), s(t), r, i, a, o);
                                        return o.delete(e), c;
                                      case M:
                                        if (Bn) return Bn.call(e) == Bn.call(t);
                                    }
                                    return !1;
                                  })(e, t, u, n, r, a, o)
                            );
                          if (!(1 & n)) {
                            var h = d && Ie.call(e, "__wrapped__"),
                              w = f && Ie.call(t, "__wrapped__");
                            if (h || w) {
                              var _ = h ? e.value() : e,
                                k = w ? t.value() : t;
                              return o || (o = new Xn()), a(_, k, n, r, o);
                            }
                          }
                          return (
                            !!p &&
                            (o || (o = new Xn()),
                            (function (e, t, n, r, a, o) {
                              var s = 1 & n,
                                l = ta(e),
                                u = l.length;
                              if (u != ta(t).length && !s) return !1;
                              for (var c = u; c--; ) {
                                var d = l[c];
                                if (!(s ? d in t : Ie.call(t, d))) return !1;
                              }
                              var f = o.get(e),
                                p = o.get(t);
                              if (f && p) return f == t && p == e;
                              var h = !0;
                              o.set(e, t), o.set(t, e);
                              for (var v = s; ++c < u; ) {
                                var g = e[(d = l[c])],
                                  m = t[d];
                                if (r) var y = s ? r(m, g, d, t, e, o) : r(g, m, d, e, t, o);
                                if (!(y === i ? g === m || a(g, m, n, r, o) : y)) {
                                  h = !1;
                                  break;
                                }
                                v || (v = "constructor" == d);
                              }
                              if (h && !v) {
                                var b = e.constructor,
                                  w = t.constructor;
                                b == w || !("constructor" in e) || !("constructor" in t) || ("function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w) || (h = !1);
                              }
                              return o.delete(e), o.delete(t), h;
                            })(e, t, n, r, a, o))
                          );
                        })(e, t, n, r, Ar, a))
                  );
                }
                function Lr(e, t, n, r) {
                  var a = n.length,
                    o = a,
                    s = !r;
                  if (null == e) return !o;
                  for (e = Te(e); a--; ) {
                    var l = n[a];
                    if (s && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
                  }
                  for (; ++a < o; ) {
                    var u = (l = n[a])[0],
                      c = e[u],
                      d = l[1];
                    if (s && l[2]) {
                      if (c === i && !(u in e)) return !1;
                    } else {
                      var f = new Xn();
                      if (r) var p = r(c, d, u, e, t, f);
                      if (!(p === i ? Ar(d, c, 3, r, f) : p)) return !1;
                    }
                  }
                  return !0;
                }
                function Ir(e) {
                  return !(!ts(e) || ((t = e), ze && ze in t)) && (Zo(e) ? Re : ve).test(Na(e));
                  var t;
                }
                function Dr(e) {
                  return "function" == typeof e ? e : null == e ? il : "object" == typeof e ? (Vo(e) ? Rr(e[0], e[1]) : Nr(e)) : pl(e);
                }
                function zr(e) {
                  if (!_a(e)) return gn(e);
                  var t = [];
                  for (var n in Te(e)) Ie.call(e, n) && "constructor" != n && t.push(n);
                  return t;
                }
                function jr(e, t) {
                  return e < t;
                }
                function Br(e, t) {
                  var n = -1,
                    i = Go(e) ? r(e.length) : [];
                  return (
                    dr(e, function (e, r, a) {
                      i[++n] = t(e, r, a);
                    }),
                    i
                  );
                }
                function Nr(e) {
                  var t = la(e);
                  return 1 == t.length && t[0][2]
                    ? Ca(t[0][0], t[0][1])
                    : function (n) {
                        return n === e || Lr(n, e, t);
                      };
                }
                function Rr(e, t) {
                  return ya(e) && xa(t)
                    ? Ca(Ba(e), t)
                    : function (n) {
                        var r = Ss(n, e);
                        return r === i && r === t ? Os(n, e) : Ar(t, r, 3);
                      };
                }
                function qr(e, t, n, r, a) {
                  e !== t &&
                    mr(
                      t,
                      function (o, s) {
                        if ((a || (a = new Xn()), ts(o)))
                          !(function (e, t, n, r, a, o, s) {
                            var l = Sa(e, n),
                              u = Sa(t, n),
                              c = s.get(u);
                            if (c) Jn(e, n, c);
                            else {
                              var d = o ? o(l, u, n + "", e, t, s) : i,
                                f = d === i;
                              if (f) {
                                var p = Vo(u),
                                  h = !p && Uo(u),
                                  v = !p && !h && cs(u);
                                (d = u),
                                  p || h || v
                                    ? Vo(l)
                                      ? (d = l)
                                      : Xo(l)
                                      ? (d = Si(l))
                                      : h
                                      ? ((f = !1), (d = _i(u, !0)))
                                      : v
                                      ? ((f = !1), (d = Ci(u, !0)))
                                      : (d = [])
                                    : as(u) || $o(u)
                                    ? ((d = l), $o(l) ? (d = ys(l)) : (ts(l) && !Zo(l)) || (d = ha(u)))
                                    : (f = !1);
                              }
                              f && (s.set(u, d), a(d, u, r, o, s), s.delete(u)), Jn(e, n, d);
                            }
                          })(e, t, s, n, qr, r, a);
                        else {
                          var l = r ? r(Sa(e, s), o, s + "", e, t, a) : i;
                          l === i && (l = o), Jn(e, s, l);
                        }
                      },
                      Is
                    );
                }
                function Fr(e, t) {
                  var n = e.length;
                  if (n) return ga((t += t < 0 ? n : 0), n) ? e[t] : i;
                }
                function Hr(e, t, n) {
                  t = t.length
                    ? kt(t, function (e) {
                        return Vo(e)
                          ? function (t) {
                              return xr(t, 1 === e.length ? e[0] : e);
                            }
                          : e;
                      })
                    : [il];
                  var r = -1;
                  t = kt(t, Wt(oa()));
                  var i = Br(e, function (e, n, i) {
                    var a = kt(t, function (t) {
                      return t(e);
                    });
                    return { criteria: a, index: ++r, value: e };
                  });
                  return (function (e, t) {
                    var r = e.length;
                    for (
                      e.sort(function (e, t) {
                        return (function (e, t, n) {
                          for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o; ) {
                            var l = Ti(i[r], a[r]);
                            if (l) return r >= s ? l : l * ("desc" == n[r] ? -1 : 1);
                          }
                          return e.index - t.index;
                        })(e, t, n);
                      });
                      r--;

                    )
                      e[r] = e[r].value;
                    return e;
                  })(i);
                }
                function Wr(e, t, n) {
                  for (var r = -1, i = t.length, a = {}; ++r < i; ) {
                    var o = t[r],
                      s = xr(e, o);
                    n(s, o) && Qr(a, mi(o, e), s);
                  }
                  return a;
                }
                function $r(e, t, n, r) {
                  var i = r ? Dt : It,
                    a = -1,
                    o = t.length,
                    s = e;
                  for (e === t && (t = Si(t)), n && (s = kt(e, Wt(n))); ++a < o; ) for (var l = 0, u = t[a], c = n ? n(u) : u; (l = i(s, c, l, r)) > -1; ) s !== e && rt.call(s, l, 1), rt.call(e, l, 1);
                  return e;
                }
                function Vr(e, t) {
                  for (var n = e ? t.length : 0, r = n - 1; n--; ) {
                    var i = t[n];
                    if (n == r || i !== a) {
                      var a = i;
                      ga(i) ? rt.call(e, i, 1) : ui(e, i);
                    }
                  }
                  return e;
                }
                function Yr(e, t) {
                  return e + dn(_n() * (t - e + 1));
                }
                function Gr(e, t) {
                  var n = "";
                  if (!e || t < 1 || t > d) return n;
                  do {
                    t % 2 && (n += e), (t = dn(t / 2)) && (e += e);
                  } while (t);
                  return n;
                }
                function Xr(e, t) {
                  return Pa(Ta(e, t, il), e + "");
                }
                function Ur(e) {
                  return Kn(Fs(e));
                }
                function Kr(e, t) {
                  var n = Fs(e);
                  return Ia(n, or(t, 0, n.length));
                }
                function Qr(e, t, n, r) {
                  if (!ts(e)) return e;
                  for (var a = -1, o = (t = mi(t, e)).length, s = o - 1, l = e; null != l && ++a < o; ) {
                    var u = Ba(t[a]),
                      c = n;
                    if ("__proto__" === u || "constructor" === u || "prototype" === u) return e;
                    if (a != s) {
                      var d = l[u];
                      (c = r ? r(d, u, l) : i) === i && (c = ts(d) ? d : ga(t[a + 1]) ? [] : {});
                    }
                    er(l, u, c), (l = l[u]);
                  }
                  return e;
                }
                var Zr = Mn
                    ? function (e, t) {
                        return Mn.set(e, t), e;
                      }
                    : il,
                  Jr = ut
                    ? function (e, t) {
                        return ut(e, "toString", { configurable: !0, enumerable: !1, value: tl(t), writable: !0 });
                      }
                    : il;
                function ei(e) {
                  return Ia(Fs(e));
                }
                function ti(e, t, n) {
                  var i = -1,
                    a = e.length;
                  t < 0 && (t = -t > a ? 0 : a + t), (n = n > a ? a : n) < 0 && (n += a), (a = t > n ? 0 : (n - t) >>> 0), (t >>>= 0);
                  for (var o = r(a); ++i < a; ) o[i] = e[i + t];
                  return o;
                }
                function ni(e, t) {
                  var n;
                  return (
                    dr(e, function (e, r, i) {
                      return !(n = t(e, r, i));
                    }),
                    !!n
                  );
                }
                function ri(e, t, n) {
                  var r = 0,
                    i = null == e ? r : e.length;
                  if ("number" == typeof t && t == t && i <= 2147483647) {
                    for (; r < i; ) {
                      var a = (r + i) >>> 1,
                        o = e[a];
                      null !== o && !us(o) && (n ? o <= t : o < t) ? (r = a + 1) : (i = a);
                    }
                    return i;
                  }
                  return ii(e, t, il, n);
                }
                function ii(e, t, n, r) {
                  var a = 0,
                    o = null == e ? 0 : e.length;
                  if (0 === o) return 0;
                  for (var s = (t = n(t)) != t, l = null === t, u = us(t), c = t === i; a < o; ) {
                    var d = dn((a + o) / 2),
                      f = n(e[d]),
                      p = f !== i,
                      h = null === f,
                      v = f == f,
                      g = us(f);
                    if (s) var m = r || v;
                    else m = c ? v && (r || p) : l ? v && p && (r || !h) : u ? v && p && !h && (r || !g) : !h && !g && (r ? f <= t : f < t);
                    m ? (a = d + 1) : (o = d);
                  }
                  return yn(o, 4294967294);
                }
                function ai(e, t) {
                  for (var n = -1, r = e.length, i = 0, a = []; ++n < r; ) {
                    var o = e[n],
                      s = t ? t(o) : o;
                    if (!n || !Fo(s, l)) {
                      var l = s;
                      a[i++] = 0 === o ? 0 : o;
                    }
                  }
                  return a;
                }
                function oi(e) {
                  return "number" == typeof e ? e : us(e) ? f : +e;
                }
                function si(e) {
                  if ("string" == typeof e) return e;
                  if (Vo(e)) return kt(e, si) + "";
                  if (us(e)) return Nn ? Nn.call(e) : "";
                  var t = e + "";
                  return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }
                function li(e, t, n) {
                  var r = -1,
                    i = Ct,
                    a = e.length,
                    o = !0,
                    s = [],
                    l = s;
                  if (n) (o = !1), (i = Tt);
                  else if (a >= 200) {
                    var u = t ? null : Gi(e);
                    if (u) return nn(u);
                    (o = !1), (i = Vt), (l = new Gn());
                  } else l = t ? [] : s;
                  e: for (; ++r < a; ) {
                    var c = e[r],
                      d = t ? t(c) : c;
                    if (((c = n || 0 !== c ? c : 0), o && d == d)) {
                      for (var f = l.length; f--; ) if (l[f] === d) continue e;
                      t && l.push(d), s.push(c);
                    } else i(l, d, n) || (l !== s && l.push(d), s.push(c));
                  }
                  return s;
                }
                function ui(e, t) {
                  return null == (e = ka(e, (t = mi(t, e)))) || delete e[Ba(Ka(t))];
                }
                function ci(e, t, n, r) {
                  return Qr(e, t, n(xr(e, t)), r);
                }
                function di(e, t, n, r) {
                  for (var i = e.length, a = r ? i : -1; (r ? a-- : ++a < i) && t(e[a], a, e); );
                  return n ? ti(e, r ? 0 : a, r ? a + 1 : i) : ti(e, r ? a + 1 : 0, r ? i : a);
                }
                function fi(e, t) {
                  var n = e;
                  return (
                    n instanceof Wn && (n = n.value()),
                    St(
                      t,
                      function (e, t) {
                        return t.func.apply(t.thisArg, Et([e], t.args));
                      },
                      n
                    )
                  );
                }
                function pi(e, t, n) {
                  var i = e.length;
                  if (i < 2) return i ? li(e[0]) : [];
                  for (var a = -1, o = r(i); ++a < i; ) for (var s = e[a], l = -1; ++l < i; ) l != a && (o[a] = cr(o[a] || s, e[l], t, n));
                  return li(gr(o, 1), t, n);
                }
                function hi(e, t, n) {
                  for (var r = -1, a = e.length, o = t.length, s = {}; ++r < a; ) {
                    var l = r < o ? t[r] : i;
                    n(s, e[r], l);
                  }
                  return s;
                }
                function vi(e) {
                  return Xo(e) ? e : [];
                }
                function gi(e) {
                  return "function" == typeof e ? e : il;
                }
                function mi(e, t) {
                  return Vo(e) ? e : ya(e, t) ? [e] : ja(bs(e));
                }
                var yi = Xr;
                function bi(e, t, n) {
                  var r = e.length;
                  return (n = n === i ? r : n), !t && n >= r ? e : ti(e, t, n);
                }
                var wi =
                  ct ||
                  function (e) {
                    return at.clearTimeout(e);
                  };
                function _i(e, t) {
                  if (t) return e.slice();
                  var n = e.length,
                    r = We ? We(n) : new e.constructor(n);
                  return e.copy(r), r;
                }
                function xi(e) {
                  var t = new e.constructor(e.byteLength);
                  return new He(t).set(new He(e)), t;
                }
                function Ci(e, t) {
                  var n = t ? xi(e.buffer) : e.buffer;
                  return new e.constructor(n, e.byteOffset, e.length);
                }
                function Ti(e, t) {
                  if (e !== t) {
                    var n = e !== i,
                      r = null === e,
                      a = e == e,
                      o = us(e),
                      s = t !== i,
                      l = null === t,
                      u = t == t,
                      c = us(t);
                    if ((!l && !c && !o && e > t) || (o && s && u && !l && !c) || (r && s && u) || (!n && u) || !a) return 1;
                    if ((!r && !o && !c && e < t) || (c && n && a && !r && !o) || (l && n && a) || (!s && a) || !u) return -1;
                  }
                  return 0;
                }
                function ki(e, t, n, i) {
                  for (var a = -1, o = e.length, s = n.length, l = -1, u = t.length, c = mn(o - s, 0), d = r(u + c), f = !i; ++l < u; ) d[l] = t[l];
                  for (; ++a < s; ) (f || a < o) && (d[n[a]] = e[a]);
                  for (; c--; ) d[l++] = e[a++];
                  return d;
                }
                function Ei(e, t, n, i) {
                  for (var a = -1, o = e.length, s = -1, l = n.length, u = -1, c = t.length, d = mn(o - l, 0), f = r(d + c), p = !i; ++a < d; ) f[a] = e[a];
                  for (var h = a; ++u < c; ) f[h + u] = t[u];
                  for (; ++s < l; ) (p || a < o) && (f[h + n[s]] = e[a++]);
                  return f;
                }
                function Si(e, t) {
                  var n = -1,
                    i = e.length;
                  for (t || (t = r(i)); ++n < i; ) t[n] = e[n];
                  return t;
                }
                function Oi(e, t, n, r) {
                  var a = !n;
                  n || (n = {});
                  for (var o = -1, s = t.length; ++o < s; ) {
                    var l = t[o],
                      u = r ? r(n[l], e[l], l, n, e) : i;
                    u === i && (u = e[l]), a ? ir(n, l, u) : er(n, l, u);
                  }
                  return n;
                }
                function Mi(e, t) {
                  return function (n, r) {
                    var i = Vo(n) ? yt : nr,
                      a = t ? t() : {};
                    return i(n, e, oa(r, 2), a);
                  };
                }
                function Pi(e) {
                  return Xr(function (t, n) {
                    var r = -1,
                      a = n.length,
                      o = a > 1 ? n[a - 1] : i,
                      s = a > 2 ? n[2] : i;
                    for (o = e.length > 3 && "function" == typeof o ? (a--, o) : i, s && ma(n[0], n[1], s) && ((o = a < 3 ? i : o), (a = 1)), t = Te(t); ++r < a; ) {
                      var l = n[r];
                      l && e(t, l, r, o);
                    }
                    return t;
                  });
                }
                function Ai(e, t) {
                  return function (n, r) {
                    if (null == n) return n;
                    if (!Go(n)) return e(n, r);
                    for (var i = n.length, a = t ? i : -1, o = Te(n); (t ? a-- : ++a < i) && !1 !== r(o[a], a, o); );
                    return n;
                  };
                }
                function Li(e) {
                  return function (t, n, r) {
                    for (var i = -1, a = Te(t), o = r(t), s = o.length; s--; ) {
                      var l = o[e ? s : ++i];
                      if (!1 === n(a[l], l, a)) break;
                    }
                    return t;
                  };
                }
                function Ii(e) {
                  return function (t) {
                    var n = Zt((t = bs(t))) ? on(t) : i,
                      r = n ? n[0] : t.charAt(0),
                      a = n ? bi(n, 1).join("") : t.slice(1);
                    return r[e]() + a;
                  };
                }
                function Di(e) {
                  return function (t) {
                    return St(Zs($s(t).replace($e, "")), e, "");
                  };
                }
                function zi(e) {
                  return function () {
                    var t = arguments;
                    switch (t.length) {
                      case 0:
                        return new e();
                      case 1:
                        return new e(t[0]);
                      case 2:
                        return new e(t[0], t[1]);
                      case 3:
                        return new e(t[0], t[1], t[2]);
                      case 4:
                        return new e(t[0], t[1], t[2], t[3]);
                      case 5:
                        return new e(t[0], t[1], t[2], t[3], t[4]);
                      case 6:
                        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                      case 7:
                        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var n = qn(e.prototype),
                      r = e.apply(n, t);
                    return ts(r) ? r : n;
                  };
                }
                function ji(e) {
                  return function (t, n, r) {
                    var a = Te(t);
                    if (!Go(t)) {
                      var o = oa(n, 3);
                      (t = Ls(t)),
                        (n = function (e) {
                          return o(a[e], e, a);
                        });
                    }
                    var s = e(t, n, r);
                    return s > -1 ? a[o ? t[s] : s] : i;
                  };
                }
                function Bi(e) {
                  return ea(function (t) {
                    var n = t.length,
                      r = n,
                      o = Hn.prototype.thru;
                    for (e && t.reverse(); r--; ) {
                      var s = t[r];
                      if ("function" != typeof s) throw new Se(a);
                      if (o && !l && "wrapper" == ia(s)) var l = new Hn([], !0);
                    }
                    for (r = l ? r : n; ++r < n; ) {
                      var u = ia((s = t[r])),
                        c = "wrapper" == u ? ra(s) : i;
                      l = c && ba(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? l[ia(c[0])].apply(l, c[3]) : 1 == s.length && ba(s) ? l[u]() : l.thru(s);
                    }
                    return function () {
                      var e = arguments,
                        r = e[0];
                      if (l && 1 == e.length && Vo(r)) return l.plant(r).value();
                      for (var i = 0, a = n ? t[i].apply(this, e) : r; ++i < n; ) a = t[i].call(this, a);
                      return a;
                    };
                  });
                }
                function Ni(e, t, n, a, o, s, l, c, d, f) {
                  var p = t & u,
                    h = 1 & t,
                    v = 2 & t,
                    g = 24 & t,
                    m = 512 & t,
                    y = v ? i : zi(e);
                  return function i() {
                    for (var u = arguments.length, b = r(u), w = u; w--; ) b[w] = arguments[w];
                    if (g)
                      var _ = aa(i),
                        x = Xt(b, _);
                    if ((a && (b = ki(b, a, o, g)), s && (b = Ei(b, s, l, g)), (u -= x), g && u < f)) {
                      var C = tn(b, _);
                      return Vi(e, t, Ni, i.placeholder, n, b, C, c, d, f - u);
                    }
                    var T = h ? n : this,
                      k = v ? T[e] : e;
                    return (u = b.length), c ? (b = Ea(b, c)) : m && u > 1 && b.reverse(), p && d < u && (b.length = d), this && this !== at && this instanceof i && (k = y || zi(k)), k.apply(T, b);
                  };
                }
                function Ri(e, t) {
                  return function (n, r) {
                    return (function (e, t, n, r) {
                      return (
                        br(e, function (e, i, a) {
                          t(r, n(e), i, a);
                        }),
                        r
                      );
                    })(n, e, t(r), {});
                  };
                }
                function qi(e, t) {
                  return function (n, r) {
                    var a;
                    if (n === i && r === i) return t;
                    if ((n !== i && (a = n), r !== i)) {
                      if (a === i) return r;
                      "string" == typeof n || "string" == typeof r ? ((n = si(n)), (r = si(r))) : ((n = oi(n)), (r = oi(r))), (a = e(n, r));
                    }
                    return a;
                  };
                }
                function Fi(e) {
                  return ea(function (t) {
                    return (
                      (t = kt(t, Wt(oa()))),
                      Xr(function (n) {
                        var r = this;
                        return e(t, function (e) {
                          return mt(e, r, n);
                        });
                      })
                    );
                  });
                }
                function Hi(e, t) {
                  var n = (t = t === i ? " " : si(t)).length;
                  if (n < 2) return n ? Gr(t, e) : t;
                  var r = Gr(t, cn(e / an(t)));
                  return Zt(t) ? bi(on(r), 0, e).join("") : r.slice(0, e);
                }
                function Wi(e) {
                  return function (t, n, a) {
                    return (
                      a && "number" != typeof a && ma(t, n, a) && (n = a = i),
                      (t = hs(t)),
                      n === i ? ((n = t), (t = 0)) : (n = hs(n)),
                      (function (e, t, n, i) {
                        for (var a = -1, o = mn(cn((t - e) / (n || 1)), 0), s = r(o); o--; ) (s[i ? o : ++a] = e), (e += n);
                        return s;
                      })(t, n, (a = a === i ? (t < n ? 1 : -1) : hs(a)), e)
                    );
                  };
                }
                function $i(e) {
                  return function (t, n) {
                    return ("string" == typeof t && "string" == typeof n) || ((t = ms(t)), (n = ms(n))), e(t, n);
                  };
                }
                function Vi(e, t, n, r, a, o, s, u, c, d) {
                  var f = 8 & t;
                  (t |= f ? l : 64), 4 & (t &= ~(f ? 64 : l)) || (t &= -4);
                  var p = [e, t, a, f ? o : i, f ? s : i, f ? i : o, f ? i : s, u, c, d],
                    h = n.apply(i, p);
                  return ba(e) && Oa(h, p), (h.placeholder = r), Aa(h, e, t);
                }
                function Yi(e) {
                  var t = Ce[e];
                  return function (e, n) {
                    if (((e = ms(e)), (n = null == n ? 0 : yn(vs(n), 292)) && hn(e))) {
                      var r = (bs(e) + "e").split("e");
                      return +((r = (bs(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
                    }
                    return t(e);
                  };
                }
                var Gi =
                  En && 1 / nn(new En([, -0]))[1] == c
                    ? function (e) {
                        return new En(e);
                      }
                    : ul;
                function Xi(e) {
                  return function (t) {
                    var n = fa(t);
                    return n == x
                      ? Jt(t)
                      : n == S
                      ? rn(t)
                      : (function (e, t) {
                          return kt(t, function (t) {
                            return [t, e[t]];
                          });
                        })(t, e(t));
                  };
                }
                function Ui(e, t, n, o, c, d, f, p) {
                  var h = 2 & t;
                  if (!h && "function" != typeof e) throw new Se(a);
                  var v = o ? o.length : 0;
                  if ((v || ((t &= -97), (o = c = i)), (f = f === i ? f : mn(vs(f), 0)), (p = p === i ? p : vs(p)), (v -= c ? c.length : 0), 64 & t)) {
                    var g = o,
                      m = c;
                    o = c = i;
                  }
                  var y = h ? i : ra(e),
                    b = [e, t, n, o, c, g, m, d, f, p];
                  if (
                    (y &&
                      (function (e, t) {
                        var n = e[1],
                          r = t[1],
                          i = n | r,
                          a = i < 131,
                          o = (r == u && 8 == n) || (r == u && 256 == n && e[7].length <= t[8]) || (384 == r && t[7].length <= t[8] && 8 == n);
                        if (!a && !o) return e;
                        1 & r && ((e[2] = t[2]), (i |= 1 & n ? 0 : 4));
                        var l = t[3];
                        if (l) {
                          var c = e[3];
                          (e[3] = c ? ki(c, l, t[4]) : l), (e[4] = c ? tn(e[3], s) : t[4]);
                        }
                        (l = t[5]) && ((c = e[5]), (e[5] = c ? Ei(c, l, t[6]) : l), (e[6] = c ? tn(e[5], s) : t[6])),
                          (l = t[7]) && (e[7] = l),
                          r & u && (e[8] = null == e[8] ? t[8] : yn(e[8], t[8])),
                          null == e[9] && (e[9] = t[9]),
                          (e[0] = t[0]),
                          (e[1] = i);
                      })(b, y),
                    (e = b[0]),
                    (t = b[1]),
                    (n = b[2]),
                    (o = b[3]),
                    (c = b[4]),
                    !(p = b[9] = b[9] === i ? (h ? 0 : e.length) : mn(b[9] - v, 0)) && 24 & t && (t &= -25),
                    t && 1 != t)
                  )
                    w =
                      8 == t || 16 == t
                        ? (function (e, t, n) {
                            var a = zi(e);
                            return function o() {
                              for (var s = arguments.length, l = r(s), u = s, c = aa(o); u--; ) l[u] = arguments[u];
                              var d = s < 3 && l[0] !== c && l[s - 1] !== c ? [] : tn(l, c);
                              return (s -= d.length) < n ? Vi(e, t, Ni, o.placeholder, i, l, d, i, i, n - s) : mt(this && this !== at && this instanceof o ? a : e, this, l);
                            };
                          })(e, t, p)
                        : (t != l && 33 != t) || c.length
                        ? Ni.apply(i, b)
                        : (function (e, t, n, i) {
                            var a = 1 & t,
                              o = zi(e);
                            return function t() {
                              for (var s = -1, l = arguments.length, u = -1, c = i.length, d = r(c + l), f = this && this !== at && this instanceof t ? o : e; ++u < c; ) d[u] = i[u];
                              for (; l--; ) d[u++] = arguments[++s];
                              return mt(f, a ? n : this, d);
                            };
                          })(e, t, n, o);
                  else
                    var w = (function (e, t, n) {
                      var r = 1 & t,
                        i = zi(e);
                      return function t() {
                        return (this && this !== at && this instanceof t ? i : e).apply(r ? n : this, arguments);
                      };
                    })(e, t, n);
                  return Aa((y ? Zr : Oa)(w, b), e, t);
                }
                function Ki(e, t, n, r) {
                  return e === i || (Fo(e, Pe[n]) && !Ie.call(r, n)) ? t : e;
                }
                function Qi(e, t, n, r, a, o) {
                  return ts(e) && ts(t) && (o.set(t, e), qr(e, t, i, Qi, o), o.delete(t)), e;
                }
                function Zi(e) {
                  return as(e) ? i : e;
                }
                function Ji(e, t, n, r, a, o) {
                  var s = 1 & n,
                    l = e.length,
                    u = t.length;
                  if (l != u && !(s && u > l)) return !1;
                  var c = o.get(e),
                    d = o.get(t);
                  if (c && d) return c == t && d == e;
                  var f = -1,
                    p = !0,
                    h = 2 & n ? new Gn() : i;
                  for (o.set(e, t), o.set(t, e); ++f < l; ) {
                    var v = e[f],
                      g = t[f];
                    if (r) var m = s ? r(g, v, f, t, e, o) : r(v, g, f, e, t, o);
                    if (m !== i) {
                      if (m) continue;
                      p = !1;
                      break;
                    }
                    if (h) {
                      if (
                        !Mt(t, function (e, t) {
                          if (!Vt(h, t) && (v === e || a(v, e, n, r, o))) return h.push(t);
                        })
                      ) {
                        p = !1;
                        break;
                      }
                    } else if (v !== g && !a(v, g, n, r, o)) {
                      p = !1;
                      break;
                    }
                  }
                  return o.delete(e), o.delete(t), p;
                }
                function ea(e) {
                  return Pa(Ta(e, i, Va), e + "");
                }
                function ta(e) {
                  return Cr(e, Ls, ca);
                }
                function na(e) {
                  return Cr(e, Is, da);
                }
                var ra = Mn
                  ? function (e) {
                      return Mn.get(e);
                    }
                  : ul;
                function ia(e) {
                  for (var t = e.name + "", n = Pn[t], r = Ie.call(Pn, t) ? n.length : 0; r--; ) {
                    var i = n[r],
                      a = i.func;
                    if (null == a || a == e) return i.name;
                  }
                  return t;
                }
                function aa(e) {
                  return (Ie.call(Rn, "placeholder") ? Rn : e).placeholder;
                }
                function oa() {
                  var e = Rn.iteratee || al;
                  return (e = e === al ? Dr : e), arguments.length ? e(arguments[0], arguments[1]) : e;
                }
                function sa(e, t) {
                  var n,
                    r,
                    i = e.__data__;
                  return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                }
                function la(e) {
                  for (var t = Ls(e), n = t.length; n--; ) {
                    var r = t[n],
                      i = e[r];
                    t[n] = [r, i, xa(i)];
                  }
                  return t;
                }
                function ua(e, t) {
                  var n = (function (e, t) {
                    return null == e ? i : e[t];
                  })(e, t);
                  return Ir(n) ? n : i;
                }
                var ca = fn
                    ? function (e) {
                        return null == e
                          ? []
                          : ((e = Te(e)),
                            xt(fn(e), function (t) {
                              return et.call(e, t);
                            }));
                      }
                    : gl,
                  da = fn
                    ? function (e) {
                        for (var t = []; e; ) Et(t, ca(e)), (e = Ye(e));
                        return t;
                      }
                    : gl,
                  fa = Tr;
                function pa(e, t, n) {
                  for (var r = -1, i = (t = mi(t, e)).length, a = !1; ++r < i; ) {
                    var o = Ba(t[r]);
                    if (!(a = null != e && n(e, o))) break;
                    e = e[o];
                  }
                  return a || ++r != i ? a : !!(i = null == e ? 0 : e.length) && es(i) && ga(o, i) && (Vo(e) || $o(e));
                }
                function ha(e) {
                  return "function" != typeof e.constructor || _a(e) ? {} : qn(Ye(e));
                }
                function va(e) {
                  return Vo(e) || $o(e) || !!(it && e && e[it]);
                }
                function ga(e, t) {
                  var n = typeof e;
                  return !!(t = null == t ? d : t) && ("number" == n || ("symbol" != n && me.test(e))) && e > -1 && e % 1 == 0 && e < t;
                }
                function ma(e, t, n) {
                  if (!ts(n)) return !1;
                  var r = typeof t;
                  return !!("number" == r ? Go(n) && ga(t, n.length) : "string" == r && t in n) && Fo(n[t], e);
                }
                function ya(e, t) {
                  if (Vo(e)) return !1;
                  var n = typeof e;
                  return !("number" != n && "symbol" != n && "boolean" != n && null != e && !us(e)) || J.test(e) || !Z.test(e) || (null != t && e in Te(t));
                }
                function ba(e) {
                  var t = ia(e),
                    n = Rn[t];
                  if ("function" != typeof n || !(t in Wn.prototype)) return !1;
                  if (e === n) return !0;
                  var r = ra(n);
                  return !!r && e === r[0];
                }
                ((Cn && fa(new Cn(new ArrayBuffer(1))) != L) || (Tn && fa(new Tn()) != x) || (kn && fa(kn.resolve()) != k) || (En && fa(new En()) != S) || (Sn && fa(new Sn()) != P)) &&
                  (fa = function (e) {
                    var t = Tr(e),
                      n = t == T ? e.constructor : i,
                      r = n ? Na(n) : "";
                    if (r)
                      switch (r) {
                        case An:
                          return L;
                        case Ln:
                          return x;
                        case In:
                          return k;
                        case Dn:
                          return S;
                        case zn:
                          return P;
                      }
                    return t;
                  });
                var wa = Ae ? Zo : ml;
                function _a(e) {
                  var t = e && e.constructor;
                  return e === (("function" == typeof t && t.prototype) || Pe);
                }
                function xa(e) {
                  return e == e && !ts(e);
                }
                function Ca(e, t) {
                  return function (n) {
                    return null != n && n[e] === t && (t !== i || e in Te(n));
                  };
                }
                function Ta(e, t, n) {
                  return (
                    (t = mn(t === i ? e.length - 1 : t, 0)),
                    function () {
                      for (var i = arguments, a = -1, o = mn(i.length - t, 0), s = r(o); ++a < o; ) s[a] = i[t + a];
                      a = -1;
                      for (var l = r(t + 1); ++a < t; ) l[a] = i[a];
                      return (l[t] = n(s)), mt(e, this, l);
                    }
                  );
                }
                function ka(e, t) {
                  return t.length < 2 ? e : xr(e, ti(t, 0, -1));
                }
                function Ea(e, t) {
                  for (var n = e.length, r = yn(t.length, n), a = Si(e); r--; ) {
                    var o = t[r];
                    e[r] = ga(o, n) ? a[o] : i;
                  }
                  return e;
                }
                function Sa(e, t) {
                  if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
                }
                var Oa = La(Zr),
                  Ma =
                    Nt ||
                    function (e, t) {
                      return at.setTimeout(e, t);
                    },
                  Pa = La(Jr);
                function Aa(e, t, n) {
                  var r = t + "";
                  return Pa(
                    e,
                    (function (e, t) {
                      var n = t.length;
                      if (!n) return e;
                      var r = n - 1;
                      return (t[r] = (n > 1 ? "& " : "") + t[r]), (t = t.join(n > 2 ? ", " : " ")), e.replace(ae, "{\n/* [wrapped with " + t + "] */\n");
                    })(
                      r,
                      (function (e, t) {
                        return (
                          bt(h, function (n) {
                            var r = "_." + n[0];
                            t & n[1] && !Ct(e, r) && e.push(r);
                          }),
                          e.sort()
                        );
                      })(
                        (function (e) {
                          var t = e.match(oe);
                          return t ? t[1].split(se) : [];
                        })(r),
                        n
                      )
                    )
                  );
                }
                function La(e) {
                  var t = 0,
                    n = 0;
                  return function () {
                    var r = bn(),
                      a = 16 - (r - n);
                    if (((n = r), a > 0)) {
                      if (++t >= 800) return arguments[0];
                    } else t = 0;
                    return e.apply(i, arguments);
                  };
                }
                function Ia(e, t) {
                  var n = -1,
                    r = e.length,
                    a = r - 1;
                  for (t = t === i ? r : t; ++n < t; ) {
                    var o = Yr(n, a),
                      s = e[o];
                    (e[o] = e[n]), (e[n] = s);
                  }
                  return (e.length = t), e;
                }
                var Da,
                  za,
                  ja =
                    ((Da = zo(
                      function (e) {
                        var t = [];
                        return (
                          46 === e.charCodeAt(0) && t.push(""),
                          e.replace(ee, function (e, n, r, i) {
                            t.push(r ? i.replace(ce, "$1") : n || e);
                          }),
                          t
                        );
                      },
                      function (e) {
                        return 500 === za.size && za.clear(), e;
                      }
                    )),
                    (za = Da.cache),
                    Da);
                function Ba(e) {
                  if ("string" == typeof e || us(e)) return e;
                  var t = e + "";
                  return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }
                function Na(e) {
                  if (null != e) {
                    try {
                      return Le.call(e);
                    } catch (e) {}
                    try {
                      return e + "";
                    } catch (e) {}
                  }
                  return "";
                }
                function Ra(e) {
                  if (e instanceof Wn) return e.clone();
                  var t = new Hn(e.__wrapped__, e.__chain__);
                  return (t.__actions__ = Si(e.__actions__)), (t.__index__ = e.__index__), (t.__values__ = e.__values__), t;
                }
                var qa = Xr(function (e, t) {
                    return Xo(e) ? cr(e, gr(t, 1, Xo, !0)) : [];
                  }),
                  Fa = Xr(function (e, t) {
                    var n = Ka(t);
                    return Xo(n) && (n = i), Xo(e) ? cr(e, gr(t, 1, Xo, !0), oa(n, 2)) : [];
                  }),
                  Ha = Xr(function (e, t) {
                    var n = Ka(t);
                    return Xo(n) && (n = i), Xo(e) ? cr(e, gr(t, 1, Xo, !0), i, n) : [];
                  });
                function Wa(e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var i = null == n ? 0 : vs(n);
                  return i < 0 && (i = mn(r + i, 0)), Lt(e, oa(t, 3), i);
                }
                function $a(e, t, n) {
                  var r = null == e ? 0 : e.length;
                  if (!r) return -1;
                  var a = r - 1;
                  return n !== i && ((a = vs(n)), (a = n < 0 ? mn(r + a, 0) : yn(a, r - 1))), Lt(e, oa(t, 3), a, !0);
                }
                function Va(e) {
                  return null != e && e.length ? gr(e, 1) : [];
                }
                function Ya(e) {
                  return e && e.length ? e[0] : i;
                }
                var Ga = Xr(function (e) {
                    var t = kt(e, vi);
                    return t.length && t[0] === e[0] ? Or(t) : [];
                  }),
                  Xa = Xr(function (e) {
                    var t = Ka(e),
                      n = kt(e, vi);
                    return t === Ka(n) ? (t = i) : n.pop(), n.length && n[0] === e[0] ? Or(n, oa(t, 2)) : [];
                  }),
                  Ua = Xr(function (e) {
                    var t = Ka(e),
                      n = kt(e, vi);
                    return (t = "function" == typeof t ? t : i) && n.pop(), n.length && n[0] === e[0] ? Or(n, i, t) : [];
                  });
                function Ka(e) {
                  var t = null == e ? 0 : e.length;
                  return t ? e[t - 1] : i;
                }
                var Qa = Xr(Za);
                function Za(e, t) {
                  return e && e.length && t && t.length ? $r(e, t) : e;
                }
                var Ja = ea(function (e, t) {
                  var n = null == e ? 0 : e.length,
                    r = ar(e, t);
                  return (
                    Vr(
                      e,
                      kt(t, function (e) {
                        return ga(e, n) ? +e : e;
                      }).sort(Ti)
                    ),
                    r
                  );
                });
                function eo(e) {
                  return null == e ? e : xn.call(e);
                }
                var to = Xr(function (e) {
                    return li(gr(e, 1, Xo, !0));
                  }),
                  no = Xr(function (e) {
                    var t = Ka(e);
                    return Xo(t) && (t = i), li(gr(e, 1, Xo, !0), oa(t, 2));
                  }),
                  ro = Xr(function (e) {
                    var t = Ka(e);
                    return (t = "function" == typeof t ? t : i), li(gr(e, 1, Xo, !0), i, t);
                  });
                function io(e) {
                  if (!e || !e.length) return [];
                  var t = 0;
                  return (
                    (e = xt(e, function (e) {
                      if (Xo(e)) return (t = mn(e.length, t)), !0;
                    })),
                    Ft(t, function (t) {
                      return kt(e, Bt(t));
                    })
                  );
                }
                function ao(e, t) {
                  if (!e || !e.length) return [];
                  var n = io(e);
                  return null == t
                    ? n
                    : kt(n, function (e) {
                        return mt(t, i, e);
                      });
                }
                var oo = Xr(function (e, t) {
                    return Xo(e) ? cr(e, t) : [];
                  }),
                  so = Xr(function (e) {
                    return pi(xt(e, Xo));
                  }),
                  lo = Xr(function (e) {
                    var t = Ka(e);
                    return Xo(t) && (t = i), pi(xt(e, Xo), oa(t, 2));
                  }),
                  uo = Xr(function (e) {
                    var t = Ka(e);
                    return (t = "function" == typeof t ? t : i), pi(xt(e, Xo), i, t);
                  }),
                  co = Xr(io),
                  fo = Xr(function (e) {
                    var t = e.length,
                      n = t > 1 ? e[t - 1] : i;
                    return (n = "function" == typeof n ? (e.pop(), n) : i), ao(e, n);
                  });
                function po(e) {
                  var t = Rn(e);
                  return (t.__chain__ = !0), t;
                }
                function ho(e, t) {
                  return t(e);
                }
                var vo = ea(function (e) {
                    var t = e.length,
                      n = t ? e[0] : 0,
                      r = this.__wrapped__,
                      a = function (t) {
                        return ar(t, e);
                      };
                    return !(t > 1 || this.__actions__.length) && r instanceof Wn && ga(n)
                      ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({ func: ho, args: [a], thisArg: i }),
                        new Hn(r, this.__chain__).thru(function (e) {
                          return t && !e.length && e.push(i), e;
                        }))
                      : this.thru(a);
                  }),
                  go = Mi(function (e, t, n) {
                    Ie.call(e, n) ? ++e[n] : ir(e, n, 1);
                  }),
                  mo = ji(Wa),
                  yo = ji($a);
                function bo(e, t) {
                  return (Vo(e) ? bt : dr)(e, oa(t, 3));
                }
                function wo(e, t) {
                  return (Vo(e) ? wt : fr)(e, oa(t, 3));
                }
                var _o = Mi(function (e, t, n) {
                    Ie.call(e, n) ? e[n].push(t) : ir(e, n, [t]);
                  }),
                  xo = Xr(function (e, t, n) {
                    var i = -1,
                      a = "function" == typeof t,
                      o = Go(e) ? r(e.length) : [];
                    return (
                      dr(e, function (e) {
                        o[++i] = a ? mt(t, e, n) : Mr(e, t, n);
                      }),
                      o
                    );
                  }),
                  Co = Mi(function (e, t, n) {
                    ir(e, n, t);
                  });
                function To(e, t) {
                  return (Vo(e) ? kt : Br)(e, oa(t, 3));
                }
                var ko = Mi(
                    function (e, t, n) {
                      e[n ? 0 : 1].push(t);
                    },
                    function () {
                      return [[], []];
                    }
                  ),
                  Eo = Xr(function (e, t) {
                    if (null == e) return [];
                    var n = t.length;
                    return n > 1 && ma(e, t[0], t[1]) ? (t = []) : n > 2 && ma(t[0], t[1], t[2]) && (t = [t[0]]), Hr(e, gr(t, 1), []);
                  }),
                  So =
                    Pt ||
                    function () {
                      return at.Date.now();
                    };
                function Oo(e, t, n) {
                  return (t = n ? i : t), (t = e && null == t ? e.length : t), Ui(e, u, i, i, i, i, t);
                }
                function Mo(e, t) {
                  var n;
                  if ("function" != typeof t) throw new Se(a);
                  return (
                    (e = vs(e)),
                    function () {
                      return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = i), n;
                    }
                  );
                }
                var Po = Xr(function (e, t, n) {
                    var r = 1;
                    if (n.length) {
                      var i = tn(n, aa(Po));
                      r |= l;
                    }
                    return Ui(e, r, t, n, i);
                  }),
                  Ao = Xr(function (e, t, n) {
                    var r = 3;
                    if (n.length) {
                      var i = tn(n, aa(Ao));
                      r |= l;
                    }
                    return Ui(t, r, e, n, i);
                  });
                function Lo(e, t, n) {
                  var r,
                    o,
                    s,
                    l,
                    u,
                    c,
                    d = 0,
                    f = !1,
                    p = !1,
                    h = !0;
                  if ("function" != typeof e) throw new Se(a);
                  function v(t) {
                    var n = r,
                      a = o;
                    return (r = o = i), (d = t), (l = e.apply(a, n));
                  }
                  function g(e) {
                    return (d = e), (u = Ma(y, t)), f ? v(e) : l;
                  }
                  function m(e) {
                    var n = e - c;
                    return c === i || n >= t || n < 0 || (p && e - d >= s);
                  }
                  function y() {
                    var e = So();
                    if (m(e)) return b(e);
                    u = Ma(
                      y,
                      (function (e) {
                        var n = t - (e - c);
                        return p ? yn(n, s - (e - d)) : n;
                      })(e)
                    );
                  }
                  function b(e) {
                    return (u = i), h && r ? v(e) : ((r = o = i), l);
                  }
                  function w() {
                    var e = So(),
                      n = m(e);
                    if (((r = arguments), (o = this), (c = e), n)) {
                      if (u === i) return g(c);
                      if (p) return wi(u), (u = Ma(y, t)), v(c);
                    }
                    return u === i && (u = Ma(y, t)), l;
                  }
                  return (
                    (t = ms(t) || 0),
                    ts(n) && ((f = !!n.leading), (s = (p = "maxWait" in n) ? mn(ms(n.maxWait) || 0, t) : s), (h = "trailing" in n ? !!n.trailing : h)),
                    (w.cancel = function () {
                      u !== i && wi(u), (d = 0), (r = c = o = u = i);
                    }),
                    (w.flush = function () {
                      return u === i ? l : b(So());
                    }),
                    w
                  );
                }
                var Io = Xr(function (e, t) {
                    return ur(e, 1, t);
                  }),
                  Do = Xr(function (e, t, n) {
                    return ur(e, ms(t) || 0, n);
                  });
                function zo(e, t) {
                  if ("function" != typeof e || (null != t && "function" != typeof t)) throw new Se(a);
                  var n = function () {
                    var r = arguments,
                      i = t ? t.apply(this, r) : r[0],
                      a = n.cache;
                    if (a.has(i)) return a.get(i);
                    var o = e.apply(this, r);
                    return (n.cache = a.set(i, o) || a), o;
                  };
                  return (n.cache = new (zo.Cache || Yn)()), n;
                }
                function jo(e) {
                  if ("function" != typeof e) throw new Se(a);
                  return function () {
                    var t = arguments;
                    switch (t.length) {
                      case 0:
                        return !e.call(this);
                      case 1:
                        return !e.call(this, t[0]);
                      case 2:
                        return !e.call(this, t[0], t[1]);
                      case 3:
                        return !e.call(this, t[0], t[1], t[2]);
                    }
                    return !e.apply(this, t);
                  };
                }
                zo.Cache = Yn;
                var Bo = yi(function (e, t) {
                    var n = (t = 1 == t.length && Vo(t[0]) ? kt(t[0], Wt(oa())) : kt(gr(t, 1), Wt(oa()))).length;
                    return Xr(function (r) {
                      for (var i = -1, a = yn(r.length, n); ++i < a; ) r[i] = t[i].call(this, r[i]);
                      return mt(e, this, r);
                    });
                  }),
                  No = Xr(function (e, t) {
                    var n = tn(t, aa(No));
                    return Ui(e, l, i, t, n);
                  }),
                  Ro = Xr(function (e, t) {
                    var n = tn(t, aa(Ro));
                    return Ui(e, 64, i, t, n);
                  }),
                  qo = ea(function (e, t) {
                    return Ui(e, 256, i, i, i, t);
                  });
                function Fo(e, t) {
                  return e === t || (e != e && t != t);
                }
                var Ho = $i(kr),
                  Wo = $i(function (e, t) {
                    return e >= t;
                  }),
                  $o = Pr(
                    (function () {
                      return arguments;
                    })()
                  )
                    ? Pr
                    : function (e) {
                        return ns(e) && Ie.call(e, "callee") && !et.call(e, "callee");
                      },
                  Vo = r.isArray,
                  Yo = dt
                    ? Wt(dt)
                    : function (e) {
                        return ns(e) && Tr(e) == A;
                      };
                function Go(e) {
                  return null != e && es(e.length) && !Zo(e);
                }
                function Xo(e) {
                  return ns(e) && Go(e);
                }
                var Uo = pn || ml,
                  Ko = ft
                    ? Wt(ft)
                    : function (e) {
                        return ns(e) && Tr(e) == y;
                      };
                function Qo(e) {
                  if (!ns(e)) return !1;
                  var t = Tr(e);
                  return t == b || "[object DOMException]" == t || ("string" == typeof e.message && "string" == typeof e.name && !as(e));
                }
                function Zo(e) {
                  if (!ts(e)) return !1;
                  var t = Tr(e);
                  return t == w || t == _ || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                }
                function Jo(e) {
                  return "number" == typeof e && e == vs(e);
                }
                function es(e) {
                  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= d;
                }
                function ts(e) {
                  var t = typeof e;
                  return null != e && ("object" == t || "function" == t);
                }
                function ns(e) {
                  return null != e && "object" == typeof e;
                }
                var rs = pt
                  ? Wt(pt)
                  : function (e) {
                      return ns(e) && fa(e) == x;
                    };
                function is(e) {
                  return "number" == typeof e || (ns(e) && Tr(e) == C);
                }
                function as(e) {
                  if (!ns(e) || Tr(e) != T) return !1;
                  var t = Ye(e);
                  if (null === t) return !0;
                  var n = Ie.call(t, "constructor") && t.constructor;
                  return "function" == typeof n && n instanceof n && Le.call(n) == Be;
                }
                var os = ht
                    ? Wt(ht)
                    : function (e) {
                        return ns(e) && Tr(e) == E;
                      },
                  ss = vt
                    ? Wt(vt)
                    : function (e) {
                        return ns(e) && fa(e) == S;
                      };
                function ls(e) {
                  return "string" == typeof e || (!Vo(e) && ns(e) && Tr(e) == O);
                }
                function us(e) {
                  return "symbol" == typeof e || (ns(e) && Tr(e) == M);
                }
                var cs = gt
                    ? Wt(gt)
                    : function (e) {
                        return ns(e) && es(e.length) && !!Ze[Tr(e)];
                      },
                  ds = $i(jr),
                  fs = $i(function (e, t) {
                    return e <= t;
                  });
                function ps(e) {
                  if (!e) return [];
                  if (Go(e)) return ls(e) ? on(e) : Si(e);
                  if (ot && e[ot])
                    return (function (e) {
                      for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
                      return n;
                    })(e[ot]());
                  var t = fa(e);
                  return (t == x ? Jt : t == S ? nn : Fs)(e);
                }
                function hs(e) {
                  return e ? ((e = ms(e)) === c || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0) : 0 === e ? e : 0;
                }
                function vs(e) {
                  var t = hs(e),
                    n = t % 1;
                  return t == t ? (n ? t - n : t) : 0;
                }
                function gs(e) {
                  return e ? or(vs(e), 0, p) : 0;
                }
                function ms(e) {
                  if ("number" == typeof e) return e;
                  if (us(e)) return f;
                  if (ts(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = ts(t) ? t + "" : t;
                  }
                  if ("string" != typeof e) return 0 === e ? e : +e;
                  e = Ht(e);
                  var n = he.test(e);
                  return n || ge.test(e) ? nt(e.slice(2), n ? 2 : 8) : pe.test(e) ? f : +e;
                }
                function ys(e) {
                  return Oi(e, Is(e));
                }
                function bs(e) {
                  return null == e ? "" : si(e);
                }
                var ws = Pi(function (e, t) {
                    if (_a(t) || Go(t)) Oi(t, Ls(t), e);
                    else for (var n in t) Ie.call(t, n) && er(e, n, t[n]);
                  }),
                  _s = Pi(function (e, t) {
                    Oi(t, Is(t), e);
                  }),
                  xs = Pi(function (e, t, n, r) {
                    Oi(t, Is(t), e, r);
                  }),
                  Cs = Pi(function (e, t, n, r) {
                    Oi(t, Ls(t), e, r);
                  }),
                  Ts = ea(ar),
                  ks = Xr(function (e, t) {
                    e = Te(e);
                    var n = -1,
                      r = t.length,
                      a = r > 2 ? t[2] : i;
                    for (a && ma(t[0], t[1], a) && (r = 1); ++n < r; )
                      for (var o = t[n], s = Is(o), l = -1, u = s.length; ++l < u; ) {
                        var c = s[l],
                          d = e[c];
                        (d === i || (Fo(d, Pe[c]) && !Ie.call(e, c))) && (e[c] = o[c]);
                      }
                    return e;
                  }),
                  Es = Xr(function (e) {
                    return e.push(i, Qi), mt(zs, i, e);
                  });
                function Ss(e, t, n) {
                  var r = null == e ? i : xr(e, t);
                  return r === i ? n : r;
                }
                function Os(e, t) {
                  return null != e && pa(e, t, Sr);
                }
                var Ms = Ri(function (e, t, n) {
                    null != t && "function" != typeof t.toString && (t = je.call(t)), (e[t] = n);
                  }, tl(il)),
                  Ps = Ri(function (e, t, n) {
                    null != t && "function" != typeof t.toString && (t = je.call(t)), Ie.call(e, t) ? e[t].push(n) : (e[t] = [n]);
                  }, oa),
                  As = Xr(Mr);
                function Ls(e) {
                  return Go(e) ? Un(e) : zr(e);
                }
                function Is(e) {
                  return Go(e)
                    ? Un(e, !0)
                    : (function (e) {
                        if (!ts(e))
                          return (function (e) {
                            var t = [];
                            if (null != e) for (var n in Te(e)) t.push(n);
                            return t;
                          })(e);
                        var t = _a(e),
                          n = [];
                        for (var r in e) ("constructor" != r || (!t && Ie.call(e, r))) && n.push(r);
                        return n;
                      })(e);
                }
                var Ds = Pi(function (e, t, n) {
                    qr(e, t, n);
                  }),
                  zs = Pi(function (e, t, n, r) {
                    qr(e, t, n, r);
                  }),
                  js = ea(function (e, t) {
                    var n = {};
                    if (null == e) return n;
                    var r = !1;
                    (t = kt(t, function (t) {
                      return (t = mi(t, e)), r || (r = t.length > 1), t;
                    })),
                      Oi(e, na(e), n),
                      r && (n = sr(n, 7, Zi));
                    for (var i = t.length; i--; ) ui(n, t[i]);
                    return n;
                  }),
                  Bs = ea(function (e, t) {
                    return null == e
                      ? {}
                      : (function (e, t) {
                          return Wr(e, t, function (t, n) {
                            return Os(e, n);
                          });
                        })(e, t);
                  });
                function Ns(e, t) {
                  if (null == e) return {};
                  var n = kt(na(e), function (e) {
                    return [e];
                  });
                  return (
                    (t = oa(t)),
                    Wr(e, n, function (e, n) {
                      return t(e, n[0]);
                    })
                  );
                }
                var Rs = Xi(Ls),
                  qs = Xi(Is);
                function Fs(e) {
                  return null == e ? [] : $t(e, Ls(e));
                }
                var Hs = Di(function (e, t, n) {
                  return (t = t.toLowerCase()), e + (n ? Ws(t) : t);
                });
                function Ws(e) {
                  return Qs(bs(e).toLowerCase());
                }
                function $s(e) {
                  return (e = bs(e)) && e.replace(ye, Ut).replace(Ve, "");
                }
                var Vs = Di(function (e, t, n) {
                    return e + (n ? "-" : "") + t.toLowerCase();
                  }),
                  Ys = Di(function (e, t, n) {
                    return e + (n ? " " : "") + t.toLowerCase();
                  }),
                  Gs = Ii("toLowerCase"),
                  Xs = Di(function (e, t, n) {
                    return e + (n ? "_" : "") + t.toLowerCase();
                  }),
                  Us = Di(function (e, t, n) {
                    return e + (n ? " " : "") + Qs(t);
                  }),
                  Ks = Di(function (e, t, n) {
                    return e + (n ? " " : "") + t.toUpperCase();
                  }),
                  Qs = Ii("toUpperCase");
                function Zs(e, t, n) {
                  return (
                    (e = bs(e)),
                    (t = n ? i : t) === i
                      ? (function (e) {
                          return Ue.test(e);
                        })(e)
                        ? (function (e) {
                            return e.match(Ge) || [];
                          })(e)
                        : (function (e) {
                            return e.match(le) || [];
                          })(e)
                      : e.match(t) || []
                  );
                }
                var Js = Xr(function (e, t) {
                    try {
                      return mt(e, i, t);
                    } catch (e) {
                      return Qo(e) ? e : new _e(e);
                    }
                  }),
                  el = ea(function (e, t) {
                    return (
                      bt(t, function (t) {
                        (t = Ba(t)), ir(e, t, Po(e[t], e));
                      }),
                      e
                    );
                  });
                function tl(e) {
                  return function () {
                    return e;
                  };
                }
                var nl = Bi(),
                  rl = Bi(!0);
                function il(e) {
                  return e;
                }
                function al(e) {
                  return Dr("function" == typeof e ? e : sr(e, 1));
                }
                var ol = Xr(function (e, t) {
                    return function (n) {
                      return Mr(n, e, t);
                    };
                  }),
                  sl = Xr(function (e, t) {
                    return function (n) {
                      return Mr(e, n, t);
                    };
                  });
                function ll(e, t, n) {
                  var r = Ls(t),
                    i = _r(t, r);
                  null != n || (ts(t) && (i.length || !r.length)) || ((n = t), (t = e), (e = this), (i = _r(t, Ls(t))));
                  var a = !(ts(n) && "chain" in n && !n.chain),
                    o = Zo(e);
                  return (
                    bt(i, function (n) {
                      var r = t[n];
                      (e[n] = r),
                        o &&
                          (e.prototype[n] = function () {
                            var t = this.__chain__;
                            if (a || t) {
                              var n = e(this.__wrapped__),
                                i = (n.__actions__ = Si(this.__actions__));
                              return i.push({ func: r, args: arguments, thisArg: e }), (n.__chain__ = t), n;
                            }
                            return r.apply(e, Et([this.value()], arguments));
                          });
                    }),
                    e
                  );
                }
                function ul() {}
                var cl = Fi(kt),
                  dl = Fi(_t),
                  fl = Fi(Mt);
                function pl(e) {
                  return ya(e)
                    ? Bt(Ba(e))
                    : (function (e) {
                        return function (t) {
                          return xr(t, e);
                        };
                      })(e);
                }
                var hl = Wi(),
                  vl = Wi(!0);
                function gl() {
                  return [];
                }
                function ml() {
                  return !1;
                }
                var yl,
                  bl = qi(function (e, t) {
                    return e + t;
                  }, 0),
                  wl = Yi("ceil"),
                  _l = qi(function (e, t) {
                    return e / t;
                  }, 1),
                  xl = Yi("floor"),
                  Cl = qi(function (e, t) {
                    return e * t;
                  }, 1),
                  Tl = Yi("round"),
                  kl = qi(function (e, t) {
                    return e - t;
                  }, 0);
                return (
                  (Rn.after = function (e, t) {
                    if ("function" != typeof t) throw new Se(a);
                    return (
                      (e = vs(e)),
                      function () {
                        if (--e < 1) return t.apply(this, arguments);
                      }
                    );
                  }),
                  (Rn.ary = Oo),
                  (Rn.assign = ws),
                  (Rn.assignIn = _s),
                  (Rn.assignInWith = xs),
                  (Rn.assignWith = Cs),
                  (Rn.at = Ts),
                  (Rn.before = Mo),
                  (Rn.bind = Po),
                  (Rn.bindAll = el),
                  (Rn.bindKey = Ao),
                  (Rn.castArray = function () {
                    if (!arguments.length) return [];
                    var e = arguments[0];
                    return Vo(e) ? e : [e];
                  }),
                  (Rn.chain = po),
                  (Rn.chunk = function (e, t, n) {
                    t = (n ? ma(e, t, n) : t === i) ? 1 : mn(vs(t), 0);
                    var a = null == e ? 0 : e.length;
                    if (!a || t < 1) return [];
                    for (var o = 0, s = 0, l = r(cn(a / t)); o < a; ) l[s++] = ti(e, o, (o += t));
                    return l;
                  }),
                  (Rn.compact = function (e) {
                    for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n; ) {
                      var a = e[t];
                      a && (i[r++] = a);
                    }
                    return i;
                  }),
                  (Rn.concat = function () {
                    var e = arguments.length;
                    if (!e) return [];
                    for (var t = r(e - 1), n = arguments[0], i = e; i--; ) t[i - 1] = arguments[i];
                    return Et(Vo(n) ? Si(n) : [n], gr(t, 1));
                  }),
                  (Rn.cond = function (e) {
                    var t = null == e ? 0 : e.length,
                      n = oa();
                    return (
                      (e = t
                        ? kt(e, function (e) {
                            if ("function" != typeof e[1]) throw new Se(a);
                            return [n(e[0]), e[1]];
                          })
                        : []),
                      Xr(function (n) {
                        for (var r = -1; ++r < t; ) {
                          var i = e[r];
                          if (mt(i[0], this, n)) return mt(i[1], this, n);
                        }
                      })
                    );
                  }),
                  (Rn.conforms = function (e) {
                    return (function (e) {
                      var t = Ls(e);
                      return function (n) {
                        return lr(n, e, t);
                      };
                    })(sr(e, 1));
                  }),
                  (Rn.constant = tl),
                  (Rn.countBy = go),
                  (Rn.create = function (e, t) {
                    var n = qn(e);
                    return null == t ? n : rr(n, t);
                  }),
                  (Rn.curry = function e(t, n, r) {
                    var a = Ui(t, 8, i, i, i, i, i, (n = r ? i : n));
                    return (a.placeholder = e.placeholder), a;
                  }),
                  (Rn.curryRight = function e(t, n, r) {
                    var a = Ui(t, 16, i, i, i, i, i, (n = r ? i : n));
                    return (a.placeholder = e.placeholder), a;
                  }),
                  (Rn.debounce = Lo),
                  (Rn.defaults = ks),
                  (Rn.defaultsDeep = Es),
                  (Rn.defer = Io),
                  (Rn.delay = Do),
                  (Rn.difference = qa),
                  (Rn.differenceBy = Fa),
                  (Rn.differenceWith = Ha),
                  (Rn.drop = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    return r ? ti(e, (t = n || t === i ? 1 : vs(t)) < 0 ? 0 : t, r) : [];
                  }),
                  (Rn.dropRight = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    return r ? ti(e, 0, (t = r - (t = n || t === i ? 1 : vs(t))) < 0 ? 0 : t) : [];
                  }),
                  (Rn.dropRightWhile = function (e, t) {
                    return e && e.length ? di(e, oa(t, 3), !0, !0) : [];
                  }),
                  (Rn.dropWhile = function (e, t) {
                    return e && e.length ? di(e, oa(t, 3), !0) : [];
                  }),
                  (Rn.fill = function (e, t, n, r) {
                    var a = null == e ? 0 : e.length;
                    return a
                      ? (n && "number" != typeof n && ma(e, t, n) && ((n = 0), (r = a)),
                        (function (e, t, n, r) {
                          var a = e.length;
                          for ((n = vs(n)) < 0 && (n = -n > a ? 0 : a + n), (r = r === i || r > a ? a : vs(r)) < 0 && (r += a), r = n > r ? 0 : gs(r); n < r; ) e[n++] = t;
                          return e;
                        })(e, t, n, r))
                      : [];
                  }),
                  (Rn.filter = function (e, t) {
                    return (Vo(e) ? xt : vr)(e, oa(t, 3));
                  }),
                  (Rn.flatMap = function (e, t) {
                    return gr(To(e, t), 1);
                  }),
                  (Rn.flatMapDeep = function (e, t) {
                    return gr(To(e, t), c);
                  }),
                  (Rn.flatMapDepth = function (e, t, n) {
                    return (n = n === i ? 1 : vs(n)), gr(To(e, t), n);
                  }),
                  (Rn.flatten = Va),
                  (Rn.flattenDeep = function (e) {
                    return null != e && e.length ? gr(e, c) : [];
                  }),
                  (Rn.flattenDepth = function (e, t) {
                    return null != e && e.length ? gr(e, (t = t === i ? 1 : vs(t))) : [];
                  }),
                  (Rn.flip = function (e) {
                    return Ui(e, 512);
                  }),
                  (Rn.flow = nl),
                  (Rn.flowRight = rl),
                  (Rn.fromPairs = function (e) {
                    for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n; ) {
                      var i = e[t];
                      r[i[0]] = i[1];
                    }
                    return r;
                  }),
                  (Rn.functions = function (e) {
                    return null == e ? [] : _r(e, Ls(e));
                  }),
                  (Rn.functionsIn = function (e) {
                    return null == e ? [] : _r(e, Is(e));
                  }),
                  (Rn.groupBy = _o),
                  (Rn.initial = function (e) {
                    return null != e && e.length ? ti(e, 0, -1) : [];
                  }),
                  (Rn.intersection = Ga),
                  (Rn.intersectionBy = Xa),
                  (Rn.intersectionWith = Ua),
                  (Rn.invert = Ms),
                  (Rn.invertBy = Ps),
                  (Rn.invokeMap = xo),
                  (Rn.iteratee = al),
                  (Rn.keyBy = Co),
                  (Rn.keys = Ls),
                  (Rn.keysIn = Is),
                  (Rn.map = To),
                  (Rn.mapKeys = function (e, t) {
                    var n = {};
                    return (
                      (t = oa(t, 3)),
                      br(e, function (e, r, i) {
                        ir(n, t(e, r, i), e);
                      }),
                      n
                    );
                  }),
                  (Rn.mapValues = function (e, t) {
                    var n = {};
                    return (
                      (t = oa(t, 3)),
                      br(e, function (e, r, i) {
                        ir(n, r, t(e, r, i));
                      }),
                      n
                    );
                  }),
                  (Rn.matches = function (e) {
                    return Nr(sr(e, 1));
                  }),
                  (Rn.matchesProperty = function (e, t) {
                    return Rr(e, sr(t, 1));
                  }),
                  (Rn.memoize = zo),
                  (Rn.merge = Ds),
                  (Rn.mergeWith = zs),
                  (Rn.method = ol),
                  (Rn.methodOf = sl),
                  (Rn.mixin = ll),
                  (Rn.negate = jo),
                  (Rn.nthArg = function (e) {
                    return (
                      (e = vs(e)),
                      Xr(function (t) {
                        return Fr(t, e);
                      })
                    );
                  }),
                  (Rn.omit = js),
                  (Rn.omitBy = function (e, t) {
                    return Ns(e, jo(oa(t)));
                  }),
                  (Rn.once = function (e) {
                    return Mo(2, e);
                  }),
                  (Rn.orderBy = function (e, t, n, r) {
                    return null == e ? [] : (Vo(t) || (t = null == t ? [] : [t]), Vo((n = r ? i : n)) || (n = null == n ? [] : [n]), Hr(e, t, n));
                  }),
                  (Rn.over = cl),
                  (Rn.overArgs = Bo),
                  (Rn.overEvery = dl),
                  (Rn.overSome = fl),
                  (Rn.partial = No),
                  (Rn.partialRight = Ro),
                  (Rn.partition = ko),
                  (Rn.pick = Bs),
                  (Rn.pickBy = Ns),
                  (Rn.property = pl),
                  (Rn.propertyOf = function (e) {
                    return function (t) {
                      return null == e ? i : xr(e, t);
                    };
                  }),
                  (Rn.pull = Qa),
                  (Rn.pullAll = Za),
                  (Rn.pullAllBy = function (e, t, n) {
                    return e && e.length && t && t.length ? $r(e, t, oa(n, 2)) : e;
                  }),
                  (Rn.pullAllWith = function (e, t, n) {
                    return e && e.length && t && t.length ? $r(e, t, i, n) : e;
                  }),
                  (Rn.pullAt = Ja),
                  (Rn.range = hl),
                  (Rn.rangeRight = vl),
                  (Rn.rearg = qo),
                  (Rn.reject = function (e, t) {
                    return (Vo(e) ? xt : vr)(e, jo(oa(t, 3)));
                  }),
                  (Rn.remove = function (e, t) {
                    var n = [];
                    if (!e || !e.length) return n;
                    var r = -1,
                      i = [],
                      a = e.length;
                    for (t = oa(t, 3); ++r < a; ) {
                      var o = e[r];
                      t(o, r, e) && (n.push(o), i.push(r));
                    }
                    return Vr(e, i), n;
                  }),
                  (Rn.rest = function (e, t) {
                    if ("function" != typeof e) throw new Se(a);
                    return Xr(e, (t = t === i ? t : vs(t)));
                  }),
                  (Rn.reverse = eo),
                  (Rn.sampleSize = function (e, t, n) {
                    return (t = (n ? ma(e, t, n) : t === i) ? 1 : vs(t)), (Vo(e) ? Qn : Kr)(e, t);
                  }),
                  (Rn.set = function (e, t, n) {
                    return null == e ? e : Qr(e, t, n);
                  }),
                  (Rn.setWith = function (e, t, n, r) {
                    return (r = "function" == typeof r ? r : i), null == e ? e : Qr(e, t, n, r);
                  }),
                  (Rn.shuffle = function (e) {
                    return (Vo(e) ? Zn : ei)(e);
                  }),
                  (Rn.slice = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    return r ? (n && "number" != typeof n && ma(e, t, n) ? ((t = 0), (n = r)) : ((t = null == t ? 0 : vs(t)), (n = n === i ? r : vs(n))), ti(e, t, n)) : [];
                  }),
                  (Rn.sortBy = Eo),
                  (Rn.sortedUniq = function (e) {
                    return e && e.length ? ai(e) : [];
                  }),
                  (Rn.sortedUniqBy = function (e, t) {
                    return e && e.length ? ai(e, oa(t, 2)) : [];
                  }),
                  (Rn.split = function (e, t, n) {
                    return (
                      n && "number" != typeof n && ma(e, t, n) && (t = n = i), (n = n === i ? p : n >>> 0) ? ((e = bs(e)) && ("string" == typeof t || (null != t && !os(t))) && !(t = si(t)) && Zt(e) ? bi(on(e), 0, n) : e.split(t, n)) : []
                    );
                  }),
                  (Rn.spread = function (e, t) {
                    if ("function" != typeof e) throw new Se(a);
                    return (
                      (t = null == t ? 0 : mn(vs(t), 0)),
                      Xr(function (n) {
                        var r = n[t],
                          i = bi(n, 0, t);
                        return r && Et(i, r), mt(e, this, i);
                      })
                    );
                  }),
                  (Rn.tail = function (e) {
                    var t = null == e ? 0 : e.length;
                    return t ? ti(e, 1, t) : [];
                  }),
                  (Rn.take = function (e, t, n) {
                    return e && e.length ? ti(e, 0, (t = n || t === i ? 1 : vs(t)) < 0 ? 0 : t) : [];
                  }),
                  (Rn.takeRight = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    return r ? ti(e, (t = r - (t = n || t === i ? 1 : vs(t))) < 0 ? 0 : t, r) : [];
                  }),
                  (Rn.takeRightWhile = function (e, t) {
                    return e && e.length ? di(e, oa(t, 3), !1, !0) : [];
                  }),
                  (Rn.takeWhile = function (e, t) {
                    return e && e.length ? di(e, oa(t, 3)) : [];
                  }),
                  (Rn.tap = function (e, t) {
                    return t(e), e;
                  }),
                  (Rn.throttle = function (e, t, n) {
                    var r = !0,
                      i = !0;
                    if ("function" != typeof e) throw new Se(a);
                    return ts(n) && ((r = "leading" in n ? !!n.leading : r), (i = "trailing" in n ? !!n.trailing : i)), Lo(e, t, { leading: r, maxWait: t, trailing: i });
                  }),
                  (Rn.thru = ho),
                  (Rn.toArray = ps),
                  (Rn.toPairs = Rs),
                  (Rn.toPairsIn = qs),
                  (Rn.toPath = function (e) {
                    return Vo(e) ? kt(e, Ba) : us(e) ? [e] : Si(ja(bs(e)));
                  }),
                  (Rn.toPlainObject = ys),
                  (Rn.transform = function (e, t, n) {
                    var r = Vo(e),
                      i = r || Uo(e) || cs(e);
                    if (((t = oa(t, 4)), null == n)) {
                      var a = e && e.constructor;
                      n = i ? (r ? new a() : []) : ts(e) && Zo(a) ? qn(Ye(e)) : {};
                    }
                    return (
                      (i ? bt : br)(e, function (e, r, i) {
                        return t(n, e, r, i);
                      }),
                      n
                    );
                  }),
                  (Rn.unary = function (e) {
                    return Oo(e, 1);
                  }),
                  (Rn.union = to),
                  (Rn.unionBy = no),
                  (Rn.unionWith = ro),
                  (Rn.uniq = function (e) {
                    return e && e.length ? li(e) : [];
                  }),
                  (Rn.uniqBy = function (e, t) {
                    return e && e.length ? li(e, oa(t, 2)) : [];
                  }),
                  (Rn.uniqWith = function (e, t) {
                    return (t = "function" == typeof t ? t : i), e && e.length ? li(e, i, t) : [];
                  }),
                  (Rn.unset = function (e, t) {
                    return null == e || ui(e, t);
                  }),
                  (Rn.unzip = io),
                  (Rn.unzipWith = ao),
                  (Rn.update = function (e, t, n) {
                    return null == e ? e : ci(e, t, gi(n));
                  }),
                  (Rn.updateWith = function (e, t, n, r) {
                    return (r = "function" == typeof r ? r : i), null == e ? e : ci(e, t, gi(n), r);
                  }),
                  (Rn.values = Fs),
                  (Rn.valuesIn = function (e) {
                    return null == e ? [] : $t(e, Is(e));
                  }),
                  (Rn.without = oo),
                  (Rn.words = Zs),
                  (Rn.wrap = function (e, t) {
                    return No(gi(t), e);
                  }),
                  (Rn.xor = so),
                  (Rn.xorBy = lo),
                  (Rn.xorWith = uo),
                  (Rn.zip = co),
                  (Rn.zipObject = function (e, t) {
                    return hi(e || [], t || [], er);
                  }),
                  (Rn.zipObjectDeep = function (e, t) {
                    return hi(e || [], t || [], Qr);
                  }),
                  (Rn.zipWith = fo),
                  (Rn.entries = Rs),
                  (Rn.entriesIn = qs),
                  (Rn.extend = _s),
                  (Rn.extendWith = xs),
                  ll(Rn, Rn),
                  (Rn.add = bl),
                  (Rn.attempt = Js),
                  (Rn.camelCase = Hs),
                  (Rn.capitalize = Ws),
                  (Rn.ceil = wl),
                  (Rn.clamp = function (e, t, n) {
                    return n === i && ((n = t), (t = i)), n !== i && (n = (n = ms(n)) == n ? n : 0), t !== i && (t = (t = ms(t)) == t ? t : 0), or(ms(e), t, n);
                  }),
                  (Rn.clone = function (e) {
                    return sr(e, 4);
                  }),
                  (Rn.cloneDeep = function (e) {
                    return sr(e, 5);
                  }),
                  (Rn.cloneDeepWith = function (e, t) {
                    return sr(e, 5, (t = "function" == typeof t ? t : i));
                  }),
                  (Rn.cloneWith = function (e, t) {
                    return sr(e, 4, (t = "function" == typeof t ? t : i));
                  }),
                  (Rn.conformsTo = function (e, t) {
                    return null == t || lr(e, t, Ls(t));
                  }),
                  (Rn.deburr = $s),
                  (Rn.defaultTo = function (e, t) {
                    return null == e || e != e ? t : e;
                  }),
                  (Rn.divide = _l),
                  (Rn.endsWith = function (e, t, n) {
                    (e = bs(e)), (t = si(t));
                    var r = e.length,
                      a = (n = n === i ? r : or(vs(n), 0, r));
                    return (n -= t.length) >= 0 && e.slice(n, a) == t;
                  }),
                  (Rn.eq = Fo),
                  (Rn.escape = function (e) {
                    return (e = bs(e)) && X.test(e) ? e.replace(Y, Kt) : e;
                  }),
                  (Rn.escapeRegExp = function (e) {
                    return (e = bs(e)) && ne.test(e) ? e.replace(te, "\\$&") : e;
                  }),
                  (Rn.every = function (e, t, n) {
                    var r = Vo(e) ? _t : pr;
                    return n && ma(e, t, n) && (t = i), r(e, oa(t, 3));
                  }),
                  (Rn.find = mo),
                  (Rn.findIndex = Wa),
                  (Rn.findKey = function (e, t) {
                    return At(e, oa(t, 3), br);
                  }),
                  (Rn.findLast = yo),
                  (Rn.findLastIndex = $a),
                  (Rn.findLastKey = function (e, t) {
                    return At(e, oa(t, 3), wr);
                  }),
                  (Rn.floor = xl),
                  (Rn.forEach = bo),
                  (Rn.forEachRight = wo),
                  (Rn.forIn = function (e, t) {
                    return null == e ? e : mr(e, oa(t, 3), Is);
                  }),
                  (Rn.forInRight = function (e, t) {
                    return null == e ? e : yr(e, oa(t, 3), Is);
                  }),
                  (Rn.forOwn = function (e, t) {
                    return e && br(e, oa(t, 3));
                  }),
                  (Rn.forOwnRight = function (e, t) {
                    return e && wr(e, oa(t, 3));
                  }),
                  (Rn.get = Ss),
                  (Rn.gt = Ho),
                  (Rn.gte = Wo),
                  (Rn.has = function (e, t) {
                    return null != e && pa(e, t, Er);
                  }),
                  (Rn.hasIn = Os),
                  (Rn.head = Ya),
                  (Rn.identity = il),
                  (Rn.includes = function (e, t, n, r) {
                    (e = Go(e) ? e : Fs(e)), (n = n && !r ? vs(n) : 0);
                    var i = e.length;
                    return n < 0 && (n = mn(i + n, 0)), ls(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && It(e, t, n) > -1;
                  }),
                  (Rn.indexOf = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    if (!r) return -1;
                    var i = null == n ? 0 : vs(n);
                    return i < 0 && (i = mn(r + i, 0)), It(e, t, i);
                  }),
                  (Rn.inRange = function (e, t, n) {
                    return (
                      (t = hs(t)),
                      n === i ? ((n = t), (t = 0)) : (n = hs(n)),
                      (function (e, t, n) {
                        return e >= yn(t, n) && e < mn(t, n);
                      })((e = ms(e)), t, n)
                    );
                  }),
                  (Rn.invoke = As),
                  (Rn.isArguments = $o),
                  (Rn.isArray = Vo),
                  (Rn.isArrayBuffer = Yo),
                  (Rn.isArrayLike = Go),
                  (Rn.isArrayLikeObject = Xo),
                  (Rn.isBoolean = function (e) {
                    return !0 === e || !1 === e || (ns(e) && Tr(e) == m);
                  }),
                  (Rn.isBuffer = Uo),
                  (Rn.isDate = Ko),
                  (Rn.isElement = function (e) {
                    return ns(e) && 1 === e.nodeType && !as(e);
                  }),
                  (Rn.isEmpty = function (e) {
                    if (null == e) return !0;
                    if (Go(e) && (Vo(e) || "string" == typeof e || "function" == typeof e.splice || Uo(e) || cs(e) || $o(e))) return !e.length;
                    var t = fa(e);
                    if (t == x || t == S) return !e.size;
                    if (_a(e)) return !zr(e).length;
                    for (var n in e) if (Ie.call(e, n)) return !1;
                    return !0;
                  }),
                  (Rn.isEqual = function (e, t) {
                    return Ar(e, t);
                  }),
                  (Rn.isEqualWith = function (e, t, n) {
                    var r = (n = "function" == typeof n ? n : i) ? n(e, t) : i;
                    return r === i ? Ar(e, t, i, n) : !!r;
                  }),
                  (Rn.isError = Qo),
                  (Rn.isFinite = function (e) {
                    return "number" == typeof e && hn(e);
                  }),
                  (Rn.isFunction = Zo),
                  (Rn.isInteger = Jo),
                  (Rn.isLength = es),
                  (Rn.isMap = rs),
                  (Rn.isMatch = function (e, t) {
                    return e === t || Lr(e, t, la(t));
                  }),
                  (Rn.isMatchWith = function (e, t, n) {
                    return (n = "function" == typeof n ? n : i), Lr(e, t, la(t), n);
                  }),
                  (Rn.isNaN = function (e) {
                    return is(e) && e != +e;
                  }),
                  (Rn.isNative = function (e) {
                    if (wa(e)) throw new _e("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
                    return Ir(e);
                  }),
                  (Rn.isNil = function (e) {
                    return null == e;
                  }),
                  (Rn.isNull = function (e) {
                    return null === e;
                  }),
                  (Rn.isNumber = is),
                  (Rn.isObject = ts),
                  (Rn.isObjectLike = ns),
                  (Rn.isPlainObject = as),
                  (Rn.isRegExp = os),
                  (Rn.isSafeInteger = function (e) {
                    return Jo(e) && e >= -9007199254740991 && e <= d;
                  }),
                  (Rn.isSet = ss),
                  (Rn.isString = ls),
                  (Rn.isSymbol = us),
                  (Rn.isTypedArray = cs),
                  (Rn.isUndefined = function (e) {
                    return e === i;
                  }),
                  (Rn.isWeakMap = function (e) {
                    return ns(e) && fa(e) == P;
                  }),
                  (Rn.isWeakSet = function (e) {
                    return ns(e) && "[object WeakSet]" == Tr(e);
                  }),
                  (Rn.join = function (e, t) {
                    return null == e ? "" : vn.call(e, t);
                  }),
                  (Rn.kebabCase = Vs),
                  (Rn.last = Ka),
                  (Rn.lastIndexOf = function (e, t, n) {
                    var r = null == e ? 0 : e.length;
                    if (!r) return -1;
                    var a = r;
                    return (
                      n !== i && (a = (a = vs(n)) < 0 ? mn(r + a, 0) : yn(a, r - 1)),
                      t == t
                        ? (function (e, t, n) {
                            for (var r = n + 1; r--; ) if (e[r] === t) return r;
                            return r;
                          })(e, t, a)
                        : Lt(e, zt, a, !0)
                    );
                  }),
                  (Rn.lowerCase = Ys),
                  (Rn.lowerFirst = Gs),
                  (Rn.lt = ds),
                  (Rn.lte = fs),
                  (Rn.max = function (e) {
                    return e && e.length ? hr(e, il, kr) : i;
                  }),
                  (Rn.maxBy = function (e, t) {
                    return e && e.length ? hr(e, oa(t, 2), kr) : i;
                  }),
                  (Rn.mean = function (e) {
                    return jt(e, il);
                  }),
                  (Rn.meanBy = function (e, t) {
                    return jt(e, oa(t, 2));
                  }),
                  (Rn.min = function (e) {
                    return e && e.length ? hr(e, il, jr) : i;
                  }),
                  (Rn.minBy = function (e, t) {
                    return e && e.length ? hr(e, oa(t, 2), jr) : i;
                  }),
                  (Rn.stubArray = gl),
                  (Rn.stubFalse = ml),
                  (Rn.stubObject = function () {
                    return {};
                  }),
                  (Rn.stubString = function () {
                    return "";
                  }),
                  (Rn.stubTrue = function () {
                    return !0;
                  }),
                  (Rn.multiply = Cl),
                  (Rn.nth = function (e, t) {
                    return e && e.length ? Fr(e, vs(t)) : i;
                  }),
                  (Rn.noConflict = function () {
                    return at._ === this && (at._ = Ne), this;
                  }),
                  (Rn.noop = ul),
                  (Rn.now = So),
                  (Rn.pad = function (e, t, n) {
                    e = bs(e);
                    var r = (t = vs(t)) ? an(e) : 0;
                    if (!t || r >= t) return e;
                    var i = (t - r) / 2;
                    return Hi(dn(i), n) + e + Hi(cn(i), n);
                  }),
                  (Rn.padEnd = function (e, t, n) {
                    e = bs(e);
                    var r = (t = vs(t)) ? an(e) : 0;
                    return t && r < t ? e + Hi(t - r, n) : e;
                  }),
                  (Rn.padStart = function (e, t, n) {
                    e = bs(e);
                    var r = (t = vs(t)) ? an(e) : 0;
                    return t && r < t ? Hi(t - r, n) + e : e;
                  }),
                  (Rn.parseInt = function (e, t, n) {
                    return n || null == t ? (t = 0) : t && (t = +t), wn(bs(e).replace(re, ""), t || 0);
                  }),
                  (Rn.random = function (e, t, n) {
                    if (
                      (n && "boolean" != typeof n && ma(e, t, n) && (t = n = i),
                      n === i && ("boolean" == typeof t ? ((n = t), (t = i)) : "boolean" == typeof e && ((n = e), (e = i))),
                      e === i && t === i ? ((e = 0), (t = 1)) : ((e = hs(e)), t === i ? ((t = e), (e = 0)) : (t = hs(t))),
                      e > t)
                    ) {
                      var r = e;
                      (e = t), (t = r);
                    }
                    if (n || e % 1 || t % 1) {
                      var a = _n();
                      return yn(e + a * (t - e + tt("1e-" + ((a + "").length - 1))), t);
                    }
                    return Yr(e, t);
                  }),
                  (Rn.reduce = function (e, t, n) {
                    var r = Vo(e) ? St : Rt,
                      i = arguments.length < 3;
                    return r(e, oa(t, 4), n, i, dr);
                  }),
                  (Rn.reduceRight = function (e, t, n) {
                    var r = Vo(e) ? Ot : Rt,
                      i = arguments.length < 3;
                    return r(e, oa(t, 4), n, i, fr);
                  }),
                  (Rn.repeat = function (e, t, n) {
                    return (t = (n ? ma(e, t, n) : t === i) ? 1 : vs(t)), Gr(bs(e), t);
                  }),
                  (Rn.replace = function () {
                    var e = arguments,
                      t = bs(e[0]);
                    return e.length < 3 ? t : t.replace(e[1], e[2]);
                  }),
                  (Rn.result = function (e, t, n) {
                    var r = -1,
                      a = (t = mi(t, e)).length;
                    for (a || ((a = 1), (e = i)); ++r < a; ) {
                      var o = null == e ? i : e[Ba(t[r])];
                      o === i && ((r = a), (o = n)), (e = Zo(o) ? o.call(e) : o);
                    }
                    return e;
                  }),
                  (Rn.round = Tl),
                  (Rn.runInContext = e),
                  (Rn.sample = function (e) {
                    return (Vo(e) ? Kn : Ur)(e);
                  }),
                  (Rn.size = function (e) {
                    if (null == e) return 0;
                    if (Go(e)) return ls(e) ? an(e) : e.length;
                    var t = fa(e);
                    return t == x || t == S ? e.size : zr(e).length;
                  }),
                  (Rn.snakeCase = Xs),
                  (Rn.some = function (e, t, n) {
                    var r = Vo(e) ? Mt : ni;
                    return n && ma(e, t, n) && (t = i), r(e, oa(t, 3));
                  }),
                  (Rn.sortedIndex = function (e, t) {
                    return ri(e, t);
                  }),
                  (Rn.sortedIndexBy = function (e, t, n) {
                    return ii(e, t, oa(n, 2));
                  }),
                  (Rn.sortedIndexOf = function (e, t) {
                    var n = null == e ? 0 : e.length;
                    if (n) {
                      var r = ri(e, t);
                      if (r < n && Fo(e[r], t)) return r;
                    }
                    return -1;
                  }),
                  (Rn.sortedLastIndex = function (e, t) {
                    return ri(e, t, !0);
                  }),
                  (Rn.sortedLastIndexBy = function (e, t, n) {
                    return ii(e, t, oa(n, 2), !0);
                  }),
                  (Rn.sortedLastIndexOf = function (e, t) {
                    if (null != e && e.length) {
                      var n = ri(e, t, !0) - 1;
                      if (Fo(e[n], t)) return n;
                    }
                    return -1;
                  }),
                  (Rn.startCase = Us),
                  (Rn.startsWith = function (e, t, n) {
                    return (e = bs(e)), (n = null == n ? 0 : or(vs(n), 0, e.length)), (t = si(t)), e.slice(n, n + t.length) == t;
                  }),
                  (Rn.subtract = kl),
                  (Rn.sum = function (e) {
                    return e && e.length ? qt(e, il) : 0;
                  }),
                  (Rn.sumBy = function (e, t) {
                    return e && e.length ? qt(e, oa(t, 2)) : 0;
                  }),
                  (Rn.template = function (e, t, n) {
                    var r = Rn.templateSettings;
                    n && ma(e, t, n) && (t = i), (e = bs(e)), (t = xs({}, t, r, Ki));
                    var a,
                      o,
                      s = xs({}, t.imports, r.imports, Ki),
                      l = Ls(s),
                      u = $t(s, l),
                      c = 0,
                      d = t.interpolate || be,
                      f = "__p += '",
                      p = ke((t.escape || be).source + "|" + d.source + "|" + (d === Q ? de : be).source + "|" + (t.evaluate || be).source + "|$", "g"),
                      h = "//# sourceURL=" + (Ie.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Qe + "]") + "\n";
                    e.replace(p, function (t, n, r, i, s, l) {
                      return (
                        r || (r = i),
                        (f += e.slice(c, l).replace(we, Qt)),
                        n && ((a = !0), (f += "' +\n__e(" + n + ") +\n'")),
                        s && ((o = !0), (f += "';\n" + s + ";\n__p += '")),
                        r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"),
                        (c = l + t.length),
                        t
                      );
                    }),
                      (f += "';\n");
                    var v = Ie.call(t, "variable") && t.variable;
                    if (v) {
                      if (ue.test(v)) throw new _e("Invalid `variable` option passed into `_.template`");
                    } else f = "with (obj) {\n" + f + "\n}\n";
                    (f = (o ? f.replace(H, "") : f).replace(W, "$1").replace($, "$1;")),
                      (f =
                        "function(" +
                        (v || "obj") +
                        ") {\n" +
                        (v ? "" : "obj || (obj = {});\n") +
                        "var __t, __p = ''" +
                        (a ? ", __e = _.escape" : "") +
                        (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") +
                        f +
                        "return __p\n}");
                    var g = Js(function () {
                      return xe(l, h + "return " + f).apply(i, u);
                    });
                    if (((g.source = f), Qo(g))) throw g;
                    return g;
                  }),
                  (Rn.times = function (e, t) {
                    if ((e = vs(e)) < 1 || e > d) return [];
                    var n = p,
                      r = yn(e, p);
                    (t = oa(t)), (e -= p);
                    for (var i = Ft(r, t); ++n < e; ) t(n);
                    return i;
                  }),
                  (Rn.toFinite = hs),
                  (Rn.toInteger = vs),
                  (Rn.toLength = gs),
                  (Rn.toLower = function (e) {
                    return bs(e).toLowerCase();
                  }),
                  (Rn.toNumber = ms),
                  (Rn.toSafeInteger = function (e) {
                    return e ? or(vs(e), -9007199254740991, d) : 0 === e ? e : 0;
                  }),
                  (Rn.toString = bs),
                  (Rn.toUpper = function (e) {
                    return bs(e).toUpperCase();
                  }),
                  (Rn.trim = function (e, t, n) {
                    if ((e = bs(e)) && (n || t === i)) return Ht(e);
                    if (!e || !(t = si(t))) return e;
                    var r = on(e),
                      a = on(t);
                    return bi(r, Yt(r, a), Gt(r, a) + 1).join("");
                  }),
                  (Rn.trimEnd = function (e, t, n) {
                    if ((e = bs(e)) && (n || t === i)) return e.slice(0, sn(e) + 1);
                    if (!e || !(t = si(t))) return e;
                    var r = on(e);
                    return bi(r, 0, Gt(r, on(t)) + 1).join("");
                  }),
                  (Rn.trimStart = function (e, t, n) {
                    if ((e = bs(e)) && (n || t === i)) return e.replace(re, "");
                    if (!e || !(t = si(t))) return e;
                    var r = on(e);
                    return bi(r, Yt(r, on(t))).join("");
                  }),
                  (Rn.truncate = function (e, t) {
                    var n = 30,
                      r = "...";
                    if (ts(t)) {
                      var a = "separator" in t ? t.separator : a;
                      (n = "length" in t ? vs(t.length) : n), (r = "omission" in t ? si(t.omission) : r);
                    }
                    var o = (e = bs(e)).length;
                    if (Zt(e)) {
                      var s = on(e);
                      o = s.length;
                    }
                    if (n >= o) return e;
                    var l = n - an(r);
                    if (l < 1) return r;
                    var u = s ? bi(s, 0, l).join("") : e.slice(0, l);
                    if (a === i) return u + r;
                    if ((s && (l += u.length - l), os(a))) {
                      if (e.slice(l).search(a)) {
                        var c,
                          d = u;
                        for (a.global || (a = ke(a.source, bs(fe.exec(a)) + "g")), a.lastIndex = 0; (c = a.exec(d)); ) var f = c.index;
                        u = u.slice(0, f === i ? l : f);
                      }
                    } else if (e.indexOf(si(a), l) != l) {
                      var p = u.lastIndexOf(a);
                      p > -1 && (u = u.slice(0, p));
                    }
                    return u + r;
                  }),
                  (Rn.unescape = function (e) {
                    return (e = bs(e)) && G.test(e) ? e.replace(V, ln) : e;
                  }),
                  (Rn.uniqueId = function (e) {
                    var t = ++De;
                    return bs(e) + t;
                  }),
                  (Rn.upperCase = Ks),
                  (Rn.upperFirst = Qs),
                  (Rn.each = bo),
                  (Rn.eachRight = wo),
                  (Rn.first = Ya),
                  ll(
                    Rn,
                    ((yl = {}),
                    br(Rn, function (e, t) {
                      Ie.call(Rn.prototype, t) || (yl[t] = e);
                    }),
                    yl),
                    { chain: !1 }
                  ),
                  (Rn.VERSION = "4.17.21"),
                  bt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
                    Rn[e].placeholder = Rn;
                  }),
                  bt(["drop", "take"], function (e, t) {
                    (Wn.prototype[e] = function (n) {
                      n = n === i ? 1 : mn(vs(n), 0);
                      var r = this.__filtered__ && !t ? new Wn(this) : this.clone();
                      return r.__filtered__ ? (r.__takeCount__ = yn(n, r.__takeCount__)) : r.__views__.push({ size: yn(n, p), type: e + (r.__dir__ < 0 ? "Right" : "") }), r;
                    }),
                      (Wn.prototype[e + "Right"] = function (t) {
                        return this.reverse()[e](t).reverse();
                      });
                  }),
                  bt(["filter", "map", "takeWhile"], function (e, t) {
                    var n = t + 1,
                      r = 1 == n || 3 == n;
                    Wn.prototype[e] = function (e) {
                      var t = this.clone();
                      return t.__iteratees__.push({ iteratee: oa(e, 3), type: n }), (t.__filtered__ = t.__filtered__ || r), t;
                    };
                  }),
                  bt(["head", "last"], function (e, t) {
                    var n = "take" + (t ? "Right" : "");
                    Wn.prototype[e] = function () {
                      return this[n](1).value()[0];
                    };
                  }),
                  bt(["initial", "tail"], function (e, t) {
                    var n = "drop" + (t ? "" : "Right");
                    Wn.prototype[e] = function () {
                      return this.__filtered__ ? new Wn(this) : this[n](1);
                    };
                  }),
                  (Wn.prototype.compact = function () {
                    return this.filter(il);
                  }),
                  (Wn.prototype.find = function (e) {
                    return this.filter(e).head();
                  }),
                  (Wn.prototype.findLast = function (e) {
                    return this.reverse().find(e);
                  }),
                  (Wn.prototype.invokeMap = Xr(function (e, t) {
                    return "function" == typeof e
                      ? new Wn(this)
                      : this.map(function (n) {
                          return Mr(n, e, t);
                        });
                  })),
                  (Wn.prototype.reject = function (e) {
                    return this.filter(jo(oa(e)));
                  }),
                  (Wn.prototype.slice = function (e, t) {
                    e = vs(e);
                    var n = this;
                    return n.__filtered__ && (e > 0 || t < 0) ? new Wn(n) : (e < 0 ? (n = n.takeRight(-e)) : e && (n = n.drop(e)), t !== i && (n = (t = vs(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
                  }),
                  (Wn.prototype.takeRightWhile = function (e) {
                    return this.reverse().takeWhile(e).reverse();
                  }),
                  (Wn.prototype.toArray = function () {
                    return this.take(p);
                  }),
                  br(Wn.prototype, function (e, t) {
                    var n = /^(?:filter|find|map|reject)|While$/.test(t),
                      r = /^(?:head|last)$/.test(t),
                      a = Rn[r ? "take" + ("last" == t ? "Right" : "") : t],
                      o = r || /^find/.test(t);
                    a &&
                      (Rn.prototype[t] = function () {
                        var t = this.__wrapped__,
                          s = r ? [1] : arguments,
                          l = t instanceof Wn,
                          u = s[0],
                          c = l || Vo(t),
                          d = function (e) {
                            var t = a.apply(Rn, Et([e], s));
                            return r && f ? t[0] : t;
                          };
                        c && n && "function" == typeof u && 1 != u.length && (l = c = !1);
                        var f = this.__chain__,
                          p = !!this.__actions__.length,
                          h = o && !f,
                          v = l && !p;
                        if (!o && c) {
                          t = v ? t : new Wn(this);
                          var g = e.apply(t, s);
                          return g.__actions__.push({ func: ho, args: [d], thisArg: i }), new Hn(g, f);
                        }
                        return h && v ? e.apply(this, s) : ((g = this.thru(d)), h ? (r ? g.value()[0] : g.value()) : g);
                      });
                  }),
                  bt(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
                    var t = Oe[e],
                      n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                      r = /^(?:pop|shift)$/.test(e);
                    Rn.prototype[e] = function () {
                      var e = arguments;
                      if (r && !this.__chain__) {
                        var i = this.value();
                        return t.apply(Vo(i) ? i : [], e);
                      }
                      return this[n](function (n) {
                        return t.apply(Vo(n) ? n : [], e);
                      });
                    };
                  }),
                  br(Wn.prototype, function (e, t) {
                    var n = Rn[t];
                    if (n) {
                      var r = n.name + "";
                      Ie.call(Pn, r) || (Pn[r] = []), Pn[r].push({ name: t, func: n });
                    }
                  }),
                  (Pn[Ni(i, 2).name] = [{ name: "wrapper", func: i }]),
                  (Wn.prototype.clone = function () {
                    var e = new Wn(this.__wrapped__);
                    return (
                      (e.__actions__ = Si(this.__actions__)),
                      (e.__dir__ = this.__dir__),
                      (e.__filtered__ = this.__filtered__),
                      (e.__iteratees__ = Si(this.__iteratees__)),
                      (e.__takeCount__ = this.__takeCount__),
                      (e.__views__ = Si(this.__views__)),
                      e
                    );
                  }),
                  (Wn.prototype.reverse = function () {
                    if (this.__filtered__) {
                      var e = new Wn(this);
                      (e.__dir__ = -1), (e.__filtered__ = !0);
                    } else (e = this.clone()).__dir__ *= -1;
                    return e;
                  }),
                  (Wn.prototype.value = function () {
                    var e = this.__wrapped__.value(),
                      t = this.__dir__,
                      n = Vo(e),
                      r = t < 0,
                      i = n ? e.length : 0,
                      a = (function (e, t, n) {
                        for (var r = -1, i = n.length; ++r < i; ) {
                          var a = n[r],
                            o = a.size;
                          switch (a.type) {
                            case "drop":
                              e += o;
                              break;
                            case "dropRight":
                              t -= o;
                              break;
                            case "take":
                              t = yn(t, e + o);
                              break;
                            case "takeRight":
                              e = mn(e, t - o);
                          }
                        }
                        return { start: e, end: t };
                      })(0, i, this.__views__),
                      o = a.start,
                      s = a.end,
                      l = s - o,
                      u = r ? s : o - 1,
                      c = this.__iteratees__,
                      d = c.length,
                      f = 0,
                      p = yn(l, this.__takeCount__);
                    if (!n || (!r && i == l && p == l)) return fi(e, this.__actions__);
                    var h = [];
                    e: for (; l-- && f < p; ) {
                      for (var v = -1, g = e[(u += t)]; ++v < d; ) {
                        var m = c[v],
                          y = m.iteratee,
                          b = m.type,
                          w = y(g);
                        if (2 == b) g = w;
                        else if (!w) {
                          if (1 == b) continue e;
                          break e;
                        }
                      }
                      h[f++] = g;
                    }
                    return h;
                  }),
                  (Rn.prototype.at = vo),
                  (Rn.prototype.chain = function () {
                    return po(this);
                  }),
                  (Rn.prototype.commit = function () {
                    return new Hn(this.value(), this.__chain__);
                  }),
                  (Rn.prototype.next = function () {
                    this.__values__ === i && (this.__values__ = ps(this.value()));
                    var e = this.__index__ >= this.__values__.length;
                    return { done: e, value: e ? i : this.__values__[this.__index__++] };
                  }),
                  (Rn.prototype.plant = function (e) {
                    for (var t, n = this; n instanceof Fn; ) {
                      var r = Ra(n);
                      (r.__index__ = 0), (r.__values__ = i), t ? (a.__wrapped__ = r) : (t = r);
                      var a = r;
                      n = n.__wrapped__;
                    }
                    return (a.__wrapped__ = e), t;
                  }),
                  (Rn.prototype.reverse = function () {
                    var e = this.__wrapped__;
                    if (e instanceof Wn) {
                      var t = e;
                      return this.__actions__.length && (t = new Wn(this)), (t = t.reverse()).__actions__.push({ func: ho, args: [eo], thisArg: i }), new Hn(t, this.__chain__);
                    }
                    return this.thru(eo);
                  }),
                  (Rn.prototype.toJSON = Rn.prototype.valueOf = Rn.prototype.value = function () {
                    return fi(this.__wrapped__, this.__actions__);
                  }),
                  (Rn.prototype.first = Rn.prototype.head),
                  ot &&
                    (Rn.prototype[ot] = function () {
                      return this;
                    }),
                  Rn
                );
              })();
            (at._ = un),
              (r = function () {
                return un;
              }.call(t, n, t, e)) === i || (e.exports = r);
          }.call(this);
      },
      411: (e, t, n) => {
        var r, i;
        (r = [n(755)]),
          void 0 ===
            (i = function (e) {
              "use strict";
              var t = e(document),
                n = e(window),
                r = "selectric",
                i = ".sl",
                a = ["a", "e", "i", "o", "u", "n", "c", "y"],
                o = [/[\xE0-\xE5]/g, /[\xE8-\xEB]/g, /[\xEC-\xEF]/g, /[\xF2-\xF6]/g, /[\xF9-\xFC]/g, /[\xF1]/g, /[\xE7]/g, /[\xFD-\xFF]/g],
                s = function (t, n) {
                  var r = this;
                  (r.element = t),
                    (r.$element = e(t)),
                    (r.state = { multiple: !!r.$element.attr("multiple"), enabled: !1, opened: !1, currValue: -1, selectedIdx: -1, highlightedIdx: -1 }),
                    (r.eventTriggers = { open: r.open, close: r.close, destroy: r.destroy, refresh: r.refresh, init: r.init }),
                    r.init(n);
                };
              (s.prototype = {
                utils: {
                  isMobile: function () {
                    return /android|ip(hone|od|ad)/i.test(navigator.userAgent);
                  },
                  escapeRegExp: function (e) {
                    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                  },
                  replaceDiacritics: function (e) {
                    for (var t = o.length; t--; ) e = e.toLowerCase().replace(o[t], a[t]);
                    return e;
                  },
                  format: function (e) {
                    var t = arguments;
                    return ("" + e).replace(/\{(?:(\d+)|(\w+))\}/g, function (e, n, r) {
                      return r && t[1] ? t[1][r] : t[n];
                    });
                  },
                  nextEnabledItem: function (e, t) {
                    for (; e[(t = (t + 1) % e.length)].disabled; );
                    return t;
                  },
                  previousEnabledItem: function (e, t) {
                    for (; e[(t = (t > 0 ? t : e.length) - 1)].disabled; );
                    return t;
                  },
                  toDash: function (e) {
                    return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
                  },
                  triggerCallback: function (t, n) {
                    var r = n.element,
                      i = n.options["on" + t],
                      a = [r].concat([].slice.call(arguments).slice(1));
                    e.isFunction(i) && i.apply(r, a), e(r).trigger("selectric-" + this.toDash(t), a);
                  },
                  arrayToClassname: function (t) {
                    var n = e.grep(t, function (e) {
                      return !!e;
                    });
                    return e.trim(n.join(" "));
                  },
                },
                init: function (t) {
                  var n = this;
                  if (((n.options = e.extend(!0, {}, e.fn.selectric.defaults, n.options, t)), n.utils.triggerCallback("BeforeInit", n), n.destroy(!0), n.options.disableOnMobile && n.utils.isMobile())) n.disableOnMobile = !0;
                  else {
                    n.classes = n.getClassNames();
                    var r = e("<input/>", { class: n.classes.input, readonly: n.utils.isMobile() }),
                      i = e("<div/>", { class: n.classes.items, tabindex: -1 }),
                      a = e("<div/>", { class: n.classes.scroll }),
                      o = e("<div/>", { class: n.classes.prefix, html: n.options.arrowButtonMarkup }),
                      s = e("<span/>", { class: "label" }),
                      l = n.$element.wrap("<div/>").parent().append(o.prepend(s), i, r),
                      u = e("<div/>", { class: n.classes.hideselect });
                    (n.elements = { input: r, items: i, itemsScroll: a, wrapper: o, label: s, outerWrapper: l }),
                      n.options.nativeOnMobile &&
                        n.utils.isMobile() &&
                        ((n.elements.input = void 0),
                        u.addClass(n.classes.prefix + "-is-native"),
                        n.$element.on("change", function () {
                          n.refresh();
                        })),
                      n.$element.on(n.eventTriggers).wrap(u),
                      (n.originalTabindex = n.$element.prop("tabindex")),
                      n.$element.prop("tabindex", -1),
                      n.populate(),
                      n.activate(),
                      n.utils.triggerCallback("Init", n);
                  }
                },
                activate: function () {
                  var e = this,
                    t = e.elements.items.closest(":visible").children(":hidden").addClass(e.classes.tempshow),
                    n = e.$element.width();
                  t.removeClass(e.classes.tempshow),
                    e.utils.triggerCallback("BeforeActivate", e),
                    e.elements.outerWrapper.prop("class", e.utils.arrayToClassname([e.classes.wrapper, e.$element.prop("class").replace(/\S+/g, e.classes.prefix + "-$&"), e.options.responsive ? e.classes.responsive : ""])),
                    e.options.inheritOriginalWidth && n > 0 && e.elements.outerWrapper.width(n),
                    e.unbindEvents(),
                    e.$element.prop("disabled")
                      ? (e.elements.outerWrapper.addClass(e.classes.disabled), e.elements.input && e.elements.input.prop("disabled", !0))
                      : ((e.state.enabled = !0), e.elements.outerWrapper.removeClass(e.classes.disabled), (e.$li = e.elements.items.removeAttr("style").find("li")), e.bindEvents()),
                    e.utils.triggerCallback("Activate", e);
                },
                getClassNames: function () {
                  var t = this,
                    n = t.options.customClass,
                    r = {};
                  return (
                    e.each("Input Items Open Disabled TempShow HideSelect Wrapper Focus Hover Responsive Above Below Scroll Group GroupLabel".split(" "), function (e, i) {
                      var a = n.prefix + i;
                      r[i.toLowerCase()] = n.camelCase ? a : t.utils.toDash(a);
                    }),
                    (r.prefix = n.prefix),
                    r
                  );
                },
                setLabel: function () {
                  var t = this,
                    n = t.options.labelBuilder;
                  if (t.state.multiple) {
                    var r = e.isArray(t.state.currValue) ? t.state.currValue : [t.state.currValue];
                    r = 0 === r.length ? [0] : r;
                    var i = e.map(r, function (n) {
                      return e.grep(t.lookupItems, function (e) {
                        return e.index === n;
                      })[0];
                    });
                    (i = e.grep(i, function (t) {
                      return i.length > 1 || 0 === i.length ? "" !== e.trim(t.value) : t;
                    })),
                      (i = e.map(i, function (r) {
                        return e.isFunction(n) ? n(r) : t.utils.format(n, r);
                      })),
                      t.options.multiple.maxLabelEntries &&
                        (i.length >= t.options.multiple.maxLabelEntries + 1 ? (i = i.slice(0, t.options.multiple.maxLabelEntries)).push(e.isFunction(n) ? n({ text: "..." }) : t.utils.format(n, { text: "..." })) : i.slice(i.length - 1)),
                      t.elements.label.html(i.join(t.options.multiple.separator));
                  } else {
                    var a = t.lookupItems[t.state.currValue];
                    t.elements.label.html(e.isFunction(n) ? n(a) : t.utils.format(n, a));
                  }
                },
                populate: function () {
                  var t = this,
                    n = t.$element.children(),
                    r = t.$element.find("option"),
                    i = r.filter(":selected"),
                    a = r.index(i),
                    o = 0,
                    s = t.state.multiple ? [] : 0;
                  i.length > 1 &&
                    t.state.multiple &&
                    ((a = []),
                    i.each(function () {
                      a.push(e(this).index());
                    })),
                    (t.state.currValue = ~a ? a : s),
                    (t.state.selectedIdx = t.state.currValue),
                    (t.state.highlightedIdx = t.state.currValue),
                    (t.items = []),
                    (t.lookupItems = []),
                    n.length &&
                      (n.each(function (n) {
                        var r = e(this);
                        if (r.is("optgroup")) {
                          var i = { element: r, label: r.prop("label"), groupDisabled: r.prop("disabled"), items: [] };
                          r.children().each(function (n) {
                            var r = e(this);
                            (i.items[n] = t.getItemData(o, r, i.groupDisabled || r.prop("disabled"))), (t.lookupItems[o] = i.items[n]), o++;
                          }),
                            (t.items[n] = i);
                        } else (t.items[n] = t.getItemData(o, r, r.prop("disabled"))), (t.lookupItems[o] = t.items[n]), o++;
                      }),
                      t.setLabel(),
                      t.elements.items.append(t.elements.itemsScroll.html(t.getItemsMarkup(t.items))));
                },
                getItemData: function (t, n, r) {
                  return {
                    index: t,
                    element: n,
                    value: n.val(),
                    className: n.prop("class"),
                    text: n.html(),
                    slug: e.trim(this.utils.replaceDiacritics(n.html())),
                    alt: n.attr("data-alt"),
                    selected: n.prop("selected"),
                    disabled: r,
                  };
                },
                getItemsMarkup: function (t) {
                  var n = this,
                    r = "<ul>";
                  return (
                    e.isFunction(n.options.listBuilder) && n.options.listBuilder && (t = n.options.listBuilder(t)),
                    e.each(t, function (t, i) {
                      void 0 !== i.label
                        ? ((r += n.utils.format(
                            '<ul class="{1}"><li class="aa {2}">{3}</li>',
                            n.utils.arrayToClassname([n.classes.group, i.groupDisabled ? "disabled" : "", i.element.prop("class")]),
                            n.classes.grouplabel,
                            i.element.prop("label")
                          )),
                          e.each(i.items, function (e, t) {
                            r += n.getItemMarkup(t.index, t);
                          }),
                          (r += "</ul>"))
                        : (r += n.getItemMarkup(i.index, i));
                    }),
                    r + "</ul>"
                  );
                },
                getItemMarkup: function (t, n) {
                  var r = this,
                    i = r.options.optionsItemBuilder,
                    a = { value: n.value, text: n.text, slug: n.slug, index: n.index };
                  return r.utils.format(
                    '<li data-index="{1}" class="{2}">{3}</li>',
                    t,
                    r.utils.arrayToClassname([n.className, t === r.items.length - 1 ? "last" : "", n.disabled ? "disabled" : "", n.selected ? "selected" : ""]),
                    e.isFunction(i) ? r.utils.format(i(n, this.$element, t), n) : r.utils.format(i, a)
                  );
                },
                unbindEvents: function () {
                  var e = this;
                  e.elements.wrapper.add(e.$element).add(e.elements.outerWrapper).add(e.elements.input).off(i);
                },
                bindEvents: function () {
                  var t = this;
                  t.elements.outerWrapper.on("mouseenter.sl mouseleave.sl", function (n) {
                    e(this).toggleClass(t.classes.hover, "mouseenter" === n.type),
                      t.options.openOnHover && (clearTimeout(t.closeTimer), "mouseleave" === n.type ? (t.closeTimer = setTimeout(e.proxy(t.close, t), t.options.hoverIntentTimeout)) : t.open());
                  }),
                    t.elements.wrapper.on("click.sl", function (e) {
                      t.state.opened ? t.close() : t.open(e);
                    }),
                    (t.options.nativeOnMobile && t.utils.isMobile()) ||
                      (t.$element.on("focus.sl", function () {
                        t.elements.input.focus();
                      }),
                      t.elements.input
                        .prop({ tabindex: t.originalTabindex, disabled: !1 })
                        .on("keydown.sl", e.proxy(t.handleKeys, t))
                        .on("focusin.sl", function (e) {
                          t.elements.outerWrapper.addClass(t.classes.focus),
                            t.elements.input.one("blur", function () {
                              t.elements.input.blur();
                            }),
                            t.options.openOnFocus && !t.state.opened && t.open(e);
                        })
                        .on("focusout.sl", function () {
                          t.elements.outerWrapper.removeClass(t.classes.focus);
                        })
                        .on("input propertychange", function () {
                          var n = t.elements.input.val(),
                            r = new RegExp("^" + t.utils.escapeRegExp(n), "i");
                          clearTimeout(t.resetStr),
                            (t.resetStr = setTimeout(function () {
                              t.elements.input.val("");
                            }, t.options.keySearchTimeout)),
                            n.length &&
                              e.each(t.items, function (e, n) {
                                if (!n.disabled)
                                  if (r.test(n.text) || r.test(n.slug)) t.highlight(e);
                                  else if (n.alt) for (var i = n.alt.split("|"), a = 0; a < i.length && i[a]; a++) if (r.test(i[a].trim())) return void t.highlight(e);
                              });
                        })),
                    t.$li.on({
                      mousedown: function (e) {
                        e.preventDefault(), e.stopPropagation();
                      },
                      click: function () {
                        return t.select(e(this).data("index")), !1;
                      },
                    });
                },
                handleKeys: function (t) {
                  var n = this,
                    r = t.which,
                    i = n.options.keys,
                    a = e.inArray(r, i.previous) > -1,
                    o = e.inArray(r, i.next) > -1,
                    s = e.inArray(r, i.select) > -1,
                    l = e.inArray(r, i.open) > -1,
                    u = n.state.highlightedIdx,
                    c = (a && 0 === u) || (o && u + 1 === n.items.length),
                    d = 0;
                  if (((13 !== r && 32 !== r) || t.preventDefault(), a || o)) {
                    if (!n.options.allowWrap && c) return;
                    a && (d = n.utils.previousEnabledItem(n.lookupItems, u)), o && (d = n.utils.nextEnabledItem(n.lookupItems, u)), n.highlight(d);
                  }
                  if (s && n.state.opened) return n.select(u), void ((n.state.multiple && n.options.multiple.keepMenuOpen) || n.close());
                  l && !n.state.opened && n.open();
                },
                refresh: function () {
                  var e = this;
                  e.populate(), e.activate(), e.utils.triggerCallback("Refresh", e);
                },
                setOptionsDimensions: function () {
                  var e = this,
                    t = e.elements.items.closest(":visible").children(":hidden").addClass(e.classes.tempshow),
                    n = e.options.maxHeight,
                    r = e.elements.items.outerWidth(),
                    i = e.elements.wrapper.outerWidth() - (r - e.elements.items.width());
                  !e.options.expandToItemText || i > r
                    ? (e.finalWidth = i)
                    : (e.elements.items.css("overflow", "scroll"), e.elements.outerWrapper.width(9e4), (e.finalWidth = e.elements.items.width()), e.elements.items.css("overflow", ""), e.elements.outerWrapper.width("")),
                    e.elements.items.width(e.finalWidth).height() > n && e.elements.items.height(n),
                    t.removeClass(e.classes.tempshow);
                },
                isInViewport: function () {
                  var e = this;
                  if (!0 === e.options.forceRenderAbove) e.elements.outerWrapper.addClass(e.classes.above);
                  else if (!0 === e.options.forceRenderBelow) e.elements.outerWrapper.addClass(e.classes.below);
                  else {
                    var t = n.scrollTop(),
                      r = n.height(),
                      i = e.elements.outerWrapper.offset().top,
                      a = i + e.elements.outerWrapper.outerHeight() + e.itemsHeight <= t + r,
                      o = i - e.itemsHeight > t,
                      s = !a && o,
                      l = !s;
                    e.elements.outerWrapper.toggleClass(e.classes.above, s), e.elements.outerWrapper.toggleClass(e.classes.below, l);
                  }
                },
                detectItemVisibility: function (t) {
                  var n = this,
                    r = n.$li.filter("[data-index]");
                  n.state.multiple && ((t = e.isArray(t) && 0 === t.length ? 0 : t), (t = e.isArray(t) ? Math.min.apply(Math, t) : t));
                  var i = r.eq(t).outerHeight(),
                    a = r[t].offsetTop,
                    o = n.elements.itemsScroll.scrollTop(),
                    s = a + 2 * i;
                  n.elements.itemsScroll.scrollTop(s > o + n.itemsHeight ? s - n.itemsHeight : a - i < o ? a - i : o);
                },
                open: function (n) {
                  var r = this;
                  if (r.options.nativeOnMobile && r.utils.isMobile()) return !1;
                  r.utils.triggerCallback("BeforeOpen", r),
                    n && (n.preventDefault(), r.options.stopPropagation && n.stopPropagation()),
                    r.state.enabled &&
                      (r.setOptionsDimensions(),
                      e("." + r.classes.hideselect, "." + r.classes.open)
                        .children()
                        .selectric("close"),
                      (r.state.opened = !0),
                      (r.itemsHeight = r.elements.items.outerHeight()),
                      (r.itemsInnerHeight = r.elements.items.height()),
                      r.elements.outerWrapper.addClass(r.classes.open),
                      r.elements.input.val(""),
                      n && "focusin" !== n.type && r.elements.input.focus(),
                      setTimeout(function () {
                        t.on("click.sl", e.proxy(r.close, r)).on("scroll.sl", e.proxy(r.isInViewport, r));
                      }, 1),
                      r.isInViewport(),
                      r.options.preventWindowScroll &&
                        t.on("mousewheel.sl DOMMouseScroll.sl", "." + r.classes.scroll, function (t) {
                          var n = t.originalEvent,
                            i = e(this).scrollTop(),
                            a = 0;
                          "detail" in n && (a = -1 * n.detail),
                            "wheelDelta" in n && (a = n.wheelDelta),
                            "wheelDeltaY" in n && (a = n.wheelDeltaY),
                            "deltaY" in n && (a = -1 * n.deltaY),
                            ((i === this.scrollHeight - r.itemsInnerHeight && a < 0) || (0 === i && a > 0)) && t.preventDefault();
                        }),
                      r.detectItemVisibility(r.state.selectedIdx),
                      r.highlight(r.state.multiple ? -1 : r.state.selectedIdx),
                      r.utils.triggerCallback("Open", r));
                },
                close: function () {
                  var e = this;
                  e.utils.triggerCallback("BeforeClose", e), t.off(i), e.elements.outerWrapper.removeClass(e.classes.open), (e.state.opened = !1), e.utils.triggerCallback("Close", e);
                },
                change: function () {
                  var t = this;
                  t.utils.triggerCallback("BeforeChange", t),
                    t.state.multiple
                      ? (e.each(t.lookupItems, function (e) {
                          (t.lookupItems[e].selected = !1), t.$element.find("option").prop("selected", !1);
                        }),
                        e.each(t.state.selectedIdx, function (e, n) {
                          (t.lookupItems[n].selected = !0), t.$element.find("option").eq(n).prop("selected", !0);
                        }),
                        (t.state.currValue = t.state.selectedIdx),
                        t.setLabel(),
                        t.utils.triggerCallback("Change", t))
                      : t.state.currValue !== t.state.selectedIdx &&
                        (t.$element.prop("selectedIndex", (t.state.currValue = t.state.selectedIdx)).data("value", t.lookupItems[t.state.selectedIdx].text), t.setLabel(), t.utils.triggerCallback("Change", t));
                },
                highlight: function (e) {
                  var t = this,
                    n = t.$li.filter("[data-index]").removeClass("highlighted");
                  t.utils.triggerCallback("BeforeHighlight", t),
                    void 0 === e || -1 === e || t.lookupItems[e].disabled || (n.eq((t.state.highlightedIdx = e)).addClass("highlighted"), t.detectItemVisibility(e), t.utils.triggerCallback("Highlight", t));
                },
                select: function (t) {
                  var n = this,
                    r = n.$li.filter("[data-index]");
                  if ((n.utils.triggerCallback("BeforeSelect", n, t), void 0 !== t && -1 !== t && !n.lookupItems[t].disabled)) {
                    if (n.state.multiple) {
                      n.state.selectedIdx = e.isArray(n.state.selectedIdx) ? n.state.selectedIdx : [n.state.selectedIdx];
                      var i = e.inArray(t, n.state.selectedIdx);
                      -1 !== i ? n.state.selectedIdx.splice(i, 1) : n.state.selectedIdx.push(t),
                        r
                          .removeClass("selected")
                          .filter(function (t) {
                            return -1 !== e.inArray(t, n.state.selectedIdx);
                          })
                          .addClass("selected");
                    } else
                      r.removeClass("selected")
                        .eq((n.state.selectedIdx = t))
                        .addClass("selected");
                    (n.state.multiple && n.options.multiple.keepMenuOpen) || n.close(), n.change(), n.utils.triggerCallback("Select", n, t);
                  }
                },
                destroy: function (e) {
                  var t = this;
                  t.state &&
                    t.state.enabled &&
                    (t.elements.items.add(t.elements.wrapper).add(t.elements.input).remove(),
                    e || t.$element.removeData(r).removeData("value"),
                    t.$element.prop("tabindex", t.originalTabindex).off(i).off(t.eventTriggers).unwrap().unwrap(),
                    (t.state.enabled = !1));
                },
              }),
                (e.fn.selectric = function (t) {
                  return this.each(function () {
                    var n = e.data(this, r);
                    n && !n.disableOnMobile ? ("string" == typeof t && n[t] ? n[t]() : n.init(t)) : e.data(this, r, new s(this, t));
                  });
                }),
                (e.fn.selectric.defaults = {
                  onChange: function (t) {
                    e(t).change();
                  },
                  maxHeight: 300,
                  keySearchTimeout: 500,
                  arrowButtonMarkup: '<b class="button">&#x25be;</b>',
                  disableOnMobile: !1,
                  nativeOnMobile: !0,
                  openOnFocus: !0,
                  openOnHover: !1,
                  hoverIntentTimeout: 500,
                  expandToItemText: !1,
                  responsive: !1,
                  preventWindowScroll: !0,
                  inheritOriginalWidth: !1,
                  allowWrap: !0,
                  forceRenderAbove: !1,
                  forceRenderBelow: !1,
                  stopPropagation: !0,
                  optionsItemBuilder: "{text}",
                  labelBuilder: "{text}",
                  listBuilder: !1,
                  keys: { previous: [37, 38], next: [39, 40], select: [9, 13, 27], open: [13, 32, 37, 38, 39, 40], close: [9, 27] },
                  customClass: { prefix: r, camelCase: !1 },
                  multiple: { separator: ", ", keepMenuOpen: !0, maxLabelEntries: !1 },
                });
            }.apply(t, r)) || (e.exports = i);
      },
      346: function (e) {
        function t(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function n(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        var r,
          i = (function () {
            function e() {
              var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              t(this, e),
                (this.selector = n),
                (this.elements = []),
                (this.version = "1.3.0"),
                (this.vp = this.getViewportSize()),
                (this.body = document.querySelector("body")),
                (this.options = {
                  wrap: r.wrap || !1,
                  wrapWith: r.wrapWith || "<span></span>",
                  marginTop: r.marginTop || 0,
                  marginBottom: r.marginBottom || 0,
                  stickyFor: r.stickyFor || 0,
                  stickyClass: r.stickyClass || null,
                  stickyContainer: r.stickyContainer || "body",
                }),
                (this.updateScrollTopPosition = this.updateScrollTopPosition.bind(this)),
                this.updateScrollTopPosition(),
                window.addEventListener("load", this.updateScrollTopPosition),
                window.addEventListener("scroll", this.updateScrollTopPosition),
                this.run();
            }
            var r, i;
            return (
              (r = e),
              (i = [
                {
                  key: "run",
                  value: function () {
                    var e = this,
                      t = setInterval(function () {
                        if ("complete" === document.readyState) {
                          clearInterval(t);
                          var n = document.querySelectorAll(e.selector);
                          e.forEach(n, function (t) {
                            return e.renderElement(t);
                          });
                        }
                      }, 10);
                  },
                },
                {
                  key: "renderElement",
                  value: function (e) {
                    var t = this;
                    (e.sticky = {}),
                      (e.sticky.active = !1),
                      (e.sticky.marginTop = parseInt(e.getAttribute("data-margin-top")) || this.options.marginTop),
                      (e.sticky.marginBottom = parseInt(e.getAttribute("data-margin-bottom")) || this.options.marginBottom),
                      (e.sticky.stickyFor = parseInt(e.getAttribute("data-sticky-for")) || this.options.stickyFor),
                      (e.sticky.stickyClass = e.getAttribute("data-sticky-class") || this.options.stickyClass),
                      (e.sticky.wrap = !!e.hasAttribute("data-sticky-wrap") || this.options.wrap),
                      (e.sticky.stickyContainer = this.options.stickyContainer),
                      (e.sticky.container = this.getStickyContainer(e)),
                      (e.sticky.container.rect = this.getRectangle(e.sticky.container)),
                      (e.sticky.rect = this.getRectangle(e)),
                      "img" === e.tagName.toLowerCase() &&
                        (e.onload = function () {
                          return (e.sticky.rect = t.getRectangle(e));
                        }),
                      e.sticky.wrap && this.wrapElement(e),
                      this.activate(e);
                  },
                },
                {
                  key: "wrapElement",
                  value: function (e) {
                    e.insertAdjacentHTML("beforebegin", e.getAttribute("data-sticky-wrapWith") || this.options.wrapWith), e.previousSibling.appendChild(e);
                  },
                },
                {
                  key: "activate",
                  value: function (e) {
                    e.sticky.rect.top + e.sticky.rect.height < e.sticky.container.rect.top + e.sticky.container.rect.height && e.sticky.stickyFor < this.vp.width && !e.sticky.active && (e.sticky.active = !0),
                      this.elements.indexOf(e) < 0 && this.elements.push(e),
                      e.sticky.resizeEvent || (this.initResizeEvents(e), (e.sticky.resizeEvent = !0)),
                      e.sticky.scrollEvent || (this.initScrollEvents(e), (e.sticky.scrollEvent = !0)),
                      this.setPosition(e);
                  },
                },
                {
                  key: "initResizeEvents",
                  value: function (e) {
                    var t = this;
                    (e.sticky.resizeListener = function () {
                      return t.onResizeEvents(e);
                    }),
                      window.addEventListener("resize", e.sticky.resizeListener);
                  },
                },
                {
                  key: "destroyResizeEvents",
                  value: function (e) {
                    window.removeEventListener("resize", e.sticky.resizeListener);
                  },
                },
                {
                  key: "onResizeEvents",
                  value: function (e) {
                    (this.vp = this.getViewportSize()),
                      (e.sticky.rect = this.getRectangle(e)),
                      (e.sticky.container.rect = this.getRectangle(e.sticky.container)),
                      e.sticky.rect.top + e.sticky.rect.height < e.sticky.container.rect.top + e.sticky.container.rect.height && e.sticky.stickyFor < this.vp.width && !e.sticky.active
                        ? (e.sticky.active = !0)
                        : (e.sticky.rect.top + e.sticky.rect.height >= e.sticky.container.rect.top + e.sticky.container.rect.height || (e.sticky.stickyFor >= this.vp.width && e.sticky.active)) && (e.sticky.active = !1),
                      this.setPosition(e);
                  },
                },
                {
                  key: "initScrollEvents",
                  value: function (e) {
                    var t = this;
                    (e.sticky.scrollListener = function () {
                      return t.onScrollEvents(e);
                    }),
                      window.addEventListener("scroll", e.sticky.scrollListener);
                  },
                },
                {
                  key: "destroyScrollEvents",
                  value: function (e) {
                    window.removeEventListener("scroll", e.sticky.scrollListener);
                  },
                },
                {
                  key: "onScrollEvents",
                  value: function (e) {
                    e.sticky && e.sticky.active && this.setPosition(e);
                  },
                },
                {
                  key: "setPosition",
                  value: function (e) {
                    this.css(e, { position: "", width: "", top: "", left: "" }),
                      this.vp.height < e.sticky.rect.height ||
                        !e.sticky.active ||
                        (e.sticky.rect.width || (e.sticky.rect = this.getRectangle(e)),
                        e.sticky.wrap && this.css(e.parentNode, { display: "block", width: e.sticky.rect.width + "px", height: e.sticky.rect.height + "px" }),
                        0 === e.sticky.rect.top && e.sticky.container === this.body
                          ? (this.css(e, { position: "fixed", top: e.sticky.rect.top + "px", left: e.sticky.rect.left + "px", width: e.sticky.rect.width + "px" }), e.sticky.stickyClass && e.classList.add(e.sticky.stickyClass))
                          : this.scrollTop > e.sticky.rect.top - e.sticky.marginTop
                          ? (this.css(e, { position: "fixed", width: e.sticky.rect.width + "px", left: e.sticky.rect.left + "px" }),
                            this.scrollTop + e.sticky.rect.height + e.sticky.marginTop > e.sticky.container.rect.top + e.sticky.container.offsetHeight - e.sticky.marginBottom
                              ? (e.sticky.stickyClass && e.classList.remove(e.sticky.stickyClass),
                                this.css(e, { top: e.sticky.container.rect.top + e.sticky.container.offsetHeight - (this.scrollTop + e.sticky.rect.height + e.sticky.marginBottom) + "px" }))
                              : (e.sticky.stickyClass && e.classList.add(e.sticky.stickyClass), this.css(e, { top: e.sticky.marginTop + "px" })))
                          : (e.sticky.stickyClass && e.classList.remove(e.sticky.stickyClass), this.css(e, { position: "", width: "", top: "", left: "" }), e.sticky.wrap && this.css(e.parentNode, { display: "", width: "", height: "" })));
                  },
                },
                {
                  key: "update",
                  value: function () {
                    var e = this;
                    this.forEach(this.elements, function (t) {
                      (t.sticky.rect = e.getRectangle(t)), (t.sticky.container.rect = e.getRectangle(t.sticky.container)), e.activate(t), e.setPosition(t);
                    });
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    var e = this;
                    window.removeEventListener("load", this.updateScrollTopPosition),
                      window.removeEventListener("scroll", this.updateScrollTopPosition),
                      this.forEach(this.elements, function (t) {
                        e.destroyResizeEvents(t), e.destroyScrollEvents(t), delete t.sticky;
                      });
                  },
                },
                {
                  key: "getStickyContainer",
                  value: function (e) {
                    for (var t = e.parentNode; !t.hasAttribute("data-sticky-container") && !t.parentNode.querySelector(e.sticky.stickyContainer) && t !== this.body; ) t = t.parentNode;
                    return t;
                  },
                },
                {
                  key: "getRectangle",
                  value: function (e) {
                    this.css(e, { position: "", width: "", top: "", left: "" });
                    var t = Math.max(e.offsetWidth, e.clientWidth, e.scrollWidth),
                      n = Math.max(e.offsetHeight, e.clientHeight, e.scrollHeight),
                      r = 0,
                      i = 0;
                    do {
                      (r += e.offsetTop || 0), (i += e.offsetLeft || 0), (e = e.offsetParent);
                    } while (e);
                    return { top: r, left: i, width: t, height: n };
                  },
                },
                {
                  key: "getViewportSize",
                  value: function () {
                    return { width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0), height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0) };
                  },
                },
                {
                  key: "updateScrollTopPosition",
                  value: function () {
                    this.scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0) || 0;
                  },
                },
                {
                  key: "forEach",
                  value: function (e, t) {
                    for (var n = 0, r = e.length; n < r; n++) t(e[n]);
                  },
                },
                {
                  key: "css",
                  value: function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e.style[n] = t[n]);
                  },
                },
              ]) && n(r.prototype, i),
              e
            );
          })();
        (r = i), (e.exports = r);
      },
      820: (e, t, n) => {
        var r = n(346);
        e.exports = r;
      },
      732: function (e) {
        e.exports = (function () {
          "use strict";
          function e() {
            return (
              (e =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                  }
                  return e;
                }),
              e.apply(this, arguments)
            );
          }
          var t = "undefined" != typeof window,
            n = (t && !("onscroll" in window)) || ("undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
            r = t && "IntersectionObserver" in window,
            i = t && "classList" in document.createElement("p"),
            a = t && window.devicePixelRatio > 1,
            o = {
              elements_selector: ".lazy",
              container: n || t ? document : null,
              threshold: 300,
              thresholds: null,
              data_src: "src",
              data_srcset: "srcset",
              data_sizes: "sizes",
              data_bg: "bg",
              data_bg_hidpi: "bg-hidpi",
              data_bg_multi: "bg-multi",
              data_bg_multi_hidpi: "bg-multi-hidpi",
              data_bg_set: "bg-set",
              data_poster: "poster",
              class_applied: "applied",
              class_loading: "loading",
              class_loaded: "loaded",
              class_error: "error",
              class_entered: "entered",
              class_exited: "exited",
              unobserve_completed: !0,
              unobserve_entered: !1,
              cancel_on_exit: !0,
              callback_enter: null,
              callback_exit: null,
              callback_applied: null,
              callback_loading: null,
              callback_loaded: null,
              callback_error: null,
              callback_finish: null,
              callback_cancel: null,
              use_native: !1,
              restore_on_error: !1,
            },
            s = function (t) {
              return e({}, o, t);
            },
            l = function (e, t) {
              var n,
                r = "LazyLoad::Initialized",
                i = new e(t);
              try {
                n = new CustomEvent(r, { detail: { instance: i } });
              } catch (e) {
                (n = document.createEvent("CustomEvent")).initCustomEvent(r, !1, !1, { instance: i });
              }
              window.dispatchEvent(n);
            },
            u = "src",
            c = "srcset",
            d = "sizes",
            f = "poster",
            p = "llOriginalAttrs",
            h = "data",
            v = "loading",
            g = "loaded",
            m = "applied",
            y = "error",
            b = "native",
            w = function (e, t) {
              return e.getAttribute("data-" + t);
            },
            _ = function (e) {
              return w(e, "ll-status");
            },
            x = function (e, t) {
              return (function (e, t, n) {
                var r = "data-ll-status";
                null !== n ? e.setAttribute(r, n) : e.removeAttribute(r);
              })(e, 0, t);
            },
            C = function (e) {
              return x(e, null);
            },
            T = function (e) {
              return null === _(e);
            },
            k = function (e) {
              return _(e) === b;
            },
            E = [v, g, m, y],
            S = function (e, t, n, r) {
              e && (void 0 === r ? (void 0 === n ? e(t) : e(t, n)) : e(t, n, r));
            },
            O = function (e, t) {
              i ? e.classList.add(t) : (e.className += (e.className ? " " : "") + t);
            },
            M = function (e, t) {
              i
                ? e.classList.remove(t)
                : (e.className = e.className
                    .replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ")
                    .replace(/^\s+/, "")
                    .replace(/\s+$/, ""));
            },
            P = function (e) {
              return e.llTempImage;
            },
            A = function (e, t) {
              if (t) {
                var n = t._observer;
                n && n.unobserve(e);
              }
            },
            L = function (e, t) {
              e && (e.loadingCount += t);
            },
            I = function (e, t) {
              e && (e.toLoadCount = t);
            },
            D = function (e) {
              for (var t, n = [], r = 0; (t = e.children[r]); r += 1) "SOURCE" === t.tagName && n.push(t);
              return n;
            },
            z = function (e, t) {
              var n = e.parentNode;
              n && "PICTURE" === n.tagName && D(n).forEach(t);
            },
            j = function (e, t) {
              D(e).forEach(t);
            },
            B = [u],
            N = [u, f],
            R = [u, c, d],
            q = [h],
            F = function (e) {
              return !!e[p];
            },
            H = function (e) {
              return e[p];
            },
            W = function (e) {
              return delete e[p];
            },
            $ = function (e, t) {
              if (!F(e)) {
                var n = {};
                t.forEach(function (t) {
                  n[t] = e.getAttribute(t);
                }),
                  (e[p] = n);
              }
            },
            V = function (e, t) {
              if (F(e)) {
                var n = H(e);
                t.forEach(function (t) {
                  !(function (e, t, n) {
                    n ? e.setAttribute(t, n) : e.removeAttribute(t);
                  })(e, t, n[t]);
                });
              }
            },
            Y = function (e, t, n) {
              O(e, t.class_applied), x(e, m), n && (t.unobserve_completed && A(e, t), S(t.callback_applied, e, n));
            },
            G = function (e, t, n) {
              O(e, t.class_loading), x(e, v), n && (L(n, 1), S(t.callback_loading, e, n));
            },
            X = function (e, t, n) {
              n && e.setAttribute(t, n);
            },
            U = function (e, t) {
              X(e, d, w(e, t.data_sizes)), X(e, c, w(e, t.data_srcset)), X(e, u, w(e, t.data_src));
            },
            K = {
              IMG: function (e, t) {
                z(e, function (e) {
                  $(e, R), U(e, t);
                }),
                  $(e, R),
                  U(e, t);
              },
              IFRAME: function (e, t) {
                $(e, B), X(e, u, w(e, t.data_src));
              },
              VIDEO: function (e, t) {
                j(e, function (e) {
                  $(e, B), X(e, u, w(e, t.data_src));
                }),
                  $(e, N),
                  X(e, f, w(e, t.data_poster)),
                  X(e, u, w(e, t.data_src)),
                  e.load();
              },
              OBJECT: function (e, t) {
                $(e, q), X(e, h, w(e, t.data_src));
              },
            },
            Q = ["IMG", "IFRAME", "VIDEO", "OBJECT"],
            Z = function (e, t) {
              !t ||
                (function (e) {
                  return e.loadingCount > 0;
                })(t) ||
                (function (e) {
                  return e.toLoadCount > 0;
                })(t) ||
                S(e.callback_finish, t);
            },
            J = function (e, t, n) {
              e.addEventListener(t, n), (e.llEvLisnrs[t] = n);
            },
            ee = function (e, t, n) {
              e.removeEventListener(t, n);
            },
            te = function (e) {
              return !!e.llEvLisnrs;
            },
            ne = function (e) {
              if (te(e)) {
                var t = e.llEvLisnrs;
                for (var n in t) {
                  var r = t[n];
                  ee(e, n, r);
                }
                delete e.llEvLisnrs;
              }
            },
            re = function (e, t, n) {
              !(function (e) {
                delete e.llTempImage;
              })(e),
                L(n, -1),
                (function (e) {
                  e && (e.toLoadCount -= 1);
                })(n),
                M(e, t.class_loading),
                t.unobserve_completed && A(e, n);
            },
            ie = function (e, t, n) {
              var r = P(e) || e;
              te(r) ||
                (function (e, t, n) {
                  te(e) || (e.llEvLisnrs = {});
                  var r = "VIDEO" === e.tagName ? "loadeddata" : "load";
                  J(e, r, t), J(e, "error", n);
                })(
                  r,
                  function (i) {
                    !(function (e, t, n, r) {
                      var i = k(t);
                      re(t, n, r), O(t, n.class_loaded), x(t, g), S(n.callback_loaded, t, r), i || Z(n, r);
                    })(0, e, t, n),
                      ne(r);
                  },
                  function (i) {
                    !(function (e, t, n, r) {
                      var i = k(t);
                      re(t, n, r), O(t, n.class_error), x(t, y), S(n.callback_error, t, r), n.restore_on_error && V(t, R), i || Z(n, r);
                    })(0, e, t, n),
                      ne(r);
                  }
                );
            },
            ae = function (e, t, n) {
              !(function (e) {
                return Q.indexOf(e.tagName) > -1;
              })(e)
                ? (function (e, t, n) {
                    !(function (e) {
                      e.llTempImage = document.createElement("IMG");
                    })(e),
                      ie(e, t, n),
                      (function (e) {
                        F(e) || (e[p] = { backgroundImage: e.style.backgroundImage });
                      })(e),
                      (function (e, t, n) {
                        var r = w(e, t.data_bg),
                          i = w(e, t.data_bg_hidpi),
                          o = a && i ? i : r;
                        o && ((e.style.backgroundImage = 'url("'.concat(o, '")')), P(e).setAttribute(u, o), G(e, t, n));
                      })(e, t, n),
                      (function (e, t, n) {
                        var r = w(e, t.data_bg_multi),
                          i = w(e, t.data_bg_multi_hidpi),
                          o = a && i ? i : r;
                        o && ((e.style.backgroundImage = o), Y(e, t, n));
                      })(e, t, n),
                      (function (e, t, n) {
                        var r = w(e, t.data_bg_set);
                        if (r) {
                          var i = r.split("|"),
                            a = i.map(function (e) {
                              return "image-set(".concat(e, ")");
                            });
                          (e.style.backgroundImage = a.join()),
                            "" === e.style.backgroundImage &&
                              ((a = i.map(function (e) {
                                return "-webkit-image-set(".concat(e, ")");
                              })),
                              (e.style.backgroundImage = a.join())),
                            Y(e, t, n);
                        }
                      })(e, t, n);
                  })(e, t, n)
                : (function (e, t, n) {
                    ie(e, t, n),
                      (function (e, t, n) {
                        var r = K[e.tagName];
                        r && (r(e, t), G(e, t, n));
                      })(e, t, n);
                  })(e, t, n);
            },
            oe = function (e) {
              e.removeAttribute(u), e.removeAttribute(c), e.removeAttribute(d);
            },
            se = function (e) {
              z(e, function (e) {
                V(e, R);
              }),
                V(e, R);
            },
            le = {
              IMG: se,
              IFRAME: function (e) {
                V(e, B);
              },
              VIDEO: function (e) {
                j(e, function (e) {
                  V(e, B);
                }),
                  V(e, N),
                  e.load();
              },
              OBJECT: function (e) {
                V(e, q);
              },
            },
            ue = ["IMG", "IFRAME", "VIDEO"],
            ce = function (e) {
              return e.use_native && "loading" in HTMLImageElement.prototype;
            },
            de = function (e) {
              return Array.prototype.slice.call(e);
            },
            fe = function (e) {
              return e.container.querySelectorAll(e.elements_selector);
            },
            pe = function (e) {
              return (function (e) {
                return _(e) === y;
              })(e);
            },
            he = function (e, t) {
              return (function (e) {
                return de(e).filter(T);
              })(e || fe(t));
            },
            ve = function (e, n) {
              var i = s(e);
              (this._settings = i),
                (this.loadingCount = 0),
                (function (e, t) {
                  r &&
                    !ce(e) &&
                    (t._observer = new IntersectionObserver(
                      function (n) {
                        !(function (e, t, n) {
                          e.forEach(function (e) {
                            return (function (e) {
                              return e.isIntersecting || e.intersectionRatio > 0;
                            })(e)
                              ? (function (e, t, n, r) {
                                  var i = (function (e) {
                                    return E.indexOf(_(e)) >= 0;
                                  })(e);
                                  x(e, "entered"),
                                    O(e, n.class_entered),
                                    M(e, n.class_exited),
                                    (function (e, t, n) {
                                      t.unobserve_entered && A(e, n);
                                    })(e, n, r),
                                    S(n.callback_enter, e, t, r),
                                    i || ae(e, n, r);
                                })(e.target, e, t, n)
                              : (function (e, t, n, r) {
                                  T(e) ||
                                    (O(e, n.class_exited),
                                    (function (e, t, n, r) {
                                      n.cancel_on_exit &&
                                        (function (e) {
                                          return _(e) === v;
                                        })(e) &&
                                        "IMG" === e.tagName &&
                                        (ne(e),
                                        (function (e) {
                                          z(e, function (e) {
                                            oe(e);
                                          }),
                                            oe(e);
                                        })(e),
                                        se(e),
                                        M(e, n.class_loading),
                                        L(r, -1),
                                        C(e),
                                        S(n.callback_cancel, e, t, r));
                                    })(e, t, n, r),
                                    S(n.callback_exit, e, t, r));
                                })(e.target, e, t, n);
                          });
                        })(n, e, t);
                      },
                      (function (e) {
                        return { root: e.container === document ? null : e.container, rootMargin: e.thresholds || e.threshold + "px" };
                      })(e)
                    ));
                })(i, this),
                (function (e, n) {
                  t &&
                    window.addEventListener("online", function () {
                      !(function (e, t) {
                        var n;
                        ((n = fe(e)), de(n).filter(pe)).forEach(function (t) {
                          M(t, e.class_error), C(t);
                        }),
                          t.update();
                      })(e, n);
                    });
                })(i, this),
                this.update(n);
            };
          return (
            (ve.prototype = {
              update: function (e) {
                var t,
                  i,
                  a = this._settings,
                  o = he(e, a);
                I(this, o.length),
                  !n && r
                    ? ce(a)
                      ? (function (e, t, n) {
                          e.forEach(function (e) {
                            -1 !== ue.indexOf(e.tagName) &&
                              (function (e, t, n) {
                                e.setAttribute("loading", "lazy"),
                                  ie(e, t, n),
                                  (function (e, t) {
                                    var n = K[e.tagName];
                                    n && n(e, t);
                                  })(e, t),
                                  x(e, b);
                              })(e, t, n);
                          }),
                            I(n, 0);
                        })(o, a, this)
                      : ((i = o),
                        (function (e) {
                          e.disconnect();
                        })((t = this._observer)),
                        (function (e, t) {
                          t.forEach(function (t) {
                            e.observe(t);
                          });
                        })(t, i))
                    : this.loadAll(o);
              },
              destroy: function () {
                this._observer && this._observer.disconnect(),
                  fe(this._settings).forEach(function (e) {
                    W(e);
                  }),
                  delete this._observer,
                  delete this._settings,
                  delete this.loadingCount,
                  delete this.toLoadCount;
              },
              loadAll: function (e) {
                var t = this,
                  n = this._settings;
                he(e, n).forEach(function (e) {
                  A(e, t), ae(e, n, t);
                });
              },
              restoreAll: function () {
                var e = this._settings;
                fe(e).forEach(function (t) {
                  !(function (e, t) {
                    (function (e) {
                      var t = le[e.tagName];
                      t
                        ? t(e)
                        : (function (e) {
                            if (F(e)) {
                              var t = H(e);
                              e.style.backgroundImage = t.backgroundImage;
                            }
                          })(e);
                    })(e),
                      (function (e, t) {
                        T(e) || k(e) || (M(e, t.class_entered), M(e, t.class_exited), M(e, t.class_applied), M(e, t.class_loading), M(e, t.class_loaded), M(e, t.class_error));
                      })(e, t),
                      C(e),
                      W(e);
                  })(t, e);
                });
              },
            }),
            (ve.load = function (e, t) {
              var n = s(t);
              ae(e, n);
            }),
            (ve.resetStatus = function (e) {
              C(e);
            }),
            t &&
              (function (e, t) {
                if (t)
                  if (t.length) for (var n, r = 0; (n = t[r]); r += 1) l(e, n);
                  else l(e, t);
              })(ve, window.lazyLoadOptions),
            ve
          );
        })();
      },
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var a = (t[r] = { id: r, loaded: !1, exports: {} });
    return e[r].call(a.exports, a, a.exports, n), (a.loaded = !0), a.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, { a: t }), t;
  }),
    (n.d = (e, t) => {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (n.nmd = (e) => ((e.paths = []), e.children || (e.children = []), e)),
    (() => {
      "use strict";
      var e = n(755),
        t = n.n(e),
        r = n(820),
        i = n.n(r),
        a = n(732),
        o = n.n(a);
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      var l = (function () {
          function e() {
            !(function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e),
              (this.cart = ".cart"),
              (this.cartOpenButton = ".js-cart"),
              (this.cartBody = ".cart__container"),
              (this.cartCloseButton = "#cart-close"),
              (this.overlay = ".cart__overlay"),
              (this.mobiCart = ".header__cart"),
              (this.cartQuantity = ".cart-card-quantity"),
              (this.tl = null),
              (this.body = t()("body"));
          }
          var n, r;
          return (
            (n = e),
            (r = [
              {
                key: "init",
                value: function () {
                  this.openMobi(), this.open(), this.close(), this.cartQuantityAction();
                },
              },
              {
                key: "openMobi",
                value: function () {
                  var e = this;
                  this.body.on("click", this.mobiCart, function (t) {
                    t.preventDefault(), e.openC();
                  });
                },
              },
              {
                key: "open",
                value: function () {
                  var e = this;
                  this.cartOpenButton &&
                    this.body.on("click", this.cartOpenButton, function (t) {
                      t.preventDefault(), e.openC();
                    });
                },
              },
              {
                key: "openC",
                value: function () {
                  var e = this;
                  t()(this.cart).addClass("cart--open"),
                    t()("html").addClass("overflow-hidden"),
                    t()(this.overlay).fadeIn(function () {
                      t()(this).on("click", function () {
                        e.closeC();
                      });
                    });
                },
              },
              {
                key: "cartQuantityAction",
                value: function () {
                  var e = this;
                  this.cartQuantity &&
                    (this.body.on("click", "".concat(this.cartQuantity, " .cart-card-quantity__down"), function (n) {
                      var r, i;
                      (i = (r = t()(e).parent().find(".cart-card-quantity__input")).value), (i = --i <= 0 ? 0 : i), (r.value = i);
                    }),
                    this.body.on("click", "".concat(this.cartQuantity, " .cart-card-quantity__up"), function (n) {
                      var r, i;
                      (i = (r = t()(e).parent().find(".cart-card-quantity__input")).value), i++, (r.value = i);
                    }));
                },
              },
              {
                key: "close",
                value: function () {
                  var e = this;
                  this.cartCloseButton &&
                    this.body.on("click", this.cartCloseButton, function (t) {
                      t.preventDefault(), e.closeC();
                    });
                },
              },
              {
                key: "closeC",
                value: function () {
                  t()("html").removeClass("overflow-hidden"), t()(this.cart).removeClass("cart--open"), t()(this.overlay).fadeOut();
                },
              },
              {
                key: "setWindowHeight",
                value: function () {
                  var e = this,
                    n = 0,
                    r = 0;
                  window.addEventListener("scroll", function (i) {
                    (r = window.pageYOffset), n < r ? t()(e.cart).removeClass("cart-fullheight") : n > r && t()(e.cart).addClass("cart-fullheight"), (n = r);
                  });
                },
              },
            ]) && s(n.prototype, r),
            Object.defineProperty(n, "prototype", { writable: !1 }),
            e
          );
        })(),
        u = n(755);
      function c(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
    u(document).ready(function () {
      var s = u("#skip-to-content");
      s.attr("autofocus");
      s.on("keydown", function(e) {
        var firstSection = u("#main-content").find(".shopify-section").first();
        var firstFocusable = firstSection.find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
        if (e.keyCode === 13) {
          firstFocusable.focus();
        }
      })
      var a = document.activeElement;
        var e = u("body");
        e.on("submit", ".AddToCartFormSet", function (e) {
          e.preventDefault();
          var t = u(this).serializeArray(),
            r = u(this).data("qty") ? u(u(this).data("qty")) : u("#set-qty-input"),
            i = parseInt(r.val()),
            a = t.reduce(function (e, t) {
              var n;
              return t.name.startsWith("items[") ? ((e[t.value] = { id: t.value, quantity: ((null === (n = e[t.value]) || void 0 === n ? void 0 : n.quantity) || 0) + i }), e) : e;
            }, {});
          u.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: { items: a },
            success: function () {
              n();
            },
          });
        });
        var t = function (e) {
          u.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: e.serialize(),
            success: function () {
              n();
            },
          });
        };
        function n() {
          u.ajax({
            url: "/cart?view=sticky",
            success: function (e) {
              u("#sticky-cart-content").html(e),
                u("#modal-sets-the-reboard-trio .icon-close").click(),
                new l().openC(),
                u.ajax({
                  url: "/cart.js",
                  dataType: "json",
                  cache: !1,
                  type: "get",
                  success: function (e) {
                    !(function (e, t) {
                      if (void 0 !== window.giftProduct && void 0 !== window.giftProduct.variants && 0 !== window.giftProduct.variants.length && window.giftProduct.variants) {
                        var r,
                          i = window.giftProduct.variants[0].id,
                          a = t.items.find(function (e) {
                            return e.id === i;
                          });
                        (a && e) ||
                          (!a && !e) ||
                          ((r = e ? { items: [{ id: i, quantity: 1 }] } : { id: i, quantity: 0 }),
                          u.ajax({
                            url: "/cart/".concat(e ? "add" : "change", ".js"),
                            dataType: "json",
                            cache: !1,
                            type: "post",
                            data: r,
                            success: function () {
                              n();
                            },
                          }));
                      }
                    })(e.total_price >= 8e3, e);
                    var t = e.item_count,
                      r = u(".desktopCartBtn"),
                      i = u(".mobileCartBtn");
                    t > 0 ? (r.html('<div class="cart__filled">Cart '.concat(t, "</div>")), i.html('<div class="cart__filled">Cart '.concat(t, "</div>"))) : (r.html('<span class="cart__empty">Cart</span>'), i.html("Cart")),
                      (window.cartData = e),
                      document.dispatchEvent(new Event("cartUpdated"));
                  },
                });
            },
          });
        }
        // this is needed for Stylux's integration; see the
        // `stylux-head.liquid` snippet for more details
        window.fetchStickyCart = n;
        e.on("submit", ".AddToCartForm", function (e) {
          e.preventDefault();
          var n = u(this);
          void 0 !== u(this).data("clear")
            ? u.ajax({
                url: "/cart/clear.js",
                type: "post",
                success: function () {
                  t(n);
                },
              })
            : t(n);
        }),
          e.on("click", ".AddToCartDiv button", function (e) {
            e.preventDefault(),
              u.ajax({
                url: "/cart/add.js",
                dataType: "json",
                cache: !1,
                type: "post",
                data: { id: u(this).siblings("input").val() },
                success: function () {
                  n();
                },
              });
          }),
          e.on("click", ".quantity-change", function (e) {
            var t = { line: u(this).data("line"), quantity: u(this).data("value") };
            u.ajax({
              url: "/cart/change.js",
              dataType: "json",
              cache: !1,
              type: "post",
              data: t,
              success: function () {
                n();
              },
            });
          }),
          e.on("click", "#add-to-cart-mobile", function () {
            u(".productMainForm").submit();
          }),
          u(document).on("refreshCart", function () {
            n();
          });
      });
      u(document)
        .on("keydown", function(e) {
        var m = u(".dropdowns");
        var j = u(".js-shop");
        if (e.keyCode === 27) {
          if (m.hasClass("dropdowns--active")) {
            m.removeClass("dropdowns--active"),
            u(".dropdown--1").removeClass("dropdown--show"),
            u(".dropdown--2").removeClass("dropdown--show"),
            j.removeClass("js-shop--active"),
            j.focus();
          }
        }
        var i = u(".dropdown--2");
        var d = i.find(".dropdown-menu__link")[0];
        if (e.keyCode === 39) {
          d.focus();
        }
      })
      var count = 0;
      var subnavImageCount = 0;
      const d = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.body = t()("body")),
            (this.header = t()(".header")),
            (this.navLink = t()(".nav__link")),
            (this.headerOverlay = t()(".header__overlay")),
            (this.navToggleBtn = t()(".header__menu-toggle")),
            (this.navPrimary = t()(".nav--primary")),
            (this.navSecondary = t()(".nav--secondary")),
            (this.hero = t()(".hero")),
            this.init();
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "init",
              value: function () {
                var e = this,
                  n = this,
                  r = null,
                  i = null;
                this.navToggleBtn.on("click", function (n) {
                  var r, i;
                  n.preventDefault(),
                    t()("body").toggleClass("navbar-open"),
                    e.navPrimary.fadeToggle(),
                    e.navSecondary.fadeToggle(),
                    t()("body").hasClass("navbar-open")
                      ? ((r = window.pageYOffset || document.documentElement.scrollTop),
                        (i = window.pageXOffset || document.documentElement.scrollLeft),
                        (window.onscroll = function () {
                          window.scrollTo(i, r);
                        }))
                      : (window.onscroll = function () {});
                }),
                  this.navLink.each(function (e) {
                    t()(this)
                      .on("click", function (e) {
                        if (t()(".js-shop").hasClass("js-shop--active")) {
                          t()(".js-shop").removeClass("js-shop--active");
                          t()(".dropdowns").removeClass("dropdowns--active");
                        } else {
                          var a = t()(e.target);
                          n.header.addClass("header--active"),
                            
                            n.headerOverlay.addClass("header__overlay--active"),
                            a.hasClass("js-shop")
                              ? ((count = 0),
                                 (subnavImageCount = 0),
                                t()(".dropdown--2").removeClass("dropdown--show"),
                                t()(".js-shop").addClass("js-shop--active"),
                                t()(".dropdown--1").addClass("dropdown--show"),
                                t()(".js-search").attr("tabindex", "-1"),
                                t()(".dropdowns").addClass("dropdowns--active"),
                                t()(".dropdowns__overlay").addClass("dropdowns__overlay--active").fadeIn())
                              : (t()(".dropdown").removeClass("dropdown--show"),
                                t()(".dropdowns__overlay").removeClass("dropdowns__overlay--active").fadeOut(),
                                (r = setTimeout(function () {
                                  t()(".dropdowns").removeClass("dropdowns--active"),
                                    t()(".dropdowns__overlay").removeClass("dropdowns__overlay--active").fadeOut(),
                                    t()(".js-shop").removeClass("js-shop--active"),
                                    t()(".dropdown-menu__link").removeClass("dropdown-menu__link--active");
                                }, 1e3)));                          
                        }
                      }),
                      t()(this)
                        .on("mouseenter", function (e) {
                          if (t()(".js-shop").hasClass("js-shop--active")) {
                            t()(".js-shop").removeClass("js-shop--active");
                            t()(".dropdowns").removeClass("dropdowns--active");
                          } else {
                            var a = t()(e.target);
                            n.header.addClass("header--active"),
                              
                              n.headerOverlay.addClass("header__overlay--active"),
                              a.hasClass("js-shop")
                                ? ((count = 0),
                                   (subnavImageCount = 0),
                                  t()(".dropdown--2").removeClass("dropdown--show"),
                                  t()(".js-shop").addClass("js-shop--active"),
                                  t()(".dropdown--1").addClass("dropdown--show"),
                                  t()(".js-search").attr("tabindex", "-1"),
                                  t()(".dropdowns").addClass("dropdowns--active"),
                                  t()(".dropdowns__overlay").addClass("dropdowns__overlay--active").fadeIn())
                                : (t()(".dropdown").removeClass("dropdown--show"),
                                  t()(".dropdowns__overlay").removeClass("dropdowns__overlay--active").fadeOut(),
                                  (r = setTimeout(function () {
                                    t()(".dropdowns").removeClass("dropdowns--active"),
                                      t()(".dropdowns__overlay").removeClass("dropdowns__overlay--active").fadeOut(),
                                      t()(".js-shop").removeClass("js-shop--active"),
                                      t()(".dropdown-menu__link").removeClass("dropdown-menu__link--active");
                                  }, 1e3)));                          
                          }
                        })
            
                  }),
                  t()(window).width() >= 992
                    ? (
                      t()(".dropdown--1 .dropdown-menu__link").on("mouseenter", function (e) {
                        // if (t()(this).hasClass("has-submenu")) {
                        //   count++;
                        // }
                        // if (!t()(this).hasClass("has-submenu")) {
                        //   count = 0;
                        //   t()(".dropdown--2 .dropdown-menu").removeClass("first-dropdown")
                        // }
                        // if (count == 1 && t()(this).hasClass("has-submenu")) {
                        //   t()(".dropdown--2 .dropdown-menu").addClass("first-dropdown")
                        // }
                        // if (count !== 1) {
                        //   t()(".dropdown--2 .dropdown-menu").removeClass("first-dropdown")
                        // }
                        var n = t()(this).parent().find(".dropdown-menu").html();
                        void 0 !== n ? 
                          (
                           t()(".dropdown--2 .dropdown-menu").html(n),
                           t()(".dropdown--2").addClass("dropdown--show")
                          ) 
                          : 
                          t()(".dropdown--3, .dropdown--2").removeClass("dropdown--show");
                      }),
                      (t()(".dropdown--1 .dropdown-menu__link").on("focus", function (e) {
                        if (t()(this).hasClass("has-submenu")) {
                          count++;
                        }
                        if (!t()(this).hasClass("has-submenu")) {
                          count = 0;
                          t()(".dropdown--2 .dropdown-menu").removeClass("first-dropdown")
                        }
                        if (count == 1 && t()(this).hasClass("has-submenu")) {
                          t()(".dropdown--2 .dropdown-menu").addClass("first-dropdown")
                        }
                        if (count == 0 || count > 1) {
                          t()(".dropdown--2 .dropdown-menu").removeClass("first-dropdown")
                        }
                        var n = t()(this).parent().find(".dropdown-menu").html();
                        void 0 !== n ? (t()(".dropdown--2 .dropdown-menu").html(n), t()(".dropdown--2").addClass("dropdown--show")) : t()(".dropdown--3, .dropdown--2").removeClass("dropdown--show");
                      }),
                      t()("body").on("mouseenter", ".dropdown--2 .dropdown-menu__link", function (e) {
                        subnavImageCount++;
                        if (subnavImageCount == 1) {
                          t()(".dropdown--3 .dropdown__img").addClass("first-dropdown__img")
                        }
                        if (subnavImageCount !== 1) {
                          t()(".dropdown--3 .dropdown__img").removeClass("first-dropdown__img")
                        }
                        var n = t()(this).attr("data-productimg");
                        void 0 !== n && (t()(".dropdown--3 .dropdown__img ").attr("src", n), t()(".dropdown--3").addClass("dropdown--show"));
                      })),
                      t()("body").on("focus", ".dropdown--2 .dropdown-menu__link", function (e) {
                        var n = t()(this).attr("data-productimg");
                        void 0 !== n && (t()(".dropdown--3 .dropdown__img ").attr("src", n), t()(".dropdown--3").addClass("dropdown--show"));
                      }))
                    : t()(".dropdown--1 .dropdown-menu__link").on("click", function (e) {
                        var n = t()(this).parent().find(".dropdown-menu");
                        t()(".nav--secondary").fadeOut(), t()(this).parent().has(".dropdown-menu").length && (e.preventDefault(), t()(".dropdown--2 .dropdown-menu").html(n.html()), t()(".dropdown--2").addClass("dropdown--show"));
                      }),
                  t()(".dropdown--1").on("mouseenter", function () {
                    subnavImageCount = 0;
                    t()(".dropdown--3 .dropdown__img").removeClass("first-dropdown__img")
                    t()(".dropdown--3").removeClass("dropdown--show");
                  }),
                  t()(".dropdown__close, .dropdowns__overlay").on("click", function () {
                    t()(".dropdown--1, .dropdown--2, .dropdown--3").removeClass("dropdown--show"),
                      setTimeout(function () {
                        t()(".dropdowns").removeClass("dropdowns--active"),
                          t()(".dropdowns__overlay").addClass("dropdowns__overlay--active").fadeOut(),
                          t()(".header").removeClass("header--active"),
                          t()(".js-shop").removeClass("js-shop--active"),
                          t()(".dropdown-menu__link").removeClass("dropdown-menu__link--active");
                      }, 1e3);
                  }),
                  t()(".dropdown--1 .dropdown-menu__link").each(function (e, n) {
                    t()(n).on("click", function () {
                      t()(this).parents(".dropdowns").find(".dropdown").hasClass("dropdown--show") && t()(".header__buttons").addClass("dropdown-open");
                    });
                  }),
                  t()(".back-to-shop").on("click", function () {
                    var e = document.querySelectorAll(".dropdown--show");
                    e.length &&
                      (1 === e.length ? (t()(this).parent(".header__buttons").removeClass("dropdown-open"), e[0].classList.remove("dropdown--show"), t()(".nav--secondary").fadeIn()) : e[e.length - 1].classList.remove("dropdown--show")),
                      t()(".search").hasClass("search--open") && (t()(this).parent(".header__buttons").removeClass("dropdown-open"), t()(".search").removeClass("search--open"));
                  }),
                  t()(".js-shop").on("click", function (e) {
                    t()(".search__overlay").trigger("click"),
                      setTimeout(function () {
                        t()(".header").addClass("header--active");
                      }, 500),
                      t()(window).outerWidth >= 992 && e.preventDefault();
                  }),
                  t()(document).on("mouseenter", ".dropdown-menu__link", function (e) {
                    t()(e.currentTarget).parent().siblings().find("a").removeClass("dropdown-menu__link--active"), t()(e.currentTarget).addClass("dropdown-menu__link--active");
                  }),
                  this.stickyHeader();
              },
            },
            {
              key: "stickyHeader",
              value: function () {
                var e = t()(".navbar"),
                  n = e.outerHeight(),
                  r = this.header;
                if ((t()(window).outerHeight(), e.wrap('<div class="navbar-placeholder"></div>'), t()(window).width() >= 992)) {
                  t()(".navbar-placeholder").outerHeight(n);
                  var i = 0,
                    a = n;
                  t()(window).on("scroll", function () {
                    var n = t()(window).scrollTop();
                    n > 100
                      ? (e.addClass("navbar--fixed").css("top", 0),
                        t()("body").addClass("scroll-up"),
                        t()(".ugc-sidebar").css("top", a),
                        r.addClass("header--sticky"),
                        n > i && (e.css("top", "-".concat(a, "px")), t()("body").removeClass("scroll-up"), t()(".ugc-sidebar").css("top", 0)),
                        (i = n))
                      : (r.removeClass("header--sticky"), e.removeClass("navbar--fixed").css("top", "-".concat(a, "px")));
                  });
                } else {
                  var o = t()(".header__logo"),
                    s = t()(window).scrollTop();
                  t()(window).on("scroll", function () {
                    t()(this).scrollTop() > 0 ? o.addClass("header__logo--active") : o.removeClass("header__logo--active");
                  }),
                    s > 0 && o.addClass("header__logo--active");
                }
              },
            },
          ]) && c(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      function f(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      var p = (function () {
        function e(n) {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.target = t()(n));
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "init",
              value: function () {
                var e = this;
                this.target.on("click", function (n) {
                  var accordionEl = t()(n.target).closest(".accordion-anchor");
                  var r = accordionEl.find("p");
                  if (r.hasClass("active")) return r.removeClass("active"), r.css({ maxHeight: "0px" }), void console.log("close elemt pls");
                  var i = document.querySelectorAll(".accordion-anchor__header span");
                  [].forEach.call(i, function (e) {
                    e.innerHTML = "+";
                  });
                  var a = e.target.find("p");
                  a.removeClass("active"), a.css({ maxHeight: "0px" }), r.addClass("active");
                  var o = r[0].scrollHeight + "px";
                  r.css({ maxHeight: o }), (accordionEl.find(".accordion-anchor__header span")[0].innerHTML = "-");
                });
                
                t()(window).on("resize", function () {
                  var activeAccordions = t()(".accordion-anchor p.active");
                  activeAccordions.each(function () {
                    var activeContent = t()(this);
                    var newHeight = this.scrollHeight + "px";
                    activeContent.css({ maxHeight: newHeight });
                  });
                });
              },
            },
          ]) && f(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      function h(e) {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
      }
      function v(e, t) {
        void 0 === e && (e = {}),
          void 0 === t && (t = {}),
          Object.keys(t).forEach(function (n) {
            void 0 === e[n] ? (e[n] = t[n]) : h(t[n]) && h(e[n]) && Object.keys(t[n]).length > 0 && v(e[n], t[n]);
          });
      }
      var g = {
        body: {},
        addEventListener: function () {},
        removeEventListener: function () {},
        activeElement: { blur: function () {}, nodeName: "" },
        querySelector: function () {
          return null;
        },
        querySelectorAll: function () {
          return [];
        },
        getElementById: function () {
          return null;
        },
        createEvent: function () {
          return { initEvent: function () {} };
        },
        createElement: function () {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () {},
            getElementsByTagName: function () {
              return [];
            },
          };
        },
        createElementNS: function () {
          return {};
        },
        importNode: function () {
          return null;
        },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
      };
      function m() {
        var e = "undefined" != typeof document ? document : {};
        return v(e, g), e;
      }
      var y = {
        document: g,
        navigator: { userAgent: "" },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        history: { replaceState: function () {}, pushState: function () {}, go: function () {}, back: function () {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener: function () {},
        removeEventListener: function () {},
        getComputedStyle: function () {
          return {
            getPropertyValue: function () {
              return "";
            },
          };
        },
        Image: function () {},
        Date: function () {},
        screen: {},
        setTimeout: function () {},
        clearTimeout: function () {},
        matchMedia: function () {
          return {};
        },
        requestAnimationFrame: function (e) {
          return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
        },
        cancelAnimationFrame: function (e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function b() {
        var e = "undefined" != typeof window ? window : {};
        return v(e, y), e;
      }
      function w(e) {
        return (
          (w = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }),
          w(e)
        );
      }
      function _(e, t) {
        return (
          (_ =
            Object.setPrototypeOf ||
            function (e, t) {
              return (e.__proto__ = t), e;
            }),
          _(e, t)
        );
      }
      function x() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      function C(e, t, n) {
        return (
          (C = x()
            ? Reflect.construct
            : function (e, t, n) {
                var r = [null];
                r.push.apply(r, t);
                var i = new (Function.bind.apply(e, r))();
                return n && _(i, n.prototype), i;
              }),
          C.apply(null, arguments)
        );
      }
      function T(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return (
          (T = function (e) {
            if (null === e || ((n = e), -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
            var n;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
              if (t.has(e)) return t.get(e);
              t.set(e, r);
            }
            function r() {
              return C(e, arguments, w(this).constructor);
            }
            return (r.prototype = Object.create(e.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } })), _(r, e);
          }),
          T(e)
        );
      }
      var k = (function (e) {
        var t, n;
        function r(t) {
          var n, r, i;
          return (
            (r = (function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            })((n = e.call.apply(e, [this].concat(t)) || this))),
            (i = r.__proto__),
            Object.defineProperty(r, "__proto__", {
              get: function () {
                return i;
              },
              set: function (e) {
                i.__proto__ = e;
              },
            }),
            n
          );
        }
        return (n = e), ((t = r).prototype = Object.create(n.prototype)), (t.prototype.constructor = t), (t.__proto__ = n), r;
      })(T(Array));
      function E(e) {
        void 0 === e && (e = []);
        var t = [];
        return (
          e.forEach(function (e) {
            Array.isArray(e) ? t.push.apply(t, E(e)) : t.push(e);
          }),
          t
        );
      }
      function S(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function O(e, t) {
        var n = b(),
          r = m(),
          i = [];
        if (!t && e instanceof k) return e;
        if (!e) return new k(i);
        if ("string" == typeof e) {
          var a = e.trim();
          if (a.indexOf("<") >= 0 && a.indexOf(">") >= 0) {
            var o = "div";
            0 === a.indexOf("<li") && (o = "ul"),
              0 === a.indexOf("<tr") && (o = "tbody"),
              (0 !== a.indexOf("<td") && 0 !== a.indexOf("<th")) || (o = "tr"),
              0 === a.indexOf("<tbody") && (o = "table"),
              0 === a.indexOf("<option") && (o = "select");
            var s = r.createElement(o);
            s.innerHTML = a;
            for (var l = 0; l < s.childNodes.length; l += 1) i.push(s.childNodes[l]);
          } else
            i = (function (e, t) {
              if ("string" != typeof e) return [e];
              for (var n = [], r = t.querySelectorAll(e), i = 0; i < r.length; i += 1) n.push(r[i]);
              return n;
            })(e.trim(), t || r);
        } else if (e.nodeType || e === n || e === r) i.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof k) return e;
          i = e;
        }
        return new k(
          (function (e) {
            for (var t = [], n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(i)
        );
      }
      O.fn = k.prototype;
      var M = "resize scroll".split(" ");
      function P(e) {
        return function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
          if (void 0 === n[0]) {
            for (var i = 0; i < this.length; i += 1) M.indexOf(e) < 0 && (e in this[i] ? this[i][e]() : O(this[i]).trigger(e));
            return this;
          }
          return this.on.apply(this, [e].concat(n));
        };
      }
      P("click"),
        P("blur"),
        P("focus"),
        P("focusin"),
        P("focusout"),
        P("keyup"),
        P("keydown"),
        P("keypress"),
        P("submit"),
        P("change"),
        P("mousedown"),
        P("mousemove"),
        P("mouseup"),
        P("mouseenter"),
        P("mouseleave"),
        P("mouseout"),
        P("mouseover"),
        P("touchstart"),
        P("touchend"),
        P("touchmove"),
        P("resize"),
        P("scroll");
      var A = {
        addClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = E(
            t.map(function (e) {
              return e.split(" ");
            })
          );
          return (
            this.forEach(function (e) {
              var t;
              (t = e.classList).add.apply(t, r);
            }),
            this
          );
        },
        removeClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = E(
            t.map(function (e) {
              return e.split(" ");
            })
          );
          return (
            this.forEach(function (e) {
              var t;
              (t = e.classList).remove.apply(t, r);
            }),
            this
          );
        },
        hasClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = E(
            t.map(function (e) {
              return e.split(" ");
            })
          );
          return (
            S(this, function (e) {
              return (
                r.filter(function (t) {
                  return e.classList.contains(t);
                }).length > 0
              );
            }).length > 0
          );
        },
        toggleClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = E(
            t.map(function (e) {
              return e.split(" ");
            })
          );
          this.forEach(function (e) {
            r.forEach(function (t) {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
          for (var n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else for (var r in e) (this[n][r] = e[r]), this[n].setAttribute(r, e[r]);
          return this;
        },
        removeAttr: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
          return this;
        },
        on: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = t[0],
            i = t[1],
            a = t[2],
            o = t[3];
          function s(e) {
            var t = e.target;
            if (t) {
              var n = e.target.dom7EventData || [];
              if ((n.indexOf(e) < 0 && n.unshift(e), O(t).is(i))) a.apply(t, n);
              else for (var r = O(t).parents(), o = 0; o < r.length; o += 1) O(r[o]).is(i) && a.apply(r[o], n);
            }
          }
          function l(e) {
            var t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), a.apply(this, t);
          }
          "function" == typeof t[1] && ((r = t[0]), (a = t[1]), (o = t[2]), (i = void 0)), o || (o = !1);
          for (var u, c = r.split(" "), d = 0; d < this.length; d += 1) {
            var f = this[d];
            if (i)
              for (u = 0; u < c.length; u += 1) {
                var p = c[u];
                f.dom7LiveListeners || (f.dom7LiveListeners = {}), f.dom7LiveListeners[p] || (f.dom7LiveListeners[p] = []), f.dom7LiveListeners[p].push({ listener: a, proxyListener: s }), f.addEventListener(p, s, o);
              }
            else
              for (u = 0; u < c.length; u += 1) {
                var h = c[u];
                f.dom7Listeners || (f.dom7Listeners = {}), f.dom7Listeners[h] || (f.dom7Listeners[h] = []), f.dom7Listeners[h].push({ listener: a, proxyListener: l }), f.addEventListener(h, l, o);
              }
          }
          return this;
        },
        off: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var r = t[0],
            i = t[1],
            a = t[2],
            o = t[3];
          "function" == typeof t[1] && ((r = t[0]), (a = t[1]), (o = t[2]), (i = void 0)), o || (o = !1);
          for (var s = r.split(" "), l = 0; l < s.length; l += 1)
            for (var u = s[l], c = 0; c < this.length; c += 1) {
              var d = this[c],
                f = void 0;
              if ((!i && d.dom7Listeners ? (f = d.dom7Listeners[u]) : i && d.dom7LiveListeners && (f = d.dom7LiveListeners[u]), f && f.length))
                for (var p = f.length - 1; p >= 0; p -= 1) {
                  var h = f[p];
                  (a && h.listener === a) || (a && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === a)
                    ? (d.removeEventListener(u, h.proxyListener, o), f.splice(p, 1))
                    : a || (d.removeEventListener(u, h.proxyListener, o), f.splice(p, 1));
                }
            }
          return this;
        },
        trigger: function () {
          for (var e = b(), t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
          for (var i = n[0].split(" "), a = n[1], o = 0; o < i.length; o += 1)
            for (var s = i[o], l = 0; l < this.length; l += 1) {
              var u = this[l];
              if (e.CustomEvent) {
                var c = new e.CustomEvent(s, { detail: a, bubbles: !0, cancelable: !0 });
                (u.dom7EventData = n.filter(function (e, t) {
                  return t > 0;
                })),
                  u.dispatchEvent(c),
                  (u.dom7EventData = []),
                  delete u.dom7EventData;
              }
            }
          return this;
        },
        transitionEnd: function (e) {
          var t = this;
          return (
            e &&
              t.on("transitionend", function n(r) {
                r.target === this && (e.call(this, r), t.off("transitionend", n));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              var t = this.styles();
              return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              var t = this.styles();
              return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          var e = b();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            var e = b(),
              t = m(),
              n = this[0],
              r = n.getBoundingClientRect(),
              i = t.body,
              a = n.clientTop || i.clientTop || 0,
              o = n.clientLeft || i.clientLeft || 0,
              s = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: r.top + s - a, left: r.left + l - o };
          }
          return null;
        },
        css: function (e, t) {
          var n,
            r = b();
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (n = 0; n < this.length; n += 1) for (var i in e) this[n].style[i] = e[i];
              return this;
            }
            if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach(function (t, n) {
                e.apply(t, [t, n]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          var t,
            n,
            r = b(),
            i = m(),
            a = this[0];
          if (!a || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (a.matches) return a.matches(e);
            if (a.webkitMatchesSelector) return a.webkitMatchesSelector(e);
            if (a.msMatchesSelector) return a.msMatchesSelector(e);
            for (t = O(e), n = 0; n < t.length; n += 1) if (t[n] === a) return !0;
            return !1;
          }
          if (e === i) return a === i;
          if (e === r) return a === r;
          if (e.nodeType || e instanceof k) {
            for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1) if (t[n] === a) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          var e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          var t = this.length;
          if (e > t - 1) return O([]);
          if (e < 0) {
            var n = t + e;
            return O(n < 0 ? [] : [this[n]]);
          }
          return O([this[e]]);
        },
        append: function () {
          for (var e, t = m(), n = 0; n < arguments.length; n += 1) {
            e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
            for (var r = 0; r < this.length; r += 1)
              if ("string" == typeof e) {
                var i = t.createElement("div");
                for (i.innerHTML = e; i.firstChild; ) this[r].appendChild(i.firstChild);
              } else if (e instanceof k) for (var a = 0; a < e.length; a += 1) this[r].appendChild(e[a]);
              else this[r].appendChild(e);
          }
          return this;
        },
        prepend: function (e) {
          var t,
            n,
            r = m();
          for (t = 0; t < this.length; t += 1)
            if ("string" == typeof e) {
              var i = r.createElement("div");
              for (i.innerHTML = e, n = i.childNodes.length - 1; n >= 0; n -= 1) this[t].insertBefore(i.childNodes[n], this[t].childNodes[0]);
            } else if (e instanceof k) for (n = 0; n < e.length; n += 1) this[t].insertBefore(e[n], this[t].childNodes[0]);
            else this[t].insertBefore(e, this[t].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0 ? (e ? (this[0].nextElementSibling && O(this[0].nextElementSibling).is(e) ? O([this[0].nextElementSibling]) : O([])) : this[0].nextElementSibling ? O([this[0].nextElementSibling]) : O([])) : O([]);
        },
        nextAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return O([]);
          for (; n.nextElementSibling; ) {
            var r = n.nextElementSibling;
            e ? O(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return O(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            var t = this[0];
            return e ? (t.previousElementSibling && O(t.previousElementSibling).is(e) ? O([t.previousElementSibling]) : O([])) : t.previousElementSibling ? O([t.previousElementSibling]) : O([]);
          }
          return O([]);
        },
        prevAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return O([]);
          for (; n.previousElementSibling; ) {
            var r = n.previousElementSibling;
            e ? O(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return O(t);
        },
        parent: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1) null !== this[n].parentNode && (e ? O(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
          return O(t);
        },
        parents: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].parentNode; r; ) e ? O(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
          return O(t);
        },
        closest: function (e) {
          var t = this;
          return void 0 === e ? O([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].querySelectorAll(e), i = 0; i < r.length; i += 1) t.push(r[i]);
          return O(t);
        },
        children: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].children, i = 0; i < r.length; i += 1) (e && !O(r[i]).is(e)) || t.push(r[i]);
          return O(t);
        },
        filter: function (e) {
          return O(S(this, e));
        },
        remove: function () {
          for (var e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(A).forEach(function (e) {
        Object.defineProperty(O.fn, e, { value: A[e], writable: !0 });
      });
      const L = O;
      function I(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function D() {
        return Date.now();
      }
      function z(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
      }
      function j(e) {
        return "undefined" != typeof window && void 0 !== window.HTMLElement ? e instanceof HTMLElement : e && (1 === e.nodeType || 11 === e.nodeType);
      }
      function B() {
        for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"], n = 1; n < arguments.length; n += 1) {
          var r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
          if (null != r && !j(r))
            for (
              var i = Object.keys(Object(r)).filter(function (e) {
                  return t.indexOf(e) < 0;
                }),
                a = 0,
                o = i.length;
              a < o;
              a += 1
            ) {
              var s = i[a],
                l = Object.getOwnPropertyDescriptor(r, s);
              void 0 !== l && l.enumerable && (z(e[s]) && z(r[s]) ? (r[s].__swiper__ ? (e[s] = r[s]) : B(e[s], r[s])) : !z(e[s]) && z(r[s]) ? ((e[s] = {}), r[s].__swiper__ ? (e[s] = r[s]) : B(e[s], r[s])) : (e[s] = r[s]));
            }
        }
        return e;
      }
      function N(e, t) {
        Object.keys(t).forEach(function (n) {
          z(t[n]) &&
            Object.keys(t[n]).forEach(function (r) {
              "function" == typeof t[n][r] && (t[n][r] = t[n][r].bind(e));
            }),
            (e[n] = t[n]);
        });
      }
      function R(e) {
        return (
          void 0 === e && (e = ""),
          "." +
            e
              .trim()
              .replace(/([\.:!\/])/g, "\\$1")
              .replace(/ /g, ".")
        );
      }
      function q(e, t, n, r) {
        var i = m();
        return (
          n &&
            Object.keys(r).forEach(function (n) {
              if (!t[n] && !0 === t.auto) {
                var a = i.createElement("div");
                (a.className = r[n]), e.append(a), (t[n] = a);
              }
            }),
          t
        );
      }
      var F, H, W;
      function $() {
        return (
          F ||
            (F = (function () {
              var e = b(),
                t = m();
              return {
                touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
                passiveListener: (function () {
                  var t = !1;
                  try {
                    var n = Object.defineProperty({}, "passive", {
                      get: function () {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, n);
                  } catch (e) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          F
        );
      }
      function V(e) {
        return (
          void 0 === e && (e = {}),
          H ||
            (H = (function (e) {
              var t = (void 0 === e ? {} : e).userAgent,
                n = $(),
                r = b(),
                i = r.navigator.platform,
                a = t || r.navigator.userAgent,
                o = { ios: !1, android: !1 },
                s = r.screen.width,
                l = r.screen.height,
                u = a.match(/(Android);?[\s\/]+([\d.]+)?/),
                c = a.match(/(iPad).*OS\s([\d_]+)/),
                d = a.match(/(iPod)(.*OS\s([\d_]+))?/),
                f = !c && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                p = "Win32" === i,
                h = "MacIntel" === i;
              return (
                !c &&
                  h &&
                  n.touch &&
                  ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(s + "x" + l) >= 0 &&
                  ((c = a.match(/(Version)\/([\d.]+)/)) || (c = [0, 1, "13_0_0"]), (h = !1)),
                u && !p && ((o.os = "android"), (o.android = !0)),
                (c || f || d) && ((o.os = "ios"), (o.ios = !0)),
                o
              );
            })(e)),
          H
        );
      }
      function Y() {
        return (
          W ||
            (W = (function () {
              var e,
                t = b();
              return {
                isEdge: !!t.navigator.userAgent.match(/Edge/g),
                isSafari: ((e = t.navigator.userAgent.toLowerCase()), e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
              };
            })()),
          W
        );
      }
      const G = {
        name: "resize",
        create: function () {
          var e = this;
          B(e, {
            resize: {
              observer: null,
              createObserver: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  ((e.resize.observer = new ResizeObserver(function (t) {
                    var n = e.width,
                      r = e.height,
                      i = n,
                      a = r;
                    t.forEach(function (t) {
                      var n = t.contentBoxSize,
                        r = t.contentRect,
                        o = t.target;
                      (o && o !== e.el) || ((i = r ? r.width : (n[0] || n).inlineSize), (a = r ? r.height : (n[0] || n).blockSize));
                    }),
                      (i === n && a === r) || e.resize.resizeHandler();
                  })),
                  e.resize.observer.observe(e.el));
              },
              removeObserver: function () {
                e.resize.observer && e.resize.observer.unobserve && e.el && (e.resize.observer.unobserve(e.el), (e.resize.observer = null));
              },
              resizeHandler: function () {
                e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
              },
              orientationChangeHandler: function () {
                e && !e.destroyed && e.initialized && e.emit("orientationchange");
              },
            },
          });
        },
        on: {
          init: function (e) {
            var t = b();
            e.params.resizeObserver && void 0 !== b().ResizeObserver ? e.resize.createObserver() : (t.addEventListener("resize", e.resize.resizeHandler), t.addEventListener("orientationchange", e.resize.orientationChangeHandler));
          },
          destroy: function (e) {
            var t = b();
            e.resize.removeObserver(), t.removeEventListener("resize", e.resize.resizeHandler), t.removeEventListener("orientationchange", e.resize.orientationChangeHandler);
          },
        },
      };
      function X() {
        return (
          (X =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          X.apply(this, arguments)
        );
      }
      var U = {
        attach: function (e, t) {
          void 0 === t && (t = {});
          var n = b(),
            r = this,
            i = new (n.MutationObserver || n.WebkitMutationObserver)(function (e) {
              if (1 !== e.length) {
                var t = function () {
                  r.emit("observerUpdate", e[0]);
                };
                n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0);
              } else r.emit("observerUpdate", e[0]);
            });
          i.observe(e, { attributes: void 0 === t.attributes || t.attributes, childList: void 0 === t.childList || t.childList, characterData: void 0 === t.characterData || t.characterData }), r.observer.observers.push(i);
        },
        init: function () {
          var e = this;
          if (e.support.observer && e.params.observer) {
            if (e.params.observeParents) for (var t = e.$el.parents(), n = 0; n < t.length; n += 1) e.observer.attach(t[n]);
            e.observer.attach(e.$el[0], { childList: e.params.observeSlideChildren }), e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
          }
        },
        destroy: function () {
          this.observer.observers.forEach(function (e) {
            e.disconnect();
          }),
            (this.observer.observers = []);
        },
      };
      const K = {
          name: "observer",
          params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
          create: function () {
            N(this, { observer: X({}, U, { observers: [] }) });
          },
          on: {
            init: function (e) {
              e.observer.init();
            },
            destroy: function (e) {
              e.observer.destroy();
            },
          },
        },
        Q = {
          on: function (e, t, n) {
            var r = this;
            if ("function" != typeof t) return r;
            var i = n ? "unshift" : "push";
            return (
              e.split(" ").forEach(function (e) {
                r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
              }),
              r
            );
          },
          once: function (e, t, n) {
            var r = this;
            if ("function" != typeof t) return r;
            function i() {
              r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
              for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++) a[o] = arguments[o];
              t.apply(r, a);
            }
            return (i.__emitterProxy = t), r.on(e, i, n);
          },
          onAny: function (e, t) {
            var n = this;
            if ("function" != typeof e) return n;
            var r = t ? "unshift" : "push";
            return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
          },
          offAny: function (e) {
            var t = this;
            if (!t.eventsAnyListeners) return t;
            var n = t.eventsAnyListeners.indexOf(e);
            return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
          },
          off: function (e, t) {
            var n = this;
            return n.eventsListeners
              ? (e.split(" ").forEach(function (e) {
                  void 0 === t
                    ? (n.eventsListeners[e] = [])
                    : n.eventsListeners[e] &&
                      n.eventsListeners[e].forEach(function (r, i) {
                        (r === t || (r.__emitterProxy && r.__emitterProxy === t)) && n.eventsListeners[e].splice(i, 1);
                      });
                }),
                n)
              : n;
          },
          emit: function () {
            var e,
              t,
              n,
              r = this;
            if (!r.eventsListeners) return r;
            for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++) a[o] = arguments[o];
            "string" == typeof a[0] || Array.isArray(a[0]) ? ((e = a[0]), (t = a.slice(1, a.length)), (n = r)) : ((e = a[0].events), (t = a[0].data), (n = a[0].context || r)), t.unshift(n);
            var s = Array.isArray(e) ? e : e.split(" ");
            return (
              s.forEach(function (e) {
                r.eventsAnyListeners &&
                  r.eventsAnyListeners.length &&
                  r.eventsAnyListeners.forEach(function (r) {
                    r.apply(n, [e].concat(t));
                  }),
                  r.eventsListeners &&
                    r.eventsListeners[e] &&
                    r.eventsListeners[e].forEach(function (e) {
                      e.apply(n, t);
                    });
              }),
              r
            );
          },
        },
        Z = {
          updateSize: function () {
            var e,
              t,
              n = this,
              r = n.$el;
            (e = void 0 !== n.params.width && null !== n.params.width ? n.params.width : r[0].clientWidth),
              (t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : r[0].clientHeight),
              (0 === e && n.isHorizontal()) ||
                (0 === t && n.isVertical()) ||
                ((e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10)),
                (t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10)),
                Number.isNaN(e) && (e = 0),
                Number.isNaN(t) && (t = 0),
                B(n, { width: e, height: t, size: n.isHorizontal() ? e : t }));
          },
          updateSlides: function () {
            var e = this;
            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[t];
            }
            function n(e, n) {
              return parseFloat(e.getPropertyValue(t(n)) || 0);
            }
            var r = e.params,
              i = e.$wrapperEl,
              a = e.size,
              o = e.rtlTranslate,
              s = e.wrongRTL,
              l = e.virtual && r.virtual.enabled,
              u = l ? e.virtual.slides.length : e.slides.length,
              c = i.children("." + e.params.slideClass),
              d = l ? e.virtual.slides.length : c.length,
              f = [],
              p = [],
              h = [],
              v = r.slidesOffsetBefore;
            "function" == typeof v && (v = r.slidesOffsetBefore.call(e));
            var g = r.slidesOffsetAfter;
            "function" == typeof g && (g = r.slidesOffsetAfter.call(e));
            var m = e.snapGrid.length,
              y = e.slidesGrid.length,
              b = r.spaceBetween,
              w = -v,
              _ = 0,
              x = 0;
            if (void 0 !== a) {
              var C, T;
              "string" == typeof b && b.indexOf("%") >= 0 && (b = (parseFloat(b.replace("%", "")) / 100) * a),
                (e.virtualSize = -b),
                o ? c.css({ marginLeft: "", marginBottom: "", marginTop: "" }) : c.css({ marginRight: "", marginBottom: "", marginTop: "" }),
                r.slidesPerColumn > 1 &&
                  ((C = Math.floor(d / r.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / r.slidesPerColumn) * r.slidesPerColumn),
                  "auto" !== r.slidesPerView && "row" === r.slidesPerColumnFill && (C = Math.max(C, r.slidesPerView * r.slidesPerColumn)));
              for (var k, E, S, O = r.slidesPerColumn, M = C / O, P = Math.floor(d / r.slidesPerColumn), A = 0; A < d; A += 1) {
                T = 0;
                var L = c.eq(A);
                if (r.slidesPerColumn > 1) {
                  var I = void 0,
                    D = void 0,
                    z = void 0;
                  if ("row" === r.slidesPerColumnFill && r.slidesPerGroup > 1) {
                    var j = Math.floor(A / (r.slidesPerGroup * r.slidesPerColumn)),
                      N = A - r.slidesPerColumn * r.slidesPerGroup * j,
                      R = 0 === j ? r.slidesPerGroup : Math.min(Math.ceil((d - j * O * r.slidesPerGroup) / O), r.slidesPerGroup);
                    (I = (D = N - (z = Math.floor(N / R)) * R + j * r.slidesPerGroup) + (z * C) / O), L.css({ "-webkit-box-ordinal-group": I, "-moz-box-ordinal-group": I, "-ms-flex-order": I, "-webkit-order": I, order: I });
                  } else "column" === r.slidesPerColumnFill ? ((z = A - (D = Math.floor(A / O)) * O), (D > P || (D === P && z === O - 1)) && (z += 1) >= O && ((z = 0), (D += 1))) : (D = A - (z = Math.floor(A / M)) * M);
                  L.css(t("margin-top"), 0 !== z ? r.spaceBetween && r.spaceBetween + "px" : "");
                }
                if ("none" !== L.css("display")) {
                  if ("auto" === r.slidesPerView) {
                    var q = getComputedStyle(L[0]),
                      F = L[0].style.transform,
                      H = L[0].style.webkitTransform;
                    if ((F && (L[0].style.transform = "none"), H && (L[0].style.webkitTransform = "none"), r.roundLengths)) T = e.isHorizontal() ? L.outerWidth(!0) : L.outerHeight(!0);
                    else {
                      var W = n(q, "width"),
                        $ = n(q, "padding-left"),
                        V = n(q, "padding-right"),
                        Y = n(q, "margin-left"),
                        G = n(q, "margin-right"),
                        X = q.getPropertyValue("box-sizing");
                      if (X && "border-box" === X) T = W + Y + G;
                      else {
                        var U = L[0],
                          K = U.clientWidth;
                        T = W + $ + V + Y + G + (U.offsetWidth - K);
                      }
                    }
                    F && (L[0].style.transform = F), H && (L[0].style.webkitTransform = H), r.roundLengths && (T = Math.floor(T));
                  } else (T = (a - (r.slidesPerView - 1) * b) / r.slidesPerView), r.roundLengths && (T = Math.floor(T)), c[A] && (c[A].style[t("width")] = T + "px");
                  c[A] && (c[A].swiperSlideSize = T),
                    h.push(T),
                    r.centeredSlides
                      ? ((w = w + T / 2 + _ / 2 + b),
                        0 === _ && 0 !== A && (w = w - a / 2 - b),
                        0 === A && (w = w - a / 2 - b),
                        Math.abs(w) < 0.001 && (w = 0),
                        r.roundLengths && (w = Math.floor(w)),
                        x % r.slidesPerGroup == 0 && f.push(w),
                        p.push(w))
                      : (r.roundLengths && (w = Math.floor(w)), (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && f.push(w), p.push(w), (w = w + T + b)),
                    (e.virtualSize += T + b),
                    (_ = T),
                    (x += 1);
                }
              }
              if (
                ((e.virtualSize = Math.max(e.virtualSize, a) + g),
                o && s && ("slide" === r.effect || "coverflow" === r.effect) && i.css({ width: e.virtualSize + r.spaceBetween + "px" }),
                r.setWrapperSize && i.css((((E = {})[t("width")] = e.virtualSize + r.spaceBetween + "px"), E)),
                r.slidesPerColumn > 1 &&
                  ((e.virtualSize = (T + r.spaceBetween) * C), (e.virtualSize = Math.ceil(e.virtualSize / r.slidesPerColumn) - r.spaceBetween), i.css((((S = {})[t("width")] = e.virtualSize + r.spaceBetween + "px"), S)), r.centeredSlides))
              ) {
                k = [];
                for (var Q = 0; Q < f.length; Q += 1) {
                  var Z = f[Q];
                  r.roundLengths && (Z = Math.floor(Z)), f[Q] < e.virtualSize + f[0] && k.push(Z);
                }
                f = k;
              }
              if (!r.centeredSlides) {
                k = [];
                for (var J = 0; J < f.length; J += 1) {
                  var ee = f[J];
                  r.roundLengths && (ee = Math.floor(ee)), f[J] <= e.virtualSize - a && k.push(ee);
                }
                (f = k), Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a);
              }
              if ((0 === f.length && (f = [0]), 0 !== r.spaceBetween)) {
                var te,
                  ne = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
                c.filter(function (e, t) {
                  return !r.cssMode || t !== c.length - 1;
                }).css((((te = {})[ne] = b + "px"), te));
              }
              if (r.centeredSlides && r.centeredSlidesBounds) {
                var re = 0;
                h.forEach(function (e) {
                  re += e + (r.spaceBetween ? r.spaceBetween : 0);
                });
                var ie = (re -= r.spaceBetween) - a;
                f = f.map(function (e) {
                  return e < 0 ? -v : e > ie ? ie + g : e;
                });
              }
              if (r.centerInsufficientSlides) {
                var ae = 0;
                if (
                  (h.forEach(function (e) {
                    ae += e + (r.spaceBetween ? r.spaceBetween : 0);
                  }),
                  (ae -= r.spaceBetween) < a)
                ) {
                  var oe = (a - ae) / 2;
                  f.forEach(function (e, t) {
                    f[t] = e - oe;
                  }),
                    p.forEach(function (e, t) {
                      p[t] = e + oe;
                    });
                }
              }
              B(e, { slides: c, snapGrid: f, slidesGrid: p, slidesSizesGrid: h }),
                d !== u && e.emit("slidesLengthChange"),
                f.length !== m && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                p.length !== y && e.emit("slidesGridLengthChange"),
                (r.watchSlidesProgress || r.watchSlidesVisibility) && e.updateSlidesOffset();
            }
          },
          updateAutoHeight: function (e) {
            var t,
              n = this,
              r = [],
              i = n.virtual && n.params.virtual.enabled,
              a = 0;
            "number" == typeof e ? n.setTransition(e) : !0 === e && n.setTransition(n.params.speed);
            var o = function (e) {
              return i
                ? n.slides.filter(function (t) {
                    return parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e;
                  })[0]
                : n.slides.eq(e)[0];
            };
            if ("auto" !== n.params.slidesPerView && n.params.slidesPerView > 1)
              if (n.params.centeredSlides)
                n.visibleSlides.each(function (e) {
                  r.push(e);
                });
              else
                for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1) {
                  var s = n.activeIndex + t;
                  if (s > n.slides.length && !i) break;
                  r.push(o(s));
                }
            else r.push(o(n.activeIndex));
            for (t = 0; t < r.length; t += 1)
              if (void 0 !== r[t]) {
                var l = r[t].offsetHeight;
                a = l > a ? l : a;
              }
            a && n.$wrapperEl.css("height", a + "px");
          },
          updateSlidesOffset: function () {
            for (var e = this.slides, t = 0; t < e.length; t += 1) e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            var t = this,
              n = t.params,
              r = t.slides,
              i = t.rtlTranslate;
            if (0 !== r.length) {
              void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
              var a = -e;
              i && (a = e), r.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
              for (var o = 0; o < r.length; o += 1) {
                var s = r[o],
                  l = (a + (n.centeredSlides ? t.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + n.spaceBetween);
                if (n.watchSlidesVisibility || (n.centeredSlides && n.autoHeight)) {
                  var u = -(a - s.swiperSlideOffset),
                    c = u + t.slidesSizesGrid[o];
                  ((u >= 0 && u < t.size - 1) || (c > 1 && c <= t.size) || (u <= 0 && c >= t.size)) && (t.visibleSlides.push(s), t.visibleSlidesIndexes.push(o), r.eq(o).addClass(n.slideVisibleClass));
                }
                s.progress = i ? -l : l;
              }
              t.visibleSlides = L(t.visibleSlides);
            }
          },
          updateProgress: function (e) {
            var t = this;
            if (void 0 === e) {
              var n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            var r = t.params,
              i = t.maxTranslate() - t.minTranslate(),
              a = t.progress,
              o = t.isBeginning,
              s = t.isEnd,
              l = o,
              u = s;
            0 === i ? ((a = 0), (o = !0), (s = !0)) : ((o = (a = (e - t.minTranslate()) / i) <= 0), (s = a >= 1)),
              B(t, { progress: a, isBeginning: o, isEnd: s }),
              (r.watchSlidesProgress || r.watchSlidesVisibility || (r.centeredSlides && r.autoHeight)) && t.updateSlidesProgress(e),
              o && !l && t.emit("reachBeginning toEdge"),
              s && !u && t.emit("reachEnd toEdge"),
              ((l && !o) || (u && !s)) && t.emit("fromEdge"),
              t.emit("progress", a);
          },
          updateSlidesClasses: function () {
            var e,
              t = this,
              n = t.slides,
              r = t.params,
              i = t.$wrapperEl,
              a = t.activeIndex,
              o = t.realIndex,
              s = t.virtual && r.virtual.enabled;
            n.removeClass(r.slideActiveClass + " " + r.slideNextClass + " " + r.slidePrevClass + " " + r.slideDuplicateActiveClass + " " + r.slideDuplicateNextClass + " " + r.slideDuplicatePrevClass),
              (e = s ? t.$wrapperEl.find("." + r.slideClass + '[data-swiper-slide-index="' + a + '"]') : n.eq(a)).addClass(r.slideActiveClass),
              r.loop &&
                (e.hasClass(r.slideDuplicateClass)
                  ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + o + '"]').addClass(r.slideDuplicateActiveClass)
                  : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + o + '"]').addClass(r.slideDuplicateActiveClass));
            var l = e
              .nextAll("." + r.slideClass)
              .eq(0)
              .addClass(r.slideNextClass);
            r.loop && 0 === l.length && (l = n.eq(0)).addClass(r.slideNextClass);
            var u = e
              .prevAll("." + r.slideClass)
              .eq(0)
              .addClass(r.slidePrevClass);
            r.loop && 0 === u.length && (u = n.eq(-1)).addClass(r.slidePrevClass),
              r.loop &&
                (l.hasClass(r.slideDuplicateClass)
                  ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass)
                  : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass),
                u.hasClass(r.slideDuplicateClass)
                  ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + u.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)
                  : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + u.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)),
              t.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            var t,
              n = this,
              r = n.rtlTranslate ? n.translate : -n.translate,
              i = n.slidesGrid,
              a = n.snapGrid,
              o = n.params,
              s = n.activeIndex,
              l = n.realIndex,
              u = n.snapIndex,
              c = e;
            if (void 0 === c) {
              for (var d = 0; d < i.length; d += 1) void 0 !== i[d + 1] ? (r >= i[d] && r < i[d + 1] - (i[d + 1] - i[d]) / 2 ? (c = d) : r >= i[d] && r < i[d + 1] && (c = d + 1)) : r >= i[d] && (c = d);
              o.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
            }
            if (a.indexOf(r) >= 0) t = a.indexOf(r);
            else {
              var f = Math.min(o.slidesPerGroupSkip, c);
              t = f + Math.floor((c - f) / o.slidesPerGroup);
            }
            if ((t >= a.length && (t = a.length - 1), c !== s)) {
              var p = parseInt(n.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
              B(n, { snapIndex: t, realIndex: p, previousIndex: s, activeIndex: c }),
                n.emit("activeIndexChange"),
                n.emit("snapIndexChange"),
                l !== p && n.emit("realIndexChange"),
                (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange");
            } else t !== u && ((n.snapIndex = t), n.emit("snapIndexChange"));
          },
          updateClickedSlide: function (e) {
            var t,
              n = this,
              r = n.params,
              i = L(e.target).closest("." + r.slideClass)[0],
              a = !1;
            if (i)
              for (var o = 0; o < n.slides.length; o += 1)
                if (n.slides[o] === i) {
                  (a = !0), (t = o);
                  break;
                }
            if (!i || !a) return (n.clickedSlide = void 0), void (n.clickedIndex = void 0);
            (n.clickedSlide = i),
              n.virtual && n.params.virtual.enabled ? (n.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10)) : (n.clickedIndex = t),
              r.slideToClickedSlide && void 0 !== n.clickedIndex && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
          },
        },
        J = {
          getTranslate: function (e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            var t = this,
              n = t.params,
              r = t.rtlTranslate,
              i = t.translate,
              a = t.$wrapperEl;
            if (n.virtualTranslate) return r ? -i : i;
            if (n.cssMode) return i;
            var o = (function (e, t) {
              void 0 === t && (t = "x");
              var n,
                r,
                i,
                a = b(),
                o = (function (e) {
                  var t,
                    n = b();
                  return n.getComputedStyle && (t = n.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t;
                })(e);
              return (
                a.WebKitCSSMatrix
                  ? ((r = o.transform || o.webkitTransform).split(",").length > 6 &&
                      (r = r
                        .split(", ")
                        .map(function (e) {
                          return e.replace(",", ".");
                        })
                        .join(", ")),
                    (i = new a.WebKitCSSMatrix("none" === r ? "" : r)))
                  : (n = (i = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(",")),
                "x" === t && (r = a.WebKitCSSMatrix ? i.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])),
                "y" === t && (r = a.WebKitCSSMatrix ? i.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])),
                r || 0
              );
            })(a[0], e);
            return r && (o = -o), o || 0;
          },
          setTranslate: function (e, t) {
            var n = this,
              r = n.rtlTranslate,
              i = n.params,
              a = n.$wrapperEl,
              o = n.wrapperEl,
              s = n.progress,
              l = 0,
              u = 0;
            n.isHorizontal() ? (l = r ? -e : e) : (u = e),
              i.roundLengths && ((l = Math.floor(l)), (u = Math.floor(u))),
              i.cssMode ? (o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -u) : i.virtualTranslate || a.transform("translate3d(" + l + "px, " + u + "px, 0px)"),
              (n.previousTranslate = n.translate),
              (n.translate = n.isHorizontal() ? l : u);
            var c = n.maxTranslate() - n.minTranslate();
            (0 === c ? 0 : (e - n.minTranslate()) / c) !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e, t, n, r, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === r && (r = !0);
            var a = this,
              o = a.params,
              s = a.wrapperEl;
            if (a.animating && o.preventInteractionOnTransition) return !1;
            var l,
              u = a.minTranslate(),
              c = a.maxTranslate();
            if (((l = r && e > u ? u : r && e < c ? c : e), a.updateProgress(l), o.cssMode)) {
              var d,
                f = a.isHorizontal();
              return 0 === t ? (s[f ? "scrollLeft" : "scrollTop"] = -l) : s.scrollTo ? s.scrollTo((((d = {})[f ? "left" : "top"] = -l), (d.behavior = "smooth"), d)) : (s[f ? "scrollLeft" : "scrollTop"] = -l), !0;
            }
            return (
              0 === t
                ? (a.setTransition(0), a.setTranslate(l), n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionEnd")))
                : (a.setTransition(t),
                  a.setTranslate(l),
                  n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionStart")),
                  a.animating ||
                    ((a.animating = !0),
                    a.onTranslateToWrapperTransitionEnd ||
                      (a.onTranslateToWrapperTransitionEnd = function (e) {
                        a &&
                          !a.destroyed &&
                          e.target === this &&
                          (a.$wrapperEl[0].removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                          a.$wrapperEl[0].removeEventListener("webkitTransitionEnd", a.onTranslateToWrapperTransitionEnd),
                          (a.onTranslateToWrapperTransitionEnd = null),
                          delete a.onTranslateToWrapperTransitionEnd,
                          n && a.emit("transitionEnd"));
                      }),
                    a.$wrapperEl[0].addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                    a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onTranslateToWrapperTransitionEnd))),
              !0
            );
          },
        },
        ee = {
          slideTo: function (e, t, n, r, i) {
            if ((void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "number" != typeof e && "string" != typeof e))
              throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
            if ("string" == typeof e) {
              var a = parseInt(e, 10);
              if (!isFinite(a)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
              e = a;
            }
            var o = this,
              s = e;
            s < 0 && (s = 0);
            var l = o.params,
              u = o.snapGrid,
              c = o.slidesGrid,
              d = o.previousIndex,
              f = o.activeIndex,
              p = o.rtlTranslate,
              h = o.wrapperEl,
              v = o.enabled;
            if ((o.animating && l.preventInteractionOnTransition) || (!v && !r && !i)) return !1;
            var g = Math.min(o.params.slidesPerGroupSkip, s),
              m = g + Math.floor((s - g) / o.params.slidesPerGroup);
            m >= u.length && (m = u.length - 1), (f || l.initialSlide || 0) === (d || 0) && n && o.emit("beforeSlideChangeStart");
            var y,
              b = -u[m];
            if ((o.updateProgress(b), l.normalizeSlideIndex))
              for (var w = 0; w < c.length; w += 1) {
                var _ = -Math.floor(100 * b),
                  x = Math.floor(100 * c[w]),
                  C = Math.floor(100 * c[w + 1]);
                void 0 !== c[w + 1] ? (_ >= x && _ < C - (C - x) / 2 ? (s = w) : _ >= x && _ < C && (s = w + 1)) : _ >= x && (s = w);
              }
            if (o.initialized && s !== f) {
              if (!o.allowSlideNext && b < o.translate && b < o.minTranslate()) return !1;
              if (!o.allowSlidePrev && b > o.translate && b > o.maxTranslate() && (f || 0) !== s) return !1;
            }
            if (((y = s > f ? "next" : s < f ? "prev" : "reset"), (p && -b === o.translate) || (!p && b === o.translate)))
              return o.updateActiveIndex(s), l.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== l.effect && o.setTranslate(b), "reset" !== y && (o.transitionStart(n, y), o.transitionEnd(n, y)), !1;
            if (l.cssMode) {
              var T,
                k = o.isHorizontal(),
                E = -b;
              return (
                p && (E = h.scrollWidth - h.offsetWidth - E),
                0 === t ? (h[k ? "scrollLeft" : "scrollTop"] = E) : h.scrollTo ? h.scrollTo((((T = {})[k ? "left" : "top"] = E), (T.behavior = "smooth"), T)) : (h[k ? "scrollLeft" : "scrollTop"] = E),
                !0
              );
            }
            return (
              0 === t
                ? (o.setTransition(0), o.setTranslate(b), o.updateActiveIndex(s), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, y), o.transitionEnd(n, y))
                : (o.setTransition(t),
                  o.setTranslate(b),
                  o.updateActiveIndex(s),
                  o.updateSlidesClasses(),
                  o.emit("beforeTransitionStart", t, r),
                  o.transitionStart(n, y),
                  o.animating ||
                    ((o.animating = !0),
                    o.onSlideToWrapperTransitionEnd ||
                      (o.onSlideToWrapperTransitionEnd = function (e) {
                        o &&
                          !o.destroyed &&
                          e.target === this &&
                          (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                          o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd),
                          (o.onSlideToWrapperTransitionEnd = null),
                          delete o.onSlideToWrapperTransitionEnd,
                          o.transitionEnd(n, y));
                      }),
                    o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd),
                    o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))),
              !0
            );
          },
          slideToLoop: function (e, t, n, r) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
            var i = this,
              a = e;
            return i.params.loop && (a += i.loopedSlides), i.slideTo(a, t, n, r);
          },
          slideNext: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var r = this,
              i = r.params,
              a = r.animating;
            if (!r.enabled) return r;
            var o = r.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
            if (i.loop) {
              if (a && i.loopPreventsSlide) return !1;
              r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
            }
            return r.slideTo(r.activeIndex + o, e, t, n);
          },
          slidePrev: function (e, t, n) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var r = this,
              i = r.params,
              a = r.animating,
              o = r.snapGrid,
              s = r.slidesGrid,
              l = r.rtlTranslate;
            if (!r.enabled) return r;
            if (i.loop) {
              if (a && i.loopPreventsSlide) return !1;
              r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
            }
            function u(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var c,
              d = u(l ? r.translate : -r.translate),
              f = o.map(function (e) {
                return u(e);
              }),
              p = o[f.indexOf(d) - 1];
            return (
              void 0 === p &&
                i.cssMode &&
                o.forEach(function (e) {
                  !p && d >= e && (p = e);
                }),
              void 0 !== p && (c = s.indexOf(p)) < 0 && (c = r.activeIndex - 1),
              r.slideTo(c, e, t, n)
            );
          },
          slideReset: function (e, t, n) {
            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, n);
          },
          slideToClosest: function (e, t, n, r) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = 0.5);
            var i = this,
              a = i.activeIndex,
              o = Math.min(i.params.slidesPerGroupSkip, a),
              s = o + Math.floor((a - o) / i.params.slidesPerGroup),
              l = i.rtlTranslate ? i.translate : -i.translate;
            if (l >= i.snapGrid[s]) {
              var u = i.snapGrid[s];
              l - u > (i.snapGrid[s + 1] - u) * r && (a += i.params.slidesPerGroup);
            } else {
              var c = i.snapGrid[s - 1];
              l - c <= (i.snapGrid[s] - c) * r && (a -= i.params.slidesPerGroup);
            }
            return (a = Math.max(a, 0)), (a = Math.min(a, i.slidesGrid.length - 1)), i.slideTo(a, e, t, n);
          },
          slideToClickedSlide: function () {
            var e,
              t = this,
              n = t.params,
              r = t.$wrapperEl,
              i = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView,
              a = t.clickedIndex;
            if (n.loop) {
              if (t.animating) return;
              (e = parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
                n.centeredSlides
                  ? a < t.loopedSlides - i / 2 || a > t.slides.length - t.loopedSlides + i / 2
                    ? (t.loopFix(),
                      (a = r
                        .children("." + n.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")")
                        .eq(0)
                        .index()),
                      I(function () {
                        t.slideTo(a);
                      }))
                    : t.slideTo(a)
                  : a > t.slides.length - i
                  ? (t.loopFix(),
                    (a = r
                      .children("." + n.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")")
                      .eq(0)
                      .index()),
                    I(function () {
                      t.slideTo(a);
                    }))
                  : t.slideTo(a);
            } else t.slideTo(a);
          },
        },
        te = {
          loopCreate: function () {
            var e = this,
              t = m(),
              n = e.params,
              r = e.$wrapperEl;
            r.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
            var i = r.children("." + n.slideClass);
            if (n.loopFillGroupWithBlank) {
              var a = n.slidesPerGroup - (i.length % n.slidesPerGroup);
              if (a !== n.slidesPerGroup) {
                for (var o = 0; o < a; o += 1) {
                  var s = L(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                  r.append(s);
                }
                i = r.children("." + n.slideClass);
              }
            }
            "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = i.length),
              (e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10))),
              (e.loopedSlides += n.loopAdditionalSlides),
              e.loopedSlides > i.length && (e.loopedSlides = i.length);
            var l = [],
              u = [];
            i.each(function (t, n) {
              var r = L(t);
              n < e.loopedSlides && u.push(t), n < i.length && n >= i.length - e.loopedSlides && l.push(t), r.attr("data-swiper-slide-index", n);
            });
            for (var c = 0; c < u.length; c += 1) r.append(L(u[c].cloneNode(!0)).addClass(n.slideDuplicateClass));
            for (var d = l.length - 1; d >= 0; d -= 1) r.prepend(L(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass));
          },
          loopFix: function () {
            var e = this;
            e.emit("beforeLoopFix");
            var t,
              n = e.activeIndex,
              r = e.slides,
              i = e.loopedSlides,
              a = e.allowSlidePrev,
              o = e.allowSlideNext,
              s = e.snapGrid,
              l = e.rtlTranslate;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            var u = -s[n] - e.getTranslate();
            n < i
              ? ((t = r.length - 3 * i + n), (t += i), e.slideTo(t, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u))
              : n >= r.length - i && ((t = -r.length + n + i), (t += i), e.slideTo(t, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u)),
              (e.allowSlidePrev = a),
              (e.allowSlideNext = o),
              e.emit("loopFix");
          },
          loopDestroy: function () {
            var e = this,
              t = e.$wrapperEl,
              n = e.params,
              r = e.slides;
            t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(), r.removeAttr("data-swiper-slide-index");
          },
        },
        ne = {
          appendSlide: function (e) {
            var t = this,
              n = t.$wrapperEl,
              r = t.params;
            if ((r.loop && t.loopDestroy(), "object" == typeof e && "length" in e)) for (var i = 0; i < e.length; i += 1) e[i] && n.append(e[i]);
            else n.append(e);
            r.loop && t.loopCreate(), (r.observer && t.support.observer) || t.update();
          },
          prependSlide: function (e) {
            var t = this,
              n = t.params,
              r = t.$wrapperEl,
              i = t.activeIndex;
            n.loop && t.loopDestroy();
            var a = i + 1;
            if ("object" == typeof e && "length" in e) {
              for (var o = 0; o < e.length; o += 1) e[o] && r.prepend(e[o]);
              a = i + e.length;
            } else r.prepend(e);
            n.loop && t.loopCreate(), (n.observer && t.support.observer) || t.update(), t.slideTo(a, 0, !1);
          },
          addSlide: function (e, t) {
            var n = this,
              r = n.$wrapperEl,
              i = n.params,
              a = n.activeIndex;
            i.loop && ((a -= n.loopedSlides), n.loopDestroy(), (n.slides = r.children("." + i.slideClass)));
            var o = n.slides.length;
            if (e <= 0) n.prependSlide(t);
            else if (e >= o) n.appendSlide(t);
            else {
              for (var s = a > e ? a + 1 : a, l = [], u = o - 1; u >= e; u -= 1) {
                var c = n.slides.eq(u);
                c.remove(), l.unshift(c);
              }
              if ("object" == typeof t && "length" in t) {
                for (var d = 0; d < t.length; d += 1) t[d] && r.append(t[d]);
                s = a > e ? a + t.length : a;
              } else r.append(t);
              for (var f = 0; f < l.length; f += 1) r.append(l[f]);
              i.loop && n.loopCreate(), (i.observer && n.support.observer) || n.update(), i.loop ? n.slideTo(s + n.loopedSlides, 0, !1) : n.slideTo(s, 0, !1);
            }
          },
          removeSlide: function (e) {
            var t = this,
              n = t.params,
              r = t.$wrapperEl,
              i = t.activeIndex;
            n.loop && ((i -= t.loopedSlides), t.loopDestroy(), (t.slides = r.children("." + n.slideClass)));
            var a,
              o = i;
            if ("object" == typeof e && "length" in e) {
              for (var s = 0; s < e.length; s += 1) (a = e[s]), t.slides[a] && t.slides.eq(a).remove(), a < o && (o -= 1);
              o = Math.max(o, 0);
            } else (a = e), t.slides[a] && t.slides.eq(a).remove(), a < o && (o -= 1), (o = Math.max(o, 0));
            n.loop && t.loopCreate(), (n.observer && t.support.observer) || t.update(), n.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
          },
          removeAllSlides: function () {
            for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
            this.removeSlide(e);
          },
        };
      function re(e) {
        var t = this,
          n = m(),
          r = b(),
          i = t.touchEventsData,
          a = t.params,
          o = t.touches;
        if (t.enabled && (!t.animating || !a.preventInteractionOnTransition)) {
          var s = e;
          s.originalEvent && (s = s.originalEvent);
          var l = L(s.target);
          if (
            ("wrapper" !== a.touchEventsTarget || l.closest(t.wrapperEl).length) &&
            ((i.isTouchEvent = "touchstart" === s.type), (i.isTouchEvent || !("which" in s) || 3 !== s.which) && !((!i.isTouchEvent && "button" in s && s.button > 0) || (i.isTouched && i.isMoved)))
          ) {
            a.noSwipingClass && "" !== a.noSwipingClass && s.target && s.target.shadowRoot && e.path && e.path[0] && (l = L(e.path[0]));
            var u = a.noSwipingSelector ? a.noSwipingSelector : "." + a.noSwipingClass,
              c = !(!s.target || !s.target.shadowRoot);
            if (
              a.noSwiping &&
              (c
                ? (function (e, t) {
                    return (
                      void 0 === t && (t = this),
                      (function t(n) {
                        return n && n !== m() && n !== b() ? (n.assignedSlot && (n = n.assignedSlot), n.closest(e) || t(n.getRootNode().host)) : null;
                      })(t)
                    );
                  })(u, s.target)
                : l.closest(u)[0])
            )
              t.allowClick = !0;
            else if (!a.swipeHandler || l.closest(a.swipeHandler)[0]) {
              (o.currentX = "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX), (o.currentY = "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY);
              var d = o.currentX,
                f = o.currentY,
                p = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
                h = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
              if (p && (d <= h || d >= r.innerWidth - h)) {
                if ("prevent" !== p) return;
                e.preventDefault();
              }
              if (
                (B(i, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                (o.startX = d),
                (o.startY = f),
                (i.touchStartTime = D()),
                (t.allowClick = !0),
                t.updateSize(),
                (t.swipeDirection = void 0),
                a.threshold > 0 && (i.allowThresholdMove = !1),
                "touchstart" !== s.type)
              ) {
                var v = !0;
                l.is(i.focusableElements) && (v = !1), n.activeElement && L(n.activeElement).is(i.focusableElements) && n.activeElement !== l[0] && n.activeElement.blur();
                var g = v && t.allowTouchMove && a.touchStartPreventDefault;
                (!a.touchStartForcePreventDefault && !g) || l[0].isContentEditable || s.preventDefault();
              }
              t.emit("touchStart", s);
            }
          }
        }
      }
      function ie(e) {
        var t = m(),
          n = this,
          r = n.touchEventsData,
          i = n.params,
          a = n.touches,
          o = n.rtlTranslate;
        if (n.enabled) {
          var s = e;
          if ((s.originalEvent && (s = s.originalEvent), r.isTouched)) {
            if (!r.isTouchEvent || "touchmove" === s.type) {
              var l = "touchmove" === s.type && s.targetTouches && (s.targetTouches[0] || s.changedTouches[0]),
                u = "touchmove" === s.type ? l.pageX : s.pageX,
                c = "touchmove" === s.type ? l.pageY : s.pageY;
              if (s.preventedByNestedSwiper) return (a.startX = u), void (a.startY = c);
              if (!n.allowTouchMove) return (n.allowClick = !1), void (r.isTouched && (B(a, { startX: u, startY: c, currentX: u, currentY: c }), (r.touchStartTime = D())));
              if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
                if (n.isVertical()) {
                  if ((c < a.startY && n.translate <= n.maxTranslate()) || (c > a.startY && n.translate >= n.minTranslate())) return (r.isTouched = !1), void (r.isMoved = !1);
                } else if ((u < a.startX && n.translate <= n.maxTranslate()) || (u > a.startX && n.translate >= n.minTranslate())) return;
              if (r.isTouchEvent && t.activeElement && s.target === t.activeElement && L(s.target).is(r.focusableElements)) return (r.isMoved = !0), void (n.allowClick = !1);
              if ((r.allowTouchCallbacks && n.emit("touchMove", s), !(s.targetTouches && s.targetTouches.length > 1))) {
                (a.currentX = u), (a.currentY = c);
                var d,
                  f = a.currentX - a.startX,
                  p = a.currentY - a.startY;
                if (!(n.params.threshold && Math.sqrt(Math.pow(f, 2) + Math.pow(p, 2)) < n.params.threshold))
                  if (
                    (void 0 === r.isScrolling &&
                      ((n.isHorizontal() && a.currentY === a.startY) || (n.isVertical() && a.currentX === a.startX)
                        ? (r.isScrolling = !1)
                        : f * f + p * p >= 25 && ((d = (180 * Math.atan2(Math.abs(p), Math.abs(f))) / Math.PI), (r.isScrolling = n.isHorizontal() ? d > i.touchAngle : 90 - d > i.touchAngle))),
                    r.isScrolling && n.emit("touchMoveOpposite", s),
                    void 0 === r.startMoving && ((a.currentX === a.startX && a.currentY === a.startY) || (r.startMoving = !0)),
                    r.isScrolling)
                  )
                    r.isTouched = !1;
                  else if (r.startMoving) {
                    (n.allowClick = !1),
                      !i.cssMode && s.cancelable && s.preventDefault(),
                      i.touchMoveStopPropagation && !i.nested && s.stopPropagation(),
                      r.isMoved ||
                        (i.loop && n.loopFix(),
                        (r.startTranslate = n.getTranslate()),
                        n.setTransition(0),
                        n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                        (r.allowMomentumBounce = !1),
                        !i.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
                        n.emit("sliderFirstMove", s)),
                      n.emit("sliderMove", s),
                      (r.isMoved = !0);
                    var h = n.isHorizontal() ? f : p;
                    (a.diff = h), (h *= i.touchRatio), o && (h = -h), (n.swipeDirection = h > 0 ? "prev" : "next"), (r.currentTranslate = h + r.startTranslate);
                    var v = !0,
                      g = i.resistanceRatio;
                    if (
                      (i.touchReleaseOnEdges && (g = 0),
                      h > 0 && r.currentTranslate > n.minTranslate()
                        ? ((v = !1), i.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + h, g)))
                        : h < 0 && r.currentTranslate < n.maxTranslate() && ((v = !1), i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - h, g))),
                      v && (s.preventedByNestedSwiper = !0),
                      !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate),
                      !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate),
                      n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate),
                      i.threshold > 0)
                    ) {
                      if (!(Math.abs(h) > i.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                      if (!r.allowThresholdMove)
                        return (r.allowThresholdMove = !0), (a.startX = a.currentX), (a.startY = a.currentY), (r.currentTranslate = r.startTranslate), void (a.diff = n.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY);
                    }
                    i.followFinger &&
                      !i.cssMode &&
                      ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (n.updateActiveIndex(), n.updateSlidesClasses()),
                      i.freeMode &&
                        (0 === r.velocities.length && r.velocities.push({ position: a[n.isHorizontal() ? "startX" : "startY"], time: r.touchStartTime }),
                        r.velocities.push({ position: a[n.isHorizontal() ? "currentX" : "currentY"], time: D() })),
                      n.updateProgress(r.currentTranslate),
                      n.setTranslate(r.currentTranslate));
                  }
              }
            }
          } else r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", s);
        }
      }
      function ae(e) {
        var t = this,
          n = t.touchEventsData,
          r = t.params,
          i = t.touches,
          a = t.rtlTranslate,
          o = t.$wrapperEl,
          s = t.slidesGrid,
          l = t.snapGrid;
        if (t.enabled) {
          var u = e;
          if ((u.originalEvent && (u = u.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", u), (n.allowTouchCallbacks = !1), !n.isTouched))
            return n.isMoved && r.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
          r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
          var c,
            d = D(),
            f = d - n.touchStartTime;
          if (
            (t.allowClick && (t.updateClickedSlide(u), t.emit("tap click", u), f < 300 && d - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", u)),
            (n.lastClickTime = D()),
            I(function () {
              t.destroyed || (t.allowClick = !0);
            }),
            !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate)
          )
            return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
          if (((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1), (c = r.followFinger ? (a ? t.translate : -t.translate) : -n.currentTranslate), !r.cssMode))
            if (r.freeMode) {
              if (c < -t.minTranslate()) return void t.slideTo(t.activeIndex);
              if (c > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
              if (r.freeModeMomentum) {
                if (n.velocities.length > 1) {
                  var p = n.velocities.pop(),
                    h = n.velocities.pop(),
                    v = p.position - h.position,
                    g = p.time - h.time;
                  (t.velocity = v / g), (t.velocity /= 2), Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0), (g > 150 || D() - p.time > 300) && (t.velocity = 0);
                } else t.velocity = 0;
                (t.velocity *= r.freeModeMomentumVelocityRatio), (n.velocities.length = 0);
                var m = 1e3 * r.freeModeMomentumRatio,
                  y = t.velocity * m,
                  b = t.translate + y;
                a && (b = -b);
                var w,
                  _,
                  x = !1,
                  C = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                if (b < t.maxTranslate())
                  r.freeModeMomentumBounce ? (b + t.maxTranslate() < -C && (b = t.maxTranslate() - C), (w = t.maxTranslate()), (x = !0), (n.allowMomentumBounce = !0)) : (b = t.maxTranslate()), r.loop && r.centeredSlides && (_ = !0);
                else if (b > t.minTranslate())
                  r.freeModeMomentumBounce ? (b - t.minTranslate() > C && (b = t.minTranslate() + C), (w = t.minTranslate()), (x = !0), (n.allowMomentumBounce = !0)) : (b = t.minTranslate()), r.loop && r.centeredSlides && (_ = !0);
                else if (r.freeModeSticky) {
                  for (var T, k = 0; k < l.length; k += 1)
                    if (l[k] > -b) {
                      T = k;
                      break;
                    }
                  b = -(b = Math.abs(l[T] - b) < Math.abs(l[T - 1] - b) || "next" === t.swipeDirection ? l[T] : l[T - 1]);
                }
                if (
                  (_ &&
                    t.once("transitionEnd", function () {
                      t.loopFix();
                    }),
                  0 !== t.velocity)
                ) {
                  if (((m = a ? Math.abs((-b - t.translate) / t.velocity) : Math.abs((b - t.translate) / t.velocity)), r.freeModeSticky)) {
                    var E = Math.abs((a ? -b : b) - t.translate),
                      S = t.slidesSizesGrid[t.activeIndex];
                    m = E < S ? r.speed : E < 2 * S ? 1.5 * r.speed : 2.5 * r.speed;
                  }
                } else if (r.freeModeSticky) return void t.slideToClosest();
                r.freeModeMomentumBounce && x
                  ? (t.updateProgress(w),
                    t.setTransition(m),
                    t.setTranslate(b),
                    t.transitionStart(!0, t.swipeDirection),
                    (t.animating = !0),
                    o.transitionEnd(function () {
                      t &&
                        !t.destroyed &&
                        n.allowMomentumBounce &&
                        (t.emit("momentumBounce"),
                        t.setTransition(r.speed),
                        setTimeout(function () {
                          t.setTranslate(w),
                            o.transitionEnd(function () {
                              t && !t.destroyed && t.transitionEnd();
                            });
                        }, 0));
                    }))
                  : t.velocity
                  ? (t.updateProgress(b),
                    t.setTransition(m),
                    t.setTranslate(b),
                    t.transitionStart(!0, t.swipeDirection),
                    t.animating ||
                      ((t.animating = !0),
                      o.transitionEnd(function () {
                        t && !t.destroyed && t.transitionEnd();
                      })))
                  : (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(b)),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses();
              } else {
                if (r.freeModeSticky) return void t.slideToClosest();
                r.freeMode && t.emit("_freeModeNoMomentumRelease");
              }
              (!r.freeModeMomentum || f >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
            } else {
              for (var O = 0, M = t.slidesSizesGrid[0], P = 0; P < s.length; P += P < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
                var A = P < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                void 0 !== s[P + A] ? c >= s[P] && c < s[P + A] && ((O = P), (M = s[P + A] - s[P])) : c >= s[P] && ((O = P), (M = s[s.length - 1] - s[s.length - 2]));
              }
              var L = (c - s[O]) / M,
                z = O < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
              if (f > r.longSwipesMs) {
                if (!r.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (L >= r.longSwipesRatio ? t.slideTo(O + z) : t.slideTo(O)), "prev" === t.swipeDirection && (L > 1 - r.longSwipesRatio ? t.slideTo(O + z) : t.slideTo(O));
              } else {
                if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
                !t.navigation || (u.target !== t.navigation.nextEl && u.target !== t.navigation.prevEl)
                  ? ("next" === t.swipeDirection && t.slideTo(O + z), "prev" === t.swipeDirection && t.slideTo(O))
                  : u.target === t.navigation.nextEl
                  ? t.slideTo(O + z)
                  : t.slideTo(O);
              }
            }
        }
      }
      function oe() {
        var e = this,
          t = e.params,
          n = e.el;
        if (!n || 0 !== n.offsetWidth) {
          t.breakpoints && e.setBreakpoint();
          var r = e.allowSlideNext,
            i = e.allowSlidePrev,
            a = e.snapGrid;
          (e.allowSlideNext = !0),
            (e.allowSlidePrev = !0),
            e.updateSize(),
            e.updateSlides(),
            e.updateSlidesClasses(),
            ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
            (e.allowSlidePrev = i),
            (e.allowSlideNext = r),
            e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
        }
      }
      function se(e) {
        var t = this;
        t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function le() {
        var e = this,
          t = e.wrapperEl,
          n = e.rtlTranslate;
        if (e.enabled) {
          (e.previousTranslate = e.translate),
            e.isHorizontal() ? (e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft) : (e.translate = -t.scrollTop),
            -0 === e.translate && (e.translate = 0),
            e.updateActiveIndex(),
            e.updateSlidesClasses();
          var r = e.maxTranslate() - e.minTranslate();
          (0 === r ? 0 : (e.translate - e.minTranslate()) / r) !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
        }
      }
      var ue = !1;
      function ce() {}
      const de = {
          attachEvents: function () {
            var e = this,
              t = m(),
              n = e.params,
              r = e.touchEvents,
              i = e.el,
              a = e.wrapperEl,
              o = e.device,
              s = e.support;
            (e.onTouchStart = re.bind(e)), (e.onTouchMove = ie.bind(e)), (e.onTouchEnd = ae.bind(e)), n.cssMode && (e.onScroll = le.bind(e)), (e.onClick = se.bind(e));
            var l = !!n.nested;
            if (!s.touch && s.pointerEvents) i.addEventListener(r.start, e.onTouchStart, !1), t.addEventListener(r.move, e.onTouchMove, l), t.addEventListener(r.end, e.onTouchEnd, !1);
            else {
              if (s.touch) {
                var u = !("touchstart" !== r.start || !s.passiveListener || !n.passiveListeners) && { passive: !0, capture: !1 };
                i.addEventListener(r.start, e.onTouchStart, u),
                  i.addEventListener(r.move, e.onTouchMove, s.passiveListener ? { passive: !1, capture: l } : l),
                  i.addEventListener(r.end, e.onTouchEnd, u),
                  r.cancel && i.addEventListener(r.cancel, e.onTouchEnd, u),
                  ue || (t.addEventListener("touchstart", ce), (ue = !0));
              }
              ((n.simulateTouch && !o.ios && !o.android) || (n.simulateTouch && !s.touch && o.ios)) &&
                (i.addEventListener("mousedown", e.onTouchStart, !1), t.addEventListener("mousemove", e.onTouchMove, l), t.addEventListener("mouseup", e.onTouchEnd, !1));
            }
            (n.preventClicks || n.preventClicksPropagation) && i.addEventListener("click", e.onClick, !0),
              n.cssMode && a.addEventListener("scroll", e.onScroll),
              n.updateOnWindowResize ? e.on(o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", oe, !0) : e.on("observerUpdate", oe, !0);
          },
          detachEvents: function () {
            var e = this,
              t = m(),
              n = e.params,
              r = e.touchEvents,
              i = e.el,
              a = e.wrapperEl,
              o = e.device,
              s = e.support,
              l = !!n.nested;
            if (!s.touch && s.pointerEvents) i.removeEventListener(r.start, e.onTouchStart, !1), t.removeEventListener(r.move, e.onTouchMove, l), t.removeEventListener(r.end, e.onTouchEnd, !1);
            else {
              if (s.touch) {
                var u = !("onTouchStart" !== r.start || !s.passiveListener || !n.passiveListeners) && { passive: !0, capture: !1 };
                i.removeEventListener(r.start, e.onTouchStart, u), i.removeEventListener(r.move, e.onTouchMove, l), i.removeEventListener(r.end, e.onTouchEnd, u), r.cancel && i.removeEventListener(r.cancel, e.onTouchEnd, u);
              }
              ((n.simulateTouch && !o.ios && !o.android) || (n.simulateTouch && !s.touch && o.ios)) &&
                (i.removeEventListener("mousedown", e.onTouchStart, !1), t.removeEventListener("mousemove", e.onTouchMove, l), t.removeEventListener("mouseup", e.onTouchEnd, !1));
            }
            (n.preventClicks || n.preventClicksPropagation) && i.removeEventListener("click", e.onClick, !0),
              n.cssMode && a.removeEventListener("scroll", e.onScroll),
              e.off(o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", oe);
          },
        },
        fe = {
          setBreakpoint: function () {
            var e = this,
              t = e.activeIndex,
              n = e.initialized,
              r = e.loopedSlides,
              i = void 0 === r ? 0 : r,
              a = e.params,
              o = e.$el,
              s = a.breakpoints;
            if (s && (!s || 0 !== Object.keys(s).length)) {
              var l = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
              if (l && e.currentBreakpoint !== l) {
                var u = l in s ? s[l] : void 0;
                u &&
                  ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach(function (e) {
                    var t = u[e];
                    void 0 !== t && (u[e] = "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t) ? ("slidesPerView" === e ? parseFloat(t) : parseInt(t, 10)) : "auto");
                  });
                var c = u || e.originalParams,
                  d = a.slidesPerColumn > 1,
                  f = c.slidesPerColumn > 1,
                  p = a.enabled;
                d && !f
                  ? (o.removeClass(a.containerModifierClass + "multirow " + a.containerModifierClass + "multirow-column"), e.emitContainerClasses())
                  : !d &&
                    f &&
                    (o.addClass(a.containerModifierClass + "multirow"),
                    ((c.slidesPerColumnFill && "column" === c.slidesPerColumnFill) || (!c.slidesPerColumnFill && "column" === a.slidesPerColumnFill)) && o.addClass(a.containerModifierClass + "multirow-column"),
                    e.emitContainerClasses());
                var h = c.direction && c.direction !== a.direction,
                  v = a.loop && (c.slidesPerView !== a.slidesPerView || h);
                h && n && e.changeDirection(), B(e.params, c);
                var g = e.params.enabled;
                B(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                  p && !g ? e.disable() : !p && g && e.enable(),
                  (e.currentBreakpoint = l),
                  e.emit("_beforeBreakpoint", c),
                  v && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)),
                  e.emit("breakpoint", c);
              }
            }
          },
          getBreakpoint: function (e, t, n) {
            if ((void 0 === t && (t = "window"), e && ("container" !== t || n))) {
              var r = !1,
                i = b(),
                a = "window" === t ? i.innerHeight : n.clientHeight,
                o = Object.keys(e).map(function (e) {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    var t = parseFloat(e.substr(1));
                    return { value: a * t, point: e };
                  }
                  return { value: e, point: e };
                });
              o.sort(function (e, t) {
                return parseInt(e.value, 10) - parseInt(t.value, 10);
              });
              for (var s = 0; s < o.length; s += 1) {
                var l = o[s],
                  u = l.point,
                  c = l.value;
                "window" === t ? i.matchMedia("(min-width: " + c + "px)").matches && (r = u) : c <= n.clientWidth && (r = u);
              }
              return r || "max";
            }
          },
        },
        pe = {
          addClasses: function () {
            var e,
              t,
              n,
              r = this,
              i = r.classNames,
              a = r.params,
              o = r.rtl,
              s = r.$el,
              l = r.device,
              u = r.support,
              c =
                ((e = [
                  "initialized",
                  a.direction,
                  { "pointer-events": u.pointerEvents && !u.touch },
                  { "free-mode": a.freeMode },
                  { autoheight: a.autoHeight },
                  { rtl: o },
                  { multirow: a.slidesPerColumn > 1 },
                  { "multirow-column": a.slidesPerColumn > 1 && "column" === a.slidesPerColumnFill },
                  { android: l.android },
                  { ios: l.ios },
                  { "css-mode": a.cssMode },
                ]),
                (t = a.containerModifierClass),
                (n = []),
                e.forEach(function (e) {
                  "object" == typeof e
                    ? Object.keys(e).forEach(function (r) {
                        e[r] && n.push(t + r);
                      })
                    : "string" == typeof e && n.push(t + e);
                }),
                n);
            i.push.apply(i, c), s.addClass([].concat(i).join(" ")), r.emitContainerClasses();
          },
          removeClasses: function () {
            var e = this,
              t = e.$el,
              n = e.classNames;
            t.removeClass(n.join(" ")), e.emitContainerClasses();
          },
        },
        he = {
          loadImage: function (e, t, n, r, i, a) {
            var o,
              s = b();
            function l() {
              a && a();
            }
            L(e).parent("picture")[0] || (e.complete && i) ? l() : t ? (((o = new s.Image()).onload = l), (o.onerror = l), r && (o.sizes = r), n && (o.srcset = n), t && (o.src = t)) : l();
          },
          preloadImages: function () {
            var e = this;
            function t() {
              null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
            }
            e.imagesToLoad = e.$el.find("img");
            for (var n = 0; n < e.imagesToLoad.length; n += 1) {
              var r = e.imagesToLoad[n];
              e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t);
            }
          },
        },
        ve = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "container",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !1,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements: "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          freeMode: !1,
          freeModeMomentum: !0,
          freeModeMomentumRatio: 1,
          freeModeMomentumBounce: !0,
          freeModeMomentumBounceRatio: 1,
          freeModeMomentumVelocityRatio: 1,
          freeModeSticky: !1,
          freeModeMinimumVelocity: 0.02,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerColumnFill: "column",
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !1,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          watchSlidesVisibility: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          containerModifierClass: "swiper-container-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function ge(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      var me = {
          modular: {
            useParams: function (e) {
              var t = this;
              t.modules &&
                Object.keys(t.modules).forEach(function (n) {
                  var r = t.modules[n];
                  r.params && B(e, r.params);
                });
            },
            useModules: function (e) {
              void 0 === e && (e = {});
              var t = this;
              t.modules &&
                Object.keys(t.modules).forEach(function (n) {
                  var r = t.modules[n],
                    i = e[n] || {};
                  r.on &&
                    t.on &&
                    Object.keys(r.on).forEach(function (e) {
                      t.on(e, r.on[e]);
                    }),
                    r.create && r.create.bind(t)(i);
                });
            },
          },
          eventsEmitter: Q,
          update: Z,
          translate: J,
          transition: {
            setTransition: function (e, t) {
              var n = this;
              n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              var n = this,
                r = n.activeIndex,
                i = n.params,
                a = n.previousIndex;
              if (!i.cssMode) {
                i.autoHeight && n.updateAutoHeight();
                var o = t;
                if ((o || (o = r > a ? "next" : r < a ? "prev" : "reset"), n.emit("transitionStart"), e && r !== a)) {
                  if ("reset" === o) return void n.emit("slideResetTransitionStart");
                  n.emit("slideChangeTransitionStart"), "next" === o ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart");
                }
              }
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              var n = this,
                r = n.activeIndex,
                i = n.previousIndex,
                a = n.params;
              if (((n.animating = !1), !a.cssMode)) {
                n.setTransition(0);
                var o = t;
                if ((o || (o = r > i ? "next" : r < i ? "prev" : "reset"), n.emit("transitionEnd"), e && r !== i)) {
                  if ("reset" === o) return void n.emit("slideResetTransitionEnd");
                  n.emit("slideChangeTransitionEnd"), "next" === o ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd");
                }
              }
            },
          },
          slide: ee,
          loop: te,
          grabCursor: {
            setGrabCursor: function (e) {
              var t = this;
              if (!(t.support.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode)) {
                var n = t.el;
                (n.style.cursor = "move"), (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"), (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"), (n.style.cursor = e ? "grabbing" : "grab");
              }
            },
            unsetGrabCursor: function () {
              var e = this;
              e.support.touch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode || (e.el.style.cursor = "");
            },
          },
          manipulation: ne,
          events: de,
          breakpoints: fe,
          checkOverflow: {
            checkOverflow: function () {
              var e = this,
                t = e.params,
                n = e.isLocked,
                r = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
              t.slidesOffsetBefore && t.slidesOffsetAfter && r ? (e.isLocked = r <= e.size) : (e.isLocked = 1 === e.snapGrid.length),
                (e.allowSlideNext = !e.isLocked),
                (e.allowSlidePrev = !e.isLocked),
                n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                n && n !== e.isLocked && ((e.isEnd = !1), e.navigation && e.navigation.update());
            },
          },
          classes: pe,
          images: he,
        },
        ye = {},
        be = (function () {
          function e() {
            for (var t, n, r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            if (
              (1 === i.length && i[0].constructor && "Object" === Object.prototype.toString.call(i[0]).slice(8, -1) ? (n = i[0]) : ((t = i[0]), (n = i[1])),
              n || (n = {}),
              (n = B({}, n)),
              t && !n.el && (n.el = t),
              n.el && L(n.el).length > 1)
            ) {
              var o = [];
              return (
                L(n.el).each(function (t) {
                  var r = B({}, n, { el: t });
                  o.push(new e(r));
                }),
                o
              );
            }
            var s = this;
            (s.__swiper__ = !0),
              (s.support = $()),
              (s.device = V({ userAgent: n.userAgent })),
              (s.browser = Y()),
              (s.eventsListeners = {}),
              (s.eventsAnyListeners = []),
              void 0 === s.modules && (s.modules = {}),
              Object.keys(s.modules).forEach(function (e) {
                var t = s.modules[e];
                if (t.params) {
                  var r = Object.keys(t.params)[0],
                    i = t.params[r];
                  if ("object" != typeof i || null === i) return;
                  if ((["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 && !0 === n[r] && (n[r] = { auto: !0 }), !(r in n) || !("enabled" in i))) return;
                  !0 === n[r] && (n[r] = { enabled: !0 }), "object" != typeof n[r] || "enabled" in n[r] || (n[r].enabled = !0), n[r] || (n[r] = { enabled: !1 });
                }
              });
            var l,
              u,
              c = B({}, ve);
            return (
              s.useParams(c),
              (s.params = B({}, c, ye, n)),
              (s.originalParams = B({}, s.params)),
              (s.passedParams = B({}, n)),
              s.params &&
                s.params.on &&
                Object.keys(s.params.on).forEach(function (e) {
                  s.on(e, s.params.on[e]);
                }),
              s.params && s.params.onAny && s.onAny(s.params.onAny),
              (s.$ = L),
              B(s, {
                enabled: s.params.enabled,
                el: t,
                classNames: [],
                slides: L(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function () {
                  return "horizontal" === s.params.direction;
                },
                isVertical: function () {
                  return "vertical" === s.params.direction;
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: s.params.allowSlideNext,
                allowSlidePrev: s.params.allowSlidePrev,
                touchEvents:
                  ((l = ["touchstart", "touchmove", "touchend", "touchcancel"]),
                  (u = ["mousedown", "mousemove", "mouseup"]),
                  s.support.pointerEvents && (u = ["pointerdown", "pointermove", "pointerup"]),
                  (s.touchEventsTouch = { start: l[0], move: l[1], end: l[2], cancel: l[3] }),
                  (s.touchEventsDesktop = { start: u[0], move: u[1], end: u[2] }),
                  s.support.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  focusableElements: s.params.focusableElements,
                  lastClickTime: D(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: s.params.allowTouchMove,
                touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              s.useModules(),
              s.emit("_swiper"),
              s.params.init && s.init(),
              s
            );
          }
          var t,
            n,
            r = e.prototype;
          return (
            (r.enable = function () {
              var e = this;
              e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
            }),
            (r.disable = function () {
              var e = this;
              e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
            }),
            (r.setProgress = function (e, t) {
              var n = this;
              e = Math.min(Math.max(e, 0), 1);
              var r = n.minTranslate(),
                i = (n.maxTranslate() - r) * e + r;
              n.translateTo(i, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
            }),
            (r.emitContainerClasses = function () {
              var e = this;
              if (e.params._emitClasses && e.el) {
                var t = e.el.className.split(" ").filter(function (t) {
                  return 0 === t.indexOf("swiper-container") || 0 === t.indexOf(e.params.containerModifierClass);
                });
                e.emit("_containerClasses", t.join(" "));
              }
            }),
            (r.getSlideClasses = function (e) {
              var t = this;
              return e.className
                .split(" ")
                .filter(function (e) {
                  return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass);
                })
                .join(" ");
            }),
            (r.emitSlidesClasses = function () {
              var e = this;
              if (e.params._emitClasses && e.el) {
                var t = [];
                e.slides.each(function (n) {
                  var r = e.getSlideClasses(n);
                  t.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
                }),
                  e.emit("_slideClasses", t);
              }
            }),
            (r.slidesPerViewDynamic = function () {
              var e = this,
                t = e.params,
                n = e.slides,
                r = e.slidesGrid,
                i = e.size,
                a = e.activeIndex,
                o = 1;
              if (t.centeredSlides) {
                for (var s, l = n[a].swiperSlideSize, u = a + 1; u < n.length; u += 1) n[u] && !s && ((o += 1), (l += n[u].swiperSlideSize) > i && (s = !0));
                for (var c = a - 1; c >= 0; c -= 1) n[c] && !s && ((o += 1), (l += n[c].swiperSlideSize) > i && (s = !0));
              } else for (var d = a + 1; d < n.length; d += 1) r[d] - r[a] < i && (o += 1);
              return o;
            }),
            (r.update = function () {
              var e = this;
              if (e && !e.destroyed) {
                var t = e.snapGrid,
                  n = e.params;
                n.breakpoints && e.setBreakpoint(),
                  e.updateSize(),
                  e.updateSlides(),
                  e.updateProgress(),
                  e.updateSlidesClasses(),
                  e.params.freeMode
                    ? (r(), e.params.autoHeight && e.updateAutoHeight())
                    : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || r(),
                  n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                  e.emit("update");
              }
              function r() {
                var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                  n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
              }
            }),
            (r.changeDirection = function (e, t) {
              void 0 === t && (t = !0);
              var n = this,
                r = n.params.direction;
              return (
                e || (e = "horizontal" === r ? "vertical" : "horizontal"),
                e === r ||
                  ("horizontal" !== e && "vertical" !== e) ||
                  (n.$el.removeClass("" + n.params.containerModifierClass + r).addClass("" + n.params.containerModifierClass + e),
                  n.emitContainerClasses(),
                  (n.params.direction = e),
                  n.slides.each(function (t) {
                    "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                  }),
                  n.emit("changeDirection"),
                  t && n.update()),
                n
              );
            }),
            (r.mount = function (e) {
              var t = this;
              if (t.mounted) return !0;
              var n = L(e || t.params.el);
              if (!(e = n[0])) return !1;
              e.swiper = t;
              var r = function () {
                  return "." + (t.params.wrapperClass || "").trim().split(" ").join(".");
                },
                i = (function () {
                  if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                    var t = L(e.shadowRoot.querySelector(r()));
                    return (
                      (t.children = function (e) {
                        return n.children(e);
                      }),
                      t
                    );
                  }
                  return n.children(r());
                })();
              if (0 === i.length && t.params.createElements) {
                var a = m().createElement("div");
                (i = L(a)),
                  (a.className = t.params.wrapperClass),
                  n.append(a),
                  n.children("." + t.params.slideClass).each(function (e) {
                    i.append(e);
                  });
              }
              return (
                B(t, {
                  $el: n,
                  el: e,
                  $wrapperEl: i,
                  wrapperEl: i[0],
                  mounted: !0,
                  rtl: "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
                  rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
                  wrongRTL: "-webkit-box" === i.css("display"),
                }),
                !0
              );
            }),
            (r.init = function (e) {
              var t = this;
              return (
                t.initialized ||
                  !1 === t.mount(e) ||
                  (t.emit("beforeInit"),
                  t.params.breakpoints && t.setBreakpoint(),
                  t.addClasses(),
                  t.params.loop && t.loopCreate(),
                  t.updateSize(),
                  t.updateSlides(),
                  t.params.watchOverflow && t.checkOverflow(),
                  t.params.grabCursor && t.enabled && t.setGrabCursor(),
                  t.params.preloadImages && t.preloadImages(),
                  t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                  t.attachEvents(),
                  (t.initialized = !0),
                  t.emit("init"),
                  t.emit("afterInit")),
                t
              );
            }),
            (r.destroy = function (e, t) {
              void 0 === e && (e = !0), void 0 === t && (t = !0);
              var n,
                r = this,
                i = r.params,
                a = r.$el,
                o = r.$wrapperEl,
                s = r.slides;
              return (
                void 0 === r.params ||
                  r.destroyed ||
                  (r.emit("beforeDestroy"),
                  (r.initialized = !1),
                  r.detachEvents(),
                  i.loop && r.loopDestroy(),
                  t &&
                    (r.removeClasses(),
                    a.removeAttr("style"),
                    o.removeAttr("style"),
                    s && s.length && s.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
                  r.emit("destroy"),
                  Object.keys(r.eventsListeners).forEach(function (e) {
                    r.off(e);
                  }),
                  !1 !== e &&
                    ((r.$el[0].swiper = null),
                    (n = r),
                    Object.keys(n).forEach(function (e) {
                      try {
                        n[e] = null;
                      } catch (e) {}
                      try {
                        delete n[e];
                      } catch (e) {}
                    })),
                  (r.destroyed = !0)),
                null
              );
            }),
            (e.extendDefaults = function (e) {
              B(ye, e);
            }),
            (e.installModule = function (t) {
              e.prototype.modules || (e.prototype.modules = {});
              var n = t.name || Object.keys(e.prototype.modules).length + "_" + D();
              e.prototype.modules[n] = t;
            }),
            (e.use = function (t) {
              return Array.isArray(t)
                ? (t.forEach(function (t) {
                    return e.installModule(t);
                  }),
                  e)
                : (e.installModule(t), e);
            }),
            (t = e),
            (n = [
              {
                key: "extendedDefaults",
                get: function () {
                  return ye;
                },
              },
              {
                key: "defaults",
                get: function () {
                  return ve;
                },
              },
            ]),
            null && ge(t.prototype, null),
            n && ge(t, n),
            e
          );
        })();
      Object.keys(me).forEach(function (e) {
        Object.keys(me[e]).forEach(function (t) {
          be.prototype[t] = me[e][t];
        });
      }),
        be.use([G, K]);
      const we = be;
      function _e() {
        return (
          (_e =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          _e.apply(this, arguments)
        );
      }
      var xe = {
        loadInSlide: function (e, t) {
          void 0 === t && (t = !0);
          var n = this,
            r = n.params.lazy;
          if (void 0 !== e && 0 !== n.slides.length) {
            var i = n.virtual && n.params.virtual.enabled ? n.$wrapperEl.children("." + n.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : n.slides.eq(e),
              a = i.find("." + r.elementClass + ":not(." + r.loadedClass + "):not(." + r.loadingClass + ")");
            !i.hasClass(r.elementClass) || i.hasClass(r.loadedClass) || i.hasClass(r.loadingClass) || a.push(i[0]),
              0 !== a.length &&
                a.each(function (e) {
                  var a = L(e);
                  a.addClass(r.loadingClass);
                  var o = a.attr("data-background"),
                    s = a.attr("data-src"),
                    l = a.attr("data-srcset"),
                    u = a.attr("data-sizes"),
                    c = a.parent("picture");
                  n.loadImage(a[0], s || o, l, u, !1, function () {
                    if (null != n && n && (!n || n.params) && !n.destroyed) {
                      if (
                        (o
                          ? (a.css("background-image", 'url("' + o + '")'), a.removeAttr("data-background"))
                          : (l && (a.attr("srcset", l), a.removeAttr("data-srcset")),
                            u && (a.attr("sizes", u), a.removeAttr("data-sizes")),
                            c.length &&
                              c.children("source").each(function (e) {
                                var t = L(e);
                                t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"));
                              }),
                            s && (a.attr("src", s), a.removeAttr("data-src"))),
                        a.addClass(r.loadedClass).removeClass(r.loadingClass),
                        i.find("." + r.preloaderClass).remove(),
                        n.params.loop && t)
                      ) {
                        var e = i.attr("data-swiper-slide-index");
                        if (i.hasClass(n.params.slideDuplicateClass)) {
                          var d = n.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + n.params.slideDuplicateClass + ")");
                          n.lazy.loadInSlide(d.index(), !1);
                        } else {
                          var f = n.$wrapperEl.children("." + n.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                          n.lazy.loadInSlide(f.index(), !1);
                        }
                      }
                      n.emit("lazyImageReady", i[0], a[0]), n.params.autoHeight && n.updateAutoHeight();
                    }
                  }),
                    n.emit("lazyImageLoad", i[0], a[0]);
                });
          }
        },
        load: function () {
          var e = this,
            t = e.$wrapperEl,
            n = e.params,
            r = e.slides,
            i = e.activeIndex,
            a = e.virtual && n.virtual.enabled,
            o = n.lazy,
            s = n.slidesPerView;
          function l(e) {
            if (a) {
              if (t.children("." + n.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
            } else if (r[e]) return !0;
            return !1;
          }
          function u(e) {
            return a ? L(e).attr("data-swiper-slide-index") : L(e).index();
          }
          if (("auto" === s && (s = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility))
            t.children("." + n.slideVisibleClass).each(function (t) {
              var n = a ? L(t).attr("data-swiper-slide-index") : L(t).index();
              e.lazy.loadInSlide(n);
            });
          else if (s > 1) for (var c = i; c < i + s; c += 1) l(c) && e.lazy.loadInSlide(c);
          else e.lazy.loadInSlide(i);
          if (o.loadPrevNext)
            if (s > 1 || (o.loadPrevNextAmount && o.loadPrevNextAmount > 1)) {
              for (var d = o.loadPrevNextAmount, f = s, p = Math.min(i + f + Math.max(d, f), r.length), h = Math.max(i - Math.max(f, d), 0), v = i + s; v < p; v += 1) l(v) && e.lazy.loadInSlide(v);
              for (var g = h; g < i; g += 1) l(g) && e.lazy.loadInSlide(g);
            } else {
              var m = t.children("." + n.slideNextClass);
              m.length > 0 && e.lazy.loadInSlide(u(m));
              var y = t.children("." + n.slidePrevClass);
              y.length > 0 && e.lazy.loadInSlide(u(y));
            }
        },
        checkInViewOnLoad: function () {
          var e = b(),
            t = this;
          if (t && !t.destroyed) {
            var n = t.params.lazy.scrollingElement ? L(t.params.lazy.scrollingElement) : L(e),
              r = n[0] === e,
              i = r ? e.innerWidth : n[0].offsetWidth,
              a = r ? e.innerHeight : n[0].offsetHeight,
              o = t.$el.offset(),
              s = !1;
            t.rtlTranslate && (o.left -= t.$el[0].scrollLeft);
            for (
              var l = [
                  [o.left, o.top],
                  [o.left + t.width, o.top],
                  [o.left, o.top + t.height],
                  [o.left + t.width, o.top + t.height],
                ],
                u = 0;
              u < l.length;
              u += 1
            ) {
              var c = l[u];
              if (c[0] >= 0 && c[0] <= i && c[1] >= 0 && c[1] <= a) {
                if (0 === c[0] && 0 === c[1]) continue;
                s = !0;
              }
            }
            var d = !("touchstart" !== t.touchEvents.start || !t.support.passiveListener || !t.params.passiveListeners) && { passive: !0, capture: !1 };
            s ? (t.lazy.load(), n.off("scroll", t.lazy.checkInViewOnLoad, d)) : t.lazy.scrollHandlerAttached || ((t.lazy.scrollHandlerAttached = !0), n.on("scroll", t.lazy.checkInViewOnLoad, d));
          }
        },
      };
      const Ce = {
        name: "lazy",
        params: {
          lazy: {
            checkInView: !1,
            enabled: !1,
            loadPrevNext: !1,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: !1,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader",
          },
        },
        create: function () {
          N(this, { lazy: _e({ initialImageLoaded: !1 }, xe) });
        },
        on: {
          beforeInit: function (e) {
            e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
          },
          init: function (e) {
            e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load());
          },
          scroll: function (e) {
            e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
          },
          "scrollbarDragMove resize _freeModeNoMomentumRelease": function (e) {
            e.params.lazy.enabled && e.lazy.load();
          },
          transitionStart: function (e) {
            e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || (!e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded)) && e.lazy.load();
          },
          transitionEnd: function (e) {
            e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load();
          },
          slideChange: function (e) {
            var t = e.params,
              n = t.lazy,
              r = t.cssMode,
              i = t.watchSlidesVisibility,
              a = t.watchSlidesProgress,
              o = t.touchReleaseOnEdges,
              s = t.resistanceRatio;
            n.enabled && (r || ((i || a) && (o || 0 === s))) && e.lazy.load();
          },
        },
      };
      function Te() {
        return (
          (Te =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Te.apply(this, arguments)
        );
      }
      var ke = {
        init: function () {
          var e = this,
            t = e.params.thumbs;
          if (e.thumbs.initialized) return !1;
          e.thumbs.initialized = !0;
          var n = e.constructor;
          return (
            t.swiper instanceof n
              ? ((e.thumbs.swiper = t.swiper), B(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), B(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }))
              : z(t.swiper) && ((e.thumbs.swiper = new n(B({}, t.swiper, { watchSlidesVisibility: !0, watchSlidesProgress: !0, slideToClickedSlide: !1 }))), (e.thumbs.swiperCreated = !0)),
            e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
            e.thumbs.swiper.on("tap", e.thumbs.onThumbClick),
            !0
          );
        },
        onThumbClick: function () {
          var e = this,
            t = e.thumbs.swiper;
          if (t) {
            var n = t.clickedIndex,
              r = t.clickedSlide;
            if (!((r && L(r).hasClass(e.params.thumbs.slideThumbActiveClass)) || null == n)) {
              var i;
              if (((i = t.params.loop ? parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10) : n), e.params.loop)) {
                var a = e.activeIndex;
                e.slides.eq(a).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (a = e.activeIndex));
                var o = e.slides
                    .eq(a)
                    .prevAll('[data-swiper-slide-index="' + i + '"]')
                    .eq(0)
                    .index(),
                  s = e.slides
                    .eq(a)
                    .nextAll('[data-swiper-slide-index="' + i + '"]')
                    .eq(0)
                    .index();
                i = void 0 === o ? s : void 0 === s ? o : s - a < a - o ? s : o;
              }
              e.slideTo(i);
            }
          }
        },
        update: function (e) {
          var t = this,
            n = t.thumbs.swiper;
          if (n) {
            var r = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView,
              i = t.params.thumbs.autoScrollOffset,
              a = i && !n.params.loop;
            if (t.realIndex !== n.realIndex || a) {
              var o,
                s,
                l = n.activeIndex;
              if (n.params.loop) {
                n.slides.eq(l).hasClass(n.params.slideDuplicateClass) && (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (l = n.activeIndex));
                var u = n.slides
                    .eq(l)
                    .prevAll('[data-swiper-slide-index="' + t.realIndex + '"]')
                    .eq(0)
                    .index(),
                  c = n.slides
                    .eq(l)
                    .nextAll('[data-swiper-slide-index="' + t.realIndex + '"]')
                    .eq(0)
                    .index();
                (o = void 0 === u ? c : void 0 === c ? u : c - l == l - u ? (n.params.slidesPerGroup > 1 ? c : l) : c - l < l - u ? c : u), (s = t.activeIndex > t.previousIndex ? "next" : "prev");
              } else s = (o = t.realIndex) > t.previousIndex ? "next" : "prev";
              a && (o += "next" === s ? i : -1 * i),
                n.visibleSlidesIndexes &&
                  n.visibleSlidesIndexes.indexOf(o) < 0 &&
                  (n.params.centeredSlides ? (o = o > l ? o - Math.floor(r / 2) + 1 : o + Math.floor(r / 2) - 1) : o > l && n.params.slidesPerGroup, n.slideTo(o, e ? 0 : void 0));
            }
            var d = 1,
              f = t.params.thumbs.slideThumbActiveClass;
            if (
              (t.params.slidesPerView > 1 && !t.params.centeredSlides && (d = t.params.slidesPerView),
              t.params.thumbs.multipleActiveThumbs || (d = 1),
              (d = Math.floor(d)),
              n.slides.removeClass(f),
              n.params.loop || (n.params.virtual && n.params.virtual.enabled))
            )
              for (var p = 0; p < d; p += 1) n.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + p) + '"]').addClass(f);
            else for (var h = 0; h < d; h += 1) n.slides.eq(t.realIndex + h).addClass(f);
          }
        },
      };
      const Ee = {
        name: "thumbs",
        params: { thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-container-thumbs" } },
        create: function () {
          N(this, { thumbs: Te({ swiper: null, initialized: !1 }, ke) });
        },
        on: {
          beforeInit: function (e) {
            var t = e.params.thumbs;
            t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0));
          },
          slideChange: function (e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          update: function (e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          resize: function (e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          observerUpdate: function (e) {
            e.thumbs.swiper && e.thumbs.update();
          },
          setTransition: function (e, t) {
            var n = e.thumbs.swiper;
            n && n.setTransition(t);
          },
          beforeDestroy: function (e) {
            var t = e.thumbs.swiper;
            t && e.thumbs.swiperCreated && t && t.destroy();
          },
        },
      };
      function Se() {
        return (
          (Se =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Se.apply(this, arguments)
        );
      }
      var Oe = {
        setTranslate: function () {
          for (var e = this, t = e.slides, n = 0; n < t.length; n += 1) {
            var r = e.slides.eq(n),
              i = -r[0].swiperSlideOffset;
            e.params.virtualTranslate || (i -= e.translate);
            var a = 0;
            e.isHorizontal() || ((a = i), (i = 0));
            var o = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(r[0].progress), 0) : 1 + Math.min(Math.max(r[0].progress, -1), 0);
            r.css({ opacity: o }).transform("translate3d(" + i + "px, " + a + "px, 0px)");
          }
        },
        setTransition: function (e) {
          var t = this,
            n = t.slides,
            r = t.$wrapperEl;
          if ((n.transition(e), t.params.virtualTranslate && 0 !== e)) {
            var i = !1;
            n.transitionEnd(function () {
              if (!i && t && !t.destroyed) {
                (i = !0), (t.animating = !1);
                for (var e = ["webkitTransitionEnd", "transitionend"], n = 0; n < e.length; n += 1) r.trigger(e[n]);
              }
            });
          }
        },
      };
      const Me = {
        name: "effect-fade",
        params: { fadeEffect: { crossFade: !1 } },
        create: function () {
          N(this, { fadeEffect: Se({}, Oe) });
        },
        on: {
          beforeInit: function (e) {
            if ("fade" === e.params.effect) {
              e.classNames.push(e.params.containerModifierClass + "fade");
              var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 };
              B(e.params, t), B(e.originalParams, t);
            }
          },
          setTranslate: function (e) {
            "fade" === e.params.effect && e.fadeEffect.setTranslate();
          },
          setTransition: function (e, t) {
            "fade" === e.params.effect && e.fadeEffect.setTransition(t);
          },
        },
      };
      function Pe() {
        return (
          (Pe =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Pe.apply(this, arguments)
        );
      }
      var Ae = {
        run: function () {
          var e = this,
            t = e.slides.eq(e.activeIndex),
            n = e.params.autoplay.delay;
          t.attr("data-swiper-autoplay") && (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
            clearTimeout(e.autoplay.timeout),
            (e.autoplay.timeout = I(function () {
              var t;
              e.params.autoplay.reverseDirection
                ? e.params.loop
                  ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
                  : e.isBeginning
                  ? e.params.autoplay.stopOnLastSlide
                    ? e.autoplay.stop()
                    : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)), e.emit("autoplay"))
                  : ((t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
                : e.params.loop
                ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay"))
                : e.isEnd
                ? e.params.autoplay.stopOnLastSlide
                  ? e.autoplay.stop()
                  : ((t = e.slideTo(0, e.params.speed, !0, !0)), e.emit("autoplay"))
                : ((t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay")),
                ((e.params.cssMode && e.autoplay.running) || !1 === t) && e.autoplay.run();
            }, n));
        },
        start: function () {
          var e = this;
          return void 0 === e.autoplay.timeout && !e.autoplay.running && ((e.autoplay.running = !0), e.emit("autoplayStart"), e.autoplay.run(), !0);
        },
        stop: function () {
          var e = this;
          return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)), (e.autoplay.running = !1), e.emit("autoplayStop"), !0);
        },
        pause: function (e) {
          var t = this;
          t.autoplay.running &&
            (t.autoplay.paused ||
              (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
              (t.autoplay.paused = !0),
              0 !== e && t.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
                    t.$wrapperEl[0].addEventListener(e, t.autoplay.onTransitionEnd);
                  })
                : ((t.autoplay.paused = !1), t.autoplay.run())));
        },
        onVisibilityChange: function () {
          var e = this,
            t = m();
          "hidden" === t.visibilityState && e.autoplay.running && e.autoplay.pause(), "visible" === t.visibilityState && e.autoplay.paused && (e.autoplay.run(), (e.autoplay.paused = !1));
        },
        onTransitionEnd: function (e) {
          var t = this;
          t &&
            !t.destroyed &&
            t.$wrapperEl &&
            e.target === t.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach(function (e) {
              t.$wrapperEl[0].removeEventListener(e, t.autoplay.onTransitionEnd);
            }),
            (t.autoplay.paused = !1),
            t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
        },
        onMouseEnter: function () {
          var e = this;
          e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause(),
            ["transitionend", "webkitTransitionEnd"].forEach(function (t) {
              e.$wrapperEl[0].removeEventListener(t, e.autoplay.onTransitionEnd);
            });
        },
        onMouseLeave: function () {
          var e = this;
          e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), e.autoplay.run());
        },
        attachMouseEvents: function () {
          var e = this;
          e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", e.autoplay.onMouseEnter), e.$el.on("mouseleave", e.autoplay.onMouseLeave));
        },
        detachMouseEvents: function () {
          var e = this;
          e.$el.off("mouseenter", e.autoplay.onMouseEnter), e.$el.off("mouseleave", e.autoplay.onMouseLeave);
        },
      };
      const Le = {
        name: "autoplay",
        params: { autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1, pauseOnMouseEnter: !1 } },
        create: function () {
          N(this, { autoplay: Pe({}, Ae, { running: !1, paused: !1 }) });
        },
        on: {
          init: function (e) {
            e.params.autoplay.enabled && (e.autoplay.start(), m().addEventListener("visibilitychange", e.autoplay.onVisibilityChange), e.autoplay.attachMouseEvents());
          },
          beforeTransitionStart: function (e, t, n) {
            e.autoplay.running && (n || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(t) : e.autoplay.stop());
          },
          sliderFirstMove: function (e) {
            e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause());
          },
          touchEnd: function (e) {
            e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run();
          },
          destroy: function (e) {
            e.autoplay.detachMouseEvents(), e.autoplay.running && e.autoplay.stop(), m().removeEventListener("visibilitychange", e.autoplay.onVisibilityChange);
          },
        },
      };
      we.use([Ce, Ee, Me, Le]);
      var Ie = new we("#brand-logo", {
        spaceBetween: 10,
        slidesPerView: 4,
        watchSlidesVisibility: !0,
        watchSlidesProgress: !0,
        touchRatio: 0.5,
        threshold: 10,
        noSwiping: !0,
        centerInsufficientSlides: !0,
        lazy: { loadPrevNext: !0 },
        breakpoints: { 320: { slidesPerView: 3, spaceBetween: 40 }, 992: { spaceBetween: 10, slidesPerView: 4, simulateTouch: !1, allowTouchMove: !1 } },
      });
      function De(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      new we("#brand-blockquote", {
        autoplay: { delay: 3e3, disableOnInteraction: !1 },
        effect: "fade",
        fadeEffect: { crossFade: !0 },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        thumbs: { swiper: Ie },
        breakpoints: { 992: { simulateTouch: !1, allowTouchMove: !1 } },
      });
      var ze = (function () {
        function e(n, r) {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.el = t()(n)),
            (this.selector = n),
            (this.trigger = r.trigger),
            (this.body = r.body),
            (this.activeClass = r.activeClass),
            (this.dynamic = r.dynamic),
            this.events();
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "events",
              value: function () {
                var e = this;
                t()("body").on("click", "".concat(this.selector, " ").concat(this.trigger), function (n) {
                  n.preventDefault();
                  var r = t()(n.target).closest(e.selector);
                  r.hasClass(e.activeClass)
                    ? r.removeClass(e.activeClass).find(e.body).slideUp()
                    : (t()("".concat(e.selector, " ").concat(e.trigger)).closest(e.selector).removeClass(e.activeClass).find(e.body).slideUp(), r.addClass(e.activeClass).find(e.body).slideDown());
                });
              },
            },
          ]) && De(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      n(812),
        t()(document).ready(function () {
          t().cookie("cookie") ||
            setTimeout(function () {
              t()(".cookie").fadeIn(), t()("body").addClass("cookie-visible");
            }, 1e3),
            t()(".cookie__close, .cookie__accept").on("click", function (e) {
              e.preventDefault(), t().cookie("cookie", !0, { expires: 30, path: "/" }), t()(".cookie").fadeOut(), t()("body").removeClass("cookie-visible");
            }),
            t()(".newsletter .newsletter__remove, .newsletter .newsletter__collapse").on("click", function (e) {
              t().cookie("newsletter", !0, { expires: 30, path: "/" });
            });
        });
      var je = n(755);
      function Be(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      const Ne = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.triggers = document.querySelectorAll(".js-modal")),
            (this.close = document.querySelectorAll(".js-close-modal")),
            (this.modals = document.querySelectorAll(".modal")),
            (this.mainWrapper = document.querySelectorAll(".content")),
            this.listeners();
        }
        var t, n, r;
        return (
          (t = e),
          (r = [
            {
              key: "hideModal",
              value: function (t) {
                var n = document.querySelector(".modal-body");
                n && n.addEventListener("transitionend", e.modalBody, !1),
                  je(".content").removeClass("modal-body modal-fadeOut"),
                  (document.body.style.overflow = ""),
                  document.querySelector(".modal.modal-visible").classList.remove("modal-visible");
              },
            },
            {
              key: "modalBody",
              value: function (e) {
                e.target.classList.contains("modal") && !e.target.classList.contains("modal-visible") && document.body.classList.remove("modal-body", "modal-fadeOut");
              },
            },
          ]),
          (n = [
            {
              key: "listeners",
              value: function () {
                var t = this;
                window.addEventListener("keydown", this.keyDown),
                  this.triggers.forEach(function (e) {
                    e.addEventListener("click", t.openModal, !1);
                  }),
                  this.modals.forEach(function (e) {
                    e.addEventListener("click", t.backdropClose, !1);
                  }),
                  this.close.forEach(function (t) {
                    t.addEventListener("click", e.hideModal, !1);
                  });
              },
            },
            {
              key: "keyDown",
              value: function (t) {
                27 === t.keyCode && je(".content").hasClass("modal-body") && e.hideModal();
              },
            },
            {
              key: "backdropClose",
              value: function (t) {
                t.target.classList.contains("modal-visible") && !0 === (void 0 === t.currentTarget.dataset.backdrop || t.currentTarget.dataset.backdrop) && e.hideModal();
              },
            },
            {
              key: "openModal",
              value: function (e) {
                if ((event.preventDefault(), e.currentTarget.dataset.modal)) {
                  e.preventDefault();
                  var t = e.currentTarget.dataset.modal,
                    n = document.getElementById(t);
                  je(".content").addClass("modal-body"), (document.body.style.overflow = "hidden"), n.classList.add("modal-visible");
                } else console.error("No data-modal attribute defined!");
              },
            },
          ]) && Be(t.prototype, n),
          r && Be(t, r),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Re(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function qe(e, t) {
        (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), (e.__proto__ = t);
      }
      n(827);
      var Fe,
        He,
        We,
        $e,
        Ve,
        Ye,
        Ge,
        Xe,
        Ue,
        Ke,
        Qe,
        Ze,
        Je,
        et = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } },
        tt = { duration: 0.5, overwrite: !1, delay: 0 },
        nt = 1e8,
        rt = 1e-8,
        it = 2 * Math.PI,
        at = it / 4,
        ot = 0,
        st = Math.sqrt,
        lt = Math.cos,
        ut = Math.sin,
        ct = function (e) {
          return "string" == typeof e;
        },
        dt = function (e) {
          return "function" == typeof e;
        },
        ft = function (e) {
          return "number" == typeof e;
        },
        pt = function (e) {
          return void 0 === e;
        },
        ht = function (e) {
          return "object" == typeof e;
        },
        vt = function (e) {
          return !1 !== e;
        },
        gt = function () {
          return "undefined" != typeof window;
        },
        mt = function (e) {
          return dt(e) || ct(e);
        },
        yt = ("function" == typeof ArrayBuffer && ArrayBuffer.isView) || function () {},
        bt = Array.isArray,
        wt = /(?:-?\.?\d|\.)+/gi,
        _t = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        xt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        Ct = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        Tt = /[+-]=-?[.\d]+/,
        kt = /[^,'"\[\]\s]+/gi,
        Et = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        St = {},
        Ot = {},
        Mt = function (e) {
          return (Ot = tn(e, St)) && Vr;
        },
        Pt = function (e, t) {
          return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
        },
        At = function (e, t) {
          return !t && console.warn(e);
        },
        Lt = function (e, t) {
          return (e && (St[e] = t) && Ot && (Ot[e] = t)) || St;
        },
        It = function () {
          return 0;
        },
        Dt = {},
        zt = [],
        jt = {},
        Bt = {},
        Nt = {},
        Rt = 30,
        qt = [],
        Ft = "",
        Ht = function (e) {
          var t,
            n,
            r = e[0];
          if ((ht(r) || dt(r) || (e = [e]), !(t = (r._gsap || {}).harness))) {
            for (n = qt.length; n-- && !qt[n].targetTest(r); );
            t = qt[n];
          }
          for (n = e.length; n--; ) (e[n] && (e[n]._gsap || (e[n]._gsap = new hr(e[n], t)))) || e.splice(n, 1);
          return e;
        },
        Wt = function (e) {
          return e._gsap || Ht(In(e))[0]._gsap;
        },
        $t = function (e, t, n) {
          return (n = e[t]) && dt(n) ? e[t]() : (pt(n) && e.getAttribute && e.getAttribute(t)) || n;
        },
        Vt = function (e, t) {
          return (e = e.split(",")).forEach(t) || e;
        },
        Yt = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        Gt = function (e) {
          return Math.round(1e7 * e) / 1e7 || 0;
        },
        Xt = function (e, t) {
          var n = t.charAt(0),
            r = parseFloat(t.substr(2));
          return (e = parseFloat(e)), "+" === n ? e + r : "-" === n ? e - r : "*" === n ? e * r : e / r;
        },
        Ut = function (e, t) {
          for (var n = t.length, r = 0; e.indexOf(t[r]) < 0 && ++r < n; );
          return r < n;
        },
        Kt = function () {
          var e,
            t,
            n = zt.length,
            r = zt.slice(0);
          for (jt = {}, zt.length = 0, e = 0; e < n; e++) (t = r[e]) && t._lazy && (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        },
        Qt = function (e, t, n, r) {
          zt.length && Kt(), e.render(t, n, r), zt.length && Kt();
        },
        Zt = function (e) {
          var t = parseFloat(e);
          return (t || 0 === t) && (e + "").match(kt).length < 2 ? t : ct(e) ? e.trim() : e;
        },
        Jt = function (e) {
          return e;
        },
        en = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        tn = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        nn = function e(t, n) {
          for (var r in n) "__proto__" !== r && "constructor" !== r && "prototype" !== r && (t[r] = ht(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
          return t;
        },
        rn = function (e, t) {
          var n,
            r = {};
          for (n in e) n in t || (r[n] = e[n]);
          return r;
        },
        an = function (e) {
          var t,
            n = e.parent || He,
            r = e.keyframes
              ? ((t = bt(e.keyframes)),
                function (e, n) {
                  for (var r in n) r in e || ("duration" === r && t) || "ease" === r || (e[r] = n[r]);
                })
              : en;
          if (vt(e.inherit)) for (; n; ) r(e, n.vars.defaults), (n = n.parent || n._dp);
          return e;
        },
        on = function (e, t, n, r, i) {
          void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
          var a,
            o = e[r];
          if (i) for (a = t[i]; o && o[i] > a; ) o = o._prev;
          return o ? ((t._next = o._next), (o._next = t)) : ((t._next = e[n]), (e[n] = t)), t._next ? (t._next._prev = t) : (e[r] = t), (t._prev = o), (t.parent = t._dp = e), t;
        },
        sn = function (e, t, n, r) {
          void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
          var i = t._prev,
            a = t._next;
          i ? (i._next = a) : e[n] === t && (e[n] = a), a ? (a._prev = i) : e[r] === t && (e[r] = i), (t._next = t._prev = t.parent = null);
        },
        ln = function (e, t) {
          e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove(e), (e._act = 0);
        },
        un = function (e, t) {
          if (e && (!t || t._end > e._dur || t._start < 0)) for (var n = e; n; ) (n._dirty = 1), (n = n.parent);
          return e;
        },
        cn = function (e) {
          for (var t = e.parent; t && t.parent; ) (t._dirty = 1), t.totalDuration(), (t = t.parent);
          return e;
        },
        dn = function e(t) {
          return !t || (t._ts && e(t.parent));
        },
        fn = function (e) {
          return e._repeat ? pn(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
        },
        pn = function (e, t) {
          var n = Math.floor((e /= t));
          return e && n === e ? n - 1 : n;
        },
        hn = function (e, t) {
          return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
        },
        vn = function (e) {
          return (e._end = Gt(e._start + (e._tDur / Math.abs(e._ts || e._rts || rt) || 0)));
        },
        gn = function (e, t) {
          var n = e._dp;
          return n && n.smoothChildTiming && e._ts && ((e._start = Gt(n._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts))), vn(e), n._dirty || un(n, e)), e;
        },
        mn = function (e, t) {
          var n;
          if (((t._time || (t._initted && !t._dur)) && ((n = hn(e.rawTime(), t)), (!t._dur || Mn(0, t.totalDuration(), n) - t._tTime > rt) && t.render(n, !0)), un(e, t)._dp && e._initted && e._time >= e._dur && e._ts)) {
            if (e._dur < e.duration()) for (n = e; n._dp; ) n.rawTime() >= 0 && n.totalTime(n._tTime), (n = n._dp);
            e._zTime = -1e-8;
          }
        },
        yn = function (e, t, n, r) {
          return (
            t.parent && ln(t),
            (t._start = Gt((ft(n) ? n : n || e !== He ? En(e, n, t) : e._time) + t._delay)),
            (t._end = Gt(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0))),
            on(e, t, "_first", "_last", e._sort ? "_start" : 0),
            xn(t) || (e._recent = t),
            r || mn(e, t),
            e
          );
        },
        bn = function (e, t) {
          return (St.ScrollTrigger || Pt("scrollTrigger", t)) && St.ScrollTrigger.create(t, e);
        },
        wn = function (e, t, n, r) {
          return xr(e, t), e._initted ? (!n && e._pt && ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) && Ge !== tr.frame ? (zt.push(e), (e._lazy = [t, r]), 1) : void 0) : 1;
        },
        _n = function e(t) {
          var n = t.parent;
          return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n));
        },
        xn = function (e) {
          var t = e.data;
          return "isFromStart" === t || "isStart" === t;
        },
        Cn = function (e, t, n, r) {
          var i = e._repeat,
            a = Gt(t) || 0,
            o = e._tTime / e._tDur;
          return o && !r && (e._time *= a / e._dur), (e._dur = a), (e._tDur = i ? (i < 0 ? 1e10 : Gt(a * (i + 1) + e._rDelay * i)) : a), o > 0 && !r ? gn(e, (e._tTime = e._tDur * o)) : e.parent && vn(e), n || un(e.parent, e), e;
        },
        Tn = function (e) {
          return e instanceof gr ? un(e) : Cn(e, e._dur);
        },
        kn = { _start: 0, endTime: It, totalDuration: It },
        En = function e(t, n, r) {
          var i,
            a,
            o,
            s = t.labels,
            l = t._recent || kn,
            u = t.duration() >= nt ? l.endTime(!1) : t._dur;
          return ct(n) && (isNaN(n) || n in s)
            ? ((a = n.charAt(0)),
              (o = "%" === n.substr(-1)),
              (i = n.indexOf("=")),
              "<" === a || ">" === a
                ? (i >= 0 && (n = n.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (o ? (i < 0 ? l : r).totalDuration() / 100 : 1))
                : i < 0
                ? (n in s || (s[n] = u), s[n])
                : ((a = parseFloat(n.charAt(i - 1) + n.substr(i + 1))), o && r && (a = (a / 100) * (bt(r) ? r[0] : r).totalDuration()), i > 1 ? e(t, n.substr(0, i - 1), r) + a : u + a))
            : null == n
            ? u
            : +n;
        },
        Sn = function (e, t, n) {
          var r,
            i,
            a = ft(t[1]),
            o = (a ? 2 : 1) + (e < 2 ? 0 : 1),
            s = t[o];
          if ((a && (s.duration = t[1]), (s.parent = n), e)) {
            for (r = s, i = n; i && !("immediateRender" in r); ) (r = i.vars.defaults || {}), (i = vt(i.vars.inherit) && i.parent);
            (s.immediateRender = vt(r.immediateRender)), e < 2 ? (s.runBackwards = 1) : (s.startAt = t[o - 1]);
          }
          return new Sr(t[0], s, t[o + 1]);
        },
        On = function (e, t) {
          return e || 0 === e ? t(e) : t;
        },
        Mn = function (e, t, n) {
          return n < e ? e : n > t ? t : n;
        },
        Pn = function (e, t) {
          return ct(e) && (t = Et.exec(e)) ? t[1] : "";
        },
        An = [].slice,
        Ln = function (e, t) {
          return e && ht(e) && "length" in e && ((!t && !e.length) || (e.length - 1 in e && ht(e[0]))) && !e.nodeType && e !== We;
        },
        In = function (e, t, n) {
          return !ct(e) || n || (!$e && nr())
            ? bt(e)
              ? (function (e, t, n) {
                  return (
                    void 0 === n && (n = []),
                    e.forEach(function (e) {
                      var r;
                      return (ct(e) && !t) || Ln(e, 1) ? (r = n).push.apply(r, In(e)) : n.push(e);
                    }) || n
                  );
                })(e, n)
              : Ln(e)
              ? An.call(e, 0)
              : e
              ? [e]
              : []
            : An.call((t || Ve).querySelectorAll(e), 0);
        },
        Dn = function (e) {
          return e.sort(function () {
            return 0.5 - Math.random();
          });
        },
        zn = function (e) {
          if (dt(e)) return e;
          var t = ht(e) ? e : { each: e },
            n = ur(t.ease),
            r = t.from || 0,
            i = parseFloat(t.base) || 0,
            a = {},
            o = r > 0 && r < 1,
            s = isNaN(r) || o,
            l = t.axis,
            u = r,
            c = r;
          return (
            ct(r) ? (u = c = { center: 0.5, edges: 0.5, end: 1 }[r] || 0) : !o && s && ((u = r[0]), (c = r[1])),
            function (e, o, d) {
              var f,
                p,
                h,
                v,
                g,
                m,
                y,
                b,
                w,
                _ = (d || t).length,
                x = a[_];
              if (!x) {
                if (!(w = "auto" === t.grid ? 0 : (t.grid || [1, nt])[1])) {
                  for (y = -nt; y < (y = d[w++].getBoundingClientRect().left) && w < _; );
                  w--;
                }
                for (x = a[_] = [], f = s ? Math.min(w, _) * u - 0.5 : r % w, p = w === nt ? 0 : s ? (_ * c) / w - 0.5 : (r / w) | 0, y = 0, b = nt, m = 0; m < _; m++)
                  (h = (m % w) - f), (v = p - ((m / w) | 0)), (x[m] = g = l ? Math.abs("y" === l ? v : h) : st(h * h + v * v)), g > y && (y = g), g < b && (b = g);
                "random" === r && Dn(x),
                  (x.max = y - b),
                  (x.min = b),
                  (x.v = _ = (parseFloat(t.amount) || parseFloat(t.each) * (w > _ ? _ - 1 : l ? ("y" === l ? _ / w : w) : Math.max(w, _ / w)) || 0) * ("edges" === r ? -1 : 1)),
                  (x.b = _ < 0 ? i - _ : i),
                  (x.u = Pn(t.amount || t.each) || 0),
                  (n = n && _ < 0 ? sr(n) : n);
              }
              return (_ = (x[e] - x.min) / x.max || 0), Gt(x.b + (n ? n(_) : _) * x.v) + x.u;
            }
          );
        },
        jn = function (e) {
          var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
          return function (n) {
            var r = Math.round(parseFloat(n) / e) * e * t;
            return (r - (r % 1)) / t + (ft(n) ? 0 : Pn(n));
          };
        },
        Bn = function (e, t) {
          var n,
            r,
            i = bt(e);
          return (
            !i && ht(e) && ((n = i = e.radius || nt), e.values ? ((e = In(e.values)), (r = !ft(e[0])) && (n *= n)) : (e = jn(e.increment))),
            On(
              t,
              i
                ? dt(e)
                  ? function (t) {
                      return (r = e(t)), Math.abs(r - t) <= n ? r : t;
                    }
                  : function (t) {
                      for (var i, a, o = parseFloat(r ? t.x : t), s = parseFloat(r ? t.y : 0), l = nt, u = 0, c = e.length; c--; ) (i = r ? (i = e[c].x - o) * i + (a = e[c].y - s) * a : Math.abs(e[c] - o)) < l && ((l = i), (u = c));
                      return (u = !n || l <= n ? e[u] : t), r || u === t || ft(t) ? u : u + Pn(t);
                    }
                : jn(e)
            )
          );
        },
        Nn = function (e, t, n, r) {
          return On(bt(e) ? !t : !0 === n ? !!(n = 0) : !r, function () {
            return bt(e) ? e[~~(Math.random() * e.length)] : (n = n || 1e-5) && (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((e - n / 2 + Math.random() * (t - e + 0.99 * n)) / n) * n * r) / r;
          });
        },
        Rn = function (e, t, n) {
          return On(n, function (n) {
            return e[~~t(n)];
          });
        },
        qn = function (e) {
          for (var t, n, r, i, a = 0, o = ""; ~(t = e.indexOf("random(", a)); )
            (r = e.indexOf(")", t)), (i = "[" === e.charAt(t + 7)), (n = e.substr(t + 7, r - t - 7).match(i ? kt : wt)), (o += e.substr(a, t - a) + Nn(i ? n : +n[0], i ? 0 : +n[1], +n[2] || 1e-5)), (a = r + 1);
          return o + e.substr(a, e.length - a);
        },
        Fn = function (e, t, n, r, i) {
          var a = t - e,
            o = r - n;
          return On(i, function (t) {
            return n + (((t - e) / a) * o || 0);
          });
        },
        Hn = function (e, t, n) {
          var r,
            i,
            a,
            o = e.labels,
            s = nt;
          for (r in o) (i = o[r] - t) < 0 == !!n && i && s > (i = Math.abs(i)) && ((a = r), (s = i));
          return a;
        },
        Wn = function (e, t, n) {
          var r,
            i,
            a = e.vars,
            o = a[t];
          if (o) return (r = a[t + "Params"]), (i = a.callbackScope || e), n && zt.length && Kt(), r ? o.apply(i, r) : o.call(i);
        },
        $n = function (e) {
          return ln(e), e.scrollTrigger && e.scrollTrigger.kill(!1), e.progress() < 1 && Wn(e, "onInterrupt"), e;
        },
        Vn = function (e) {
          var t = (e = (!e.name && e.default) || e).name,
            n = dt(e),
            r =
              t && !n && e.init
                ? function () {
                    this._props = [];
                  }
                : e,
            i = { init: It, render: jr, add: wr, kill: Nr, modifier: Br, rawVars: 0 },
            a = { targetTest: 0, get: 0, getSetter: Lr, aliases: {}, register: 0 };
          if ((nr(), e !== r)) {
            if (Bt[t]) return;
            en(r, en(rn(e, i), a)), tn(r.prototype, tn(i, rn(e, a))), (Bt[(r.prop = t)] = r), e.targetTest && (qt.push(r), (Dt[t] = 1)), (t = ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin");
          }
          Lt(t, r), e.register && e.register(Vr, r, Fr);
        },
        Yn = 255,
        Gn = {
          aqua: [0, Yn, Yn],
          lime: [0, Yn, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, Yn],
          navy: [0, 0, 128],
          white: [Yn, Yn, Yn],
          olive: [128, 128, 0],
          yellow: [Yn, Yn, 0],
          orange: [Yn, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [Yn, 0, 0],
          pink: [Yn, 192, 203],
          cyan: [0, Yn, Yn],
          transparent: [Yn, Yn, Yn, 0],
        },
        Xn = function (e, t, n) {
          return ((6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1 ? t + (n - t) * e * 6 : e < 0.5 ? n : 3 * e < 2 ? t + (n - t) * (2 / 3 - e) * 6 : t) * Yn + 0.5) | 0;
        },
        Un = function (e, t, n) {
          var r,
            i,
            a,
            o,
            s,
            l,
            u,
            c,
            d,
            f,
            p = e ? (ft(e) ? [e >> 16, (e >> 8) & Yn, e & Yn] : 0) : Gn.black;
          if (!p) {
            if (("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), Gn[e])) p = Gn[e];
            else if ("#" === e.charAt(0)) {
              if ((e.length < 6 && ((r = e.charAt(1)), (i = e.charAt(2)), (a = e.charAt(3)), (e = "#" + r + r + i + i + a + a + (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))), 9 === e.length))
                return [(p = parseInt(e.substr(1, 6), 16)) >> 16, (p >> 8) & Yn, p & Yn, parseInt(e.substr(7), 16) / 255];
              p = [(e = parseInt(e.substr(1), 16)) >> 16, (e >> 8) & Yn, e & Yn];
            } else if ("hsl" === e.substr(0, 3))
              if (((p = f = e.match(wt)), t)) {
                if (~e.indexOf("=")) return (p = e.match(_t)), n && p.length < 4 && (p[3] = 1), p;
              } else
                (o = (+p[0] % 360) / 360),
                  (s = +p[1] / 100),
                  (r = 2 * (l = +p[2] / 100) - (i = l <= 0.5 ? l * (s + 1) : l + s - l * s)),
                  p.length > 3 && (p[3] *= 1),
                  (p[0] = Xn(o + 1 / 3, r, i)),
                  (p[1] = Xn(o, r, i)),
                  (p[2] = Xn(o - 1 / 3, r, i));
            else p = e.match(wt) || Gn.transparent;
            p = p.map(Number);
          }
          return (
            t &&
              !f &&
              ((r = p[0] / Yn),
              (i = p[1] / Yn),
              (a = p[2] / Yn),
              (l = ((u = Math.max(r, i, a)) + (c = Math.min(r, i, a))) / 2),
              u === c ? (o = s = 0) : ((d = u - c), (s = l > 0.5 ? d / (2 - u - c) : d / (u + c)), (o = u === r ? (i - a) / d + (i < a ? 6 : 0) : u === i ? (a - r) / d + 2 : (r - i) / d + 4), (o *= 60)),
              (p[0] = ~~(o + 0.5)),
              (p[1] = ~~(100 * s + 0.5)),
              (p[2] = ~~(100 * l + 0.5))),
            n && p.length < 4 && (p[3] = 1),
            p
          );
        },
        Kn = function (e) {
          var t = [],
            n = [],
            r = -1;
          return (
            e.split(Zn).forEach(function (e) {
              var i = e.match(xt) || [];
              t.push.apply(t, i), n.push((r += i.length + 1));
            }),
            (t.c = n),
            t
          );
        },
        Qn = function (e, t, n) {
          var r,
            i,
            a,
            o,
            s = "",
            l = (e + s).match(Zn),
            u = t ? "hsla(" : "rgba(",
            c = 0;
          if (!l) return e;
          if (
            ((l = l.map(function (e) {
              return (e = Un(e, t, 1)) && u + (t ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3] : e.join(",")) + ")";
            })),
            n && ((a = Kn(e)), (r = n.c).join(s) !== a.c.join(s)))
          )
            for (o = (i = e.replace(Zn, "1").split(xt)).length - 1; c < o; c++) s += i[c] + (~r.indexOf(c) ? l.shift() || u + "0,0,0,0)" : (a.length ? a : l.length ? l : n).shift());
          if (!i) for (o = (i = e.split(Zn)).length - 1; c < o; c++) s += i[c] + l[c];
          return s + i[o];
        },
        Zn = (function () {
          var e,
            t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (e in Gn) t += "|" + e + "\\b";
          return new RegExp(t + ")", "gi");
        })(),
        Jn = /hsl[a]?\(/,
        er = function (e) {
          var t,
            n = e.join(" ");
          if (((Zn.lastIndex = 0), Zn.test(n))) return (t = Jn.test(n)), (e[1] = Qn(e[1], t)), (e[0] = Qn(e[0], t, Kn(e[1]))), !0;
        },
        tr = (function () {
          var e,
            t,
            n,
            r,
            i,
            a,
            o = Date.now,
            s = 500,
            l = 33,
            u = o(),
            c = u,
            d = 1e3 / 240,
            f = d,
            p = [],
            h = function n(h) {
              var v,
                g,
                m,
                y,
                b = o() - c,
                w = !0 === h;
              if ((b > s && (u += b - l), ((v = (m = (c += b) - u) - f) > 0 || w) && ((y = ++r.frame), (i = m - 1e3 * r.time), (r.time = m /= 1e3), (f += v + (v >= d ? 4 : d - v)), (g = 1)), w || (e = t(n)), g))
                for (a = 0; a < p.length; a++) p[a](m, i, y, h);
            };
          return (r = {
            time: 0,
            frame: 0,
            tick: function () {
              h(!0);
            },
            deltaRatio: function (e) {
              return i / (1e3 / (e || 60));
            },
            wake: function () {
              Ye &&
                (!$e &&
                  gt() &&
                  ((We = $e = window), (Ve = We.document || {}), (St.gsap = Vr), (We.gsapVersions || (We.gsapVersions = [])).push(Vr.version), Mt(Ot || We.GreenSockGlobals || (!We.gsap && We) || {}), (n = We.requestAnimationFrame)),
                e && r.sleep(),
                (t =
                  n ||
                  function (e) {
                    return setTimeout(e, (f - 1e3 * r.time + 1) | 0);
                  }),
                (Ue = 1),
                h(2));
            },
            sleep: function () {
              (n ? We.cancelAnimationFrame : clearTimeout)(e), (Ue = 0), (t = It);
            },
            lagSmoothing: function (e, t) {
              (s = e || 1e8), (l = Math.min(t, s, 0));
            },
            fps: function (e) {
              (d = 1e3 / (e || 240)), (f = 1e3 * r.time + d);
            },
            add: function (e, t, n) {
              var i = t
                ? function (t, n, a, o) {
                    e(t, n, a, o), r.remove(i);
                  }
                : e;
              return r.remove(e), p[n ? "unshift" : "push"](i), nr(), i;
            },
            remove: function (e, t) {
              ~(t = p.indexOf(e)) && p.splice(t, 1) && a >= t && a--;
            },
            _listeners: p,
          });
        })(),
        nr = function () {
          return !Ue && tr.wake();
        },
        rr = {},
        ir = /^[\d.\-M][\d.\-,\s]/,
        ar = /["']/g,
        or = function (e) {
          for (var t, n, r, i = {}, a = e.substr(1, e.length - 3).split(":"), o = a[0], s = 1, l = a.length; s < l; s++)
            (n = a[s]), (t = s !== l - 1 ? n.lastIndexOf(",") : n.length), (r = n.substr(0, t)), (i[o] = isNaN(r) ? r.replace(ar, "").trim() : +r), (o = n.substr(t + 1).trim());
          return i;
        },
        sr = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        lr = function e(t, n) {
          for (var r, i = t._first; i; )
            i instanceof gr ? e(i, n) : !i.vars.yoyoEase || (i._yoyo && i._repeat) || i._yoyo === n || (i.timeline ? e(i.timeline, n) : ((r = i._ease), (i._ease = i._yEase), (i._yEase = r), (i._yoyo = n))), (i = i._next);
        },
        ur = function (e, t) {
          return (
            (e &&
              (dt(e)
                ? e
                : rr[e] ||
                  (function (e) {
                    var t,
                      n,
                      r,
                      i,
                      a = (e + "").split("("),
                      o = rr[a[0]];
                    return o && a.length > 1 && o.config
                      ? o.config.apply(null, ~e.indexOf("{") ? [or(a[1])] : ((t = e), (n = t.indexOf("(") + 1), (r = t.indexOf(")")), (i = t.indexOf("(", n)), t.substring(n, ~i && i < r ? t.indexOf(")", r + 1) : r)).split(",").map(Zt))
                      : rr._CE && ir.test(e)
                      ? rr._CE("", e)
                      : o;
                  })(e))) ||
            t
          );
        },
        cr = function (e, t, n, r) {
          void 0 === n &&
            (n = function (e) {
              return 1 - t(1 - e);
            }),
            void 0 === r &&
              (r = function (e) {
                return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
              });
          var i,
            a = { easeIn: t, easeOut: n, easeInOut: r };
          return (
            Vt(e, function (e) {
              for (var t in ((rr[e] = St[e] = a), (rr[(i = e.toLowerCase())] = n), a)) rr[i + ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")] = rr[e + "." + t] = a[t];
            }),
            a
          );
        },
        dr = function (e) {
          return function (t) {
            return t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : 0.5 + e(2 * (t - 0.5)) / 2;
          };
        },
        fr = function e(t, n, r) {
          var i = n >= 1 ? n : 1,
            a = (r || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1),
            o = (a / it) * (Math.asin(1 / i) || 0),
            s = function (e) {
              return 1 === e ? 1 : i * Math.pow(2, -10 * e) * ut((e - o) * a) + 1;
            },
            l =
              "out" === t
                ? s
                : "in" === t
                ? function (e) {
                    return 1 - s(1 - e);
                  }
                : dr(s);
          return (
            (a = it / a),
            (l.config = function (n, r) {
              return e(t, n, r);
            }),
            l
          );
        },
        pr = function e(t, n) {
          void 0 === n && (n = 1.70158);
          var r = function (e) {
              return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
            },
            i =
              "out" === t
                ? r
                : "in" === t
                ? function (e) {
                    return 1 - r(1 - e);
                  }
                : dr(r);
          return (
            (i.config = function (n) {
              return e(t, n);
            }),
            i
          );
        };
      Vt("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
        var n = t < 5 ? t + 1 : t;
        cr(
          e + ",Power" + (n - 1),
          t
            ? function (e) {
                return Math.pow(e, n);
              }
            : function (e) {
                return e;
              },
          function (e) {
            return 1 - Math.pow(1 - e, n);
          },
          function (e) {
            return e < 0.5 ? Math.pow(2 * e, n) / 2 : 1 - Math.pow(2 * (1 - e), n) / 2;
          }
        );
      }),
        (rr.Linear.easeNone = rr.none = rr.Linear.easeIn),
        cr("Elastic", fr("in"), fr("out"), fr()),
        (Ke = 7.5625),
        (Ze = 1 / (Qe = 2.75)),
        cr(
          "Bounce",
          function (e) {
            return 1 - Je(1 - e);
          },
          (Je = function (e) {
            return e < Ze ? Ke * e * e : e < 0.7272727272727273 ? Ke * Math.pow(e - 1.5 / Qe, 2) + 0.75 : e < 0.9090909090909092 ? Ke * (e -= 2.25 / Qe) * e + 0.9375 : Ke * Math.pow(e - 2.625 / Qe, 2) + 0.984375;
          })
        ),
        cr("Expo", function (e) {
          return e ? Math.pow(2, 10 * (e - 1)) : 0;
        }),
        cr("Circ", function (e) {
          return -(st(1 - e * e) - 1);
        }),
        cr("Sine", function (e) {
          return 1 === e ? 1 : 1 - lt(e * at);
        }),
        cr("Back", pr("in"), pr("out"), pr()),
        (rr.SteppedEase = rr.steps = St.SteppedEase = {
          config: function (e, t) {
            void 0 === e && (e = 1);
            var n = 1 / e,
              r = e + (t ? 0 : 1),
              i = t ? 1 : 0;
            return function (e) {
              return (((r * Mn(0, 0.99999999, e)) | 0) + i) * n;
            };
          },
        }),
        (tt.ease = rr["quad.out"]),
        Vt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (e) {
          return (Ft += e + "," + e + "Params,");
        });
      var hr = function (e, t) {
          (this.id = ot++), (e._gsap = this), (this.target = e), (this.harness = t), (this.get = t ? t.get : $t), (this.set = t ? t.getSetter : Lr);
        },
        vr = (function () {
          function e(e) {
            (this.vars = e),
              (this._delay = +e.delay || 0),
              (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && ((this._rDelay = e.repeatDelay || 0), (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
              (this._ts = 1),
              Cn(this, +e.duration, 1, 1),
              (this.data = e.data),
              Ue || tr.wake();
          }
          var t = e.prototype;
          return (
            (t.delay = function (e) {
              return e || 0 === e ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e - this._delay), (this._delay = e), this) : this._delay;
            }),
            (t.duration = function (e) {
              return arguments.length ? this.totalDuration(this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e) : this.totalDuration() && this._dur;
            }),
            (t.totalDuration = function (e) {
              return arguments.length ? ((this._dirty = 0), Cn(this, this._repeat < 0 ? e : (e - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }),
            (t.totalTime = function (e, t) {
              if ((nr(), !arguments.length)) return this._tTime;
              var n = this._dp;
              if (n && n.smoothChildTiming && this._ts) {
                for (gn(this, e), !n._dp || n.parent || mn(n, this); n && n.parent; ) n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), (n = n.parent);
                !this.parent && this._dp.autoRemoveChildren && ((this._ts > 0 && e < this._tDur) || (this._ts < 0 && e > 0) || (!this._tDur && !e)) && yn(this._dp, this, this._start - this._delay);
              }
              return (this._tTime !== e || (!this._dur && !t) || (this._initted && Math.abs(this._zTime) === rt) || (!e && !this._initted && (this.add || this._ptLookup))) && (this._ts || (this._pTime = e), Qt(this, e, t)), this;
            }),
            (t.time = function (e, t) {
              return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e + fn(this)) % (this._dur + this._rDelay) || (e ? this._dur : 0), t) : this._time;
            }),
            (t.totalProgress = function (e, t) {
              return arguments.length ? this.totalTime(this.totalDuration() * e, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
            }),
            (t.progress = function (e, t) {
              return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? e : 1 - e) + fn(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
            }),
            (t.iteration = function (e, t) {
              var n = this.duration() + this._rDelay;
              return arguments.length ? this.totalTime(this._time + (e - 1) * n, t) : this._repeat ? pn(this._tTime, n) + 1 : 1;
            }),
            (t.timeScale = function (e) {
              if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
              if (this._rts === e) return this;
              var t = this.parent && this._ts ? hn(this.parent._time, this) : this._tTime;
              return (this._rts = +e || 0), (this._ts = this._ps || -1e-8 === e ? 0 : this._rts), this.totalTime(Mn(-this._delay, this._tDur, t), !0), vn(this), cn(this);
            }),
            (t.paused = function (e) {
              return arguments.length
                ? (this._ps !== e &&
                    ((this._ps = e),
                    e
                      ? ((this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())), (this._ts = this._act = 0))
                      : (nr(),
                        (this._ts = this._rts),
                        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== rt && (this._tTime -= rt)))),
                  this)
                : this._ps;
            }),
            (t.startTime = function (e) {
              if (arguments.length) {
                this._start = e;
                var t = this.parent || this._dp;
                return t && (t._sort || !this.parent) && yn(t, this, e - this._delay), this;
              }
              return this._start;
            }),
            (t.endTime = function (e) {
              return this._start + (vt(e) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }),
            (t.rawTime = function (e) {
              var t = this.parent || this._dp;
              return t ? (e && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1)) ? this._tTime % (this._dur + this._rDelay) : this._ts ? hn(t.rawTime(e), this) : this._tTime) : this._tTime;
            }),
            (t.globalTime = function (e) {
              for (var t = this, n = arguments.length ? e : t.rawTime(); t; ) (n = t._start + n / (t._ts || 1)), (t = t._dp);
              return n;
            }),
            (t.repeat = function (e) {
              return arguments.length ? ((this._repeat = e === 1 / 0 ? -2 : e), Tn(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }),
            (t.repeatDelay = function (e) {
              if (arguments.length) {
                var t = this._time;
                return (this._rDelay = e), Tn(this), t ? this.time(t) : this;
              }
              return this._rDelay;
            }),
            (t.yoyo = function (e) {
              return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
            }),
            (t.seek = function (e, t) {
              return this.totalTime(En(this, e), vt(t));
            }),
            (t.restart = function (e, t) {
              return this.play().totalTime(e ? -this._delay : 0, vt(t));
            }),
            (t.play = function (e, t) {
              return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
            }),
            (t.reverse = function (e, t) {
              return null != e && this.seek(e || this.totalDuration(), t), this.reversed(!0).paused(!1);
            }),
            (t.pause = function (e, t) {
              return null != e && this.seek(e, t), this.paused(!0);
            }),
            (t.resume = function () {
              return this.paused(!1);
            }),
            (t.reversed = function (e) {
              return arguments.length ? (!!e !== this.reversed() && this.timeScale(-this._rts || (e ? -1e-8 : 0)), this) : this._rts < 0;
            }),
            (t.invalidate = function () {
              return (this._initted = this._act = 0), (this._zTime = -1e-8), this;
            }),
            (t.isActive = function () {
              var e,
                t = this.parent || this._dp,
                n = this._start;
              return !(t && !(this._ts && this._initted && t.isActive() && (e = t.rawTime(!0)) >= n && e < this.endTime(!0) - rt));
            }),
            (t.eventCallback = function (e, t, n) {
              var r = this.vars;
              return arguments.length > 1 ? (t ? ((r[e] = t), n && (r[e + "Params"] = n), "onUpdate" === e && (this._onUpdate = t)) : delete r[e], this) : r[e];
            }),
            (t.then = function (e) {
              var t = this;
              return new Promise(function (n) {
                var r = dt(e) ? e : Jt,
                  i = function () {
                    var e = t.then;
                    (t.then = null), dt(r) && (r = r(t)) && (r.then || r === t) && (t.then = e), n(r), (t.then = e);
                  };
                (t._initted && 1 === t.totalProgress() && t._ts >= 0) || (!t._tTime && t._ts < 0) ? i() : (t._prom = i);
              });
            }),
            (t.kill = function () {
              $n(this);
            }),
            e
          );
        })();
      en(vr.prototype, { _time: 0, _start: 0, _end: 0, _tTime: 0, _tDur: 0, _dirty: 0, _repeat: 0, _yoyo: !1, parent: null, _initted: !1, _rDelay: 0, _ts: 1, _dp: 0, ratio: 0, _zTime: -1e-8, _prom: 0, _ps: !1, _rts: 1 });
      var gr = (function (e) {
        function t(t, n) {
          var r;
          return (
            void 0 === t && (t = {}),
            ((r = e.call(this, t) || this).labels = {}),
            (r.smoothChildTiming = !!t.smoothChildTiming),
            (r.autoRemoveChildren = !!t.autoRemoveChildren),
            (r._sort = vt(t.sortChildren)),
            He && yn(t.parent || He, Re(r), n),
            t.reversed && r.reverse(),
            t.paused && r.paused(!0),
            t.scrollTrigger && bn(Re(r), t.scrollTrigger),
            r
          );
        }
        qe(t, e);
        var n = t.prototype;
        return (
          (n.to = function (e, t, n) {
            return Sn(0, arguments, this), this;
          }),
          (n.from = function (e, t, n) {
            return Sn(1, arguments, this), this;
          }),
          (n.fromTo = function (e, t, n, r) {
            return Sn(2, arguments, this), this;
          }),
          (n.set = function (e, t, n) {
            return (t.duration = 0), (t.parent = this), an(t).repeatDelay || (t.repeat = 0), (t.immediateRender = !!t.immediateRender), new Sr(e, t, En(this, n), 1), this;
          }),
          (n.call = function (e, t, n) {
            return yn(this, Sr.delayedCall(0, e, t), n);
          }),
          (n.staggerTo = function (e, t, n, r, i, a, o) {
            return (n.duration = t), (n.stagger = n.stagger || r), (n.onComplete = a), (n.onCompleteParams = o), (n.parent = this), new Sr(e, n, En(this, i)), this;
          }),
          (n.staggerFrom = function (e, t, n, r, i, a, o) {
            return (n.runBackwards = 1), (an(n).immediateRender = vt(n.immediateRender)), this.staggerTo(e, t, n, r, i, a, o);
          }),
          (n.staggerFromTo = function (e, t, n, r, i, a, o, s) {
            return (r.startAt = n), (an(r).immediateRender = vt(r.immediateRender)), this.staggerTo(e, t, r, i, a, o, s);
          }),
          (n.render = function (e, t, n) {
            var r,
              i,
              a,
              o,
              s,
              l,
              u,
              c,
              d,
              f,
              p,
              h,
              v = this._time,
              g = this._dirty ? this.totalDuration() : this._tDur,
              m = this._dur,
              y = e <= 0 ? 0 : Gt(e),
              b = this._zTime < 0 != e < 0 && (this._initted || !m);
            if ((this !== He && y > g && e >= 0 && (y = g), y !== this._tTime || n || b)) {
              if ((v !== this._time && m && ((y += this._time - v), (e += this._time - v)), (r = y), (d = this._start), (l = !(c = this._ts)), b && (m || (v = this._zTime), (e || !t) && (this._zTime = e)), this._repeat)) {
                if (((p = this._yoyo), (s = m + this._rDelay), this._repeat < -1 && e < 0)) return this.totalTime(100 * s + e, t, n);
                if (
                  ((r = Gt(y % s)),
                  y === g ? ((o = this._repeat), (r = m)) : ((o = ~~(y / s)) && o === y / s && ((r = m), o--), r > m && (r = m)),
                  (f = pn(this._tTime, s)),
                  !v && this._tTime && f !== o && (f = o),
                  p && 1 & o && ((r = m - r), (h = 1)),
                  o !== f && !this._lock)
                ) {
                  var w = p && 1 & f,
                    _ = w === (p && 1 & o);
                  if (
                    (o < f && (w = !w),
                    (v = w ? 0 : m),
                    (this._lock = 1),
                    (this.render(v || (h ? 0 : Gt(o * s)), t, !m)._lock = 0),
                    (this._tTime = y),
                    !t && this.parent && Wn(this, "onRepeat"),
                    this.vars.repeatRefresh && !h && (this.invalidate()._lock = 1),
                    (v && v !== this._time) || l !== !this._ts || (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (((m = this._dur), (g = this._tDur), _ && ((this._lock = 2), (v = w ? m : -1e-4), this.render(v, !0), this.vars.repeatRefresh && !h && this.invalidate()), (this._lock = 0), !this._ts && !l)) return this;
                  lr(this, h);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  ((u = (function (e, t, n) {
                    var r;
                    if (n > t)
                      for (r = e._first; r && r._start <= n; ) {
                        if ("isPause" === r.data && r._start > t) return r;
                        r = r._next;
                      }
                    else
                      for (r = e._last; r && r._start >= n; ) {
                        if ("isPause" === r.data && r._start < t) return r;
                        r = r._prev;
                      }
                  })(this, Gt(v), Gt(r))),
                  u && (y -= r - (r = u._start))),
                (this._tTime = y),
                (this._time = r),
                (this._act = !c),
                this._initted || ((this._onUpdate = this.vars.onUpdate), (this._initted = 1), (this._zTime = e), (v = 0)),
                !v && r && !t && (Wn(this, "onStart"), this._tTime !== y))
              )
                return this;
              if (r >= v && e >= 0)
                for (i = this._first; i; ) {
                  if (((a = i._next), (i._act || r >= i._start) && i._ts && u !== i)) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if ((i.render(i._ts > 0 ? (r - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (r - i._start) * i._ts, t, n), r !== this._time || (!this._ts && !l))) {
                      (u = 0), a && (y += this._zTime = -1e-8);
                      break;
                    }
                  }
                  i = a;
                }
              else {
                i = this._last;
                for (var x = e < 0 ? e : r; i; ) {
                  if (((a = i._prev), (i._act || x <= i._end) && i._ts && u !== i)) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if ((i.render(i._ts > 0 ? (x - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (x - i._start) * i._ts, t, n), r !== this._time || (!this._ts && !l))) {
                      (u = 0), a && (y += this._zTime = x ? -1e-8 : rt);
                      break;
                    }
                  }
                  i = a;
                }
              }
              if (u && !t && (this.pause(), (u.render(r >= v ? 0 : -1e-8)._zTime = r >= v ? 1 : -1), this._ts)) return (this._start = d), vn(this), this.render(e, t, n);
              this._onUpdate && !t && Wn(this, "onUpdate", !0),
                ((y === g && this._tTime >= this.totalDuration()) || (!y && v)) &&
                  ((d !== this._start && Math.abs(c) === Math.abs(this._ts)) ||
                    this._lock ||
                    ((e || !m) && ((y === g && this._ts > 0) || (!y && this._ts < 0)) && ln(this, 1),
                    t || (e < 0 && !v) || (!y && !v && g) || (Wn(this, y === g && e >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(y < g && this.timeScale() > 0) && this._prom())));
            }
            return this;
          }),
          (n.add = function (e, t) {
            var n = this;
            if ((ft(t) || (t = En(this, t, e)), !(e instanceof vr))) {
              if (bt(e))
                return (
                  e.forEach(function (e) {
                    return n.add(e, t);
                  }),
                  this
                );
              if (ct(e)) return this.addLabel(e, t);
              if (!dt(e)) return this;
              e = Sr.delayedCall(0, e);
            }
            return this !== e ? yn(this, e, t) : this;
          }),
          (n.getChildren = function (e, t, n, r) {
            void 0 === e && (e = !0), void 0 === t && (t = !0), void 0 === n && (n = !0), void 0 === r && (r = -nt);
            for (var i = [], a = this._first; a; ) a._start >= r && (a instanceof Sr ? t && i.push(a) : (n && i.push(a), e && i.push.apply(i, a.getChildren(!0, t, n)))), (a = a._next);
            return i;
          }),
          (n.getById = function (e) {
            for (var t = this.getChildren(1, 1, 1), n = t.length; n--; ) if (t[n].vars.id === e) return t[n];
          }),
          (n.remove = function (e) {
            return ct(e) ? this.removeLabel(e) : dt(e) ? this.killTweensOf(e) : (sn(this, e), e === this._recent && (this._recent = this._last), un(this));
          }),
          (n.totalTime = function (t, n) {
            return arguments.length
              ? ((this._forcing = 1), !this._dp && this._ts && (this._start = Gt(tr.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts))), e.prototype.totalTime.call(this, t, n), (this._forcing = 0), this)
              : this._tTime;
          }),
          (n.addLabel = function (e, t) {
            return (this.labels[e] = En(this, t)), this;
          }),
          (n.removeLabel = function (e) {
            return delete this.labels[e], this;
          }),
          (n.addPause = function (e, t, n) {
            var r = Sr.delayedCall(0, t || It, n);
            return (r.data = "isPause"), (this._hasPause = 1), yn(this, r, En(this, e));
          }),
          (n.removePause = function (e) {
            var t = this._first;
            for (e = En(this, e); t; ) t._start === e && "isPause" === t.data && ln(t), (t = t._next);
          }),
          (n.killTweensOf = function (e, t, n) {
            for (var r = this.getTweensOf(e, n), i = r.length; i--; ) mr !== r[i] && r[i].kill(e, t);
            return this;
          }),
          (n.getTweensOf = function (e, t) {
            for (var n, r = [], i = In(e), a = this._first, o = ft(t); a; )
              a instanceof Sr
                ? Ut(a._targets, i) && (o ? (!mr || (a._initted && a._ts)) && a.globalTime(0) <= t && a.globalTime(a.totalDuration()) > t : !t || a.isActive()) && r.push(a)
                : (n = a.getTweensOf(i, t)).length && r.push.apply(r, n),
                (a = a._next);
            return r;
          }),
          (n.tweenTo = function (e, t) {
            t = t || {};
            var n,
              r = this,
              i = En(r, e),
              a = t,
              o = a.startAt,
              s = a.onStart,
              l = a.onStartParams,
              u = a.immediateRender,
              c = Sr.to(
                r,
                en(
                  {
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: i,
                    overwrite: "auto",
                    duration: t.duration || Math.abs((i - (o && "time" in o ? o.time : r._time)) / r.timeScale()) || rt,
                    onStart: function () {
                      if ((r.pause(), !n)) {
                        var e = t.duration || Math.abs((i - (o && "time" in o ? o.time : r._time)) / r.timeScale());
                        c._dur !== e && Cn(c, e, 0, 1).render(c._time, !0, !0), (n = 1);
                      }
                      s && s.apply(c, l || []);
                    },
                  },
                  t
                )
              );
            return u ? c.render(0) : c;
          }),
          (n.tweenFromTo = function (e, t, n) {
            return this.tweenTo(t, en({ startAt: { time: En(this, e) } }, n));
          }),
          (n.recent = function () {
            return this._recent;
          }),
          (n.nextLabel = function (e) {
            return void 0 === e && (e = this._time), Hn(this, En(this, e));
          }),
          (n.previousLabel = function (e) {
            return void 0 === e && (e = this._time), Hn(this, En(this, e), 1);
          }),
          (n.currentLabel = function (e) {
            return arguments.length ? this.seek(e, !0) : this.previousLabel(this._time + rt);
          }),
          (n.shiftChildren = function (e, t, n) {
            void 0 === n && (n = 0);
            for (var r, i = this._first, a = this.labels; i; ) i._start >= n && ((i._start += e), (i._end += e)), (i = i._next);
            if (t) for (r in a) a[r] >= n && (a[r] += e);
            return un(this);
          }),
          (n.invalidate = function () {
            var t = this._first;
            for (this._lock = 0; t; ) t.invalidate(), (t = t._next);
            return e.prototype.invalidate.call(this);
          }),
          (n.clear = function (e) {
            void 0 === e && (e = !0);
            for (var t, n = this._first; n; ) (t = n._next), this.remove(n), (n = t);
            return this._dp && (this._time = this._tTime = this._pTime = 0), e && (this.labels = {}), un(this);
          }),
          (n.totalDuration = function (e) {
            var t,
              n,
              r,
              i = 0,
              a = this,
              o = a._last,
              s = nt;
            if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -e : e));
            if (a._dirty) {
              for (r = a.parent; o; )
                (t = o._prev),
                  o._dirty && o.totalDuration(),
                  (n = o._start) > s && a._sort && o._ts && !a._lock ? ((a._lock = 1), (yn(a, o, n - o._delay, 1)._lock = 0)) : (s = n),
                  n < 0 && o._ts && ((i -= n), ((!r && !a._dp) || (r && r.smoothChildTiming)) && ((a._start += n / a._ts), (a._time -= n), (a._tTime -= n)), a.shiftChildren(-n, !1, -Infinity), (s = 0)),
                  o._end > i && o._ts && (i = o._end),
                  (o = t);
              Cn(a, a === He && a._time > i ? a._time : i, 1, 1), (a._dirty = 0);
            }
            return a._tDur;
          }),
          (t.updateRoot = function (e) {
            if ((He._ts && (Qt(He, hn(e, He)), (Ge = tr.frame)), tr.frame >= Rt)) {
              Rt += et.autoSleep || 120;
              var t = He._first;
              if ((!t || !t._ts) && et.autoSleep && tr._listeners.length < 2) {
                for (; t && !t._ts; ) t = t._next;
                t || tr.sleep();
              }
            }
          }),
          t
        );
      })(vr);
      en(gr.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var mr,
        yr,
        br = function (e, t, n, r, i, a, o) {
          var s,
            l,
            u,
            c,
            d,
            f,
            p,
            h,
            v = new Fr(this._pt, e, t, 0, 1, zr, null, i),
            g = 0,
            m = 0;
          for (v.b = n, v.e = r, n += "", (p = ~(r += "").indexOf("random(")) && (r = qn(r)), a && (a((h = [n, r]), e, t), (n = h[0]), (r = h[1])), l = n.match(Ct) || []; (s = Ct.exec(r)); )
            (c = s[0]),
              (d = r.substring(g, s.index)),
              u ? (u = (u + 1) % 5) : "rgba(" === d.substr(-5) && (u = 1),
              c !== l[m++] && ((f = parseFloat(l[m - 1]) || 0), (v._pt = { _next: v._pt, p: d || 1 === m ? d : ",", s: f, c: "=" === c.charAt(1) ? Xt(f, c) - f : parseFloat(c) - f, m: u && u < 4 ? Math.round : 0 }), (g = Ct.lastIndex));
          return (v.c = g < r.length ? r.substring(g, r.length) : ""), (v.fp = o), (Tt.test(r) || p) && (v.e = 0), (this._pt = v), v;
        },
        wr = function (e, t, n, r, i, a, o, s, l) {
          dt(r) && (r = r(i || 0, e, a));
          var u,
            c = e[t],
            d = "get" !== n ? n : dt(c) ? (l ? e[t.indexOf("set") || !dt(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e[t]()) : c,
            f = dt(c) ? (l ? Pr : Mr) : Or;
          if ((ct(r) && (~r.indexOf("random(") && (r = qn(r)), "=" === r.charAt(1) && ((u = Xt(d, r) + (Pn(d) || 0)) || 0 === u) && (r = u)), d !== r || yr))
            return isNaN(d * r) || "" === r
              ? (!c && !(t in e) && Pt(t, r), br.call(this, e, t, d, r, f, s || et.stringFilter, l))
              : ((u = new Fr(this._pt, e, t, +d || 0, r - (d || 0), "boolean" == typeof c ? Dr : Ir, 0, f)), l && (u.fp = l), o && u.modifier(o, this, e), (this._pt = u));
        },
        _r = function (e, t, n, r, i, a) {
          var o, s, l, u;
          if (
            Bt[e] &&
            !1 !==
              (o = new Bt[e]()).init(
                i,
                o.rawVars
                  ? t[e]
                  : (function (e, t, n, r, i) {
                      if ((dt(e) && (e = Tr(e, i, t, n, r)), !ht(e) || (e.style && e.nodeType) || bt(e) || yt(e))) return ct(e) ? Tr(e, i, t, n, r) : e;
                      var a,
                        o = {};
                      for (a in e) o[a] = Tr(e[a], i, t, n, r);
                      return o;
                    })(t[e], r, i, a, n),
                n,
                r,
                a
              ) &&
            ((n._pt = s = new Fr(n._pt, i, e, 0, 1, o.render, o, 0, o.priority)), n !== Xe)
          )
            for (l = n._ptLookup[n._targets.indexOf(i)], u = o._props.length; u--; ) l[o._props[u]] = s;
          return o;
        },
        xr = function e(t, n) {
          var r,
            i,
            a,
            o,
            s,
            l,
            u,
            c,
            d,
            f,
            p,
            h,
            v,
            g = t.vars,
            m = g.ease,
            y = g.startAt,
            b = g.immediateRender,
            w = g.lazy,
            _ = g.onUpdate,
            x = g.onUpdateParams,
            C = g.callbackScope,
            T = g.runBackwards,
            k = g.yoyoEase,
            E = g.keyframes,
            S = g.autoRevert,
            O = t._dur,
            M = t._startAt,
            P = t._targets,
            A = t.parent,
            L = A && "nested" === A.data ? A.parent._targets : P,
            I = "auto" === t._overwrite && !Fe,
            D = t.timeline;
          if (
            (D && (!E || !m) && (m = "none"),
            (t._ease = ur(m, tt.ease)),
            (t._yEase = k ? sr(ur(!0 === k ? m : k, tt.ease)) : 0),
            k && t._yoyo && !t._repeat && ((k = t._yEase), (t._yEase = t._ease), (t._ease = k)),
            (t._from = !D && !!g.runBackwards),
            !D || (E && !g.stagger))
          ) {
            if (((h = (c = P[0] ? Wt(P[0]).harness : 0) && g[c.prop]), (r = rn(g, Dt)), M && (ln(M.render(-1, !0)), (M._lazy = 0)), y))
              if (
                (ln((t._startAt = Sr.set(P, en({ data: "isStart", overwrite: !1, parent: A, immediateRender: !0, lazy: vt(w), startAt: null, delay: 0, onUpdate: _, onUpdateParams: x, callbackScope: C, stagger: 0 }, y)))),
                n < 0 && !b && !S && t._startAt.render(-1, !0),
                b)
              ) {
                if ((n > 0 && !S && (t._startAt = 0), O && n <= 0)) return void (n && (t._zTime = n));
              } else !1 === S && (t._startAt = 0);
            else if (T && O)
              if (M) !S && (t._startAt = 0);
              else if (
                (n && (b = !1),
                (a = en({ overwrite: !1, data: "isFromStart", lazy: b && vt(w), immediateRender: b, stagger: 0, parent: A }, r)),
                h && (a[c.prop] = h),
                ln((t._startAt = Sr.set(P, a))),
                n < 0 && t._startAt.render(-1, !0),
                (t._zTime = n),
                b)
              ) {
                if (!n) return;
              } else e(t._startAt, rt);
            for (t._pt = t._ptCache = 0, w = (O && vt(w)) || (w && !O), i = 0; i < P.length; i++) {
              if (
                ((u = (s = P[i])._gsap || Ht(P)[i]._gsap),
                (t._ptLookup[i] = f = {}),
                jt[u.id] && zt.length && Kt(),
                (p = L === P ? i : L.indexOf(s)),
                c &&
                  !1 !== (d = new c()).init(s, h || r, t, p, L) &&
                  ((t._pt = o = new Fr(t._pt, s, d.name, 0, 1, d.render, d, 0, d.priority)),
                  d._props.forEach(function (e) {
                    f[e] = o;
                  }),
                  d.priority && (l = 1)),
                !c || h)
              )
                for (a in r) Bt[a] && (d = _r(a, r, t, p, s, L)) ? d.priority && (l = 1) : (f[a] = o = wr.call(t, s, a, "get", r[a], p, L, 0, g.stringFilter));
              t._op && t._op[i] && t.kill(s, t._op[i]), I && t._pt && ((mr = t), He.killTweensOf(s, f, t.globalTime(n)), (v = !t.parent), (mr = 0)), t._pt && w && (jt[u.id] = 1);
            }
            l && qr(t), t._onInit && t._onInit(t);
          }
          (t._onUpdate = _), (t._initted = (!t._op || t._pt) && !v), E && n <= 0 && D.render(nt, !0, !0);
        },
        Cr = function (e, t, n, r) {
          var i,
            a,
            o = t.ease || r || "power1.inOut";
          if (bt(t))
            (a = n[e] || (n[e] = [])),
              t.forEach(function (e, n) {
                return a.push({ t: (n / (t.length - 1)) * 100, v: e, e: o });
              });
          else for (i in t) (a = n[i] || (n[i] = [])), "ease" === i || a.push({ t: parseFloat(e), v: t[i], e: o });
        },
        Tr = function (e, t, n, r, i) {
          return dt(e) ? e.call(t, n, r, i) : ct(e) && ~e.indexOf("random(") ? qn(e) : e;
        },
        kr = Ft + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
        Er = {};
      Vt(kr + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
        return (Er[e] = 1);
      });
      var Sr = (function (e) {
        function t(t, n, r, i) {
          var a;
          "number" == typeof n && ((r.duration = n), (n = r), (r = null));
          var o,
            s,
            l,
            u,
            c,
            d,
            f,
            p,
            h = (a = e.call(this, i ? n : an(n)) || this).vars,
            v = h.duration,
            g = h.delay,
            m = h.immediateRender,
            y = h.stagger,
            b = h.overwrite,
            w = h.keyframes,
            _ = h.defaults,
            x = h.scrollTrigger,
            C = h.yoyoEase,
            T = n.parent || He,
            k = (bt(t) || yt(t) ? ft(t[0]) : "length" in n) ? [t] : In(t);
          if (((a._targets = k.length ? Ht(k) : At("GSAP target " + t + " not found. https://greensock.com", !et.nullTargetWarn) || []), (a._ptLookup = []), (a._overwrite = b), w || y || mt(v) || mt(g))) {
            if (((n = a.vars), (o = a.timeline = new gr({ data: "nested", defaults: _ || {} })).kill(), (o.parent = o._dp = Re(a)), (o._start = 0), y || mt(v) || mt(g))) {
              if (((u = k.length), (f = y && zn(y)), ht(y))) for (c in y) ~kr.indexOf(c) && (p || (p = {}), (p[c] = y[c]));
              for (s = 0; s < u; s++)
                ((l = rn(n, Er)).stagger = 0),
                  C && (l.yoyoEase = C),
                  p && tn(l, p),
                  (d = k[s]),
                  (l.duration = +Tr(v, Re(a), s, d, k)),
                  (l.delay = (+Tr(g, Re(a), s, d, k) || 0) - a._delay),
                  !y && 1 === u && l.delay && ((a._delay = g = l.delay), (a._start += g), (l.delay = 0)),
                  o.to(d, l, f ? f(s, d, k) : 0),
                  (o._ease = rr.none);
              o.duration() ? (v = g = 0) : (a.timeline = 0);
            } else if (w) {
              an(en(o.vars.defaults, { ease: "none" })), (o._ease = ur(w.ease || n.ease || "none"));
              var E,
                S,
                O,
                M = 0;
              if (bt(w))
                w.forEach(function (e) {
                  return o.to(k, e, ">");
                });
              else {
                for (c in ((l = {}), w)) "ease" === c || "easeEach" === c || Cr(c, w[c], l, w.easeEach);
                for (c in l)
                  for (
                    E = l[c].sort(function (e, t) {
                      return e.t - t.t;
                    }),
                      M = 0,
                      s = 0;
                    s < E.length;
                    s++
                  )
                    ((O = { ease: (S = E[s]).e, duration: ((S.t - (s ? E[s - 1].t : 0)) / 100) * v })[c] = S.v), o.to(k, O, M), (M += O.duration);
                o.duration() < v && o.to({}, { duration: v - o.duration() });
              }
            }
            v || a.duration((v = o.duration()));
          } else a.timeline = 0;
          return (
            !0 !== b || Fe || ((mr = Re(a)), He.killTweensOf(k), (mr = 0)),
            yn(T, Re(a), r),
            n.reversed && a.reverse(),
            n.paused && a.paused(!0),
            (m || (!v && !w && a._start === Gt(T._time) && vt(m) && dn(Re(a)) && "nested" !== T.data)) && ((a._tTime = -1e-8), a.render(Math.max(0, -g))),
            x && bn(Re(a), x),
            a
          );
        }
        qe(t, e);
        var n = t.prototype;
        return (
          (n.render = function (e, t, n) {
            var r,
              i,
              a,
              o,
              s,
              l,
              u,
              c,
              d,
              f = this._time,
              p = this._tDur,
              h = this._dur,
              v = e > p - rt && e >= 0 ? p : e < rt ? 0 : e;
            if (h) {
              if (v !== this._tTime || !e || n || (!this._initted && this._tTime) || (this._startAt && this._zTime < 0 != e < 0)) {
                if (((r = v), (c = this.timeline), this._repeat)) {
                  if (((o = h + this._rDelay), this._repeat < -1 && e < 0)) return this.totalTime(100 * o + e, t, n);
                  if (
                    ((r = Gt(v % o)),
                    v === p ? ((a = this._repeat), (r = h)) : ((a = ~~(v / o)) && a === v / o && ((r = h), a--), r > h && (r = h)),
                    (l = this._yoyo && 1 & a) && ((d = this._yEase), (r = h - r)),
                    (s = pn(this._tTime, o)),
                    r === f && !n && this._initted)
                  )
                    return (this._tTime = v), this;
                  a !== s && (c && this._yEase && lr(c, l), !this.vars.repeatRefresh || l || this._lock || ((this._lock = n = 1), (this.render(Gt(o * a), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (wn(this, e < 0 ? e : r, n, t)) return (this._tTime = 0), this;
                  if (f !== this._time) return this;
                  if (h !== this._dur) return this.render(e, t, n);
                }
                if (
                  ((this._tTime = v),
                  (this._time = r),
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  (this.ratio = u = (d || this._ease)(r / h)),
                  this._from && (this.ratio = u = 1 - u),
                  r && !f && !t && (Wn(this, "onStart"), this._tTime !== v))
                )
                  return this;
                for (i = this._pt; i; ) i.r(u, i.d), (i = i._next);
                (c && c.render(e < 0 ? e : !r && l ? -1e-8 : c._dur * c._ease(r / this._dur), t, n)) || (this._startAt && (this._zTime = e)),
                  this._onUpdate && !t && (e < 0 && this._startAt && this._startAt.render(e, !0, n), Wn(this, "onUpdate")),
                  this._repeat && a !== s && this.vars.onRepeat && !t && this.parent && Wn(this, "onRepeat"),
                  (v !== this._tDur && v) ||
                    this._tTime !== v ||
                    (e < 0 && this._startAt && !this._onUpdate && this._startAt.render(e, !0, !0),
                    (e || !h) && ((v === this._tDur && this._ts > 0) || (!v && this._ts < 0)) && ln(this, 1),
                    t || (e < 0 && !f) || (!v && !f) || (Wn(this, v === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < p && this.timeScale() > 0) && this._prom()));
              }
            } else
              !(function (e, t, n, r) {
                var i,
                  a,
                  o,
                  s = e.ratio,
                  l = t < 0 || (!t && ((!e._start && _n(e) && (e._initted || !xn(e))) || ((e._ts < 0 || e._dp._ts < 0) && !xn(e)))) ? 0 : 1,
                  u = e._rDelay,
                  c = 0;
                if (
                  (u && e._repeat && ((c = Mn(0, e._tDur, t)), (a = pn(c, u)), e._yoyo && 1 & a && (l = 1 - l), a !== pn(e._tTime, u) && ((s = 1 - l), e.vars.repeatRefresh && e._initted && e.invalidate())),
                  l !== s || r || e._zTime === rt || (!t && e._zTime))
                ) {
                  if (!e._initted && wn(e, t, r, n)) return;
                  for (o = e._zTime, e._zTime = t || (n ? rt : 0), n || (n = t && !o), e.ratio = l, e._from && (l = 1 - l), e._time = 0, e._tTime = c, i = e._pt; i; ) i.r(l, i.d), (i = i._next);
                  e._startAt && t < 0 && e._startAt.render(t, !0, !0),
                    e._onUpdate && !n && Wn(e, "onUpdate"),
                    c && e._repeat && !n && e.parent && Wn(e, "onRepeat"),
                    (t >= e._tDur || t < 0) && e.ratio === l && (l && ln(e, 1), n || (Wn(e, l ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
                } else e._zTime || (e._zTime = t);
              })(this, e, t, n);
            return this;
          }),
          (n.targets = function () {
            return this._targets;
          }),
          (n.invalidate = function () {
            return (this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0), (this._ptLookup = []), this.timeline && this.timeline.invalidate(), e.prototype.invalidate.call(this);
          }),
          (n.resetTo = function (e, t, n, r) {
            Ue || tr.wake(), this._ts || this.play();
            var i = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
            return (
              this._initted || xr(this, i),
              (function (e, t, n, r, i, a, o) {
                var s,
                  l,
                  u,
                  c = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                if (!c)
                  for (c = e._ptCache[t] = [], l = e._ptLookup, u = e._targets.length; u--; ) {
                    if ((s = l[u][t]) && s.d && s.d._pt) for (s = s.d._pt; s && s.p !== t; ) s = s._next;
                    if (!s) return (yr = 1), (e.vars[t] = "+=0"), xr(e, o), (yr = 0), 1;
                    c.push(s);
                  }
                for (u = c.length; u--; ) ((s = c[u]).s = (!r && 0 !== r) || i ? s.s + (r || 0) + a * s.c : r), (s.c = n - s.s), s.e && (s.e = Yt(n) + Pn(s.e)), s.b && (s.b = s.s + Pn(s.b));
              })(this, e, t, n, r, this._ease(i / this._dur), i)
                ? this.resetTo(e, t, n, r)
                : (gn(this, 0), this.parent || on(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0))
            );
          }),
          (n.kill = function (e, t) {
            if ((void 0 === t && (t = "all"), !(e || (t && "all" !== t)))) return (this._lazy = this._pt = 0), this.parent ? $n(this) : this;
            if (this.timeline) {
              var n = this.timeline.totalDuration();
              return this.timeline.killTweensOf(e, t, mr && !0 !== mr.vars.overwrite)._first || $n(this), this.parent && n !== this.timeline.totalDuration() && Cn(this, (this._dur * this.timeline._tDur) / n, 0, 1), this;
            }
            var r,
              i,
              a,
              o,
              s,
              l,
              u,
              c = this._targets,
              d = e ? In(e) : c,
              f = this._ptLookup,
              p = this._pt;
            if (
              (!t || "all" === t) &&
              (function (e, t) {
                for (var n = e.length, r = n === t.length; r && n-- && e[n] === t[n]; );
                return n < 0;
              })(c, d)
            )
              return "all" === t && (this._pt = 0), $n(this);
            for (
              r = this._op = this._op || [],
                "all" !== t &&
                  (ct(t) &&
                    ((s = {}),
                    Vt(t, function (e) {
                      return (s[e] = 1);
                    }),
                    (t = s)),
                  (t = (function (e, t) {
                    var n,
                      r,
                      i,
                      a,
                      o = e[0] ? Wt(e[0]).harness : 0,
                      s = o && o.aliases;
                    if (!s) return t;
                    for (r in ((n = tn({}, t)), s)) if ((r in n)) for (i = (a = s[r].split(",")).length; i--; ) n[a[i]] = n[r];
                    return n;
                  })(c, t))),
                u = c.length;
              u--;

            )
              if (~d.indexOf(c[u]))
                for (s in ((i = f[u]), "all" === t ? ((r[u] = t), (o = i), (a = {})) : ((a = r[u] = r[u] || {}), (o = t)), o))
                  (l = i && i[s]) && (("kill" in l.d && !0 !== l.d.kill(s)) || sn(this, l, "_pt"), delete i[s]), "all" !== a && (a[s] = 1);
            return this._initted && !this._pt && p && $n(this), this;
          }),
          (t.to = function (e, n) {
            return new t(e, n, arguments[2]);
          }),
          (t.from = function (e, t) {
            return Sn(1, arguments);
          }),
          (t.delayedCall = function (e, n, r, i) {
            return new t(n, 0, { immediateRender: !1, lazy: !1, overwrite: !1, delay: e, onComplete: n, onReverseComplete: n, onCompleteParams: r, onReverseCompleteParams: r, callbackScope: i });
          }),
          (t.fromTo = function (e, t, n) {
            return Sn(2, arguments);
          }),
          (t.set = function (e, n) {
            return (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(e, n);
          }),
          (t.killTweensOf = function (e, t, n) {
            return He.killTweensOf(e, t, n);
          }),
          t
        );
      })(vr);
      en(Sr.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
        Vt("staggerTo,staggerFrom,staggerFromTo", function (e) {
          Sr[e] = function () {
            var t = new gr(),
              n = An.call(arguments, 0);
            return n.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, n);
          };
        });
      var Or = function (e, t, n) {
          return (e[t] = n);
        },
        Mr = function (e, t, n) {
          return e[t](n);
        },
        Pr = function (e, t, n, r) {
          return e[t](r.fp, n);
        },
        Ar = function (e, t, n) {
          return e.setAttribute(t, n);
        },
        Lr = function (e, t) {
          return dt(e[t]) ? Mr : pt(e[t]) && e.setAttribute ? Ar : Or;
        },
        Ir = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
        },
        Dr = function (e, t) {
          return t.set(t.t, t.p, !!(t.s + t.c * e), t);
        },
        zr = function (e, t) {
          var n = t._pt,
            r = "";
          if (!e && t.b) r = t.b;
          else if (1 === e && t.e) r = t.e;
          else {
            for (; n; ) (r = n.p + (n.m ? n.m(n.s + n.c * e) : Math.round(1e4 * (n.s + n.c * e)) / 1e4) + r), (n = n._next);
            r += t.c;
          }
          t.set(t.t, t.p, r, t);
        },
        jr = function (e, t) {
          for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
        },
        Br = function (e, t, n, r) {
          for (var i, a = this._pt; a; ) (i = a._next), a.p === r && a.modifier(e, t, n), (a = i);
        },
        Nr = function (e) {
          for (var t, n, r = this._pt; r; ) (n = r._next), (r.p === e && !r.op) || r.op === e ? sn(this, r, "_pt") : r.dep || (t = 1), (r = n);
          return !t;
        },
        Rr = function (e, t, n, r) {
          r.mSet(e, t, r.m.call(r.tween, n, r.mt), r);
        },
        qr = function (e) {
          for (var t, n, r, i, a = e._pt; a; ) {
            for (t = a._next, n = r; n && n.pr > a.pr; ) n = n._next;
            (a._prev = n ? n._prev : i) ? (a._prev._next = a) : (r = a), (a._next = n) ? (n._prev = a) : (i = a), (a = t);
          }
          e._pt = r;
        },
        Fr = (function () {
          function e(e, t, n, r, i, a, o, s, l) {
            (this.t = t), (this.s = r), (this.c = i), (this.p = n), (this.r = a || Ir), (this.d = o || this), (this.set = s || Or), (this.pr = l || 0), (this._next = e), e && (e._prev = this);
          }
          return (
            (e.prototype.modifier = function (e, t, n) {
              (this.mSet = this.mSet || this.set), (this.set = Rr), (this.m = e), (this.mt = n), (this.tween = t);
            }),
            e
          );
        })();
      Vt(
        Ft +
          "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
        function (e) {
          return (Dt[e] = 1);
        }
      ),
        (St.TweenMax = St.TweenLite = Sr),
        (St.TimelineLite = St.TimelineMax = gr),
        (He = new gr({ sortChildren: !1, defaults: tt, autoRemoveChildren: !0, id: "root", smoothChildTiming: !0 })),
        (et.stringFilter = er);
      var Hr = {
        registerPlugin: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          t.forEach(function (e) {
            return Vn(e);
          });
        },
        timeline: function (e) {
          return new gr(e);
        },
        getTweensOf: function (e, t) {
          return He.getTweensOf(e, t);
        },
        getProperty: function (e, t, n, r) {
          ct(e) && (e = In(e)[0]);
          var i = Wt(e || {}).get,
            a = n ? Jt : Zt;
          return (
            "native" === n && (n = ""),
            e
              ? t
                ? a(((Bt[t] && Bt[t].get) || i)(e, t, n, r))
                : function (t, n, r) {
                    return a(((Bt[t] && Bt[t].get) || i)(e, t, n, r));
                  }
              : e
          );
        },
        quickSetter: function (e, t, n) {
          if ((e = In(e)).length > 1) {
            var r = e.map(function (e) {
                return Vr.quickSetter(e, t, n);
              }),
              i = r.length;
            return function (e) {
              for (var t = i; t--; ) r[t](e);
            };
          }
          e = e[0] || {};
          var a = Bt[t],
            o = Wt(e),
            s = (o.harness && (o.harness.aliases || {})[t]) || t,
            l = a
              ? function (t) {
                  var r = new a();
                  (Xe._pt = 0), r.init(e, n ? t + n : t, Xe, 0, [e]), r.render(1, r), Xe._pt && jr(1, Xe);
                }
              : o.set(e, s);
          return a
            ? l
            : function (t) {
                return l(e, s, n ? t + n : t, o, 1);
              };
        },
        quickTo: function (e, t, n) {
          var r,
            i = Vr.to(e, tn((((r = {})[t] = "+=0.1"), (r.paused = !0), r), n || {})),
            a = function (e, n, r) {
              return i.resetTo(t, e, n, r);
            };
          return (a.tween = i), a;
        },
        isTweening: function (e) {
          return He.getTweensOf(e, !0).length > 0;
        },
        defaults: function (e) {
          return e && e.ease && (e.ease = ur(e.ease, tt.ease)), nn(tt, e || {});
        },
        config: function (e) {
          return nn(et, e || {});
        },
        registerEffect: function (e) {
          var t = e.name,
            n = e.effect,
            r = e.plugins,
            i = e.defaults,
            a = e.extendTimeline;
          (r || "").split(",").forEach(function (e) {
            return e && !Bt[e] && !St[e] && At(t + " effect requires " + e + " plugin.");
          }),
            (Nt[t] = function (e, t, r) {
              return n(In(e), en(t || {}, i), r);
            }),
            a &&
              (gr.prototype[t] = function (e, n, r) {
                return this.add(Nt[t](e, ht(n) ? n : (r = n) && {}, this), r);
              });
        },
        registerEase: function (e, t) {
          rr[e] = ur(t);
        },
        parseEase: function (e, t) {
          return arguments.length ? ur(e, t) : rr;
        },
        getById: function (e) {
          return He.getById(e);
        },
        exportRoot: function (e, t) {
          void 0 === e && (e = {});
          var n,
            r,
            i = new gr(e);
          for (i.smoothChildTiming = vt(e.smoothChildTiming), He.remove(i), i._dp = 0, i._time = i._tTime = He._time, n = He._first; n; )
            (r = n._next), (!t && !n._dur && n instanceof Sr && n.vars.onComplete === n._targets[0]) || yn(i, n, n._start - n._delay), (n = r);
          return yn(He, i, 0), i;
        },
        utils: {
          wrap: function e(t, n, r) {
            var i = n - t;
            return bt(t)
              ? Rn(t, e(0, t.length), n)
              : On(r, function (e) {
                  return ((i + ((e - t) % i)) % i) + t;
                });
          },
          wrapYoyo: function e(t, n, r) {
            var i = n - t,
              a = 2 * i;
            return bt(t)
              ? Rn(t, e(0, t.length - 1), n)
              : On(r, function (e) {
                  return t + ((e = (a + ((e - t) % a)) % a || 0) > i ? a - e : e);
                });
          },
          distribute: zn,
          random: Nn,
          snap: Bn,
          normalize: function (e, t, n) {
            return Fn(e, t, 0, 1, n);
          },
          getUnit: Pn,
          clamp: function (e, t, n) {
            return On(n, function (n) {
              return Mn(e, t, n);
            });
          },
          splitColor: Un,
          toArray: In,
          selector: function (e) {
            return (
              (e = In(e)[0] || At("Invalid scope") || {}),
              function (t) {
                var n = e.current || e.nativeElement || e;
                return In(t, n.querySelectorAll ? n : n === e ? At("Invalid scope") || Ve.createElement("div") : e);
              }
            );
          },
          mapRange: Fn,
          pipe: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return function (e) {
              return t.reduce(function (e, t) {
                return t(e);
              }, e);
            };
          },
          unitize: function (e, t) {
            return function (n) {
              return e(parseFloat(n)) + (t || Pn(n));
            };
          },
          interpolate: function e(t, n, r, i) {
            var a = isNaN(t + n)
              ? 0
              : function (e) {
                  return (1 - e) * t + e * n;
                };
            if (!a) {
              var o,
                s,
                l,
                u,
                c,
                d = ct(t),
                f = {};
              if ((!0 === r && (i = 1) && (r = null), d)) (t = { p: t }), (n = { p: n });
              else if (bt(t) && !bt(n)) {
                for (l = [], u = t.length, c = u - 2, s = 1; s < u; s++) l.push(e(t[s - 1], t[s]));
                u--,
                  (a = function (e) {
                    e *= u;
                    var t = Math.min(c, ~~e);
                    return l[t](e - t);
                  }),
                  (r = n);
              } else i || (t = tn(bt(t) ? [] : {}, t));
              if (!l) {
                for (o in n) wr.call(f, t, o, "get", n[o]);
                a = function (e) {
                  return jr(e, f) || (d ? t.p : t);
                };
              }
            }
            return On(r, a);
          },
          shuffle: Dn,
        },
        install: Mt,
        effects: Nt,
        ticker: tr,
        updateRoot: gr.updateRoot,
        plugins: Bt,
        globalTimeline: He,
        core: {
          PropTween: Fr,
          globals: Lt,
          Tween: Sr,
          Timeline: gr,
          Animation: vr,
          getCache: Wt,
          _removeLinkedListItem: sn,
          suppressOverwrites: function (e) {
            return (Fe = e);
          },
        },
      };
      Vt("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
        return (Hr[e] = Sr[e]);
      }),
        tr.add(gr.updateRoot),
        (Xe = Hr.to({}, { duration: 0 }));
      var Wr = function (e, t) {
          for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; ) n = n._next;
          return n;
        },
        $r = function (e, t) {
          return {
            name: e,
            rawVars: 1,
            init: function (e, n, r) {
              r._onInit = function (e) {
                var r, i;
                if (
                  (ct(n) &&
                    ((r = {}),
                    Vt(n, function (e) {
                      return (r[e] = 1);
                    }),
                    (n = r)),
                  t)
                ) {
                  for (i in ((r = {}), n)) r[i] = t(n[i]);
                  n = r;
                }
                !(function (e, t) {
                  var n,
                    r,
                    i,
                    a = e._targets;
                  for (n in t) for (r = a.length; r--; ) (i = e._ptLookup[r][n]) && (i = i.d) && (i._pt && (i = Wr(i, n)), i && i.modifier && i.modifier(t[n], e, a[r], n));
                })(e, n);
              };
            },
          };
        },
        Vr =
          Hr.registerPlugin(
            {
              name: "attr",
              init: function (e, t, n, r, i) {
                var a, o;
                for (a in t) (o = this.add(e, "setAttribute", (e.getAttribute(a) || 0) + "", t[a], r, i, 0, 0, a)) && (o.op = a), this._props.push(a);
              },
            },
            {
              name: "endArray",
              init: function (e, t) {
                for (var n = t.length; n--; ) this.add(e, n, e[n] || 0, t[n]);
              },
            },
            $r("roundProps", jn),
            $r("modifiers"),
            $r("snap", Bn)
          ) || Hr;
      (Sr.version = gr.version = Vr.version = "3.10.4"),
        (Ye = 1),
        gt() && nr(),
        rr.Power0,
        rr.Power1,
        rr.Power2,
        rr.Power3,
        rr.Power4,
        rr.Linear,
        rr.Quad,
        rr.Cubic,
        rr.Quart,
        rr.Quint,
        rr.Strong,
        rr.Elastic,
        rr.Back,
        rr.SteppedEase,
        rr.Bounce,
        rr.Sine,
        rr.Expo,
        rr.Circ;
      var Yr,
        Gr,
        Xr,
        Ur,
        Kr,
        Qr,
        Zr,
        Jr = {},
        ei = 180 / Math.PI,
        ti = Math.PI / 180,
        ni = Math.atan2,
        ri = /([A-Z])/g,
        ii = /(left|right|width|margin|padding|x)/i,
        ai = /[\s,\(]\S/,
        oi = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" },
        si = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t);
        },
        li = function (e, t) {
          return t.set(t.t, t.p, 1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u, t);
        },
        ui = function (e, t) {
          return t.set(t.t, t.p, e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b, t);
        },
        ci = function (e, t) {
          var n = t.s + t.c * e;
          t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
        },
        di = function (e, t) {
          return t.set(t.t, t.p, e ? t.e : t.b, t);
        },
        fi = function (e, t) {
          return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
        },
        pi = function (e, t, n) {
          return (e.style[t] = n);
        },
        hi = function (e, t, n) {
          return e.style.setProperty(t, n);
        },
        vi = function (e, t, n) {
          return (e._gsap[t] = n);
        },
        gi = function (e, t, n) {
          return (e._gsap.scaleX = e._gsap.scaleY = n);
        },
        mi = function (e, t, n, r, i) {
          var a = e._gsap;
          (a.scaleX = a.scaleY = n), a.renderTransform(i, a);
        },
        yi = function (e, t, n, r, i) {
          var a = e._gsap;
          (a[t] = n), a.renderTransform(i, a);
        },
        bi = "transform",
        wi = bi + "Origin",
        _i = function (e, t) {
          var n = Gr.createElementNS ? Gr.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Gr.createElement(e);
          return n.style ? n : Gr.createElement(e);
        },
        xi = function e(t, n, r) {
          var i = getComputedStyle(t);
          return i[n] || i.getPropertyValue(n.replace(ri, "-$1").toLowerCase()) || i.getPropertyValue(n) || (!r && e(t, Ti(n) || n, 1)) || "";
        },
        Ci = "O,Moz,ms,Ms,Webkit".split(","),
        Ti = function (e, t, n) {
          var r = (t || Kr).style,
            i = 5;
          if (e in r && !n) return e;
          for (e = e.charAt(0).toUpperCase() + e.substr(1); i-- && !(Ci[i] + e in r); );
          return i < 0 ? null : (3 === i ? "ms" : i >= 0 ? Ci[i] : "") + e;
        },
        ki = function () {
          "undefined" != typeof window &&
            window.document &&
            ((Yr = window),
            (Gr = Yr.document),
            (Xr = Gr.documentElement),
            (Kr = _i("div") || { style: {} }),
            _i("div"),
            (bi = Ti(bi)),
            (wi = bi + "Origin"),
            (Kr.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"),
            (Zr = !!Ti("perspective")),
            (Ur = 1));
        },
        Ei = function e(t) {
          var n,
            r = _i("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
            i = this.parentNode,
            a = this.nextSibling,
            o = this.style.cssText;
          if ((Xr.appendChild(r), r.appendChild(this), (this.style.display = "block"), t))
            try {
              (n = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = e);
            } catch (e) {}
          else this._gsapBBox && (n = this._gsapBBox());
          return i && (a ? i.insertBefore(this, a) : i.appendChild(this)), Xr.removeChild(r), (this.style.cssText = o), n;
        },
        Si = function (e, t) {
          for (var n = t.length; n--; ) if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
        },
        Oi = function (e) {
          var t;
          try {
            t = e.getBBox();
          } catch (n) {
            t = Ei.call(e, !0);
          }
          return (t && (t.width || t.height)) || e.getBBox === Ei || (t = Ei.call(e, !0)), !t || t.width || t.x || t.y ? t : { x: +Si(e, ["x", "cx", "x1"]) || 0, y: +Si(e, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
        },
        Mi = function (e) {
          return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !Oi(e));
        },
        Pi = function (e, t) {
          if (t) {
            var n = e.style;
            t in Jr && t !== wi && (t = bi), n.removeProperty ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) || (t = "-" + t), n.removeProperty(t.replace(ri, "-$1").toLowerCase())) : n.removeAttribute(t);
          }
        },
        Ai = function (e, t, n, r, i, a) {
          var o = new Fr(e._pt, t, n, 0, 1, a ? fi : di);
          return (e._pt = o), (o.b = r), (o.e = i), e._props.push(n), o;
        },
        Li = { deg: 1, rad: 1, turn: 1 },
        Ii = function e(t, n, r, i) {
          var a,
            o,
            s,
            l,
            u = parseFloat(r) || 0,
            c = (r + "").trim().substr((u + "").length) || "px",
            d = Kr.style,
            f = ii.test(n),
            p = "svg" === t.tagName.toLowerCase(),
            h = (p ? "client" : "offset") + (f ? "Width" : "Height"),
            v = 100,
            g = "px" === i,
            m = "%" === i;
          return i === c || !u || Li[i] || Li[c]
            ? u
            : ("px" !== c && !g && (u = e(t, n, r, "px")),
              (l = t.getCTM && Mi(t)),
              (!m && "%" !== c) || (!Jr[n] && !~n.indexOf("adius"))
                ? ((d[f ? "width" : "height"] = v + (g ? c : i)),
                  (o = ~n.indexOf("adius") || ("em" === i && t.appendChild && !p) ? t : t.parentNode),
                  l && (o = (t.ownerSVGElement || {}).parentNode),
                  (o && o !== Gr && o.appendChild) || (o = Gr.body),
                  (s = o._gsap) && m && s.width && f && s.time === tr.time
                    ? Yt((u / s.width) * v)
                    : ((m || "%" === c) && (d.position = xi(t, "position")),
                      o === t && (d.position = "static"),
                      o.appendChild(Kr),
                      (a = Kr[h]),
                      o.removeChild(Kr),
                      (d.position = "absolute"),
                      f && m && (((s = Wt(o)).time = tr.time), (s.width = o[h])),
                      Yt(g ? (a * u) / v : a && u ? (v / a) * u : 0)))
                : ((a = l ? t.getBBox()[f ? "width" : "height"] : t[h]), Yt(m ? (u / a) * v : (u / 100) * a)));
        },
        Di = function (e, t, n, r) {
          var i;
          return (
            Ur || ki(),
            t in oi && "transform" !== t && ~(t = oi[t]).indexOf(",") && (t = t.split(",")[0]),
            Jr[t] && "transform" !== t
              ? ((i = Vi(e, r)), (i = "transformOrigin" !== t ? i[t] : i.svg ? i.origin : Yi(xi(e, wi)) + " " + i.zOrigin + "px"))
              : (!(i = e.style[t]) || "auto" === i || r || ~(i + "").indexOf("calc(")) && (i = (Ni[t] && Ni[t](e, t, n)) || xi(e, t) || $t(e, t) || ("opacity" === t ? 1 : 0)),
            n && !~(i + "").trim().indexOf(" ") ? Ii(e, t, i, n) + n : i
          );
        },
        zi = function (e, t, n, r) {
          if (!n || "none" === n) {
            var i = Ti(t, e, 1),
              a = i && xi(e, i, 1);
            a && a !== n ? ((t = i), (n = a)) : "borderColor" === t && (n = xi(e, "borderTopColor"));
          }
          var o,
            s,
            l,
            u,
            c,
            d,
            f,
            p,
            h,
            v,
            g,
            m = new Fr(this._pt, e.style, t, 0, 1, zr),
            y = 0,
            b = 0;
          if (((m.b = n), (m.e = r), (n += ""), "auto" == (r += "") && ((e.style[t] = r), (r = xi(e, t) || r), (e.style[t] = n)), er((o = [n, r])), (r = o[1]), (l = (n = o[0]).match(xt) || []), (r.match(xt) || []).length)) {
            for (; (s = xt.exec(r)); )
              (f = s[0]),
                (h = r.substring(y, s.index)),
                c ? (c = (c + 1) % 5) : ("rgba(" !== h.substr(-5) && "hsla(" !== h.substr(-5)) || (c = 1),
                f !== (d = l[b++] || "") &&
                  ((u = parseFloat(d) || 0),
                  (g = d.substr((u + "").length)),
                  "=" === f.charAt(1) && (f = Xt(u, f) + g),
                  (p = parseFloat(f)),
                  (v = f.substr((p + "").length)),
                  (y = xt.lastIndex - v.length),
                  v || ((v = v || et.units[t] || g), y === r.length && ((r += v), (m.e += v))),
                  g !== v && (u = Ii(e, t, d, v) || 0),
                  (m._pt = { _next: m._pt, p: h || 1 === b ? h : ",", s: u, c: p - u, m: (c && c < 4) || "zIndex" === t ? Math.round : 0 }));
            m.c = y < r.length ? r.substring(y, r.length) : "";
          } else m.r = "display" === t && "none" === r ? fi : di;
          return Tt.test(r) && (m.e = 0), (this._pt = m), m;
        },
        ji = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
        Bi = function (e, t) {
          if (t.tween && t.tween._time === t.tween._dur) {
            var n,
              r,
              i,
              a = t.t,
              o = a.style,
              s = t.u,
              l = a._gsap;
            if ("all" === s || !0 === s) (o.cssText = ""), (r = 1);
            else for (i = (s = s.split(",")).length; --i > -1; ) (n = s[i]), Jr[n] && ((r = 1), (n = "transformOrigin" === n ? wi : bi)), Pi(a, n);
            r && (Pi(a, bi), l && (l.svg && a.removeAttribute("transform"), Vi(a, 1), (l.uncache = 1)));
          }
        },
        Ni = {
          clearProps: function (e, t, n, r, i) {
            if ("isFromStart" !== i.data) {
              var a = (e._pt = new Fr(e._pt, t, n, 0, 0, Bi));
              return (a.u = r), (a.pr = -10), (a.tween = i), e._props.push(n), 1;
            }
          },
        },
        Ri = [1, 0, 0, 1, 0, 0],
        qi = {},
        Fi = function (e) {
          return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
        },
        Hi = function (e) {
          var t = xi(e, bi);
          return Fi(t) ? Ri : t.substr(7).match(_t).map(Yt);
        },
        Wi = function (e, t) {
          var n,
            r,
            i,
            a,
            o = e._gsap || Wt(e),
            s = e.style,
            l = Hi(e);
          return o.svg && e.getAttribute("transform")
            ? "1,0,0,1,0,0" === (l = [(i = e.transform.baseVal.consolidate().matrix).a, i.b, i.c, i.d, i.e, i.f]).join(",")
              ? Ri
              : l
            : (l !== Ri ||
                e.offsetParent ||
                e === Xr ||
                o.svg ||
                ((i = s.display),
                (s.display = "block"),
                ((n = e.parentNode) && e.offsetParent) || ((a = 1), (r = e.nextSibling), Xr.appendChild(e)),
                (l = Hi(e)),
                i ? (s.display = i) : Pi(e, "display"),
                a && (r ? n.insertBefore(e, r) : n ? n.appendChild(e) : Xr.removeChild(e))),
              t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
        },
        $i = function (e, t, n, r, i, a) {
          var o,
            s,
            l,
            u = e._gsap,
            c = i || Wi(e, !0),
            d = u.xOrigin || 0,
            f = u.yOrigin || 0,
            p = u.xOffset || 0,
            h = u.yOffset || 0,
            v = c[0],
            g = c[1],
            m = c[2],
            y = c[3],
            b = c[4],
            w = c[5],
            _ = t.split(" "),
            x = parseFloat(_[0]) || 0,
            C = parseFloat(_[1]) || 0;
          n
            ? c !== Ri && (s = v * y - g * m) && ((l = x * (-g / s) + C * (v / s) - (v * w - g * b) / s), (x = x * (y / s) + C * (-m / s) + (m * w - y * b) / s), (C = l))
            : ((x = (o = Oi(e)).x + (~_[0].indexOf("%") ? (x / 100) * o.width : x)), (C = o.y + (~(_[1] || _[0]).indexOf("%") ? (C / 100) * o.height : C))),
            r || (!1 !== r && u.smooth) ? ((b = x - d), (w = C - f), (u.xOffset = p + (b * v + w * m) - b), (u.yOffset = h + (b * g + w * y) - w)) : (u.xOffset = u.yOffset = 0),
            (u.xOrigin = x),
            (u.yOrigin = C),
            (u.smooth = !!r),
            (u.origin = t),
            (u.originIsAbsolute = !!n),
            (e.style[wi] = "0px 0px"),
            a && (Ai(a, u, "xOrigin", d, x), Ai(a, u, "yOrigin", f, C), Ai(a, u, "xOffset", p, u.xOffset), Ai(a, u, "yOffset", h, u.yOffset)),
            e.setAttribute("data-svg-origin", x + " " + C);
        },
        Vi = function (e, t) {
          var n = e._gsap || new hr(e);
          if ("x" in n && !t && !n.uncache) return n;
          var r,
            i,
            a,
            o,
            s,
            l,
            u,
            c,
            d,
            f,
            p,
            h,
            v,
            g,
            m,
            y,
            b,
            w,
            _,
            x,
            C,
            T,
            k,
            E,
            S,
            O,
            M,
            P,
            A,
            L,
            I,
            D,
            z = e.style,
            j = n.scaleX < 0,
            B = "px",
            N = "deg",
            R = xi(e, wi) || "0";
          return (
            (r = i = a = l = u = c = d = f = p = 0),
            (o = s = 1),
            (n.svg = !(!e.getCTM || !Mi(e))),
            (g = Wi(e, n.svg)),
            n.svg && ((E = (!n.uncache || "0px 0px" === R) && !t && e.getAttribute("data-svg-origin")), $i(e, E || R, !!E || n.originIsAbsolute, !1 !== n.smooth, g)),
            (h = n.xOrigin || 0),
            (v = n.yOrigin || 0),
            g !== Ri &&
              ((w = g[0]),
              (_ = g[1]),
              (x = g[2]),
              (C = g[3]),
              (r = T = g[4]),
              (i = k = g[5]),
              6 === g.length
                ? ((o = Math.sqrt(w * w + _ * _)),
                  (s = Math.sqrt(C * C + x * x)),
                  (l = w || _ ? ni(_, w) * ei : 0),
                  (d = x || C ? ni(x, C) * ei + l : 0) && (s *= Math.abs(Math.cos(d * ti))),
                  n.svg && ((r -= h - (h * w + v * x)), (i -= v - (h * _ + v * C))))
                : ((D = g[6]),
                  (L = g[7]),
                  (M = g[8]),
                  (P = g[9]),
                  (A = g[10]),
                  (I = g[11]),
                  (r = g[12]),
                  (i = g[13]),
                  (a = g[14]),
                  (u = (m = ni(D, A)) * ei),
                  m && ((E = T * (y = Math.cos(-m)) + M * (b = Math.sin(-m))), (S = k * y + P * b), (O = D * y + A * b), (M = T * -b + M * y), (P = k * -b + P * y), (A = D * -b + A * y), (I = L * -b + I * y), (T = E), (k = S), (D = O)),
                  (c = (m = ni(-x, A)) * ei),
                  m && ((y = Math.cos(-m)), (I = C * (b = Math.sin(-m)) + I * y), (w = E = w * y - M * b), (_ = S = _ * y - P * b), (x = O = x * y - A * b)),
                  (l = (m = ni(_, w)) * ei),
                  m && ((E = w * (y = Math.cos(m)) + _ * (b = Math.sin(m))), (S = T * y + k * b), (_ = _ * y - w * b), (k = k * y - T * b), (w = E), (T = S)),
                  u && Math.abs(u) + Math.abs(l) > 359.9 && ((u = l = 0), (c = 180 - c)),
                  (o = Yt(Math.sqrt(w * w + _ * _ + x * x))),
                  (s = Yt(Math.sqrt(k * k + D * D))),
                  (m = ni(T, k)),
                  (d = Math.abs(m) > 2e-4 ? m * ei : 0),
                  (p = I ? 1 / (I < 0 ? -I : I) : 0)),
              n.svg && ((E = e.getAttribute("transform")), (n.forceCSS = e.setAttribute("transform", "") || !Fi(xi(e, bi))), E && e.setAttribute("transform", E))),
            Math.abs(d) > 90 && Math.abs(d) < 270 && (j ? ((o *= -1), (d += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180)) : ((s *= -1), (d += d <= 0 ? 180 : -180))),
            (t = t || n.uncache),
            (n.x = r - ((n.xPercent = r && ((!t && n.xPercent) || (Math.round(e.offsetWidth / 2) === Math.round(-r) ? -50 : 0))) ? (e.offsetWidth * n.xPercent) / 100 : 0) + B),
            (n.y = i - ((n.yPercent = i && ((!t && n.yPercent) || (Math.round(e.offsetHeight / 2) === Math.round(-i) ? -50 : 0))) ? (e.offsetHeight * n.yPercent) / 100 : 0) + B),
            (n.z = a + B),
            (n.scaleX = Yt(o)),
            (n.scaleY = Yt(s)),
            (n.rotation = Yt(l) + N),
            (n.rotationX = Yt(u) + N),
            (n.rotationY = Yt(c) + N),
            (n.skewX = d + N),
            (n.skewY = f + N),
            (n.transformPerspective = p + B),
            (n.zOrigin = parseFloat(R.split(" ")[2]) || 0) && (z[wi] = Yi(R)),
            (n.xOffset = n.yOffset = 0),
            (n.force3D = et.force3D),
            (n.renderTransform = n.svg ? Ji : Zr ? Zi : Xi),
            (n.uncache = 0),
            n
          );
        },
        Yi = function (e) {
          return (e = e.split(" "))[0] + " " + e[1];
        },
        Gi = function (e, t, n) {
          var r = Pn(t);
          return Yt(parseFloat(t) + parseFloat(Ii(e, "x", n + "px", r))) + r;
        },
        Xi = function (e, t) {
          (t.z = "0px"), (t.rotationY = t.rotationX = "0deg"), (t.force3D = 0), Zi(e, t);
        },
        Ui = "0deg",
        Ki = "0px",
        Qi = ") ",
        Zi = function (e, t) {
          var n = t || this,
            r = n.xPercent,
            i = n.yPercent,
            a = n.x,
            o = n.y,
            s = n.z,
            l = n.rotation,
            u = n.rotationY,
            c = n.rotationX,
            d = n.skewX,
            f = n.skewY,
            p = n.scaleX,
            h = n.scaleY,
            v = n.transformPerspective,
            g = n.force3D,
            m = n.target,
            y = n.zOrigin,
            b = "",
            w = ("auto" === g && e && 1 !== e) || !0 === g;
          if (y && (c !== Ui || u !== Ui)) {
            var _,
              x = parseFloat(u) * ti,
              C = Math.sin(x),
              T = Math.cos(x);
            (x = parseFloat(c) * ti), (_ = Math.cos(x)), (a = Gi(m, a, C * _ * -y)), (o = Gi(m, o, -Math.sin(x) * -y)), (s = Gi(m, s, T * _ * -y + y));
          }
          v !== Ki && (b += "perspective(" + v + Qi),
            (r || i) && (b += "translate(" + r + "%, " + i + "%) "),
            (w || a !== Ki || o !== Ki || s !== Ki) && (b += s !== Ki || w ? "translate3d(" + a + ", " + o + ", " + s + ") " : "translate(" + a + ", " + o + Qi),
            l !== Ui && (b += "rotate(" + l + Qi),
            u !== Ui && (b += "rotateY(" + u + Qi),
            c !== Ui && (b += "rotateX(" + c + Qi),
            (d === Ui && f === Ui) || (b += "skew(" + d + ", " + f + Qi),
            (1 === p && 1 === h) || (b += "scale(" + p + ", " + h + Qi),
            (m.style[bi] = b || "translate(0, 0)");
        },
        Ji = function (e, t) {
          var n,
            r,
            i,
            a,
            o,
            s = t || this,
            l = s.xPercent,
            u = s.yPercent,
            c = s.x,
            d = s.y,
            f = s.rotation,
            p = s.skewX,
            h = s.skewY,
            v = s.scaleX,
            g = s.scaleY,
            m = s.target,
            y = s.xOrigin,
            b = s.yOrigin,
            w = s.xOffset,
            _ = s.yOffset,
            x = s.forceCSS,
            C = parseFloat(c),
            T = parseFloat(d);
          (f = parseFloat(f)),
            (p = parseFloat(p)),
            (h = parseFloat(h)) && ((p += h = parseFloat(h)), (f += h)),
            f || p
              ? ((f *= ti),
                (p *= ti),
                (n = Math.cos(f) * v),
                (r = Math.sin(f) * v),
                (i = Math.sin(f - p) * -g),
                (a = Math.cos(f - p) * g),
                p && ((h *= ti), (o = Math.tan(p - h)), (i *= o = Math.sqrt(1 + o * o)), (a *= o), h && ((o = Math.tan(h)), (n *= o = Math.sqrt(1 + o * o)), (r *= o))),
                (n = Yt(n)),
                (r = Yt(r)),
                (i = Yt(i)),
                (a = Yt(a)))
              : ((n = v), (a = g), (r = i = 0)),
            ((C && !~(c + "").indexOf("px")) || (T && !~(d + "").indexOf("px"))) && ((C = Ii(m, "x", c, "px")), (T = Ii(m, "y", d, "px"))),
            (y || b || w || _) && ((C = Yt(C + y - (y * n + b * i) + w)), (T = Yt(T + b - (y * r + b * a) + _))),
            (l || u) && ((o = m.getBBox()), (C = Yt(C + (l / 100) * o.width)), (T = Yt(T + (u / 100) * o.height))),
            (o = "matrix(" + n + "," + r + "," + i + "," + a + "," + C + "," + T + ")"),
            m.setAttribute("transform", o),
            x && (m.style[bi] = o);
        },
        ea = function (e, t, n, r, i) {
          var a,
            o,
            s = 360,
            l = ct(i),
            u = parseFloat(i) * (l && ~i.indexOf("rad") ? ei : 1) - r,
            c = r + u + "deg";
          return (
            l && ("short" === (a = i.split("_")[1]) && (u %= s) != u % 180 && (u += u < 0 ? s : -360), "cw" === a && u < 0 ? (u = ((u + 36e9) % s) - ~~(u / s) * s) : "ccw" === a && u > 0 && (u = ((u - 36e9) % s) - ~~(u / s) * s)),
            (e._pt = o = new Fr(e._pt, t, n, r, u, li)),
            (o.e = c),
            (o.u = "deg"),
            e._props.push(n),
            o
          );
        },
        ta = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        na = function (e, t, n) {
          var r,
            i,
            a,
            o,
            s,
            l,
            u,
            c = ta({}, n._gsap),
            d = n.style;
          for (i in (c.svg
            ? ((a = n.getAttribute("transform")), n.setAttribute("transform", ""), (d[bi] = t), (r = Vi(n, 1)), Pi(n, bi), n.setAttribute("transform", a))
            : ((a = getComputedStyle(n)[bi]), (d[bi] = t), (r = Vi(n, 1)), (d[bi] = a)),
          Jr))
            (a = c[i]) !== (o = r[i]) &&
              "perspective,force3D,transformOrigin,svgOrigin".indexOf(i) < 0 &&
              ((s = Pn(a) !== (u = Pn(o)) ? Ii(n, i, a, u) : parseFloat(a)), (l = parseFloat(o)), (e._pt = new Fr(e._pt, r, i, s, l - s, si)), (e._pt.u = u || 0), e._props.push(i));
          ta(r, c);
        };
      Vt("padding,margin,Width,Radius", function (e, t) {
        var n = "Top",
          r = "Right",
          i = "Bottom",
          a = "Left",
          o = (t < 3 ? [n, r, i, a] : [n + a, n + r, i + r, i + a]).map(function (n) {
            return t < 2 ? e + n : "border" + n + e;
          });
        Ni[t > 1 ? "border" + e : e] = function (e, t, n, r, i) {
          var a, s;
          if (arguments.length < 4)
            return (
              (a = o.map(function (t) {
                return Di(e, t, n);
              })),
              5 === (s = a.join(" ")).split(a[0]).length ? a[0] : s
            );
          (a = (r + "").split(" ")),
            (s = {}),
            o.forEach(function (e, t) {
              return (s[e] = a[t] = a[t] || a[((t - 1) / 2) | 0]);
            }),
            e.init(t, s, i);
        };
      });
      var ra,
        ia,
        aa = {
          name: "css",
          register: ki,
          targetTest: function (e) {
            return e.style && e.nodeType;
          },
          init: function (e, t, n, r, i) {
            var a,
              o,
              s,
              l,
              u,
              c,
              d,
              f,
              p,
              h,
              v,
              g,
              m,
              y,
              b,
              w,
              _,
              x,
              C,
              T = this._props,
              k = e.style,
              E = n.vars.startAt;
            for (d in (Ur || ki(), t))
              if ("autoRound" !== d && ((o = t[d]), !Bt[d] || !_r(d, t, n, r, e, i)))
                if (((u = typeof o), (c = Ni[d]), "function" === u && (u = typeof (o = o.call(n, r, e, i))), "string" === u && ~o.indexOf("random(") && (o = qn(o)), c)) c(this, e, d, o, n) && (b = 1);
                else if ("--" === d.substr(0, 2))
                  (a = (getComputedStyle(e).getPropertyValue(d) + "").trim()),
                    (o += ""),
                    (Zn.lastIndex = 0),
                    Zn.test(a) || ((f = Pn(a)), (p = Pn(o))),
                    p ? f !== p && (a = Ii(e, d, a, p) + p) : f && (o += f),
                    this.add(k, "setProperty", a, o, r, i, 0, 0, d),
                    T.push(d);
                else if ("undefined" !== u) {
                  if (
                    (E && d in E
                      ? ((a = "function" == typeof E[d] ? E[d].call(n, r, e, i) : E[d]), ct(a) && ~a.indexOf("random(") && (a = qn(a)), Pn(a + "") || (a += et.units[d] || Pn(Di(e, d)) || ""), "=" === (a + "").charAt(1) && (a = Di(e, d)))
                      : (a = Di(e, d)),
                    (l = parseFloat(a)),
                    (h = "string" === u && "=" === o.charAt(1) && o.substr(0, 2)) && (o = o.substr(2)),
                    (s = parseFloat(o)),
                    d in oi &&
                      ("autoAlpha" === d && (1 === l && "hidden" === Di(e, "visibility") && s && (l = 0), Ai(this, k, "visibility", l ? "inherit" : "hidden", s ? "inherit" : "hidden", !s)),
                      "scale" !== d && "transform" !== d && ~(d = oi[d]).indexOf(",") && (d = d.split(",")[0])),
                    (v = d in Jr))
                  )
                    if (
                      (g || (((m = e._gsap).renderTransform && !t.parseTransform) || Vi(e, t.parseTransform), (y = !1 !== t.smoothOrigin && m.smooth), ((g = this._pt = new Fr(this._pt, k, bi, 0, 1, m.renderTransform, m, 0, -1)).dep = 1)),
                      "scale" === d)
                    )
                      (this._pt = new Fr(this._pt, m, "scaleY", m.scaleY, (h ? Xt(m.scaleY, h + s) : s) - m.scaleY || 0)), T.push("scaleY", d), (d += "X");
                    else {
                      if ("transformOrigin" === d) {
                        (_ = void 0),
                          (x = void 0),
                          (C = void 0),
                          (_ = (w = o).split(" ")),
                          (x = _[0]),
                          (C = _[1] || "50%"),
                          ("top" !== x && "bottom" !== x && "left" !== C && "right" !== C) || ((w = x), (x = C), (C = w)),
                          (_[0] = ji[x] || x),
                          (_[1] = ji[C] || C),
                          (o = _.join(" ")),
                          m.svg ? $i(e, o, 0, y, 0, this) : ((p = parseFloat(o.split(" ")[2]) || 0) !== m.zOrigin && Ai(this, m, "zOrigin", m.zOrigin, p), Ai(this, k, d, Yi(a), Yi(o)));
                        continue;
                      }
                      if ("svgOrigin" === d) {
                        $i(e, o, 1, y, 0, this);
                        continue;
                      }
                      if (d in qi) {
                        ea(this, m, d, l, h ? Xt(l, h + o) : o);
                        continue;
                      }
                      if ("smoothOrigin" === d) {
                        Ai(this, m, "smooth", m.smooth, o);
                        continue;
                      }
                      if ("force3D" === d) {
                        m[d] = o;
                        continue;
                      }
                      if ("transform" === d) {
                        na(this, o, e);
                        continue;
                      }
                    }
                  else d in k || (d = Ti(d) || d);
                  if (v || ((s || 0 === s) && (l || 0 === l) && !ai.test(o) && d in k))
                    s || (s = 0),
                      (f = (a + "").substr((l + "").length)) !== (p = Pn(o) || (d in et.units ? et.units[d] : f)) && (l = Ii(e, d, a, p)),
                      (this._pt = new Fr(this._pt, v ? m : k, d, l, (h ? Xt(l, h + s) : s) - l, v || ("px" !== p && "zIndex" !== d) || !1 === t.autoRound ? si : ci)),
                      (this._pt.u = p || 0),
                      f !== p && "%" !== p && ((this._pt.b = a), (this._pt.r = ui));
                  else if (d in k) zi.call(this, e, d, a, h ? h + o : o);
                  else {
                    if (!(d in e)) {
                      Pt(d, o);
                      continue;
                    }
                    this.add(e, d, a || e[d], h ? h + o : o, r, i);
                  }
                  T.push(d);
                }
            b && qr(this);
          },
          get: Di,
          aliases: oi,
          getSetter: function (e, t, n) {
            var r = oi[t];
            return (
              r && r.indexOf(",") < 0 && (t = r),
              t in Jr && t !== wi && (e._gsap.x || Di(e, "x")) ? (n && Qr === n ? ("scale" === t ? gi : vi) : (Qr = n || {}) && ("scale" === t ? mi : yi)) : e.style && !pt(e.style[t]) ? pi : ~t.indexOf("-") ? hi : Lr(e, t)
            );
          },
          core: { _removeProperty: Pi, _getMatrix: Wi },
        };
      (Vr.utils.checkPrefix = Ti),
        (ia = Vt("x,y,z,scale,scaleX,scaleY,xPercent,yPercent" + "," + (ra = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function (e) {
          Jr[e] = 1;
        })),
        Vt(ra, function (e) {
          (et.units[e] = "deg"), (qi[e] = 1);
        }),
        (oi[ia[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + ra),
        Vt("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function (e) {
          var t = e.split(":");
          oi[t[1]] = ia[t[0]];
        }),
        Vt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (e) {
          et.units[e] = "px";
        }),
        Vr.registerPlugin(aa);
      var oa = Vr.registerPlugin(aa) || Vr;
      function sa(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      oa.core.Tween;
      var la,
        ua,
        ca,
        da,
        fa,
        pa,
        ha,
        va,
        ga,
        ma,
        ya,
        ba,
        wa = function () {
          return la || ("undefined" != typeof window && (la = window.gsap) && la.registerPlugin && la);
        },
        _a = 1,
        xa = [],
        Ca = [],
        Ta = [],
        ka = Date.now,
        Ea = function (e, t) {
          return t;
        },
        Sa = function (e, t) {
          return ~Ta.indexOf(e) && Ta[Ta.indexOf(e) + 1][t];
        },
        Oa = function (e) {
          return !!~ma.indexOf(e);
        },
        Ma = function (e, t, n, r, i) {
          return e.addEventListener(t, n, { passive: !r, capture: !!i });
        },
        Pa = function (e, t, n, r) {
          return e.removeEventListener(t, n, !!r);
        },
        Aa = function () {
          return (ya && ya.isPressed) || Ca.cache++;
        },
        La = function (e, t) {
          var n = function n(r) {
            if (r || 0 === r) {
              _a && (ca.history.scrollRestoration = "manual");
              var i = ya && ya.isPressed;
              (r = n.v = Math.round(r) || (ya && ya.iOS ? 1 : 0)), e(r), (n.cacheID = Ca.cache), i && Ea("ss", r);
            } else (t || Ca.cache !== n.cacheID || Ea("ref")) && ((n.cacheID = Ca.cache), (n.v = e()));
            return n.v + n.offset;
          };
          return (n.offset = 0), e && n;
        },
        Ia = {
          s: "scrollLeft",
          p: "left",
          p2: "Left",
          os: "right",
          os2: "Right",
          d: "width",
          d2: "Width",
          a: "x",
          sc: La(function (e) {
            return arguments.length ? ca.scrollTo(e, Da.sc()) : ca.pageXOffset || da.scrollLeft || fa.scrollLeft || pa.scrollLeft || 0;
          }),
        },
        Da = {
          s: "scrollTop",
          p: "top",
          p2: "Top",
          os: "bottom",
          os2: "Bottom",
          d: "height",
          d2: "Height",
          a: "y",
          op: Ia,
          sc: La(function (e) {
            return arguments.length ? ca.scrollTo(Ia.sc(), e) : ca.pageYOffset || da.scrollTop || fa.scrollTop || pa.scrollTop || 0;
          }),
        },
        za = function (e) {
          return la.utils.toArray(e)[0] || ("string" == typeof e && !1 !== la.config().nullTargetWarn ? console.warn("Element not found:", e) : null);
        },
        ja = function (e, t) {
          var n = t.s,
            r = t.sc,
            i = Ca.indexOf(e),
            a = r === Da.sc ? 1 : 2;
          return (
            !~i && (i = Ca.push(e) - 1),
            Ca[i + a] ||
              (Ca[i + a] =
                La(Sa(e, n), !0) ||
                (Oa(e)
                  ? r
                  : La(function (t) {
                      return arguments.length ? (e[n] = t) : e[n];
                    })))
          );
        },
        Ba = function (e, t, n) {
          var r = e,
            i = e,
            a = ka(),
            o = a,
            s = t || 50,
            l = Math.max(500, 3 * s),
            u = function (e, t) {
              var l = ka();
              t || l - a > s ? ((i = r), (r = e), (o = a), (a = l)) : n ? (r += e) : (r = i + ((e - i) / (l - o)) * (a - o));
            };
          return {
            update: u,
            reset: function () {
              (i = r = n ? 0 : r), (o = a = 0);
            },
            getVelocity: function (e) {
              var t = o,
                s = i,
                c = ka();
              return (e || 0 === e) && e !== r && u(e), a === o || c - o > l ? 0 : ((r + (n ? s : -s)) / ((n ? c : a) - t)) * 1e3;
            },
          };
        },
        Na = function (e, t) {
          return t && !e._gsapAllow && e.preventDefault(), e.changedTouches ? e.changedTouches[0] : e;
        },
        Ra = function (e) {
          var t = Math.max.apply(Math, e),
            n = Math.min.apply(Math, e);
          return Math.abs(t) >= Math.abs(n) ? t : n;
        },
        qa = function () {
          var e, t, n, r;
          (ga = la.core.globals().ScrollTrigger) &&
            ga.core &&
            ((e = ga.core),
            (t = e.bridge || {}),
            (n = e._scrollers),
            (r = e._proxies),
            n.push.apply(n, Ca),
            r.push.apply(r, Ta),
            (Ca = n),
            (Ta = r),
            (Ea = function (e, n) {
              return t[e](n);
            }));
        },
        Fa = function (e) {
          return (
            (la = e || wa()) &&
              "undefined" != typeof document &&
              document.body &&
              ((ca = window),
              (da = document),
              (fa = da.documentElement),
              (pa = da.body),
              (ma = [ca, da, fa, pa]),
              la.utils.clamp,
              (va = "onpointerenter" in pa ? "pointer" : "mouse"),
              (ha = Ha.isTouch = ca.matchMedia && ca.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in ca || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0),
              (ba = Ha.eventTypes = ("ontouchstart" in fa ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in fa ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(",")),
              setTimeout(function () {
                return (_a = 0);
              }, 500),
              qa(),
              (ua = 1)),
            ua
          );
        };
      (Ia.op = Da), (Ca.cache = 0);
      var Ha = (function () {
        function e(e) {
          this.init(e);
        }
        var t, n;
        return (
          (e.prototype.init = function (e) {
            ua || Fa(la) || console.warn("Please gsap.registerPlugin(Observer)"), ga || qa();
            var t = e.tolerance,
              n = e.dragMinimum,
              r = e.type,
              i = e.target,
              a = e.lineHeight,
              o = e.debounce,
              s = e.preventDefault,
              l = e.onStop,
              u = e.onStopDelay,
              c = e.ignore,
              d = e.wheelSpeed,
              f = e.event,
              p = e.onDragStart,
              h = e.onDragEnd,
              v = e.onDrag,
              g = e.onPress,
              m = e.onRelease,
              y = e.onRight,
              b = e.onLeft,
              w = e.onUp,
              _ = e.onDown,
              x = e.onChangeX,
              C = e.onChangeY,
              T = e.onChange,
              k = e.onToggleX,
              E = e.onToggleY,
              S = e.onHover,
              O = e.onHoverEnd,
              M = e.onMove,
              P = e.ignoreCheck,
              A = e.isNormalizer,
              L = e.onGestureStart,
              I = e.onGestureEnd,
              D = e.onWheel,
              z = e.onEnable,
              j = e.onDisable,
              B = e.onClick,
              N = e.scrollSpeed,
              R = e.capture,
              q = e.allowClicks,
              F = e.lockAxis,
              H = e.onLockAxis;
            (this.target = i = za(i) || fa),
              (this.vars = e),
              c && (c = la.utils.toArray(c)),
              (t = t || 0),
              (n = n || 0),
              (d = d || 1),
              (N = N || 1),
              (r = r || "wheel,touch,pointer"),
              (o = !1 !== o),
              a || (a = parseFloat(ca.getComputedStyle(pa).lineHeight) || 22);
            var W,
              $,
              V,
              Y,
              G,
              X,
              U,
              K = this,
              Q = 0,
              Z = 0,
              J = ja(i, Ia),
              ee = ja(i, Da),
              te = J(),
              ne = ee(),
              re = ~r.indexOf("touch") && !~r.indexOf("pointer") && "pointerdown" === ba[0],
              ie = Oa(i),
              ae = i.ownerDocument || da,
              oe = [0, 0, 0],
              se = [0, 0, 0],
              le = 0,
              ue = function () {
                return (le = ka());
              },
              ce = function (e, t) {
                return ((K.event = e) && c && ~c.indexOf(e.target)) || (t && re && "touch" !== e.pointerType) || (P && P(e, t));
              },
              de = function () {
                var e = (K.deltaX = Ra(oe)),
                  n = (K.deltaY = Ra(se)),
                  r = Math.abs(e) >= t,
                  i = Math.abs(n) >= t;
                T && (r || i) && T(K, e, n, oe, se),
                  r && (y && K.deltaX > 0 && y(K), b && K.deltaX < 0 && b(K), x && x(K), k && K.deltaX < 0 != Q < 0 && k(K), (Q = K.deltaX), (oe[0] = oe[1] = oe[2] = 0)),
                  i && (_ && K.deltaY > 0 && _(K), w && K.deltaY < 0 && w(K), C && C(K), E && K.deltaY < 0 != Z < 0 && E(K), (Z = K.deltaY), (se[0] = se[1] = se[2] = 0)),
                  (Y || V) && (M && M(K), H && X && H(K), V && (v(K), (V = !1)), (Y = X = !1)),
                  G && (D(K), (G = !1)),
                  (W = 0);
              },
              fe = function (e, t, n) {
                (oe[n] += e), (se[n] += t), K._vx.update(e), K._vy.update(t), o ? W || (W = requestAnimationFrame(de)) : de();
              },
              pe = function (e, t) {
                "y" !== U && ((oe[2] += e), K._vx.update(e, !0)),
                  "x" !== U && ((se[2] += t), K._vy.update(t, !0)),
                  F && !U && ((K.axis = U = Math.abs(e) > Math.abs(t) ? "x" : "y"), (X = !0)),
                  o ? W || (W = requestAnimationFrame(de)) : de();
              },
              he = function (e) {
                if (!ce(e, 1)) {
                  var t = (e = Na(e, s)).clientX,
                    r = e.clientY,
                    i = t - K.x,
                    a = r - K.y,
                    o = K.isDragging;
                  (K.x = t), (K.y = r), (o || Math.abs(K.startX - t) >= n || Math.abs(K.startY - r) >= n) && (v && (V = !0), o || (K.isDragging = !0), pe(i, a), o || (p && p(K)));
                }
              },
              ve = (K.onPress = function (e) {
                ce(e, 1) ||
                  ((K.axis = U = null),
                  $.pause(),
                  (K.isPressed = !0),
                  (e = Na(e)),
                  (Q = Z = 0),
                  (K.startX = K.x = e.clientX),
                  (K.startY = K.y = e.clientY),
                  K._vx.reset(),
                  K._vy.reset(),
                  Ma(A ? i : ae, ba[1], he, s, !0),
                  (K.deltaX = K.deltaY = 0),
                  g && g(K));
              }),
              ge = function (e) {
                if (!ce(e, 1)) {
                  Pa(A ? i : ae, ba[1], he, !0);
                  var t = K.isDragging && (Math.abs(K.x - K.startX) > 3 || Math.abs(K.y - K.startY) > 3),
                    n = Na(e);
                  t ||
                    (K._vx.reset(),
                    K._vy.reset(),
                    s &&
                      q &&
                      la.delayedCall(0.08, function () {
                        if (ka() - le > 300 && !e.defaultPrevented)
                          if (e.target.click) e.target.click();
                          else if (ae.createEvent) {
                            var t = ae.createEvent("MouseEvents");
                            t.initMouseEvent("click", !0, !0, ca, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null), e.target.dispatchEvent(t);
                          }
                      })),
                    (K.isDragging = K.isGesturing = K.isPressed = !1),
                    l && !A && $.restart(!0),
                    h && t && h(K),
                    m && m(K, t);
                }
              },
              me = function (e) {
                return e.touches && e.touches.length > 1 && (K.isGesturing = !0) && L(e, K.isDragging);
              },
              ye = function () {
                return (K.isGesturing = !1) || I(K);
              },
              be = function (e) {
                if (!ce(e)) {
                  var t = J(),
                    n = ee();
                  fe((t - te) * N, (n - ne) * N, 1), (te = t), (ne = n), l && $.restart(!0);
                }
              },
              we = function (e) {
                if (!ce(e)) {
                  (e = Na(e, s)), D && (G = !0);
                  var t = (1 === e.deltaMode ? a : 2 === e.deltaMode ? ca.innerHeight : 1) * d;
                  fe(e.deltaX * t, e.deltaY * t, 0), l && !A && $.restart(!0);
                }
              },
              _e = function (e) {
                if (!ce(e)) {
                  var t = e.clientX,
                    n = e.clientY,
                    r = t - K.x,
                    i = n - K.y;
                  (K.x = t), (K.y = n), (Y = !0), (r || i) && pe(r, i);
                }
              },
              xe = function (e) {
                (K.event = e), S(K);
              },
              Ce = function (e) {
                (K.event = e), O(K);
              },
              Te = function (e) {
                return ce(e) || (Na(e, s) && B(K));
              };
            ($ = K._dc = la
              .delayedCall(u || 0.25, function () {
                K._vx.reset(), K._vy.reset(), $.pause(), l && l(K);
              })
              .pause()),
              (K.deltaX = K.deltaY = 0),
              (K._vx = Ba(0, 50, !0)),
              (K._vy = Ba(0, 50, !0)),
              (K.scrollX = J),
              (K.scrollY = ee),
              (K.isDragging = K.isGesturing = K.isPressed = !1),
              (K.enable = function (e) {
                return (
                  K.isEnabled ||
                    (Ma(ie ? ae : i, "scroll", Aa),
                    r.indexOf("scroll") >= 0 && Ma(ie ? ae : i, "scroll", be, s, R),
                    r.indexOf("wheel") >= 0 && Ma(i, "wheel", we, s, R),
                    ((r.indexOf("touch") >= 0 && ha) || r.indexOf("pointer") >= 0) &&
                      (Ma(i, ba[0], ve, s, R),
                      Ma(ae, ba[2], ge),
                      Ma(ae, ba[3], ge),
                      q && Ma(i, "click", ue, !1, !0),
                      B && Ma(i, "click", Te),
                      L && Ma(ae, "gesturestart", me),
                      I && Ma(ae, "gestureend", ye),
                      S && Ma(i, va + "enter", xe),
                      O && Ma(i, va + "leave", Ce),
                      M && Ma(i, va + "move", _e)),
                    (K.isEnabled = !0),
                    e && e.type && ve(e),
                    z && z(K)),
                  K
                );
              }),
              (K.disable = function () {
                K.isEnabled &&
                  (xa.filter(function (e) {
                    return e !== K && Oa(e.target);
                  }).length || Pa(ie ? ae : i, "scroll", Aa),
                  K.isPressed && (K._vx.reset(), K._vy.reset(), Pa(A ? i : ae, ba[1], he, !0)),
                  Pa(ie ? ae : i, "scroll", be, R),
                  Pa(i, "wheel", we, R),
                  Pa(i, ba[0], ve, R),
                  Pa(ae, ba[2], ge),
                  Pa(ae, ba[3], ge),
                  Pa(i, "click", ue, !0),
                  Pa(i, "click", Te),
                  Pa(ae, "gesturestart", me),
                  Pa(ae, "gestureend", ye),
                  Pa(i, va + "enter", xe),
                  Pa(i, va + "leave", Ce),
                  Pa(i, va + "move", _e),
                  (K.isEnabled = K.isPressed = K.isDragging = !1),
                  j && j(K));
              }),
              (K.kill = function () {
                K.disable();
                var e = xa.indexOf(K);
                e >= 0 && xa.splice(e, 1), ya === K && (ya = 0);
              }),
              xa.push(K),
              A && Oa(i) && (ya = K),
              K.enable(f);
          }),
          (t = e),
          (n = [
            {
              key: "velocityX",
              get: function () {
                return this._vx.getVelocity();
              },
            },
            {
              key: "velocityY",
              get: function () {
                return this._vy.getVelocity();
              },
            },
          ]) && sa(t.prototype, n),
          e
        );
      })();
      (Ha.version = "3.10.4"),
        (Ha.create = function (e) {
          return new Ha(e);
        }),
        (Ha.register = Fa),
        (Ha.getAll = function () {
          return xa.slice();
        }),
        (Ha.getById = function (e) {
          return xa.filter(function (t) {
            return t.vars.id === e;
          })[0];
        }),
        wa() && la.registerPlugin(Ha);
      var Wa,
        $a,
        Va,
        Ya,
        Ga,
        Xa,
        Ua,
        Ka,
        Qa,
        Za,
        Ja,
        eo,
        to,
        no,
        ro,
        io,
        ao,
        oo,
        so,
        lo,
        uo,
        co,
        fo,
        po,
        ho,
        vo,
        go,
        mo,
        yo,
        bo,
        wo,
        _o,
        xo,
        Co = 1,
        To = Date.now,
        ko = To(),
        Eo = 0,
        So = 0,
        Oo = function () {
          return (no = 1);
        },
        Mo = function () {
          return (no = 0);
        },
        Po = function (e) {
          return e;
        },
        Ao = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        Lo = function () {
          return "undefined" != typeof window;
        },
        Io = function () {
          return Wa || (Lo() && (Wa = window.gsap) && Wa.registerPlugin && Wa);
        },
        Do = function (e) {
          return !!~Ua.indexOf(e);
        },
        zo = function (e) {
          return (
            Sa(e, "getBoundingClientRect") ||
            (Do(e)
              ? function () {
                  return ($s.width = Va.innerWidth), ($s.height = Va.innerHeight), $s;
                }
              : function () {
                  return rs(e);
                })
          );
        },
        jo = function (e, t) {
          var n = t.s,
            r = t.d2,
            i = t.d,
            a = t.a;
          return (n = "scroll" + r) && (a = Sa(e, n)) ? a() - zo(e)()[i] : Do(e) ? (Ga[n] || Xa[n]) - (Va["inner" + r] || Ga["client" + r] || Xa["client" + r]) : e[n] - e["offset" + r];
        },
        Bo = function (e, t) {
          for (var n = 0; n < so.length; n += 3) (!t || ~t.indexOf(so[n + 1])) && e(so[n], so[n + 1], so[n + 2]);
        },
        No = function (e) {
          return "string" == typeof e;
        },
        Ro = function (e) {
          return "function" == typeof e;
        },
        qo = function (e) {
          return "number" == typeof e;
        },
        Fo = function (e) {
          return "object" == typeof e;
        },
        Ho = function (e) {
          return Ro(e) && e();
        },
        Wo = function (e, t) {
          return function () {
            var n = Ho(e),
              r = Ho(t);
            return function () {
              Ho(n), Ho(r);
            };
          };
        },
        $o = function (e, t, n) {
          return e && e.progress(t ? 0 : 1) && n && e.pause();
        },
        Vo = function (e, t) {
          if (e.enabled) {
            var n = t(e);
            n && n.totalTime && (e.callbackAnimation = n);
          }
        },
        Yo = Math.abs,
        Go = "right",
        Xo = "bottom",
        Uo = "width",
        Ko = "height",
        Qo = "padding",
        Zo = "margin",
        Jo = "Width",
        es = "px",
        ts = function (e) {
          return Va.getComputedStyle(e);
        },
        ns = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        rs = function (e, t) {
          var n = t && "matrix(1, 0, 0, 1, 0, 0)" !== ts(e)[ro] && Wa.to(e, { x: 0, y: 0, xPercent: 0, yPercent: 0, rotation: 0, rotationX: 0, rotationY: 0, scale: 1, skewX: 0, skewY: 0 }).progress(1),
            r = e.getBoundingClientRect();
          return n && n.progress(0).kill(), r;
        },
        is = function (e, t) {
          var n = t.d2;
          return e["offset" + n] || e["client" + n] || 0;
        },
        as = function (e) {
          var t,
            n = [],
            r = e.labels,
            i = e.duration();
          for (t in r) n.push(r[t] / i);
          return n;
        },
        os = function (e) {
          var t = Wa.utils.snap(e),
            n =
              Array.isArray(e) &&
              e.slice(0).sort(function (e, t) {
                return e - t;
              });
          return n
            ? function (e, r, i) {
                var a;
                if ((void 0 === i && (i = 0.001), !r)) return t(e);
                if (r > 0) {
                  for (e -= i, a = 0; a < n.length; a++) if (n[a] >= e) return n[a];
                  return n[a - 1];
                }
                for (a = n.length, e += i; a--; ) if (n[a] <= e) return n[a];
                return n[0];
              }
            : function (n, r, i) {
                void 0 === i && (i = 0.001);
                var a = t(n);
                return !r || Math.abs(a - n) < i || a - n < 0 == r < 0 ? a : t(r < 0 ? n - e : n + e);
              };
        },
        ss = function (e, t, n, r) {
          return n.split(",").forEach(function (n) {
            return e(t, n, r);
          });
        },
        ls = function (e, t, n, r, i) {
          return e.addEventListener(t, n, { passive: !r, capture: !!i });
        },
        us = function (e, t, n, r) {
          return e.removeEventListener(t, n, !!r);
        },
        cs = function (e, t, n) {
          return n && n.wheelHandler && e(t, "wheel", n);
        },
        ds = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" },
        fs = { toggleActions: "play", anticipatePin: 0 },
        ps = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
        hs = function (e, t) {
          if (No(e)) {
            var n = e.indexOf("="),
              r = ~n ? +(e.charAt(n - 1) + 1) * parseFloat(e.substr(n + 1)) : 0;
            ~n && (e.indexOf("%") > n && (r *= t / 100), (e = e.substr(0, n - 1))), (e = r + (e in ps ? ps[e] * t : ~e.indexOf("%") ? (parseFloat(e) * t) / 100 : parseFloat(e) || 0));
          }
          return e;
        },
        vs = function (e, t, n, r, i, a, o, s) {
          var l = i.startColor,
            u = i.endColor,
            c = i.fontSize,
            d = i.indent,
            f = i.fontWeight,
            p = Ya.createElement("div"),
            h = Do(n) || "fixed" === Sa(n, "pinType"),
            v = -1 !== e.indexOf("scroller"),
            g = h ? Xa : n,
            m = -1 !== e.indexOf("start"),
            y = m ? l : u,
            b = "border-color:" + y + ";font-size:" + c + ";color:" + y + ";font-weight:" + f + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
          return (
            (b += "position:" + ((v || s) && h ? "fixed;" : "absolute;")),
            (v || s || !h) && (b += (r === Da ? Go : Xo) + ":" + (a + parseFloat(d)) + "px;"),
            o && (b += "box-sizing:border-box;text-align:left;width:" + o.offsetWidth + "px;"),
            (p._isStart = m),
            p.setAttribute("class", "gsap-marker-" + e + (t ? " marker-" + t : "")),
            (p.style.cssText = b),
            (p.innerText = t || 0 === t ? e + "-" + t : e),
            g.children[0] ? g.insertBefore(p, g.children[0]) : g.appendChild(p),
            (p._offset = p["offset" + r.op.d2]),
            gs(p, 0, r, m),
            p
          );
        },
        gs = function (e, t, n, r) {
          var i = { display: "block" },
            a = n[r ? "os2" : "p2"],
            o = n[r ? "p2" : "os2"];
          (e._isFlipped = r), (i[n.a + "Percent"] = r ? -100 : 0), (i[n.a] = r ? "1px" : 0), (i["border" + a + Jo] = 1), (i["border" + o + Jo] = 0), (i[n.p] = t + "px"), Wa.set(e, i);
        },
        ms = [],
        ys = {},
        bs = function () {
          return To() - Eo > 34 && Bs();
        },
        ws = function () {
          (!fo || !fo.isPressed || fo.startX > Xa.clientWidth) && (Ca.cache++, yo || (yo = requestAnimationFrame(Bs)), Eo || Os("scrollStart"), (Eo = To()));
        },
        _s = function () {
          (vo = Va.innerWidth), (ho = Va.innerHeight);
        },
        xs = function () {
          Ca.cache++, !to && !co && !Ya.fullscreenElement && !Ya.webkitFullscreenElement && (!po || vo !== Va.innerWidth || Math.abs(Va.innerHeight - ho) > 0.25 * Va.innerHeight) && Ka.restart(!0);
        },
        Cs = {},
        Ts = [],
        ks = [],
        Es = function (e) {
          var t,
            n = Wa.ticker.frame,
            r = [],
            i = 0;
          if (wo !== n || Co) {
            for (As(); i < ks.length; i += 4) (t = Va.matchMedia(ks[i]).matches) !== ks[i + 3] && ((ks[i + 3] = t), t ? r.push(i) : As(1, ks[i]) || (Ro(ks[i + 2]) && ks[i + 2]()));
            for (Ps(), i = 0; i < r.length; i++) (t = r[i]), (bo = ks[t]), (ks[t + 2] = ks[t + 1](e));
            (bo = 0), $a && Ds(0, 1), (wo = n), Os("matchMedia");
          }
        },
        Ss = function e() {
          return us(Us, "scrollEnd", e) || Ds(!0);
        },
        Os = function (e) {
          return (
            (Cs[e] &&
              Cs[e].map(function (e) {
                return e();
              })) ||
            Ts
          );
        },
        Ms = [],
        Ps = function (e) {
          for (var t = 0; t < Ms.length; t += 5) (e && Ms[t + 4] !== e) || ((Ms[t].style.cssText = Ms[t + 1]), Ms[t].getBBox && Ms[t].setAttribute("transform", Ms[t + 2] || ""), (Ms[t + 3].uncache = 1));
        },
        As = function (e, t) {
          var n;
          for (io = 0; io < ms.length; io++) (n = ms[io]), (t && n.media !== t) || (e ? n.kill(1) : n.revert());
          t && Ps(t), t || Os("revert");
        },
        Ls = function () {
          return (
            Ca.cache++ &&
            Ca.forEach(function (e) {
              return "function" == typeof e && (e.rec = 0);
            })
          );
        },
        Is = 0,
        Ds = function (e, t) {
          if (!Eo || e) {
            _o = !0;
            var n = Os("refreshInit");
            lo && Us.sort(),
              t || As(),
              ms.slice(0).forEach(function (e) {
                return e.refresh();
              }),
              ms.forEach(function (e) {
                return "max" === e.vars.end && e.setPositions(e.start, jo(e.scroller, e._dir));
              }),
              n.forEach(function (e) {
                return e && e.render && e.render(-1);
              }),
              Ls(),
              Ka.pause(),
              Is++,
              (_o = !1),
              Os("refresh");
          } else ls(Us, "scrollEnd", Ss);
        },
        zs = 0,
        js = 1,
        Bs = function () {
          if (!_o) {
            (Us.isUpdating = !0), xo && xo.update(0);
            var e = ms.length,
              t = To(),
              n = t - ko >= 50,
              r = e && ms[0].scroll();
            if (((js = zs > r ? -1 : 1), (zs = r), n && (Eo && !no && t - Eo > 200 && ((Eo = 0), Os("scrollEnd")), (Ja = ko), (ko = t)), js < 0)) {
              for (io = e; io-- > 0; ) ms[io] && ms[io].update(0, n);
              js = 1;
            } else for (io = 0; io < e; io++) ms[io] && ms[io].update(0, n);
            Us.isUpdating = !1;
          }
          yo = 0;
        },
        Ns = [
          "left",
          "top",
          Xo,
          Go,
          "marginBottom",
          "marginRight",
          "marginTop",
          "marginLeft",
          "display",
          "flexShrink",
          "float",
          "zIndex",
          "gridColumnStart",
          "gridColumnEnd",
          "gridRowStart",
          "gridRowEnd",
          "gridArea",
          "justifySelf",
          "alignSelf",
          "placeSelf",
          "order",
        ],
        Rs = Ns.concat([Uo, Ko, "boxSizing", "maxWidth", "maxHeight", "position", Zo, Qo, "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"]),
        qs = function (e, t, n, r) {
          if (e.parentNode !== t) {
            for (var i, a = Ns.length, o = t.style, s = e.style; a--; ) o[(i = Ns[a])] = n[i];
            (o.position = "absolute" === n.position ? "absolute" : "relative"),
              "inline" === n.display && (o.display = "inline-block"),
              (s.bottom = s.right = o.flexBasis = "auto"),
              (o.overflow = "visible"),
              (o.boxSizing = "border-box"),
              (o.width = is(e, Ia) + es),
              (o.height = is(e, Da) + es),
              (o.padding = s.margin = s.top = s.left = "0"),
              Hs(r),
              (s.width = s.maxWidth = n.width),
              (s.height = s.maxHeight = n.height),
              (s.padding = n.padding),
              e.parentNode.insertBefore(t, e),
              t.appendChild(e);
          }
        },
        Fs = /([A-Z])/g,
        Hs = function (e) {
          if (e) {
            var t,
              n,
              r = e.t.style,
              i = e.length,
              a = 0;
            for ((e.t._gsap || Wa.core.getCache(e.t)).uncache = 1; a < i; a += 2) (n = e[a + 1]), (t = e[a]), n ? (r[t] = n) : r[t] && r.removeProperty(t.replace(Fs, "-$1").toLowerCase());
          }
        },
        Ws = function (e) {
          for (var t = Rs.length, n = e.style, r = [], i = 0; i < t; i++) r.push(Rs[i], n[Rs[i]]);
          return (r.t = e), r;
        },
        $s = { left: 0, top: 0 },
        Vs = function (e, t, n, r, i, a, o, s, l, u, c, d, f) {
          Ro(e) && (e = e(s)), No(e) && "max" === e.substr(0, 3) && (e = d + ("=" === e.charAt(4) ? hs("0" + e.substr(3), n) : 0));
          var p,
            h,
            v,
            g = f ? f.time() : 0;
          if ((f && f.seek(0), qo(e))) o && gs(o, n, r, !0);
          else {
            Ro(t) && (t = t(s));
            var m,
              y,
              b,
              w,
              _ = e.split(" ");
            (v = za(t) || Xa),
              ((m = rs(v) || {}) && (m.left || m.top)) || "none" !== ts(v).display || ((w = v.style.display), (v.style.display = "block"), (m = rs(v)), w ? (v.style.display = w) : v.style.removeProperty("display")),
              (y = hs(_[0], m[r.d])),
              (b = hs(_[1] || "0", n)),
              (e = m[r.p] - l[r.p] - u + y + i - b),
              o && gs(o, b, r, n - b < 20 || (o._isStart && b > 20)),
              (n -= n - b);
          }
          if (a) {
            var x = e + n,
              C = a._isStart;
            (p = "scroll" + r.d2), gs(a, x, r, (C && x > 20) || (!C && (c ? Math.max(Xa[p], Ga[p]) : a.parentNode[p]) <= x + 1)), c && ((l = rs(o)), c && (a.style[r.op.p] = l[r.op.p] - r.op.m - a._offset + es));
          }
          return f && v && ((p = rs(v)), f.seek(d), (h = rs(v)), (f._caScrollDist = p[r.p] - h[r.p]), (e = (e / f._caScrollDist) * d)), f && f.seek(g), f ? e : Math.round(e);
        },
        Ys = /(webkit|moz|length|cssText|inset)/i,
        Gs = function (e, t, n, r) {
          if (e.parentNode !== t) {
            var i,
              a,
              o = e.style;
            if (t === Xa) {
              for (i in ((e._stOrig = o.cssText), (a = ts(e)))) +i || Ys.test(i) || !a[i] || "string" != typeof o[i] || "0" === i || (o[i] = a[i]);
              (o.top = n), (o.left = r);
            } else o.cssText = e._stOrig;
            (Wa.core.getCache(e).uncache = 1), t.appendChild(e);
          }
        },
        Xs = function (e, t) {
          var n,
            r,
            i = ja(e, t),
            a = "_scroll" + t.p2,
            o = function t(o, s, l, u, c) {
              var d = t.tween,
                f = s.onComplete,
                p = {};
              return (
                (l = l || i()),
                (c = (u && c) || 0),
                (u = u || o - l),
                d && d.kill(),
                (n = Math.round(l)),
                (s[a] = o),
                (s.modifiers = p),
                (p[a] = function (e) {
                  return (e = Ao(i())) !== n && e !== r && Math.abs(e - n) > 2 && Math.abs(e - r) > 2 ? (d.kill(), (t.tween = 0)) : (e = l + u * d.ratio + c * d.ratio * d.ratio), (r = n), (n = Ao(e));
                }),
                (s.onComplete = function () {
                  (t.tween = 0), f && f.call(d);
                }),
                (d = t.tween = Wa.to(e, s))
              );
            };
          return (
            (e[a] = i),
            (i.wheelHandler = function () {
              return o.tween && o.tween.kill() && (o.tween = 0);
            }),
            ls(e, "wheel", i.wheelHandler),
            o
          );
        },
        Us = (function () {
          function e(t, n) {
            $a || e.register(Wa) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), this.init(t, n);
          }
          return (
            (e.prototype.init = function (t, n) {
              if (((this.progress = this.start = 0), this.vars && this.kill(!0, !0), So)) {
                var r,
                  i,
                  a,
                  o,
                  s,
                  l,
                  u,
                  c,
                  d,
                  f,
                  p,
                  h,
                  v,
                  g,
                  m,
                  y,
                  b,
                  w,
                  _,
                  x,
                  C,
                  T,
                  k,
                  E,
                  S,
                  O,
                  M,
                  P,
                  A,
                  L,
                  I,
                  D,
                  z,
                  j,
                  B,
                  N,
                  R,
                  q,
                  F,
                  H,
                  W,
                  $ = (t = ns(No(t) || qo(t) || t.nodeType ? { trigger: t } : t, fs)),
                  V = $.onUpdate,
                  Y = $.toggleClass,
                  G = $.id,
                  X = $.onToggle,
                  U = $.onRefresh,
                  K = $.scrub,
                  Q = $.trigger,
                  Z = $.pin,
                  J = $.pinSpacing,
                  ee = $.invalidateOnRefresh,
                  te = $.anticipatePin,
                  ne = $.onScrubComplete,
                  re = $.onSnapComplete,
                  ie = $.once,
                  ae = $.snap,
                  oe = $.pinReparent,
                  se = $.pinSpacer,
                  le = $.containerAnimation,
                  ue = $.fastScrollEnd,
                  ce = $.preventOverlaps,
                  de = t.horizontal || (t.containerAnimation && !1 !== t.horizontal) ? Ia : Da,
                  fe = !K && 0 !== K,
                  pe = za(t.scroller || Va),
                  he = Wa.core.getCache(pe),
                  ve = Do(pe),
                  ge = "fixed" === ("pinType" in t ? t.pinType : Sa(pe, "pinType") || (ve && "fixed")),
                  me = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
                  ye = fe && t.toggleActions.split(" "),
                  be = "markers" in t ? t.markers : fs.markers,
                  we = ve ? 0 : parseFloat(ts(pe)["border" + de.p2 + Jo]) || 0,
                  _e = this,
                  xe =
                    t.onRefreshInit &&
                    function () {
                      return t.onRefreshInit(_e);
                    },
                  Ce = (function (e, t, n) {
                    var r = n.d,
                      i = n.d2,
                      a = n.a;
                    return (a = Sa(e, "getBoundingClientRect"))
                      ? function () {
                          return a()[r];
                        }
                      : function () {
                          return (t ? Va["inner" + i] : e["client" + i]) || 0;
                        };
                  })(pe, ve, de),
                  Te = (function (e, t) {
                    return !t || ~Ta.indexOf(e)
                      ? zo(e)
                      : function () {
                          return $s;
                        };
                  })(pe, ve),
                  ke = 0,
                  Ee = 0,
                  Se = ja(pe, de);
                if (
                  ((_e.media = bo),
                  (_e._dir = de),
                  (te *= 45),
                  (_e.scroller = pe),
                  (_e.scroll = le ? le.time.bind(le) : Se),
                  (o = Se()),
                  (_e.vars = t),
                  (n = n || t.animation),
                  "refreshPriority" in t && ((lo = 1), -9999 === t.refreshPriority && (xo = _e)),
                  (he.tweenScroll = he.tweenScroll || { top: Xs(pe, Da), left: Xs(pe, Ia) }),
                  (_e.tweenTo = r = he.tweenScroll[de.p]),
                  (_e.scrubDuration = function (e) {
                    (I = qo(e) && e)
                      ? L
                        ? L.duration(e)
                        : (L = Wa.to(n, {
                            ease: "expo",
                            totalProgress: "+=0.001",
                            duration: I,
                            paused: !0,
                            onComplete: function () {
                              return ne && ne(_e);
                            },
                          }))
                      : (L && L.progress(1).kill(), (L = 0));
                  }),
                  n &&
                    ((n.vars.lazy = !1),
                    n._initted || (!1 !== n.vars.immediateRender && !1 !== t.immediateRender && n.render(0, !0, !0)),
                    (_e.animation = n.pause()),
                    (n.scrollTrigger = _e),
                    _e.scrubDuration(K),
                    (P = 0),
                    G || (G = n.vars.id)),
                  ms.push(_e),
                  ae &&
                    ((Fo(ae) && !ae.push) || (ae = { snapTo: ae }),
                    "scrollBehavior" in Xa.style && Wa.set(ve ? [Xa, Ga] : pe, { scrollBehavior: "auto" }),
                    (a = Ro(ae.snapTo)
                      ? ae.snapTo
                      : "labels" === ae.snapTo
                      ? (function (e) {
                          return function (t) {
                            return Wa.utils.snap(as(e), t);
                          };
                        })(n)
                      : "labelsDirectional" === ae.snapTo
                      ? ((F = n),
                        function (e, t) {
                          return os(as(F))(e, t.direction);
                        })
                      : !1 !== ae.directional
                      ? function (e, t) {
                          return os(ae.snapTo)(e, To() - Ee < 500 ? 0 : t.direction);
                        }
                      : Wa.utils.snap(ae.snapTo)),
                    (D = ae.duration || { min: 0.1, max: 2 }),
                    (D = Fo(D) ? Za(D.min, D.max) : Za(D, D)),
                    (z = Wa.delayedCall(ae.delay || I / 2 || 0.1, function () {
                      var e = Se(),
                        t = To() - Ee < 500,
                        i = r.tween;
                      if (!(t || Math.abs(_e.getVelocity()) < 10) || i || no || ke === e) _e.isActive && ke !== e && z.restart(!0);
                      else {
                        var o = (e - l) / v,
                          s = n && !fe ? n.totalProgress() : o,
                          c = t ? 0 : ((s - A) / (To() - Ja)) * 1e3 || 0,
                          d = Wa.utils.clamp(-o, 1 - o, (Yo(c / 2) * c) / 0.185),
                          f = o + (!1 === ae.inertia ? 0 : d),
                          p = Za(0, 1, a(f, _e)),
                          h = Math.round(l + p * v),
                          g = ae,
                          m = g.onStart,
                          y = g.onInterrupt,
                          b = g.onComplete;
                        if (e <= u && e >= l && h !== e) {
                          if (i && !i._initted && i.data <= Yo(h - e)) return;
                          !1 === ae.inertia && (d = p - o),
                            r(
                              h,
                              {
                                duration: D(Yo((0.185 * Math.max(Yo(f - s), Yo(p - s))) / c / 0.05 || 0)),
                                ease: ae.ease || "power3",
                                data: Yo(h - e),
                                onInterrupt: function () {
                                  return z.restart(!0) && y && y(_e);
                                },
                                onComplete: function () {
                                  _e.update(), (ke = Se()), (P = A = n && !fe ? n.totalProgress() : _e.progress), re && re(_e), b && b(_e);
                                },
                              },
                              e,
                              d * v,
                              h - e - d * v
                            ),
                            m && m(_e, r.tween);
                        }
                      }
                    }).pause())),
                  G && (ys[G] = _e),
                  (q = (Q = _e.trigger = za(Q || Z)) && Q._gsap && Q._gsap.stRevert) && (q = q(_e)),
                  (Z = !0 === Z ? Q : za(Z)),
                  No(Y) && (Y = { targets: Q, className: Y }),
                  Z &&
                    (!1 === J || J === Zo || (J = !(!J && "flex" === ts(Z.parentNode).display) && Qo),
                    (_e.pin = Z),
                    !1 !== t.force3D && Wa.set(Z, { force3D: !0 }),
                    (i = Wa.core.getCache(Z)).spacer
                      ? (g = i.pinState)
                      : (se && ((se = za(se)) && !se.nodeType && (se = se.current || se.nativeElement), (i.spacerIsNative = !!se), se && (i.spacerState = Ws(se))),
                        (i.spacer = b = se || Ya.createElement("div")),
                        b.classList.add("pin-spacer"),
                        G && b.classList.add("pin-spacer-" + G),
                        (i.pinState = g = Ws(Z))),
                    (_e.spacer = b = i.spacer),
                    (M = ts(Z)),
                    (k = M[J + de.os2]),
                    (_ = Wa.getProperty(Z)),
                    (x = Wa.quickSetter(Z, de.a, es)),
                    qs(Z, b, M),
                    (y = Ws(Z))),
                  be)
                ) {
                  (h = Fo(be) ? ns(be, ds) : ds), (f = vs("scroller-start", G, pe, de, h, 0)), (p = vs("scroller-end", G, pe, de, h, 0, f)), (w = f["offset" + de.op.d2]);
                  var Oe = za(Sa(pe, "content") || pe);
                  (c = this.markerStart = vs("start", G, Oe, de, h, w, 0, le)),
                    (d = this.markerEnd = vs("end", G, Oe, de, h, w, 0, le)),
                    le && (R = Wa.quickSetter([c, d], de.a, es)),
                    ge ||
                      (Ta.length && !0 === Sa(pe, "fixedMarkers")) ||
                      ((W = ts((H = ve ? Xa : pe)).position), (H.style.position = "absolute" === W || "fixed" === W ? W : "relative"), Wa.set([f, p], { force3D: !0 }), (S = Wa.quickSetter(f, de.a, es)), (O = Wa.quickSetter(p, de.a, es)));
                }
                if (le) {
                  var Me = le.vars.onUpdate,
                    Pe = le.vars.onUpdateParams;
                  le.eventCallback("onUpdate", function () {
                    _e.update(0, 0, 1), Me && Me.apply(Pe || []);
                  });
                }
                (_e.previous = function () {
                  return ms[ms.indexOf(_e) - 1];
                }),
                  (_e.next = function () {
                    return ms[ms.indexOf(_e) + 1];
                  }),
                  (_e.revert = function (e) {
                    var t = !1 !== e || !_e.enabled,
                      r = to;
                    t !== _e.isReverted &&
                      (t && (_e.scroll.rec || !to || !_o || (_e.scroll.rec = Se()), (B = Math.max(Se(), _e.scroll.rec || 0)), (j = _e.progress), (N = n && n.progress())),
                      c &&
                        [c, d, f, p].forEach(function (e) {
                          return (e.style.display = t ? "none" : "block");
                        }),
                      t && (to = 1),
                      _e.update(t),
                      (to = r),
                      Z &&
                        (t
                          ? (function (e, t, n) {
                              Hs(n);
                              var r = e._gsap;
                              if (r.spacerIsNative) Hs(r.spacerState);
                              else if (e.parentNode === t) {
                                var i = t.parentNode;
                                i && (i.insertBefore(e, t), i.removeChild(t));
                              }
                            })(Z, b, g)
                          : (!oe || !_e.isActive) && qs(Z, b, ts(Z), E)),
                      (_e.isReverted = t));
                  }),
                  (_e.refresh = function (i, a) {
                    if ((!to && _e.enabled) || a)
                      if (Z && i && Eo) ls(e, "scrollEnd", Ss);
                      else {
                        !_o && xe && xe(_e), (to = 1), (Ee = To()), r.tween && (r.tween.kill(), (r.tween = 0)), L && L.pause(), ee && n && n.time(-0.01, !0).invalidate(), _e.isReverted || _e.revert();
                        for (
                          var h,
                            w,
                            x,
                            k,
                            S,
                            O,
                            M,
                            P,
                            A,
                            I,
                            D = Ce(),
                            R = Te(),
                            q = le ? le.duration() : jo(pe, de),
                            F = 0,
                            H = 0,
                            W = t.end,
                            $ = t.endTrigger || Q,
                            V = t.start || (0 !== t.start && Q ? (Z ? "0 0" : "0 100%") : 0),
                            Y = (_e.pinnedContainer = t.pinnedContainer && za(t.pinnedContainer)),
                            G = (Q && Math.max(0, ms.indexOf(_e))) || 0,
                            X = G;
                          X--;

                        )
                          (O = ms[X]).end || O.refresh(0, 1) || (to = 1), !(M = O.pin) || (M !== Q && M !== Z) || O.isReverted || (I || (I = []), I.unshift(O), O.revert()), O !== ms[X] && (G--, X--);
                        for (
                          Ro(V) && (V = V(_e)),
                            l = Vs(V, Q, D, de, Se(), c, f, _e, R, we, ge, q, le) || (Z ? -0.001 : 0),
                            Ro(W) && (W = W(_e)),
                            No(W) && !W.indexOf("+=") && (~W.indexOf(" ") ? (W = (No(V) ? V.split(" ")[0] : "") + W) : ((F = hs(W.substr(2), D)), (W = No(V) ? V : l + F), ($ = Q))),
                            u = Math.max(l, Vs(W || ($ ? "100% 0" : q), $, D, de, Se() + F, d, p, _e, R, we, ge, q, le)) || -0.001,
                            v = u - l || ((l -= 0.01) && 0.001),
                            F = 0,
                            X = G;
                          X--;

                        )
                          (M = (O = ms[X]).pin) && O.start - O._pinPush < l && !le && O.end > 0 && ((h = O.end - O.start), (M !== Q && M !== Y) || qo(V) || (F += h * (1 - O.progress)), M === Z && (H += h));
                        if (((l += F), (u += F), (_e._pinPush = H), c && F && (((h = {})[de.a] = "+=" + F), Y && (h[de.p] = "-=" + Se()), Wa.set([c, d], h)), Z))
                          (h = ts(Z)),
                            (k = de === Da),
                            (x = Se()),
                            (C = parseFloat(_(de.a)) + H),
                            !q && u > 1 && ((ve ? Xa : pe).style["overflow-" + de.a] = "scroll"),
                            qs(Z, b, h),
                            (y = Ws(Z)),
                            (w = rs(Z, !0)),
                            (P = ge && ja(pe, k ? Ia : Da)()),
                            J && (((E = [J + de.os2, v + H + es]).t = b), (X = J === Qo ? is(Z, de) + v + H : 0) && E.push(de.d, X + es), Hs(E), ge && Se(B)),
                            ge &&
                              (((S = { top: w.top + (k ? x - l : P) + es, left: w.left + (k ? P : x - l) + es, boxSizing: "border-box", position: "fixed" }).width = S.maxWidth = Math.ceil(w.width) + es),
                              (S.height = S.maxHeight = Math.ceil(w.height) + es),
                              (S.margin = S.marginTop = S.marginRight = S.marginBottom = S.marginLeft = "0"),
                              (S.padding = h.padding),
                              (S.paddingTop = h.paddingTop),
                              (S.paddingRight = h.paddingRight),
                              (S.paddingBottom = h.paddingBottom),
                              (S.paddingLeft = h.paddingLeft),
                              (m = (function (e, t, n) {
                                for (var r, i = [], a = e.length, o = n ? 8 : 0; o < a; o += 2) (r = e[o]), i.push(r, r in t ? t[r] : e[o + 1]);
                                return (i.t = e.t), i;
                              })(g, S, oe))),
                            n ? ((A = n._initted), uo(1), n.render(n.duration(), !0, !0), (T = _(de.a) - C + v + H), v !== T && ge && m.splice(m.length - 2, 2), n.render(0, !0, !0), A || n.invalidate(), uo(0)) : (T = v);
                        else if (Q && Se() && !le) for (w = Q.parentNode; w && w !== Xa; ) w._pinOffset && ((l -= w._pinOffset), (u -= w._pinOffset)), (w = w.parentNode);
                        I &&
                          I.forEach(function (e) {
                            return e.revert(!1);
                          }),
                          (_e.start = l),
                          (_e.end = u),
                          (o = s = Se()),
                          le || (o < B && Se(B), (_e.scroll.rec = 0)),
                          _e.revert(!1),
                          z && ((ke = -1), _e.isActive && Se(l + v * j), z.restart(!0)),
                          (to = 0),
                          n && fe && (n._initted || N) && n.progress() !== N && n.progress(N, !0).render(n.time(), !0, !0),
                          (j !== _e.progress || le) && (n && !fe && n.totalProgress(j, !0), (_e.progress = j), _e.update(0, 0, 1)),
                          Z && J && (b._pinOffset = Math.round(_e.progress * T)),
                          U && U(_e);
                      }
                  }),
                  (_e.getVelocity = function () {
                    return ((Se() - s) / (To() - Ja)) * 1e3 || 0;
                  }),
                  (_e.endAnimation = function () {
                    $o(_e.callbackAnimation), n && (L ? L.progress(1) : n.paused() ? fe || $o(n, _e.direction < 0, 1) : $o(n, n.reversed()));
                  }),
                  (_e.labelToScroll = function (e) {
                    return (n && n.labels && (l || _e.refresh() || l) + (n.labels[e] / n.duration()) * v) || 0;
                  }),
                  (_e.getTrailing = function (e) {
                    var t = ms.indexOf(_e),
                      n = _e.direction > 0 ? ms.slice(0, t).reverse() : ms.slice(t + 1);
                    return (No(e)
                      ? n.filter(function (t) {
                          return t.vars.preventOverlaps === e;
                        })
                      : n
                    ).filter(function (e) {
                      return _e.direction > 0 ? e.end <= l : e.start >= u;
                    });
                  }),
                  (_e.update = function (e, t, i) {
                    if (!le || i || e) {
                      var a,
                        c,
                        d,
                        p,
                        h,
                        g,
                        w,
                        _ = _e.scroll(),
                        E = e ? 0 : (_ - l) / v,
                        M = E < 0 ? 0 : E > 1 ? 1 : E || 0,
                        I = _e.progress;
                      if ((t && ((s = o), (o = le ? Se() : _), ae && ((A = P), (P = n && !fe ? n.totalProgress() : M))), te && !M && Z && !to && !Co && Eo && l < _ + ((_ - s) / (To() - Ja)) * te && (M = 1e-4), M !== I && _e.enabled)) {
                        if (
                          ((p = (h = (a = _e.isActive = !!M && M < 1) != (!!I && I < 1)) || !!M != !!I),
                          (_e.direction = M > I ? 1 : -1),
                          (_e.progress = M),
                          p && !to && ((c = M && !I ? 0 : 1 === M ? 1 : 1 === I ? 2 : 3), fe && ((d = (!h && "none" !== ye[c + 1] && ye[c + 1]) || ye[c]), (w = n && ("complete" === d || "reset" === d || d in n)))),
                          ce &&
                            (h || w) &&
                            (w || K || !n) &&
                            (Ro(ce)
                              ? ce(_e)
                              : _e.getTrailing(ce).forEach(function (e) {
                                  return e.endAnimation();
                                })),
                          fe ||
                            (!L || to || Co
                              ? n && n.totalProgress(M, !!to)
                              : ((le || (xo && xo !== _e)) && L.render(L._dp._time - L._start), L.resetTo ? L.resetTo("totalProgress", M, n._tTime / n._tDur) : ((L.vars.totalProgress = M), L.invalidate().restart()))),
                          Z)
                        )
                          if ((e && J && (b.style[J + de.os2] = k), ge)) {
                            if (p) {
                              if (((g = !e && M > I && u + 1 > _ && _ + 1 >= jo(pe, de)), oe))
                                if (e || (!a && !g)) Gs(Z, b);
                                else {
                                  var D = rs(Z, !0),
                                    j = _ - l;
                                  Gs(Z, Xa, D.top + (de === Da ? j : 0) + es, D.left + (de === Da ? 0 : j) + es);
                                }
                              Hs(a || g ? m : y), (T !== v && M < 1 && a) || x(C + (1 !== M || g ? 0 : T));
                            }
                          } else x(Ao(C + T * M));
                        ae && !r.tween && !to && !Co && z.restart(!0),
                          Y &&
                            (h || (ie && M && (M < 1 || !mo))) &&
                            Qa(Y.targets).forEach(function (e) {
                              return e.classList[a || ie ? "add" : "remove"](Y.className);
                            }),
                          V && !fe && !e && V(_e),
                          p && !to
                            ? (fe && (w && ("complete" === d ? n.pause().totalProgress(1) : "reset" === d ? n.restart(!0).pause() : "restart" === d ? n.restart(!0) : n[d]()), V && V(_e)),
                              (!h && mo) || (X && h && Vo(_e, X), me[c] && Vo(_e, me[c]), ie && (1 === M ? _e.kill(!1, 1) : (me[c] = 0)), h || (me[(c = 1 === M ? 1 : 3)] && Vo(_e, me[c]))),
                              ue && !a && Math.abs(_e.getVelocity()) > (qo(ue) ? ue : 2500) && ($o(_e.callbackAnimation), L ? L.progress(1) : $o(n, !M, 1)))
                            : fe && V && !to && V(_e);
                      }
                      if (O) {
                        var B = le ? (_ / le.duration()) * (le._caScrollDist || 0) : _;
                        S(B + (f._isFlipped ? 1 : 0)), O(B);
                      }
                      R && R((-_ / le.duration()) * (le._caScrollDist || 0));
                    }
                  }),
                  (_e.enable = function (t, n) {
                    _e.enabled || ((_e.enabled = !0), ls(pe, "resize", xs), ls(ve ? Ya : pe, "scroll", ws), xe && ls(e, "refreshInit", xe), !1 !== t && ((_e.progress = j = 0), (o = s = ke = Se())), !1 !== n && _e.refresh());
                  }),
                  (_e.getTween = function (e) {
                    return e && r ? r.tween : L;
                  }),
                  (_e.setPositions = function (e, t) {
                    Z && ((C += e - l), (T += t - e - v)), (_e.start = l = e), (_e.end = u = t), (v = t - e), _e.update();
                  }),
                  (_e.disable = function (t, n) {
                    if (
                      _e.enabled &&
                      (!1 !== t && _e.revert(), (_e.enabled = _e.isActive = !1), n || (L && L.pause()), (B = 0), i && (i.uncache = 1), xe && us(e, "refreshInit", xe), z && (z.pause(), r.tween && r.tween.kill() && (r.tween = 0)), !ve)
                    ) {
                      for (var a = ms.length; a--; ) if (ms[a].scroller === pe && ms[a] !== _e) return;
                      us(pe, "resize", xs), us(pe, "scroll", ws);
                    }
                  }),
                  (_e.kill = function (e, r) {
                    _e.disable(e, r), L && !r && L.kill(), G && delete ys[G];
                    var a = ms.indexOf(_e);
                    a >= 0 && ms.splice(a, 1),
                      a === io && js > 0 && io--,
                      (a = 0),
                      ms.forEach(function (e) {
                        return e.scroller === _e.scroller && (a = 1);
                      }),
                      a || (_e.scroll.rec = 0),
                      n && ((n.scrollTrigger = null), e && n.render(-1), r || n.kill()),
                      c &&
                        [c, d, f, p].forEach(function (e) {
                          return e.parentNode && e.parentNode.removeChild(e);
                        }),
                      xo === _e && (xo = 0),
                      Z &&
                        (i && (i.uncache = 1),
                        (a = 0),
                        ms.forEach(function (e) {
                          return e.pin === Z && a++;
                        }),
                        a || (i.spacer = 0)),
                      t.onKill && t.onKill(_e);
                  }),
                  _e.enable(!1, !1),
                  q && q(_e),
                  n && n.add && !v
                    ? Wa.delayedCall(0.01, function () {
                        return l || u || _e.refresh();
                      }) &&
                      (v = 0.01) &&
                      (l = u = 0)
                    : _e.refresh();
              } else this.update = this.refresh = this.kill = Po;
            }),
            (e.register = function (t) {
              return $a || ((Wa = t || Io()), Lo() && window.document && e.enable(), ($a = So)), $a;
            }),
            (e.defaults = function (e) {
              if (e) for (var t in e) fs[t] = e[t];
              return fs;
            }),
            (e.disable = function (e, t) {
              (So = 0),
                ms.forEach(function (n) {
                  return n[t ? "kill" : "disable"](e);
                }),
                us(Va, "wheel", ws),
                us(Ya, "scroll", ws),
                clearInterval(eo),
                us(Ya, "touchcancel", Po),
                us(Xa, "touchstart", Po),
                ss(us, Ya, "pointerdown,touchstart,mousedown", Oo),
                ss(us, Ya, "pointerup,touchend,mouseup", Mo),
                Ka.kill(),
                Bo(us);
              for (var n = 0; n < Ca.length; n += 3) cs(us, Ca[n], Ca[n + 1]), cs(us, Ca[n], Ca[n + 2]);
            }),
            (e.enable = function () {
              if (((Va = window), (Ya = document), (Ga = Ya.documentElement), (Xa = Ya.body), Wa && ((Qa = Wa.utils.toArray), (Za = Wa.utils.clamp), (uo = Wa.core.suppressOverwrites || Po), Wa.core.globals("ScrollTrigger", e), Xa))) {
                (So = 1),
                  Ha.register(Wa),
                  (e.isTouch = Ha.isTouch),
                  (go = Ha.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                  ls(Va, "wheel", ws),
                  (Ua = [Va, Ya, Ga, Xa]),
                  e.matchMedia({
                    "(orientation: portrait)": function () {
                      return _s(), _s;
                    },
                  }),
                  ls(Ya, "scroll", ws);
                var t,
                  n,
                  r = Xa.style,
                  i = r.borderTopStyle;
                for (
                  r.borderTopStyle = "solid",
                    t = rs(Xa),
                    Da.m = Math.round(t.top + Da.sc()) || 0,
                    Ia.m = Math.round(t.left + Ia.sc()) || 0,
                    i ? (r.borderTopStyle = i) : r.removeProperty("border-top-style"),
                    eo = setInterval(bs, 250),
                    Wa.delayedCall(0.5, function () {
                      return (Co = 0);
                    }),
                    ls(Ya, "touchcancel", Po),
                    ls(Xa, "touchstart", Po),
                    ss(ls, Ya, "pointerdown,touchstart,mousedown", Oo),
                    ss(ls, Ya, "pointerup,touchend,mouseup", Mo),
                    ro = Wa.utils.checkPrefix("transform"),
                    Rs.push(ro),
                    $a = To(),
                    Ka = Wa.delayedCall(0.2, Ds).pause(),
                    so = [
                      Ya,
                      "visibilitychange",
                      function () {
                        var e = Va.innerWidth,
                          t = Va.innerHeight;
                        Ya.hidden ? ((ao = e), (oo = t)) : (ao === e && oo === t) || xs();
                      },
                      Ya,
                      "DOMContentLoaded",
                      Ds,
                      Va,
                      "load",
                      Ds,
                      Va,
                      "resize",
                      xs,
                    ],
                    Bo(ls),
                    ms.forEach(function (e) {
                      return e.enable(0, 1);
                    }),
                    n = 0;
                  n < Ca.length;
                  n += 3
                )
                  cs(us, Ca[n], Ca[n + 1]), cs(us, Ca[n], Ca[n + 2]);
              }
            }),
            (e.config = function (t) {
              "limitCallbacks" in t && (mo = !!t.limitCallbacks);
              var n = t.syncInterval;
              (n && clearInterval(eo)) || ((eo = n) && setInterval(bs, n)),
                "ignoreMobileResize" in t && (po = 1 === e.isTouch && t.ignoreMobileResize),
                "autoRefreshEvents" in t && (Bo(us) || Bo(ls, t.autoRefreshEvents || "none"), (co = -1 === (t.autoRefreshEvents + "").indexOf("resize")));
            }),
            (e.scrollerProxy = function (e, t) {
              var n = za(e),
                r = Ca.indexOf(n),
                i = Do(n);
              ~r && Ca.splice(r, i ? 6 : 2), t && (i ? Ta.unshift(Va, t, Xa, t, Ga, t) : Ta.unshift(n, t));
            }),
            (e.matchMedia = function (e) {
              var t, n, r, i, a;
              for (n in e)
                (r = ks.indexOf(n)),
                  (i = e[n]),
                  (bo = n),
                  "all" === n
                    ? i()
                    : (t = Va.matchMedia(n)) &&
                      (t.matches && (a = i()),
                      ~r ? ((ks[r + 1] = Wo(ks[r + 1], i)), (ks[r + 2] = Wo(ks[r + 2], a))) : ((r = ks.length), ks.push(n, i, a), t.addListener ? t.addListener(Es) : t.addEventListener("change", Es)),
                      (ks[r + 3] = t.matches)),
                  (bo = 0);
              return ks;
            }),
            (e.clearMatchMedia = function (e) {
              e || (ks.length = 0), (e = ks.indexOf(e)) >= 0 && ks.splice(e, 4);
            }),
            (e.isInViewport = function (e, t, n) {
              var r = (No(e) ? za(e) : e).getBoundingClientRect(),
                i = r[n ? Uo : Ko] * t || 0;
              return n ? r.right - i > 0 && r.left + i < Va.innerWidth : r.bottom - i > 0 && r.top + i < Va.innerHeight;
            }),
            (e.positionInViewport = function (e, t, n) {
              No(e) && (e = za(e));
              var r = e.getBoundingClientRect(),
                i = r[n ? Uo : Ko],
                a = null == t ? i / 2 : t in ps ? ps[t] * i : ~t.indexOf("%") ? (parseFloat(t) * i) / 100 : parseFloat(t) || 0;
              return n ? (r.left + a) / Va.innerWidth : (r.top + a) / Va.innerHeight;
            }),
            e
          );
        })();
      (Us.version = "3.10.4"),
        (Us.saveStyles = function (e) {
          return e
            ? Qa(e).forEach(function (e) {
                if (e && e.style) {
                  var t = Ms.indexOf(e);
                  t >= 0 && Ms.splice(t, 5), Ms.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), Wa.core.getCache(e), bo);
                }
              })
            : Ms;
        }),
        (Us.revert = function (e, t) {
          return As(!e, t);
        }),
        (Us.create = function (e, t) {
          return new Us(e, t);
        }),
        (Us.refresh = function (e) {
          return e ? xs() : ($a || Us.register()) && Ds(!0);
        }),
        (Us.update = Bs),
        (Us.clearScrollMemory = Ls),
        (Us.maxScroll = function (e, t) {
          return jo(e, t ? Ia : Da);
        }),
        (Us.getScrollFunc = function (e, t) {
          return ja(za(e), t ? Ia : Da);
        }),
        (Us.getById = function (e) {
          return ys[e];
        }),
        (Us.getAll = function () {
          return ms.filter(function (e) {
            return "ScrollSmoother" !== e.vars.id;
          });
        }),
        (Us.isScrolling = function () {
          return !!Eo;
        }),
        (Us.snapDirectional = os),
        (Us.addEventListener = function (e, t) {
          var n = Cs[e] || (Cs[e] = []);
          ~n.indexOf(t) || n.push(t);
        }),
        (Us.removeEventListener = function (e, t) {
          var n = Cs[e],
            r = n && n.indexOf(t);
          r >= 0 && n.splice(r, 1);
        }),
        (Us.batch = function (e, t) {
          var n,
            r = [],
            i = {},
            a = t.interval || 0.016,
            o = t.batchMax || 1e9,
            s = function (e, t) {
              var n = [],
                r = [],
                i = Wa.delayedCall(a, function () {
                  t(n, r), (n = []), (r = []);
                }).pause();
              return function (e) {
                n.length || i.restart(!0), n.push(e.trigger), r.push(e), o <= n.length && i.progress(1);
              };
            };
          for (n in t) i[n] = "on" === n.substr(0, 2) && Ro(t[n]) && "onRefreshInit" !== n ? s(0, t[n]) : t[n];
          return (
            Ro(o) &&
              ((o = o()),
              ls(Us, "refresh", function () {
                return (o = t.batchMax());
              })),
            Qa(e).forEach(function (e) {
              var t = {};
              for (n in i) t[n] = i[n];
              (t.trigger = e), r.push(Us.create(t));
            }),
            r
          );
        });
      var Ks,
        Qs = function (e, t, n, r) {
          return t > r ? e(r) : t < 0 && e(0), n > r ? (r - t) / (n - t) : n < 0 ? t / (t - n) : 1;
        },
        Zs = function e(t, n) {
          !0 === n ? t.style.removeProperty("touch-action") : (t.style.touchAction = !0 === n ? "auto" : n ? "pan-" + n + (Ha.isTouch ? " pinch-zoom" : "") : "none"), t === Ga && e(Xa, n);
        },
        Js = { auto: 1, scroll: 1 },
        el = function (e) {
          var t,
            n = e.event,
            r = e.target,
            i = e.axis,
            a = (n.changedTouches ? n.changedTouches[0] : n).target,
            o = a._gsap || Wa.core.getCache(a),
            s = To();
          if (!o._isScrollT || s - o._isScrollT > 2e3) {
            for (; a && a.scrollHeight <= a.clientHeight; ) a = a.parentNode;
            (o._isScroll = a && !Do(a) && a !== r && (Js[(t = ts(a)).overflowY] || Js[t.overflowX])), (o._isScrollT = s);
          }
          (o._isScroll || "x" === i) && (n._gsapAllow = !0);
        },
        tl = function (e, t, n, r) {
          return Ha.create({
            target: e,
            capture: !0,
            debounce: !1,
            lockAxis: !0,
            type: t,
            onWheel: (r = r && el),
            onPress: r,
            onDrag: r,
            onScroll: r,
            onEnable: function () {
              return n && ls(Ya, Ha.eventTypes[0], rl, !1, !0);
            },
            onDisable: function () {
              return us(Ya, Ha.eventTypes[0], rl, !0);
            },
          });
        },
        nl = /(input|label|select|textarea)/i,
        rl = function (e) {
          var t = nl.test(e.target.tagName);
          (t || Ks) && ((e._gsapAllow = !0), (Ks = t));
        };
      (Us.sort = function (e) {
        return ms.sort(
          e ||
            function (e, t) {
              return -1e6 * (e.vars.refreshPriority || 0) + e.start - (t.start + -1e6 * (t.vars.refreshPriority || 0));
            }
        );
      }),
        (Us.observe = function (e) {
          return new Ha(e);
        }),
        (Us.normalizeScroll = function (e) {
          if (void 0 === e) return fo;
          if (!0 === e && fo) return fo.enable();
          if (!1 === e) return fo && fo.kill();
          var t =
            e instanceof Ha
              ? e
              : (function (e) {
                  Fo(e) || (e = {}), (e.preventDefault = e.isNormalizer = e.allowClicks = !0), e.type || (e.type = "wheel,touch"), (e.debounce = !!e.debounce), (e.id = e.id || "normalizer");
                  var t,
                    n,
                    r,
                    i,
                    a,
                    o,
                    s,
                    l,
                    u = e,
                    c = u.normalizeScrollX,
                    d = u.momentum,
                    f = u.allowNestedScroll,
                    p = za(e.target) || Ga,
                    h = Wa.core.globals().ScrollSmoother,
                    v = go && ((e.content && za(e.content)) || (h && h.get() && h.get().content())),
                    g = ja(p, Da),
                    m = ja(p, Ia),
                    y = 1,
                    b = (Ha.isTouch && Va.visualViewport ? Va.visualViewport.scale * Va.visualViewport.width : Va.outerWidth) / Va.innerWidth,
                    w = 0,
                    _ = Ro(d)
                      ? function () {
                          return d(t);
                        }
                      : function () {
                          return d || 2.8;
                        },
                    x = tl(p, e.type, !0, f),
                    C = function () {
                      return (r = !1);
                    },
                    T = Po,
                    k = Po,
                    E = function () {
                      (n = jo(p, Da)), (k = Za(go ? 1 : 0, n)), c && (T = Za(0, jo(p, Ia))), (i = Is);
                    },
                    S = function () {
                      E(), a.isActive() && a.vars.scrollY > n && (g() > n ? a.progress(1) && g(n) : a.resetTo("scrollY", n));
                    };
                  return (
                    (e.ignoreCheck = function (e) {
                      return (
                        (go &&
                          "touchmove" === e.type &&
                          (function () {
                            if (r) {
                              requestAnimationFrame(C);
                              var e = Ao(t.deltaY / 2),
                                n = k(g.v - e);
                              return v && n !== g.v + g.offset && ((g.offset = n - g.v), (v.style.transform = "translateY(" + -g.offset + "px)"), v._gsap && (v._gsap.y = -g.offset + "px"), (g.cacheID = Ca.cache), Bs()), !0;
                            }
                            v && ((v.style.transform = "translateY(0px)"), (g.offset = g.cacheID = 0), v._gsap && (v._gsap.y = "0px")), (r = !0);
                          })()) ||
                        (y > 1.05 && "touchstart" !== e.type) ||
                        t.isGesturing ||
                        (e.touches && e.touches.length > 1)
                      );
                    }),
                    (e.onPress = function () {
                      var e = y;
                      (y = Ao(((Va.visualViewport && Va.visualViewport.scale) || 1) / b)), a.pause(), e !== y && Zs(p, y > 1.01 || (!c && "x")), (r = !1), (o = m()), (s = g()), E(), (i = Is);
                    }),
                    (e.onRelease = e.onGestureStart = function (e, t) {
                      if ((v && ((v.style.transform = "translateY(0px)"), (g.offset = g.cacheID = 0), v._gsap && (v._gsap.y = "0px")), t)) {
                        Ca.cache++;
                        var r,
                          i,
                          o = _();
                        c && ((i = (r = m()) + (0.05 * o * -e.velocityX) / 0.227), (o *= Qs(m, r, i, jo(p, Ia))), (a.vars.scrollX = T(i))),
                          (i = (r = g()) + (0.05 * o * -e.velocityY) / 0.227),
                          (o *= Qs(g, r, i, jo(p, Da))),
                          (a.vars.scrollY = k(i)),
                          a.invalidate().duration(o).play(0.01),
                          ((go && a.vars.scrollY >= n) || r >= n - 1) && Wa.to({}, { onUpdate: S, duration: o });
                      } else l.restart(!0);
                    }),
                    (e.onWheel = function () {
                      a._ts && a.pause(), To() - w > 1e3 && ((i = 0), (w = To()));
                    }),
                    (e.onChange = function (e, t, n, r, a) {
                      Is !== i && E(), t && c && m(T(r[2] === t ? o + (e.startX - e.x) : m() + t - r[1])), n && g(k(a[2] === n ? s + (e.startY - e.y) : g() + n - a[1])), Bs();
                    }),
                    (e.onEnable = function () {
                      Zs(p, !c && "x"), ls(Va, "resize", S), x.enable();
                    }),
                    (e.onDisable = function () {
                      Zs(p, !0), us(Va, "resize", S), x.kill();
                    }),
                    ((t = new Ha(e)).iOS = go),
                    go && !g() && g(1),
                    (l = t._dc),
                    (a = Wa.to(t, { ease: "power4", paused: !0, scrollX: c ? "+=0.1" : "+=0", scrollY: "+=0.1", onComplete: l.vars.onComplete })),
                    t
                  );
                })(e);
          return fo && fo.target === t.target && fo.kill(), Do(t.target) && (fo = t), t;
        }),
        (Us.core = {
          _getVelocityProp: Ba,
          _inputObserver: tl,
          _scrollers: Ca,
          _proxies: Ta,
          bridge: {
            ss: function () {
              Eo || Os("scrollStart"), (Eo = To());
            },
            ref: function () {
              return to;
            },
          },
        }),
        Io() && Wa.registerPlugin(Us);
      var il,
        al,
        ol,
        sl,
        ll,
        ul,
        cl,
        dl = function () {
          return "undefined" != typeof window;
        },
        fl = function () {
          return il || (dl() && (il = window.gsap) && il.registerPlugin && il);
        },
        pl = function (e) {
          return "string" == typeof e;
        },
        hl = function (e) {
          return "function" == typeof e;
        },
        vl = function (e, t) {
          var n = "x" === t ? "Width" : "Height",
            r = "scroll" + n,
            i = "client" + n;
          return e === ol || e === sl || e === ll ? Math.max(sl[r], ll[r]) - (ol["inner" + n] || sl[i] || ll[i]) : e[r] - e["offset" + n];
        },
        gl = function (e, t) {
          var n = "scroll" + ("x" === t ? "Left" : "Top");
          return (
            e === ol && (null != e.pageXOffset ? (n = "page" + t.toUpperCase() + "Offset") : (e = null != sl[n] ? sl : ll)),
            function () {
              return e[n];
            }
          );
        },
        ml = function (e, t) {
          if (!(e = ul(e)[0]) || !e.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || { x: 0, y: 0 };
          var n = e.getBoundingClientRect(),
            r = !t || t === ol || t === ll,
            i = r ? { top: sl.clientTop - (ol.pageYOffset || sl.scrollTop || ll.scrollTop || 0), left: sl.clientLeft - (ol.pageXOffset || sl.scrollLeft || ll.scrollLeft || 0) } : t.getBoundingClientRect(),
            a = { x: n.left - i.left, y: n.top - i.top };
          return !r && t && ((a.x += gl(t, "x")()), (a.y += gl(t, "y")())), a;
        },
        yl = function (e, t, n, r, i) {
          return isNaN(e) || "object" == typeof e ? (pl(e) && "=" === e.charAt(1) ? parseFloat(e.substr(2)) * ("-" === e.charAt(0) ? -1 : 1) + r - i : "max" === e ? vl(t, n) - i : Math.min(vl(t, n), ml(e, t)[n] - i)) : parseFloat(e) - i;
        },
        bl = function () {
          (il = fl()), dl() && il && document.body && ((ol = window), (ll = document.body), (sl = document.documentElement), (ul = il.utils.toArray), il.config({ autoKillThreshold: 7 }), (cl = il.config()), (al = 1));
        },
        wl = {
          version: "3.10.4",
          name: "scrollTo",
          rawVars: 1,
          register: function (e) {
            (il = e), bl();
          },
          init: function (e, t, n, r, i) {
            al || bl();
            var a = this,
              o = il.getProperty(e, "scrollSnapType");
            (a.isWin = e === ol),
              (a.target = e),
              (a.tween = n),
              (t = (function (e, t, n, r) {
                if ((hl(e) && (e = e(t, n, r)), "object" != typeof e)) return pl(e) && "max" !== e && "=" !== e.charAt(1) ? { x: e, y: e } : { y: e };
                if (e.nodeType) return { y: e, x: e };
                var i,
                  a = {};
                for (i in e) a[i] = "onAutoKill" !== i && hl(e[i]) ? e[i](t, n, r) : e[i];
                return a;
              })(t, r, e, i)),
              (a.vars = t),
              (a.autoKill = !!t.autoKill),
              (a.getX = gl(e, "x")),
              (a.getY = gl(e, "y")),
              (a.x = a.xPrev = a.getX()),
              (a.y = a.yPrev = a.getY()),
              o && "none" !== o && ((a.snap = 1), (a.snapInline = e.style.scrollSnapType), (e.style.scrollSnapType = "none")),
              null != t.x ? (a.add(a, "x", a.x, yl(t.x, e, "x", a.x, t.offsetX || 0), r, i), a._props.push("scrollTo_x")) : (a.skipX = 1),
              null != t.y ? (a.add(a, "y", a.y, yl(t.y, e, "y", a.y, t.offsetY || 0), r, i), a._props.push("scrollTo_y")) : (a.skipY = 1);
          },
          render: function (e, t) {
            for (var n, r, i, a, o, s = t._pt, l = t.target, u = t.tween, c = t.autoKill, d = t.xPrev, f = t.yPrev, p = t.isWin, h = t.snap, v = t.snapInline; s; ) s.r(e, s.d), (s = s._next);
            (n = p || !t.skipX ? t.getX() : d),
              (i = (r = p || !t.skipY ? t.getY() : f) - f),
              (a = n - d),
              (o = cl.autoKillThreshold),
              t.x < 0 && (t.x = 0),
              t.y < 0 && (t.y = 0),
              c &&
                (!t.skipX && (a > o || a < -o) && n < vl(l, "x") && (t.skipX = 1),
                !t.skipY && (i > o || i < -o) && r < vl(l, "y") && (t.skipY = 1),
                t.skipX && t.skipY && (u.kill(), t.vars.onAutoKill && t.vars.onAutoKill.apply(u, t.vars.onAutoKillParams || []))),
              p ? ol.scrollTo(t.skipX ? n : t.x, t.skipY ? r : t.y) : (t.skipY || (l.scrollTop = t.y), t.skipX || (l.scrollLeft = t.x)),
              !h ||
                (1 !== e && 0 !== e) ||
                ((r = l.scrollTop), (n = l.scrollLeft), v ? (l.style.scrollSnapType = v) : l.style.removeProperty("scroll-snap-type"), (l.scrollTop = r + 1), (l.scrollLeft = n + 1), (l.scrollTop = r), (l.scrollLeft = n)),
              (t.xPrev = t.x),
              (t.yPrev = t.y);
          },
          kill: function (e) {
            var t = "scrollTo" === e;
            (t || "scrollTo_x" === e) && (this.skipX = 1), (t || "scrollTo_y" === e) && (this.skipY = 1);
          },
        };
      if (
        ((wl.max = vl),
        (wl.getOffset = ml),
        (wl.buildGetter = gl),
        fl() && il.registerPlugin(wl),
        oa.registerPlugin(Us, Sr, wl),
        window.addEventListener("load", function () {
          var e = oa.timeline();
          window.innerWidth < 992
            ? e.to(".site-overlay", { alpha: 0 })
            : e
                .to(".site-overlay", {
                  alpha: 0,
                  duration: 1.5,
                  onStart: function () {
                    var e = document.querySelector(".hero");
                    e &&
                      setTimeout(function () {
                        e.classList.add("hero--loaded"),
                          setTimeout(function () {
                            document.querySelectorAll(".hero__content").forEach(function (e) {
                              e.classList.add("hero__content--loaded");
                            });
                          }, 1e3);
                      }, 1e3);
                  },
                })
                .to(".site-overlay", { display: "none" })
                .to("main.content", { duration: 1 }, "-=1.5");
        }),
        oa.timeline({ scrollTrigger: { trigger: ".scale-animation", start: "top 80%" } }).to(".scale-animation", { maxWidth: "403px", duration: 2 }),
        window.innerWidth >= 992)
      ) {
        var _l = oa.timeline({ scrollTrigger: { trigger: ".kitchenware-about", start: "top 90%" } });
        _l.from(".kitchenware-about__graphics--left", { left: "-100%", alpha: 0, duration: 3 }).to(".kitchenware-about__graphics--left", { left: 0, alpha: 1, duration: 3 }),
          _l.from(".kitchenware-about__graphics--right", { right: "-100%", alpha: 0, duration: 3, delay: -3 }, "-=3").to(".kitchenware-about__graphics--right", { right: 0, alpha: 1, duration: -3 }, "-=3");
      }
      var xl = document.querySelector(".material-article");
      if (xl) {
        var Cl = function (e, t) {
            oa.to(e, 0.5, { x: ((kl.x - Tl.width / 2) / Tl.width) * t, y: ((kl.y - Tl.height / 2) / Tl.height) * t });
          },
          Tl = xl.getBoundingClientRect(),
          kl = { x: 0, y: 0, moved: !1 };
        xl.addEventListener("mousemove", function (e) {
          (kl.moved = !0), (kl.x = e.clientX - Tl.left), (kl.y = e.clientY - Tl.top);
        }),
          oa.ticker.add(function () {
            kl.moved && (Cl(".material-article__item--1", -100), Cl(".material-article__item--2", 50), Cl(".material-article__item--3", -70), Cl(".material-article__item--4", -30)), (kl.moved = !1);
          }),
          window.addEventListener("resize", function () {
            Tl = xl.getBoundingClientRect();
          }),
          window.addEventListener("scroll", function () {
            Tl = xl.getBoundingClientRect();
          });
      }
      var El = window.innerHeight,
        Sl = document.querySelector(".hero");
      Sl &&
        (window.addEventListener("scroll", function (e) {
          (window.pageYOffset || document.documentElement.scrollTop) >= El ? Sl.setAttribute("style", "opacity: 0; visibility: hidden") : Sl.removeAttribute("style");
        }),
        window.addEventListener("resize", function () {
          window.innerWidth >= 992 && Sl.classList.add("hero--desktop");
        }));
      var Ol = document.querySelector(".kitchenware__background");
      function Ml(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      Ol && oa.to(".scroll-animated-img", { scale: 1, duration: 1.5, scrollTrigger: { trigger: Ol, start: "top bottom-=300px", toggleActions: "play none none reset" } });
      const Pl = (function () {
        function e() {
          var t, n, r;
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (r = void 0),
            (n = "show") in (t = this) ? Object.defineProperty(t, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t.show = r),
            (this.header = document.querySelector(".header")),
            (this.searchTrigger = document.querySelectorAll(".js-search")),
            (this.searchBar = document.querySelector("#search")),
            (this.searchColumnAll = document.querySelectorAll(".search__column")),
            (this.searchColumn1 = document.querySelector(".search__column--level-1")),
            (this.searchActive = document.querySelector(".slfe.js-search")),
            (this.searchColumn2 = document.querySelector(".search__column--level-2")),
            (this.searchColumn3 = document.querySelector(".search__column--level-3")),
            (this.searchInput = document.querySelector(".search__input")),
            (this.headerButtons = document.querySelector(".header__buttons")),
            (this.searchColumnProductImage = document.querySelector(".search__product-img img")),
            (this.searchOverlay = document.querySelector(".search__overlay")),
            (this.searchSeeDetails = document.querySelector(".search__btn")),
            this.events();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "events",
              value: function () {
                var e = this;
                this.searchTrigger.forEach(function (t) {
                  t.addEventListener("click", e.toggleSearch.bind(e));
                }),
                  this.searchOverlay.addEventListener("click", this.closeSearchBar.bind(this));
              },
            },
            {
              key: "toggleSearch",
              value: function (e) {
                e.preventDefault(), console.log(this), this.searchBar.classList.contains("search--open") ? this.closeSearchBar() : (this.showSearchBar(), window.innerWidth <= 991.98 && this.headerButtons.classList.add("dropdown-open"));
              },
            },
            {
              key: "showSearchBar",
              value: function () {
                var e = this;
                this.header.classList.add("header--active"),
                  this.searchBar.classList.add("search--open"),
                  this.searchColumn1.classList.add("search__column--view"),
                  this.searchActive.classList.add("active"),
                  this.checkSearchInputValue(),
                  this.closeSearchColumn(),
                  this.searchBar.addEventListener("mouseenter", function () {
                    e.header.classList.add("header--active");
                  });
              },
            },
            {
              key: "closeSearchBar",
              value: function () {
                this.header.classList.remove("header--active"),
                  this.searchBar.classList.remove("search--open"),
                  this.searchActive.classList.remove("active"),
                  this.searchColumnAll.forEach(function (e) {
                    e.classList.remove("search__column--view");
                  }),
                  this.clearSearchField();
              },
            },
            {
              key: "checkSearchInputValue",
              value: function () {
                var e = this;
                this.searchInput.addEventListener("keyup", function (t) {
                  var n = t.target.value;
                  setTimeout(function () {
                    n.length > 0 ? e.searchColumn2.classList.add("search__column--view") : (e.searchColumn2.classList.remove("search__column--view"), e.searchColumn3.classList.remove("search__column--view"));
                  }, 500);
                }),
                  this.showProductImageOnHover();
              },
            },
            {
              key: "clearSearchField",
              value: function () {
                (this.searchInput.value = ""), console.log("closed");
              },
            },
            {
              key: "showProductImageOnHover",
              value: function () {
                var e = this;
                document.querySelectorAll(".search-list__link").forEach(function (e, n) {
                  e.addEventListener("mouseenter", function (e) {
                    var n = e.target;
                    t(n);
                  });
                });
                var t = function (t) {
                  t.getAttribute("data-productimage"),
                    t.getAttribute("href"),
                    e.searchColumn1.addEventListener("mouseenter", function () {
                      e.searchColumn3.classList.remove("search__column--view");
                    });
                };
              },
            },
            {
              key: "closeSearchColumn",
              value: function () {
                document.addEventListener("click", function (e) {
                  var t = e.target.parentElement;
                  "search__close" == t.className &&
                    (t.parentElement.classList.remove("search__column--view"),
                    t.parentElement.classList.contains("search__column--level-2") &&
                      (document.querySelector(".search__column--level-3").classList.remove("search__column--view"), document.querySelector(".search__column--level-2").classList.remove("search__column--view")));
                });
              },
            },
          ]) && Ml(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function Al() {
        return (
          (Al =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Al.apply(this, arguments)
        );
      }
      n(411);
      var Ll = {
        toggleEl: function (e, t) {
          e[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass), e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t);
        },
        update: function () {
          var e = this,
            t = e.params.navigation,
            n = e.navigation.toggleEl;
          if (!e.params.loop) {
            var r = e.navigation,
              i = r.$nextEl,
              a = r.$prevEl;
            a && a.length > 0 && (e.isBeginning ? n(a, !0) : n(a, !1), e.params.watchOverflow && e.enabled && a[e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
              i && i.length > 0 && (e.isEnd ? n(i, !0) : n(i, !1), e.params.watchOverflow && e.enabled && i[e.isLocked ? "addClass" : "removeClass"](t.lockClass));
          }
        },
        onPrevClick: function (e) {
          var t = this;
          e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev();
        },
        onNextClick: function (e) {
          var t = this;
          e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
        },
        init: function () {
          var e,
            t,
            n = this,
            r = n.params.navigation;
          (n.params.navigation = q(n.$el, n.params.navigation, n.params.createElements, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })),
            (r.nextEl || r.prevEl) &&
              (r.nextEl && ((e = L(r.nextEl)), n.params.uniqueNavElements && "string" == typeof r.nextEl && e.length > 1 && 1 === n.$el.find(r.nextEl).length && (e = n.$el.find(r.nextEl))),
              r.prevEl && ((t = L(r.prevEl)), n.params.uniqueNavElements && "string" == typeof r.prevEl && t.length > 1 && 1 === n.$el.find(r.prevEl).length && (t = n.$el.find(r.prevEl))),
              e && e.length > 0 && e.on("click", n.navigation.onNextClick),
              t && t.length > 0 && t.on("click", n.navigation.onPrevClick),
              B(n.navigation, { $nextEl: e, nextEl: e && e[0], $prevEl: t, prevEl: t && t[0] }),
              n.enabled || (e && e.addClass(r.lockClass), t && t.addClass(r.lockClass)));
        },
        destroy: function () {
          var e = this,
            t = e.navigation,
            n = t.$nextEl,
            r = t.$prevEl;
          n && n.length && (n.off("click", e.navigation.onNextClick), n.removeClass(e.params.navigation.disabledClass)), r && r.length && (r.off("click", e.navigation.onPrevClick), r.removeClass(e.params.navigation.disabledClass));
        },
      };
      const Il = {
        name: "navigation",
        params: { navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } },
        create: function () {
          N(this, { navigation: Al({}, Ll) });
        },
        on: {
          init: function (e) {
            e.navigation.init(), e.navigation.update();
          },
          toEdge: function (e) {
            e.navigation.update();
          },
          fromEdge: function (e) {
            e.navigation.update();
          },
          destroy: function (e) {
            e.navigation.destroy();
          },
          "enable disable": function (e) {
            var t = e.navigation,
              n = t.$nextEl,
              r = t.$prevEl;
            n && n[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass), r && r[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass);
          },
          click: function (e, t) {
            var n = e.navigation,
              r = n.$nextEl,
              i = n.$prevEl,
              a = t.target;
            if (e.params.navigation.hideOnClick && !L(a).is(i) && !L(a).is(r)) {
              if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === a || e.pagination.el.contains(a))) return;
              var o;
              r ? (o = r.hasClass(e.params.navigation.hiddenClass)) : i && (o = i.hasClass(e.params.navigation.hiddenClass)),
                !0 === o ? e.emit("navigationShow") : e.emit("navigationHide"),
                r && r.toggleClass(e.params.navigation.hiddenClass),
                i && i.toggleClass(e.params.navigation.hiddenClass);
            }
          },
        },
      };
      function Dl() {
        return (
          (Dl =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Dl.apply(this, arguments)
        );
      }
      var zl = {
        update: function () {
          var e = this,
            t = e.rtl,
            n = e.params.pagination;
          if (n.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
            var r,
              i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              a = e.pagination.$el,
              o = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > i - 1 - 2 * e.loopedSlides && (r -= i - 2 * e.loopedSlides),
                  r > o - 1 && (r -= o),
                  r < 0 && "bullets" !== e.params.paginationType && (r = o + r))
                : (r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
              "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
            ) {
              var s,
                l,
                u,
                c = e.pagination.bullets;
              if (
                (n.dynamicBullets &&
                  ((e.pagination.bulletSize = c.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  a.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"),
                  n.dynamicMainBullets > 1 &&
                    void 0 !== e.previousIndex &&
                    ((e.pagination.dynamicBulletIndex += r - e.previousIndex),
                    e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? (e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1) : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                  (s = r - e.pagination.dynamicBulletIndex),
                  (u = ((l = s + (Math.min(c.length, n.dynamicMainBullets) - 1)) + s) / 2)),
                c.removeClass(n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"),
                a.length > 1)
              )
                c.each(function (e) {
                  var t = L(e),
                    i = t.index();
                  i === r && t.addClass(n.bulletActiveClass),
                    n.dynamicBullets &&
                      (i >= s && i <= l && t.addClass(n.bulletActiveClass + "-main"),
                      i === s &&
                        t
                          .prev()
                          .addClass(n.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(n.bulletActiveClass + "-prev-prev"),
                      i === l &&
                        t
                          .next()
                          .addClass(n.bulletActiveClass + "-next")
                          .next()
                          .addClass(n.bulletActiveClass + "-next-next"));
                });
              else {
                var d = c.eq(r),
                  f = d.index();
                if ((d.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                  for (var p = c.eq(s), h = c.eq(l), v = s; v <= l; v += 1) c.eq(v).addClass(n.bulletActiveClass + "-main");
                  if (e.params.loop)
                    if (f >= c.length - n.dynamicMainBullets) {
                      for (var g = n.dynamicMainBullets; g >= 0; g -= 1) c.eq(c.length - g).addClass(n.bulletActiveClass + "-main");
                      c.eq(c.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev");
                    } else
                      p
                        .prev()
                        .addClass(n.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(n.bulletActiveClass + "-prev-prev"),
                        h
                          .next()
                          .addClass(n.bulletActiveClass + "-next")
                          .next()
                          .addClass(n.bulletActiveClass + "-next-next");
                  else
                    p
                      .prev()
                      .addClass(n.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(n.bulletActiveClass + "-prev-prev"),
                      h
                        .next()
                        .addClass(n.bulletActiveClass + "-next")
                        .next()
                        .addClass(n.bulletActiveClass + "-next-next");
                }
              }
              if (n.dynamicBullets) {
                var m = Math.min(c.length, n.dynamicMainBullets + 4),
                  y = (e.pagination.bulletSize * m - e.pagination.bulletSize) / 2 - u * e.pagination.bulletSize,
                  b = t ? "right" : "left";
                c.css(e.isHorizontal() ? b : "top", y + "px");
              }
            }
            if (("fraction" === n.type && (a.find(R(n.currentClass)).text(n.formatFractionCurrent(r + 1)), a.find(R(n.totalClass)).text(n.formatFractionTotal(o))), "progressbar" === n.type)) {
              var w;
              w = n.progressbarOpposite ? (e.isHorizontal() ? "vertical" : "horizontal") : e.isHorizontal() ? "horizontal" : "vertical";
              var _ = (r + 1) / o,
                x = 1,
                C = 1;
              "horizontal" === w ? (x = _) : (C = _),
                a
                  .find(R(n.progressbarFillClass))
                  .transform("translate3d(0,0,0) scaleX(" + x + ") scaleY(" + C + ")")
                  .transition(e.params.speed);
            }
            "custom" === n.type && n.renderCustom ? (a.html(n.renderCustom(e, r + 1, o)), e.emit("paginationRender", a[0])) : e.emit("paginationUpdate", a[0]),
              e.params.watchOverflow && e.enabled && a[e.isLocked ? "addClass" : "removeClass"](n.lockClass);
          }
        },
        render: function () {
          var e = this,
            t = e.params.pagination;
          if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
            var n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
              r = e.pagination.$el,
              i = "";
            if ("bullets" === t.type) {
              var a = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
              e.params.freeMode && !e.params.loop && a > n && (a = n);
              for (var o = 0; o < a; o += 1) t.renderBullet ? (i += t.renderBullet.call(e, o, t.bulletClass)) : (i += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">");
              r.html(i), (e.pagination.bullets = r.find(R(t.bulletClass)));
            }
            "fraction" === t.type && ((i = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>'), r.html(i)),
              "progressbar" === t.type && ((i = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>'), r.html(i)),
              "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
          }
        },
        init: function () {
          var e = this;
          e.params.pagination = q(e.$el, e.params.pagination, e.params.createElements, { el: "swiper-pagination" });
          var t = e.params.pagination;
          if (t.el) {
            var n = L(t.el);
            0 !== n.length &&
              (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)),
              "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
              n.addClass(t.modifierClass + t.type),
              "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"), (e.pagination.dynamicBulletIndex = 0), t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
              "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
              t.clickable &&
                n.on("click", R(t.bulletClass), function (t) {
                  t.preventDefault();
                  var n = L(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                }),
              B(e.pagination, { $el: n, el: n[0] }),
              e.enabled || n.addClass(t.lockClass));
          }
        },
        destroy: function () {
          var e = this,
            t = e.params.pagination;
          if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
            var n = e.pagination.$el;
            n.removeClass(t.hiddenClass), n.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && n.off("click", R(t.bulletClass));
          }
        },
      };
      const jl = {
        name: "pagination",
        params: {
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function (e) {
              return e;
            },
            formatFractionTotal: function (e) {
              return e;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock",
          },
        },
        create: function () {
          N(this, { pagination: Dl({ dynamicBulletIndex: 0 }, zl) });
        },
        on: {
          init: function (e) {
            e.pagination.init(), e.pagination.render(), e.pagination.update();
          },
          activeIndexChange: function (e) {
            (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
          },
          snapIndexChange: function (e) {
            e.params.loop || e.pagination.update();
          },
          slidesLengthChange: function (e) {
            e.params.loop && (e.pagination.render(), e.pagination.update());
          },
          snapGridLengthChange: function (e) {
            e.params.loop || (e.pagination.render(), e.pagination.update());
          },
          destroy: function (e) {
            e.pagination.destroy();
          },
          "enable disable": function (e) {
            var t = e.pagination.$el;
            t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass);
          },
          click: function (e, t) {
            var n = t.target;
            if (e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !L(n).hasClass(e.params.pagination.bulletClass)) {
              if (e.navigation && ((e.navigation.nextEl && n === e.navigation.nextEl) || (e.navigation.prevEl && n === e.navigation.prevEl))) return;
              !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass);
            }
          },
        },
      };
      var Bl = {
        lastScrollTime: D(),
        lastEventBeforeSnap: void 0,
        recentWheelEvents: [],
        event: function () {
          return b().navigator.userAgent.indexOf("firefox") > -1
            ? "DOMMouseScroll"
            : (function () {
                var e = m(),
                  t = "onwheel",
                  n = t in e;
                if (!n) {
                  var r = e.createElement("div");
                  r.setAttribute(t, "return;"), (n = "function" == typeof r.onwheel);
                }
                return !n && e.implementation && e.implementation.hasFeature && !0 !== e.implementation.hasFeature("", "") && (n = e.implementation.hasFeature("Events.wheel", "3.0")), n;
              })()
            ? "wheel"
            : "mousewheel";
        },
        normalize: function (e) {
          var t = 0,
            n = 0,
            r = 0,
            i = 0;
          return (
            "detail" in e && (n = e.detail),
            "wheelDelta" in e && (n = -e.wheelDelta / 120),
            "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
            "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
            "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
            (r = 10 * t),
            (i = 10 * n),
            "deltaY" in e && (i = e.deltaY),
            "deltaX" in e && (r = e.deltaX),
            e.shiftKey && !r && ((r = i), (i = 0)),
            (r || i) && e.deltaMode && (1 === e.deltaMode ? ((r *= 40), (i *= 40)) : ((r *= 800), (i *= 800))),
            r && !t && (t = r < 1 ? -1 : 1),
            i && !n && (n = i < 1 ? -1 : 1),
            { spinX: t, spinY: n, pixelX: r, pixelY: i }
          );
        },
        handleMouseEnter: function () {
          this.enabled && (this.mouseEntered = !0);
        },
        handleMouseLeave: function () {
          this.enabled && (this.mouseEntered = !1);
        },
        handle: function (e) {
          var t = e,
            n = this;
          if (n.enabled) {
            var r = n.params.mousewheel;
            n.params.cssMode && t.preventDefault();
            var i = n.$el;
            if (("container" !== n.params.mousewheel.eventsTarget && (i = L(n.params.mousewheel.eventsTarget)), !n.mouseEntered && !i[0].contains(t.target) && !r.releaseOnEdges)) return !0;
            t.originalEvent && (t = t.originalEvent);
            var a = 0,
              o = n.rtlTranslate ? -1 : 1,
              s = Bl.normalize(t);
            if (r.forceToAxis)
              if (n.isHorizontal()) {
                if (!(Math.abs(s.pixelX) > Math.abs(s.pixelY))) return !0;
                a = -s.pixelX * o;
              } else {
                if (!(Math.abs(s.pixelY) > Math.abs(s.pixelX))) return !0;
                a = -s.pixelY;
              }
            else a = Math.abs(s.pixelX) > Math.abs(s.pixelY) ? -s.pixelX * o : -s.pixelY;
            if (0 === a) return !0;
            r.invert && (a = -a);
            var l = n.getTranslate() + a * r.sensitivity;
            if (
              (l >= n.minTranslate() && (l = n.minTranslate()),
              l <= n.maxTranslate() && (l = n.maxTranslate()),
              (!!n.params.loop || !(l === n.minTranslate() || l === n.maxTranslate())) && n.params.nested && t.stopPropagation(),
              n.params.freeMode)
            ) {
              var u = { time: D(), delta: Math.abs(a), direction: Math.sign(a) },
                c = n.mousewheel.lastEventBeforeSnap,
                d = c && u.time < c.time + 500 && u.delta <= c.delta && u.direction === c.direction;
              if (!d) {
                (n.mousewheel.lastEventBeforeSnap = void 0), n.params.loop && n.loopFix();
                var f = n.getTranslate() + a * r.sensitivity,
                  p = n.isBeginning,
                  h = n.isEnd;
                if (
                  (f >= n.minTranslate() && (f = n.minTranslate()),
                  f <= n.maxTranslate() && (f = n.maxTranslate()),
                  n.setTransition(0),
                  n.setTranslate(f),
                  n.updateProgress(),
                  n.updateActiveIndex(),
                  n.updateSlidesClasses(),
                  ((!p && n.isBeginning) || (!h && n.isEnd)) && n.updateSlidesClasses(),
                  n.params.freeModeSticky)
                ) {
                  clearTimeout(n.mousewheel.timeout), (n.mousewheel.timeout = void 0);
                  var v = n.mousewheel.recentWheelEvents;
                  v.length >= 15 && v.shift();
                  var g = v.length ? v[v.length - 1] : void 0,
                    m = v[0];
                  if ((v.push(u), g && (u.delta > g.delta || u.direction !== g.direction))) v.splice(0);
                  else if (v.length >= 15 && u.time - m.time < 500 && m.delta - u.delta >= 1 && u.delta <= 6) {
                    var y = a > 0 ? 0.8 : 0.2;
                    (n.mousewheel.lastEventBeforeSnap = u),
                      v.splice(0),
                      (n.mousewheel.timeout = I(function () {
                        n.slideToClosest(n.params.speed, !0, void 0, y);
                      }, 0));
                  }
                  n.mousewheel.timeout ||
                    (n.mousewheel.timeout = I(function () {
                      (n.mousewheel.lastEventBeforeSnap = u), v.splice(0), n.slideToClosest(n.params.speed, !0, void 0, 0.5);
                    }, 500));
                }
                if ((d || n.emit("scroll", t), n.params.autoplay && n.params.autoplayDisableOnInteraction && n.autoplay.stop(), f === n.minTranslate() || f === n.maxTranslate())) return !0;
              }
            } else {
              var b = { time: D(), delta: Math.abs(a), direction: Math.sign(a), raw: e },
                w = n.mousewheel.recentWheelEvents;
              w.length >= 2 && w.shift();
              var _ = w.length ? w[w.length - 1] : void 0;
              if ((w.push(b), _ ? (b.direction !== _.direction || b.delta > _.delta || b.time > _.time + 150) && n.mousewheel.animateSlider(b) : n.mousewheel.animateSlider(b), n.mousewheel.releaseScroll(b))) return !0;
            }
            return t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1;
          }
        },
        animateSlider: function (e) {
          var t = this,
            n = b();
          return !(
            (this.params.mousewheel.thresholdDelta && e.delta < this.params.mousewheel.thresholdDelta) ||
            (this.params.mousewheel.thresholdTime && D() - t.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) ||
            (!(e.delta >= 6 && D() - t.mousewheel.lastScrollTime < 60) &&
              (e.direction < 0 ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), t.emit("scroll", e.raw)) : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), t.emit("scroll", e.raw)),
              (t.mousewheel.lastScrollTime = new n.Date().getTime()),
              1))
          );
        },
        releaseScroll: function (e) {
          var t = this,
            n = t.params.mousewheel;
          if (e.direction < 0) {
            if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
          } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges) return !0;
          return !1;
        },
        enable: function () {
          var e = this,
            t = Bl.event();
          if (e.params.cssMode) return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
          if (!t) return !1;
          if (e.mousewheel.enabled) return !1;
          var n = e.$el;
          return (
            "container" !== e.params.mousewheel.eventsTarget && (n = L(e.params.mousewheel.eventsTarget)),
            n.on("mouseenter", e.mousewheel.handleMouseEnter),
            n.on("mouseleave", e.mousewheel.handleMouseLeave),
            n.on(t, e.mousewheel.handle),
            (e.mousewheel.enabled = !0),
            !0
          );
        },
        disable: function () {
          var e = this,
            t = Bl.event();
          if (e.params.cssMode) return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
          if (!t) return !1;
          if (!e.mousewheel.enabled) return !1;
          var n = e.$el;
          return "container" !== e.params.mousewheel.eventsTarget && (n = L(e.params.mousewheel.eventsTarget)), n.off(t, e.mousewheel.handle), (e.mousewheel.enabled = !1), !0;
        },
      };
      const Nl = {
        name: "mousewheel",
        params: { mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null } },
        create: function () {
          N(this, {
            mousewheel: {
              enabled: !1,
              lastScrollTime: D(),
              lastEventBeforeSnap: void 0,
              recentWheelEvents: [],
              enable: Bl.enable,
              disable: Bl.disable,
              handle: Bl.handle,
              handleMouseEnter: Bl.handleMouseEnter,
              handleMouseLeave: Bl.handleMouseLeave,
              animateSlider: Bl.animateSlider,
              releaseScroll: Bl.releaseScroll,
            },
          });
        },
        on: {
          init: function (e) {
            !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(), e.params.mousewheel.enabled && e.mousewheel.enable();
          },
          destroy: function (e) {
            e.params.cssMode && e.mousewheel.enable(), e.mousewheel.enabled && e.mousewheel.disable();
          },
        },
      };
      function Rl() {
        return (
          (Rl =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          Rl.apply(this, arguments)
        );
      }
      var ql = {
        LinearSpline: function (e, t) {
          var n, r, i, a, o;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((o = (function (e, t) {
                    for (r = -1, n = e.length; n - r > 1; ) e[(i = (n + r) >> 1)] <= t ? (r = i) : (n = i);
                    return n;
                  })(this.x, e)),
                  (a = o - 1),
                  ((e - this.x[a]) * (this.y[o] - this.y[a])) / (this.x[o] - this.x[a]) + this.y[a])
                : 0;
            }),
            this
          );
        },
        getInterpolateFunction: function (e) {
          var t = this;
          t.controller.spline || (t.controller.spline = t.params.loop ? new ql.LinearSpline(t.slidesGrid, e.slidesGrid) : new ql.LinearSpline(t.snapGrid, e.snapGrid));
        },
        setTranslate: function (e, t) {
          var n,
            r,
            i = this,
            a = i.controller.control,
            o = i.constructor;
          function s(e) {
            var t = i.rtlTranslate ? -i.translate : i.translate;
            "slide" === i.params.controller.by && (i.controller.getInterpolateFunction(e), (r = -i.controller.spline.interpolate(-t))),
              (r && "container" !== i.params.controller.by) || ((n = (e.maxTranslate() - e.minTranslate()) / (i.maxTranslate() - i.minTranslate())), (r = (t - i.minTranslate()) * n + e.minTranslate())),
              i.params.controller.inverse && (r = e.maxTranslate() - r),
              e.updateProgress(r),
              e.setTranslate(r, i),
              e.updateActiveIndex(),
              e.updateSlidesClasses();
          }
          if (Array.isArray(a)) for (var l = 0; l < a.length; l += 1) a[l] !== t && a[l] instanceof o && s(a[l]);
          else a instanceof o && t !== a && s(a);
        },
        setTransition: function (e, t) {
          var n,
            r = this,
            i = r.constructor,
            a = r.controller.control;
          function o(t) {
            t.setTransition(e, r),
              0 !== e &&
                (t.transitionStart(),
                t.params.autoHeight &&
                  I(function () {
                    t.updateAutoHeight();
                  }),
                t.$wrapperEl.transitionEnd(function () {
                  a && (t.params.loop && "slide" === r.params.controller.by && t.loopFix(), t.transitionEnd());
                }));
          }
          if (Array.isArray(a)) for (n = 0; n < a.length; n += 1) a[n] !== t && a[n] instanceof i && o(a[n]);
          else a instanceof i && t !== a && o(a);
        },
      };
      const Fl = {
        name: "controller",
        params: { controller: { control: void 0, inverse: !1, by: "slide" } },
        create: function () {
          N(this, { controller: Rl({ control: this.params.controller.control }, ql) });
        },
        on: {
          update: function (e) {
            e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
          },
          resize: function (e) {
            e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
          },
          observerUpdate: function (e) {
            e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
          },
          setTranslate: function (e, t, n) {
            e.controller.control && e.controller.setTranslate(t, n);
          },
          setTransition: function (e, t, n) {
            e.controller.control && e.controller.setTransition(t, n);
          },
        },
      };
      function Hl(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      we.use([Il, jl, Me, Nl, Le, Ce, Ee, Fl]);
      const Wl = (function () {
        function e(t, n) {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.container = t),
            (this.settings = n),
            (this.instanceOfSwiper = null),
            this.init();
        }
        var t, n;
        return (
          (t = e),
          (n = [
            {
              key: "init",
              value: function () {
                var e = this.settings,
                  t = Object.assign(e, { watchSlidesVisibility: !0, watchOverflow: !0, resizeObserver: !0, observer: !0, observeSlideChildren: !0, lazy: { loadPrevNext: !0 } });
                this.instanceOfSwiper = new we(this.container, t);
              },
            },
            {
              key: "getSwiperObject",
              value: function () {
                return this.instanceOfSwiper;
              },
            },
          ]) && Hl(t.prototype, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function $l() {
        return (
          ($l =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
              return e;
            }),
          $l.apply(this, arguments)
        );
      }
      var Vl = {
        setTranslate: function () {
          var e = this;
          if (e.params.scrollbar.el && e.scrollbar.el) {
            var t = e.scrollbar,
              n = e.rtlTranslate,
              r = e.progress,
              i = t.dragSize,
              a = t.trackSize,
              o = t.$dragEl,
              s = t.$el,
              l = e.params.scrollbar,
              u = i,
              c = (a - i) * r;
            n ? ((c = -c) > 0 ? ((u = i - c), (c = 0)) : -c + i > a && (u = a + c)) : c < 0 ? ((u = i + c), (c = 0)) : c + i > a && (u = a - c),
              e.isHorizontal() ? (o.transform("translate3d(" + c + "px, 0, 0)"), (o[0].style.width = u + "px")) : (o.transform("translate3d(0px, " + c + "px, 0)"), (o[0].style.height = u + "px")),
              l.hide &&
                (clearTimeout(e.scrollbar.timeout),
                (s[0].style.opacity = 1),
                (e.scrollbar.timeout = setTimeout(function () {
                  (s[0].style.opacity = 0), s.transition(400);
                }, 1e3)));
          }
        },
        setTransition: function (e) {
          var t = this;
          t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
        },
        updateSize: function () {
          var e = this;
          if (e.params.scrollbar.el && e.scrollbar.el) {
            var t = e.scrollbar,
              n = t.$dragEl,
              r = t.$el;
            (n[0].style.width = ""), (n[0].style.height = "");
            var i,
              a = e.isHorizontal() ? r[0].offsetWidth : r[0].offsetHeight,
              o = e.size / e.virtualSize,
              s = o * (a / e.size);
            (i = "auto" === e.params.scrollbar.dragSize ? a * o : parseInt(e.params.scrollbar.dragSize, 10)),
              e.isHorizontal() ? (n[0].style.width = i + "px") : (n[0].style.height = i + "px"),
              (r[0].style.display = o >= 1 ? "none" : ""),
              e.params.scrollbar.hide && (r[0].style.opacity = 0),
              B(t, { trackSize: a, divider: o, moveDivider: s, dragSize: i }),
              e.params.watchOverflow && e.enabled && t.$el[e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
          }
        },
        getPointerPosition: function (e) {
          return this.isHorizontal() ? ("touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX) : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY;
        },
        setDragPosition: function (e) {
          var t,
            n = this,
            r = n.scrollbar,
            i = n.rtlTranslate,
            a = r.$el,
            o = r.dragSize,
            s = r.trackSize,
            l = r.dragStartPos;
          (t = (r.getPointerPosition(e) - a.offset()[n.isHorizontal() ? "left" : "top"] - (null !== l ? l : o / 2)) / (s - o)), (t = Math.max(Math.min(t, 1), 0)), i && (t = 1 - t);
          var u = n.minTranslate() + (n.maxTranslate() - n.minTranslate()) * t;
          n.updateProgress(u), n.setTranslate(u), n.updateActiveIndex(), n.updateSlidesClasses();
        },
        onDragStart: function (e) {
          var t = this,
            n = t.params.scrollbar,
            r = t.scrollbar,
            i = t.$wrapperEl,
            a = r.$el,
            o = r.$dragEl;
          (t.scrollbar.isTouched = !0),
            (t.scrollbar.dragStartPos = e.target === o[0] || e.target === o ? r.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
            e.preventDefault(),
            e.stopPropagation(),
            i.transition(100),
            o.transition(100),
            r.setDragPosition(e),
            clearTimeout(t.scrollbar.dragTimeout),
            a.transition(0),
            n.hide && a.css("opacity", 1),
            t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
            t.emit("scrollbarDragStart", e);
        },
        onDragMove: function (e) {
          var t = this,
            n = t.scrollbar,
            r = t.$wrapperEl,
            i = n.$el,
            a = n.$dragEl;
          t.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), n.setDragPosition(e), r.transition(0), i.transition(0), a.transition(0), t.emit("scrollbarDragMove", e));
        },
        onDragEnd: function (e) {
          var t = this,
            n = t.params.scrollbar,
            r = t.scrollbar,
            i = t.$wrapperEl,
            a = r.$el;
          t.scrollbar.isTouched &&
            ((t.scrollbar.isTouched = !1),
            t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
            n.hide &&
              (clearTimeout(t.scrollbar.dragTimeout),
              (t.scrollbar.dragTimeout = I(function () {
                a.css("opacity", 0), a.transition(400);
              }, 1e3))),
            t.emit("scrollbarDragEnd", e),
            n.snapOnRelease && t.slideToClosest());
        },
        enableDraggable: function () {
          var e = this;
          if (e.params.scrollbar.el) {
            var t = m(),
              n = e.scrollbar,
              r = e.touchEventsTouch,
              i = e.touchEventsDesktop,
              a = e.params,
              o = e.support,
              s = n.$el[0],
              l = !(!o.passiveListener || !a.passiveListeners) && { passive: !1, capture: !1 },
              u = !(!o.passiveListener || !a.passiveListeners) && { passive: !0, capture: !1 };
            s &&
              (o.touch
                ? (s.addEventListener(r.start, e.scrollbar.onDragStart, l), s.addEventListener(r.move, e.scrollbar.onDragMove, l), s.addEventListener(r.end, e.scrollbar.onDragEnd, u))
                : (s.addEventListener(i.start, e.scrollbar.onDragStart, l), t.addEventListener(i.move, e.scrollbar.onDragMove, l), t.addEventListener(i.end, e.scrollbar.onDragEnd, u)));
          }
        },
        disableDraggable: function () {
          var e = this;
          if (e.params.scrollbar.el) {
            var t = m(),
              n = e.scrollbar,
              r = e.touchEventsTouch,
              i = e.touchEventsDesktop,
              a = e.params,
              o = e.support,
              s = n.$el[0],
              l = !(!o.passiveListener || !a.passiveListeners) && { passive: !1, capture: !1 },
              u = !(!o.passiveListener || !a.passiveListeners) && { passive: !0, capture: !1 };
            s &&
              (o.touch
                ? (s.removeEventListener(r.start, e.scrollbar.onDragStart, l), s.removeEventListener(r.move, e.scrollbar.onDragMove, l), s.removeEventListener(r.end, e.scrollbar.onDragEnd, u))
                : (s.removeEventListener(i.start, e.scrollbar.onDragStart, l), t.removeEventListener(i.move, e.scrollbar.onDragMove, l), t.removeEventListener(i.end, e.scrollbar.onDragEnd, u)));
          }
        },
        init: function () {
          var e = this,
            t = e.scrollbar,
            n = e.$el;
          e.params.scrollbar = q(n, e.params.scrollbar, e.params.createElements, { el: "swiper-scrollbar" });
          var r = e.params.scrollbar;
          if (r.el) {
            var i = L(r.el);
            e.params.uniqueNavElements && "string" == typeof r.el && i.length > 1 && 1 === n.find(r.el).length && (i = n.find(r.el));
            var a = i.find("." + e.params.scrollbar.dragClass);
            0 === a.length && ((a = L('<div class="' + e.params.scrollbar.dragClass + '"></div>')), i.append(a)),
              B(t, { $el: i, el: i[0], $dragEl: a, dragEl: a[0] }),
              r.draggable && t.enableDraggable(),
              i && i[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
          }
        },
        destroy: function () {
          this.scrollbar.disableDraggable();
        },
      };
      const Yl = {
        name: "scrollbar",
        params: { scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } },
        create: function () {
          N(this, { scrollbar: $l({ isTouched: !1, timeout: null, dragTimeout: null }, Vl) });
        },
        on: {
          init: function (e) {
            e.scrollbar.init(), e.scrollbar.updateSize(), e.scrollbar.setTranslate();
          },
          update: function (e) {
            e.scrollbar.updateSize();
          },
          resize: function (e) {
            e.scrollbar.updateSize();
          },
          observerUpdate: function (e) {
            e.scrollbar.updateSize();
          },
          setTranslate: function (e) {
            e.scrollbar.setTranslate();
          },
          setTransition: function (e, t) {
            e.scrollbar.setTransition(t);
          },
          "enable disable": function (e) {
            var t = e.scrollbar.$el;
            t && t[e.enabled ? "removeClass" : "addClass"](e.params.scrollbar.lockClass);
          },
          destroy: function (e) {
            e.scrollbar.destroy();
          },
        },
      };
      function Gl(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      we.use([Nl, Me, Yl]),
        oa.registerPlugin(Us),
        (function () {
          var e = t()(".manifesto-slides").data("slide");
          if (t()("#manifestoSlides").length)
            if (t()(window).width() >= 992) {
              var n = new we("#manifestoSlides", { speed: 600, slidesPerView: 1, direction: "vertical", effect: "fade", fadeEffect: { crossFade: !0 } });
              Us.create({
                trigger: ".manifesto-slides",
                pin: !0,
                start: "top top",
                toggleClass: "manifesto-slides--active",
                end: "+=100%",
                onUpdate: function (r) {
                  var i = r.progress,
                    a = (r.direction, r.isActive, i * e),
                    o = 100 * i;
                  n.slideTo(a, 600), t()(".scrollbar-thumb").css("height", "".concat(o, "%"));
                },
              });
            } else new we("#manifestoSlides", { speed: 600, slidesPerView: 1, pagination: { el: ".swiper-progress__fill", type: "progressbar" } });
        })();
      var Xl = (function () {
        function e(n) {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.target = t()(n));
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "init",
              value: function () {
                var e = this;
                this.target.on("click", function (n) {
                  e.target.removeClass("active");
                  var r = t()(n.target);
                  r.addClass("active");
                  var i = r.data("href");
                  t()(document.documentElement).animate({ scrollTop: t()("#".concat(i)).offset().top - 20 }, 500);
                });
              },
            },
          ]) && Gl(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      function Ul(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      oa.registerPlugin(Us), we.use([Il, Ee, Ce, Fl, Yl, Le]);
      var Kl = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.stickyPurchase = document.querySelector(".product-purchase")),
            (this.selectricPrice = t()("#selectric-price")),
            (this.pdpWaitlist = t()(".pdp-waitlist")),
            (this.pdpWaitlistForm = t()(".pdp-waitlist__form")),
            this.initWaitlist();
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "stickyAddToCart",
              value: function () {
                var e = this,
                  t = (document.querySelector(".product-purchase__static"), document.querySelector(".product-purchase__sticky"), document.querySelector(".pdp-top"));
                Us.create({
                  trigger: ".pdp-description",
                  start: "top center",
                  onEnterBack: function () {
                    e.stickyPurchase && e.stickyPurchase.removeAttribute("style");
                  },
                }),
                  oa.timeline({
                    scrollTrigger: {
                      trigger: t,
                      start: "bottom center",
                      onEnter: function () {
                        e.stickyPurchase && e.stickyPurchase.classList.add("product-purchase--sticky");
                      },
                      onLeaveBack: function () {
                        oa.to(e.stickyPurchase, {
                          alpha: 1,
                          duration: 0.5,
                          onComplete: function () {
                            e.stickyPurchase && e.stickyPurchase.classList.remove("product-purchase--sticky");
                          },
                        });
                      },
                    },
                  });
              },
            },
            {
              key: "initPriceVariant",
              value: function () {
                this.selectricPrice.selectric({ arrowButtonMarkup: '<b class="button"><i class="icon-arrow-next"></i></b>', disableOnMobile: !1, nativeOnMobile: !1 });
              },
            },
            {
              key: "initSpecificationsGallery",
              value: function () {
                var e = new we("#specification-controller", { slidesPerView: "auto", slideToClickedSlide: !0, watchSlidesProgress: !0, scrollbar: { el: "#specification-controller .swiper-progressbar" } }),
                  t = new we("#specification__left", {
                    slidesPerView: 1,
                    watchSlidesVisibility: !0,
                    watchSlidesProgress: !0,
                    lazy: { loadPrevNext: !0 },
                    thumbs: { swiper: e },
                    navigation: { nextEl: ".specification__left .swiper-button-next", prevEl: ".specification__left .swiper-button-prev" },
                  }),
                  n = new we("#specification__right", { effect: "fade", speed: 800, allowTouchMove: !1, simulateTouch: !1, fadeEffect: { crossFade: !0 } });
                t.controller.control = n;
              },
            },
            {
              key: "initWaitlist",
              value: function () {
                t()(this.pdpWaitlistForm).on("submit", function (e) {
                  e.preventDefault(), t()(this).parents(".pdp-waitlist").addClass("pdp-waitlist--submitted");
                });
              },
            },
            {
              key: "initPdpDescriptionCarousel",
              value: function () {
                var e = new we("#pdp-description", {
                  slidesPerView: 1,
                  loop: !0,
                  spaceBetween: 15,
                  lazy: { loadPrevNext: !0 },
                  navigation: { prevEl: ".pdp-description .swiper-button-prev", nextEl: ".pdp-description .swiper-button-next" },
                  scrollbar: { el: "#pdp-description .swiper-progressbar" },
                  breakpoints: { 992: { spaceBetween: 0 } },
                  on: {
                    activeIndexChange: function (e) {
                      var n = e.realIndex;
                      console.log(n), 0 == n ? t()(".btn--loadmore").removeClass("btn--loadmore--inactive") : t()(".btn--loadmore").addClass("btn--loadmore--inactive");
                    },
                  },
                });
                t()(".btn--loadmore .abs-link").on("click", function (t) {
                  t.preventDefault(), e.slideTo(2);
                });
              },
            },
          ]),
          r && Ul(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      function Ql(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      var Zl = (function () {
          function e(n) {
            !(function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e),
              (this.target = t()(n));
          }
          var n, r;
          return (
            (n = e),
            (r = [
              {
                key: "init",
                value: function () {
                  var e = t()(".load_more");
                  e.on("click", function () {
                    t()(".article--hide:lt(".concat(8, ")")).removeClass("article--hide"), t()(".article--hide").length || e.hide();
                  }),
                    t()(".article--hide").length || e.hide();
                },
              },
            ]) && Ql(n.prototype, r),
            Object.defineProperty(n, "prototype", { writable: !1 }),
            e
          );
        })(),
        Jl = n(486);
      function eu(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return tu(e);
          })(e) ||
          (function (e) {
            if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
          })(e) ||
          (function (e, t) {
            if (e) {
              if ("string" == typeof e) return tu(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? tu(e, t) : void 0;
            }
          })(e) ||
          (function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          })()
        );
      }
      function tu(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function nu(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      we.use([Le, Nl, Me]);
      var ru = (function () {
        function e() {
          !(function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.ugcLightbox = t()(".ugc-lightbox")),
            (this.ugcCardsWrap = t()(".ugc__products")),
            (this.ugcInfoCarousel = Array.from(document.querySelectorAll(".ugc-info__carousel"))),
            this.init();
        }
        var n, r;
        return (
          (n = e),
          (r = [
            {
              key: "init",
              value: function () {
                var e = this;
                t()(".ugc-hero__item").each(function (e, n) {
                  if (0 == e || 1 == e) {
                    var r = t()(n).clone();
                    t()(n).parent().append(r);
                  }
                }),
                  t()(".ugc-filter__btn").on("click", function (e) {
                    e.preventDefault(),
                      t()(this).parent().hasClass("ugc-filter--open")
                        ? (t()(this).parent().toggleClass("ugc-filter--open"), t()(this).next(".ugc-filter__body").slideToggle())
                        : (t()(".ugc-filter__body").slideUp(), t()(this).parent().siblings(".ugc-filter").removeClass("ugc-filter--open"), t()(this).next(".ugc-filter__body").slideDown(), t()(this).parent().addClass("ugc-filter--open"));
                  }),
                  t()(".ugc-view").on("click", ".ugc-view__btn", function (e) {
                    e.preventDefault(), t()(".ugc-view__btn").removeClass("ugc-view__btn--active"), t()(this).addClass("ugc-view__btn--active");
                    var n = t()(this).data("view"),
                      r = t()(".ugc__products"),
                      i = r.attr("class").replace("ugc__products", "");
                    r.removeClass(i), r.addClass("ugc__products--grid-".concat(n));
                  });
                var n = t()(".ugc__products");
                function r() {
                  var e = n.length && n.attr("class").replace("ugc__products", "");
                  t()(window).width() <= 991.98 &&
                    e &&
                    (t()(".ugc-view__btn").removeClass("ugc-view__btn--active"),
                    t()(".ugc-view__btn[data-view=2]").addClass("ugc-view__btn--active"),
                    t()(".ugc__products").removeClass(e),
                    t()(".ugc__products").addClass("ugc__products--grid-2"));
                }
                r(),
                  t()(window).on("resize", r),
                  t()(".ugc-sidebar__btn").on("click", function (e) {
                    t()(".ugc-sidebar").addClass("ugc-sidebar--open"), t()(".ugc-sidebar__overlay").fadeIn();
                  }),
                  t()(".ugc-sidebar__close-btn").on("click", function (e) {
                    t()(".ugc-sidebar").removeClass("ugc-sidebar--open"), t()(".ugc-sidebar__overlay").fadeOut();
                  });
                var i = new we(".ugc-lightbox__carousel", {
                    slidesPerView: 1,
                    observer: !0,
                    loop: !0,
                    observeParents: !0,
                    observeSlideChildren: !0,
                    navigation: { prevEl: ".ugc-lightbox__pagination-prev", nextEl: ".ugc-lightbox__pagination-next" },
                  }),
                  a = this;
                t()(this.ugcCardsWrap).on("click", ".ugc-card", function (e) {
                  e.preventDefault(), a.ugcLightbox.fadeIn(), i.slideToLoop(t()(this).index(), 0), t()("body").addClass("ugc-open");
                }),
                  t()(".ugc-lightbox__close").on("click", function () {
                    t()(e.ugcLightbox).fadeOut(), t()("body").removeClass("ugc-open");
                  });
                var o = { slidesPerView: 1, observer: !0, observeParents: !0, observeSlideChildren: !0, nested: !0 };
                function s() {
                  var e = a.ugcInfoCarousel.map(function (e) {
                    if (e) return (o.pagination = { type: "progressbar", el: e.querySelector(".ugc-info__carousel-progress") }), new we(e, o);
                  });
                  window.innerWidth >= 992 &&
                    e.forEach(function (e) {
                      return e.destroy(!1, !0);
                    });
                }
                s(), window.addEventListener("resize", (0, Jl.throttle)(s, 100));
                var l = t()(".ugc-lightbox__content .ugc-lightbox__item"),
                  u = Array.from(l)
                    .reduce(function (e, n) {
                      return (
                        t()(n)
                          .find("[data-color]")
                          .each(function () {
                            e.includes(t()(this).data("color")) || e.push(t()(this).data("color"));
                          }),
                        e
                      );
                    }, [])
                    .sort();
                function c() {
                  var e = Array.from(t()('.ugc-filter__item input[type="checkbox"][name="color"]:checked')).map(function (e) {
                      return t()(e).val();
                    }),
                    n = Array.from(t()('.ugc-filter__item input[type="checkbox"][name="category"]:checked')).map(function (e) {
                      return t()(e).val();
                    });
                  (u.length || categories.length) &&
                    t()(".ugc-lightbox__content .ugc-lightbox__item").each(function () {
                      var r = t()(this),
                        i = t()('.ugc-card[data-id="'.concat(r.attr("id"), '"]')),
                        a = Array.from(r.find("[data-color]")).map(function (e) {
                          return t()(e).data("color");
                        }),
                        o = Array.from(r.find("[data-tags]")).reduce(function (e, n) {
                          var r = t()(n).data("tags").split("|");
                          return [].concat(eu(e), eu(r));
                        }, []);
                      (a = eu(new Set(a))),
                        (o = eu(new Set(o))),
                        (e.length &&
                          e.every(function (e) {
                            return !a.includes(e);
                          })) ||
                        (n.length &&
                          n.every(function (e) {
                            return !o.includes(e);
                          }))
                          ? (d(i[0], "span"), r.hide())
                          : (d(i[0], "div"), r.show());
                    });
                }
                function d(e, n) {
                  var r = e.outerHTML,
                    i = new RegExp("<" + e.tagName, "i"),
                    a = r.replace(i, "<" + n);
                  (i = new RegExp("</" + e.tagName, "i")), (a = a.replace(i, "</" + n)), t()(e).replaceWith(a);
                }
                u.forEach(function (e) {
                  var n = '\n\t\t\t\t<li class="ugc-filter__item ugc-color">\n\t\t\t\t\t<input class="ugc-color__input" type="checkbox" id="ugc-color-'
                    .concat(e, '" name="color" value="')
                    .concat(e, '">\n\t\t\t\t\t<label class="ugc-color__label" style="background-color: ')
                    .concat(e, '" for="ugc-color-')
                    .concat(e, '"></label>\n\t\t\t\t</li>\n\t\t\t');
                  t()(".ugc-filter--color .ugc-filter__list").append(n);
                }),
                  t()('.ugc-filter__item input[type="checkbox"]').on("change", function () {
                    c();
                  }),
                  t()(".ugc-filter--color .ugc-filter__reset-btn").on("click", function () {
                    t()('.ugc-filter__item input[type="checkbox"][name="color"]:checked').trigger("click"), c();
                  }),
                  t()(".ugc-filter .ugc-filter__reset-btn").on("click", function () {
                    t()('.ugc-filter__item input[type="checkbox"][name="category"]:checked').trigger("click"), c();
                  });
              },
            },
          ]) && nu(n.prototype, r),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          e
        );
      })();
      oa.registerPlugin(Us),
        document.addEventListener("DOMContentLoaded", function () {
          var e = 0,
            n = t()("header.header");
          function r(r) {
            if (1 == e) {
              var i = t()("#hero-slide-bg").find(".swiper-slide").attr("data-header");
              n.addClass(i);
            } else {
              var a = r.realIndex,
                o = t()(r.el).find(".swiper-slide[data-swiper-slide-index=".concat(a, "]")).attr("data-header");
              n.removeClass("header--light header--dark").addClass(o);
            }
          }
          t()("#hero-slide-bg .swiper-slide").each(function () {
            e++;
          }),
            t()("#hero-column-slide .swiper-slide").length > 1
              ? new Wl("#hero-column-slide", {
                  slidesPerView: 1,
                  loop: !0,
                  noSwiping: !1,
                  autoplay: { delay: 3e3 },
                  speed: 5000,
                  pagination: { el: ".swiper-pagination", clickable: !0 },
                  on: {
                    slideChange: function (e) {
                      var n = e.slides[e.activeIndex];
                      t()("header.header").removeClass("header--dark").removeClass("header--light").addClass(t()(n).data("header"));
                    },
                  },
                })
              : t()("header.header").removeClass("header--dark").removeClass("header--light").addClass(t()("#hero-column-slide .swiper-slide").data("header")),
            t()("#hero-slide-bg .swiper-slide").length > 1
              ? new Wl("#hero-slide-bg", {
                  slidesPerView: 1,
                  loop: !0,
                  noSwiping: !1,
                  autoplay: { delay: 3e3, disableOnInteraction: !1 },
                  speed: 5000,
                  pagination: { el: "#hero-slide-bg .swiper-pagination", clickable: !0 },
                  on: {
                    slideChange: function (e) {
                      var n = e.slides[e.activeIndex];
                      t()("header.header").removeClass("header--dark").removeClass("header--light").addClass(t()(n).data("header"));
                    },
                  },
                  init: function (e) {
                    if ((r(e), t()(window).width() >= 992)) {
                      var n = oa.timeline({ scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: !0 } });
                      oa.utils.toArray(".hr-parallax").forEach(function (e) {
                        var t = e.dataset.depth,
                          r = -e.offsetHeight * t;
                        n.to(e, { y: r, ease: "none" }, 0);
                      });
                    }
                  },
                  activeIndexChange: function (e) {
                    r(e);
                  },
                })
              : t()("header.header").removeClass("header--dark").removeClass("header--light").addClass(t()("#hero-slide-bg .swiper-slide").data("header"));
        }),
        we.use([Le, Ce]),
        window.addEventListener("DOMContentLoaded", function () {
          new Wl(".plp-carousel", {
            slidesPerView: 2.5,
            spaceBetween: 32,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            speed: 600,
            breakpoints: {
              320: { slidesPerView: 1.25, spaceBetween: 15 },
              575: { slidesPerView: 1.5, spaceBetween: 15 },
              992: { slidesPerView: 1.5 },
              1024: { slidesPerView: 2 },
              1200: { slidesPerView: 2.5, touchRatio: 0.7, threshold: 100, shortSwipes: !1 },
            },
          }),
            t()(".plp-product-grid-carousel").each(function () {
              var e = t()(this).outerWidth(),
                n = t()(this).find(".swiper-slide"),
                r = n.length,
                i = e;
              n.outerWidth(e + 0.1), (i *= r - 1), t()(n).parent().outerWidth(i);
            });
        }),
        t()(window).on("resize", function () {
          setTimeout(function () {
            t()(".plp-product-grid-carousel").each(function () {
              var e = t()(this).outerWidth(),
                n = t()(this).find(".swiper-slide"),
                r = n.length,
                i = e;
              n.outerWidth(e + 0.1), (i *= r - 1), t()(n).parent().outerWidth(i);
            });
          }, 300);
        });
      var iu = Vr.registerPlugin(aa) || Vr;
      iu.core.Tween,
        window.addEventListener("DOMContentLoaded", function () {
          var e = document.querySelector(".jumbo");
          if (e) {
            var t = function (e, t) {
                iu.to(e, 0.5, { x: ((r.x - n.width / 2) / n.width) * t, y: ((r.y - n.height / 2) / n.height) * t });
              },
              n = e.getBoundingClientRect(),
              r = { x: 0, y: 0, moved: !1 };
            e.addEventListener("mousemove", function (e) {
              (r.moved = !0), (r.x = e.clientX - n.left), (r.y = e.clientY - n.top);
            }),
              iu.ticker.add(function () {
                r.moved && (t(".jumbo--parallax-item--1", -50), t(".jumbo--parallax-item--2", 50)), (r.moved = !1);
              }),
              window.addEventListener("resize", function () {
                n = e.getBoundingClientRect();
              }),
              window.addEventListener("scroll", function () {
                n = e.getBoundingClientRect();
              });
          }
        }),
        (window.$ = t()),
        t()(document).ready(function () {
          new (o())(), new d(), new Pl(), new Ne();
          var e = new p(".accordion-anchor"),
            n = new Xl(".faq-link"),
            r = new Zl(".press"),
            a = (new (i())(".faq-stick"), new l()),
            s = new Kl();
          if ((new ru(), a.init(), s.initSpecificationsGallery(), s.initPdpDescriptionCarousel(), t()(".product-purchase"))) {
            var u = new Kl();
            u.stickyAddToCart(), u.initPriceVariant();
          }
          new ze(".collapse", { selector: ".collapse__item", trigger: ".collapse__head", body: ".collapse__body", activeClass: "active" }),
            e.init(),
            n.init(),
            r.init(),
            t()("section.about").length &&
              ((function (e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100,
                  r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".press-years--aboutYear",
                  i = t()(e),
                  a = t()(".active-circle"),
                  o = t()(r);
                i &&
                  i.on("click", function (e) {
                    var r = t()(e.target),
                      s = r.index(),
                      l = e.target.getBoundingClientRect(),
                      u = window.getComputedStyle(e.target);
                    (u = u.getPropertyValue("padding-left")),
                      (u = parseFloat(u)),
                      r.hasClass("active") ||
                        (r.data("text"),
                        r.hasClass("active") ||
                          i.each(function (e, n) {
                            t()(n).removeClass("active");
                          }),
                        r.addClass("active"),
                        o.hide(),
                        o.eq(s - 1).fadeIn(),
                        t()(window).width() >= 1280 ? a.css({ left: "".concat(l.x - n, "px") }) : a.css({ left: "".concat(l.x - u, "px") }));
                  });
              })(".year-anchor"),
              (function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ".manifesto",
                  n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".manifesto-scrollbar",
                  r = t()(window),
                  a = t()(e),
                  o = t()(n);
                o.find(".scrollbar-thumb"), o.height() > r.height() && o.css({ maxHeight: "".concat(r.height() - 50, "px") }), a.get(0);
                var s = t()(window).height() - o.height();
                new (i())(n, { stickyContainer: ".manifesto", marginTop: s / 1.5, marginBottom: s / 1.5 });
              })(".manifesto")),
            new Wl("#notification", { direction: "vertical", allowTouchMove: !1, autoplay: { delay: 5e3, disableOnInteraction: !1 } }),
            new Wl("#hero-blog-slide", {
              slidesPerView: 1,
              loop: !1,
              noSwiping: !0,
              noSwipingClass: "swiper-no-swiping",
              pagination: { el: ".swiper-pagination", clickable: !0 },
              on: {
                init: function () {
                  this.slides.length <= 1 && document.querySelector("#hero-blog-slide").classList.add("swiper-no-swiping");
                },
              },
            }),
            new Wl("#morefor-carousel", {
              slidesPerView: 1,
              loop: !1,
              noSwiping: !0,
              noSwipingClass: "swiper-no-swiping",
              navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
              on: {
                init: function () {
                  this.slides.length <= 1 && document.querySelector("#morefor-carousel").classList.add("swiper-no-swiping");
                },
              },
            }),
            new Wl("#featured-product", {
              slidesPerView: 3,
              spaceBetween: 32,
              pagination: { el: ".swiper-progress__fill", type: "progressbar" },
              navigation: { nextEl: ".featured-product--next", prevEl: ".featured-product--prev" },
              breakpoints: { 320: { slidesPerView: 1, spaceBetween: 0 }, 768: { slidesPerView: 2, spaceBetween: 32 }, 992: { slidesPerView: 3, spaceBetween: 32 } },
            });
          var c = new Wl("#product-category", {
            spaceBetween: 0,
            speed: 6e3,
            autoplay: { delay: 1, disableOnInteraction: !1, pauseOnMouseEnter: !0 },
            loop: !0,
            slidesPerView: 4,
            allowTouchMove: !0,
            infinite: !0,
            breakpoints: { 320: { slidesPerView: 2 }, 1024: { slidesPerView: 4 } },
          }).getSwiperObject();
          c.on("sliderMove", function (e) {
            t()(e.$el).addClass("swiper-container--dragging");
          }),
            c.on("touchEnd", function (e) {
              setTimeout(function () {
                t()(e.$el).removeClass("swiper-container--dragging");
              }, 1e3);
            }),
            new Wl("#testimonial-carousel", {
              slidesPerView: 3,
              spaceBetween: 32,
              loop: !0,
              autoplay: { delay: 5e3, disableOnInteraction: !1 },
              breakpoints: { 320: { slidesPerView: 1, spaceBetween: 16 }, 768: { slidesPerView: 2, spaceBetween: 24 }, 1280: { slidesPerView: 3, spaceBetween: 32 } },
            }),
            new Wl(".about-carousel", {
              slidesPerView: "auto",
              spaceBetween: 40,
              loop: !0,
              observer: !0,
              observeParents: !0,
              observeSlideChildren: !0,
              autoplay: { delay: 0 },
              speed: 8e3,
              breakpoints: { 992: { spaceBetween: 78 } },
            }),
            new Wl(".notfound-carousel", { slidesPerView: 1, spaceBetween: 0, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" } }),
            new Wl(".jumbo-carousel", {
              slidesPerView: 1,
              spaceBetween: 0,
              navigation: !1,
              autoplay: { delay: 5e3, disableOnInteraction: !1 },
              loop: !0,
              pagination: {
                el: ".jumbo-pagination",
                clickable: !0,
                renderBullet: function (e, t) {
                  return '<span class="' + t + '"></span>';
                },
              },
            }),
            new Wl(".ugc__carousel", { slidesPerView: 1.1, autoplay: { delay: 5e3 }, pagination: { type: "progressbar", el: ".ugc__gallery .swiper-progress__fill" }, breakpoints: { 992: { slidesPerView: 2 } } }),
            t()(document).click(function () {
              t()(".dropdown-select.dropdown-select__open").removeClass("dropdown-select__open");
            }),
            t()(".dropdown-select").click(function (e) {
              e.stopImmediatePropagation(), t()(this).toggleClass("dropdown-select__open");
            }),
            t()(".dropdown-select .item").click(function () {
              t()(this).parent().find(".active").removeClass("active"), t()(this).addClass("active");
            }),
            t()(document).on("click", ".colors-picker__list input[type=radio], .pick-tool__names input[type=radio]", function (e) {
              var n,
                r,
                i,
                a,
                o = t()(this).parent().find(".colors-picker__name").text(),
                s = t()(this).closest(".customset__item").find(".product-title"),
                l = t()(this).data("image"),
                u = t()(this).data("pdp-image"),
                c = t()(this).data("variant-id"),
                d = t()(this).data("product-id"),
                f = t()("[data-pdp-variant-image-".concat(d, "]")),
                p = t()(this).closest(".colors-picker__list").find(".colors-picker__selected"),
                h = t()(this).closest(".save-sets__item, .customset__item").find("picture"),
                v = t()(this).data("product-title");
              if (
                (s.length && v && s.text(v),
                h.find("img").attr("src", l),
                h.find("source").attr("srcset", l),
                p.text(o),
                t()(".atc-note").hide(),
                t()("#atc_notes-".concat(c)).show(),
                t()("#atc_notes-mobile-".concat(c)).show(),
                u &&
                  (f.find("img").attr("src", u),
                  f.find("source").attr("srcset", u),
                  0 !== (null === (n = window.pdpTopCarousel) || void 0 === n || null === (r = n.instanceOfSwiper) || void 0 === r ? void 0 : r.realIndex) &&
                    (null === (i = window.pdpTopCarousel) || void 0 === i || null === (a = i.instanceOfSwiper) || void 0 === a || a.slideTo(0))),
                t()(this).data("variant-available") ? (t()(".atc-".concat(d)).show(), t()(".ntfy-".concat(d)).hide()) : (t()(".atc-".concat(d)).hide(), t()(".ntfy-".concat(d)).show()),
                typeof variantData !== "undefined" && c && d && (function() {
                  var variant = variantData.find(function(v) { return v.id === parseInt(c); });
                  if (variant && typeof Shopify !== "undefined" && Shopify.api && Shopify.api.formatMoney) {
                    var variantPrice = Shopify.api.formatMoney(variant.price),
                        compareAtPrice = variant.compare_at_price ? Shopify.api.formatMoney(variant.compare_at_price) : null,
                        formatMoney = function(amount) {
                          amount = amount.toString();
                          return amount.match(/\.00$/) ? amount.slice(0, -3) : amount;
                        };
                    variantPrice = formatMoney(variantPrice);
                    if (compareAtPrice) compareAtPrice = formatMoney(compareAtPrice);
                    var atcButtons = document.querySelectorAll(".atc-".concat(d));
                    atcButtons.forEach(function(btn) {
                      var span = btn.querySelector("span");
                      if (span) {
                        if (compareAtPrice) {
                          span.innerHTML = "<u>".concat(compareAtPrice, "</u> ").concat(variantPrice);
                        } else {
                          span.textContent = variantPrice;
                        }
                      }
                    });
                    var ntfyButtons = document.querySelectorAll(".ntfy-".concat(d));
                    ntfyButtons.forEach(function(btn) {
                      var span = btn.querySelector(".product-price-value-".concat(d));
                      if (span) span.textContent = variantPrice;
                    });
                  }
                })(),
                !t()(this).prop("disabled") &&
                  (t()(".colors-picker__item").removeClass("colors-picker__item--active"),
                  t()(this).parent().addClass("colors-picker__item--active"),
                  t()(this).closest(".colors-picker").find(".shipping-notes").html(t()(this).data("note")),
                  e.hasOwnProperty("originalEvent")))
              ) {
                var g = t()(this).data("paired");
                t()("#".concat(g)).click();
              }
            }),
            new Wl("#quotes-slider", { 
              slidesPerView: 1, 
              loop: !0, speed: 800, 
              autoplay: { 
                delay: 3e3 
              }, 
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              }
            }),
            new Wl(".kitchenware-about__graphics .swiper-container", { slidesPerView: 1, loop: !0, effect: "fade", speed: 800, fadeEffect: { crossFade: !0 }, autoplay: { delay: 3e3 } }),
            new Wl("#related-articles", {
              slidesPerView: 4,
              spaceBetween: 32,
              pagination: { el: ".swiper-progress__fill", type: "progressbar" },
              breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 0 },
                525: { slidesPerView: 2, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 32 },
                992: { slidesPerView: 3, spaceBetween: 32 },
                1024: { slidesPerView: 4, spaceBetween: 32, pagination: { el: ".swiper-progress__fill", type: "progressbar" } },
              },
            }),
            (window.pdpTopCarousel = new Wl("#pdp-top--carousel", {
              slidesPerView: "auto",
              spaceBetween: 0,
              loop: !0,
              lazy: { loadPrevNext: !0, loadPrevNextAmount: 2 },
              navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
              breakpoints: { 320: { slidesPerView: 1.1 }, 992: { slidesPerView: "auto" } },
            })),
            (window.pdpTopCarouselGift = new Wl("#pdp-gift", {
              slidesPerView: "auto",
              loop: !0,
              lazy: { loadPrevNext: !0, loadPrevNextAmount: 2 },
              navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
              breakpoints: { 320: { slidesPerView: 1.1 }, 992: { slidesPerView: "auto" } },
            })),
            new Wl("#ticker .swiper-container", {
              spaceBetween: 0,
              speed: 7800,
              autoplay: { delay: 1, disableOnInteraction: !1 },
              loop: !0,
              slidesPerView: "4",
              allowTouchMove: !0,
              pauseOnMouseEnter: !0,
              infinite: !0,
              breakpoints: { 320: { slidesPerView: 2 }, 1024: { slidesPerView: 4 } },
            }),
            new Wl("#ticker-card .swiper-container", {
              spaceBetween: 0,
              speed: 6e3,
              autoplay: { delay: 1, disableOnInteraction: !1 },
              loop: !0,
              slidesPerView: "4",
              allowTouchMove: !0,
              pauseOnMouseEnter: !0,
              infinite: !0,
              breakpoints: { 320: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } },
            }),
            t()(".counter-range__minus").click(function () {
              var e = t()(this).parent().find("input"),
                n = parseInt(e.val()) - 1;
              (n = n < 1 ? 1 : n), e.val(n), e[0].dispatchEvent(new Event("change"));
            }),
            t()(".counter-range__plus").click(function () {
              var e = t()(this).parent().find("input");
              e.val(parseInt(e.val()) + 1), e[0].dispatchEvent(new Event("change"));
            }),
            t()(".variant-selectric").selectric({
              arrowButtonMarkup: '<b class="button"><i class="icon-arrow-next"></i></b>',
              optionsItemBuilder: function (e) {
                return e.value.length ? '<i class="variant-color" style="background-color: ' + t()(e.element).data("color") + '"></i>' + e.text : e.text;
              },
              labelBuilder: function (e) {
                return e.value.length ? '<i class="variant-color" style="background-color: ' + t()(e.element).data("color") + '"></i>' + e.text : e.text;
              },
              disableOnMobile: !1,
              nativeOnMobile: !1,
            }),
            new Wl("#blog__row-carousel", { slidesPerView: 1.5, spaceBetween: 40, loop: !0, autoplay: !0, breakpoints: { 320: { slidesPerView: 1.5, spaceBetween: 40 }, 1200: { slidesPerView: 1.8, spaceBetween: 58 } } }),
            new Wl(".customer-review__carousel", { slidesPerView: 1, pagination: { el: ".customer-review__pagination", type: "bullets", clickable: !0 } }),
            t()("#attentive_overlay").contents().find("div#page0").css("display", "none");
          var f = t()(".sticky-navbar").outerHeight();
          t()(".sticky-navbar__nav li a").each(function () {
            var e = this;
            t()(this).on("click", function (n) {
              n.preventDefault();
              var r = t()(n.target),
                i = r.attr("href");
              t()(".sticky-navbar__nav li").removeClass("active"),
                r.parent().addClass("active"),
                t()("html, body").animate({ scrollTop: t()("".concat(i)).offset().top - f + 10 }, 1500, function () {
                  t()("body").hasClass("scroll-up") &&
                    (t()("html, body").animate({ scrollTop: t()("".concat(i)).offset().top - (f + t()(".navbar-placeholder").outerHeight()) }),
                    setTimeout(function () {
                      t()(".sticky-navbar__nav li").removeClass("active"), t()(e).parent().addClass("active"), console.log(e);
                    }, 500));
                });
            });
          }),
            t()(window).on("scroll", function () {
              var e = t()(window).scrollTop(),
                n = "";
              t()(".guide-product__grid").each(function (r, i) {
                var a = t()(i).offset().top - (f + 20);
                e >= a && (n = t()(i).attr("id"));
              }),
                t()(".sticky-navbar__nav li a").each(function (e, r) {
                  t()(r).parent().removeClass("active"),
                    t()(r).attr("href") == "#".concat(n) ? t()('a[href="#'.concat(n, '"]')).parent().addClass("active") : "" == "".concat(n) && t()(".sticky-navbar__nav li:first-child").addClass("active");
                });
            }),
            t()(".sticky-navbar__nav li a.sectiongiftcard").on("click", function () {
              var e = this;
              t()(".sticky-navbar__nav li").removeClass("active"),
                setTimeout(function () {
                  t()(".sticky-navbar__nav li").removeClass("active"), t()(e).parent().addClass("active");
                }, 1550);
            });
        }),
        t()(window).on("load", function (e) {
          var n;
          t()("section.about").length &&
            (".about-fadein",
            (n = t()(".about-fadein")) &&
              n.each(function (e, n) {
                var r = 500 * (e + 1);
                t()(n).delay(r).fadeIn(2e3);
              }));
        });
    })();
})();
